import { gql } from '@nerdwallet/apollo';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  Date: any;
  DateTime: any;
  DateTimeWithTimeOffset: any;
  EmailAddress: any;
  FinancialCurrency: any;
  JSON: any;
  StructuredContentDocument: any;
  URL: any;
};

/** The expected payload for the "updateDismissAccountAggCta" mutation. */
export type AccountAggCtaDismissedInput = {
  accountsSmallBanner?: InputMaybe<Scalars['Boolean']>;
  ageAndMixOfAccountsSmallBanner?: InputMaybe<Scalars['Boolean']>;
  balancesSmallBanner?: InputMaybe<Scalars['Boolean']>;
  creditScoreBigBanner?: InputMaybe<Scalars['Boolean']>;
  creditScoreSmallBanner?: InputMaybe<Scalars['Boolean']>;
  debtSmallBanner?: InputMaybe<Scalars['Boolean']>;
  spendingSmallBanner?: InputMaybe<Scalars['Boolean']>;
  tradelineSmallBanner?: InputMaybe<Scalars['Boolean']>;
  tradelineTopLink?: InputMaybe<Scalars['Boolean']>;
  utilizationBigBanner?: InputMaybe<Scalars['Boolean']>;
  utilizationFaq?: InputMaybe<Scalars['Boolean']>;
  utilizationSmallBanner?: InputMaybe<Scalars['Boolean']>;
};

/** List of Account Aggregation CTAs and whether they have been dismissed */
export type AccountAggCtaDismissedResponse = {
  __typename?: 'AccountAggCtaDismissedResponse';
  accountsSmallBanner?: Maybe<Scalars['Boolean']>;
  ageAndMixOfAccountsSmallBanner?: Maybe<Scalars['Boolean']>;
  balancesSmallBanner?: Maybe<Scalars['Boolean']>;
  creditScoreBigBanner?: Maybe<Scalars['Boolean']>;
  creditScoreSmallBanner?: Maybe<Scalars['Boolean']>;
  debtSmallBanner?: Maybe<Scalars['Boolean']>;
  spendingSmallBanner?: Maybe<Scalars['Boolean']>;
  tradelineSmallBanner?: Maybe<Scalars['Boolean']>;
  tradelineTopLink?: Maybe<Scalars['Boolean']>;
  utilizationBigBanner?: Maybe<Scalars['Boolean']>;
  utilizationFaq?: Maybe<Scalars['Boolean']>;
  utilizationSmallBanner?: Maybe<Scalars['Boolean']>;
};

/** TODO: the `canonicalInstitutionId` field should map to a canonical institution */
export type AccountAggregationInstitution = {
  __typename?: 'AccountAggregationInstitution';
  /** Manual override by NW employee for the popularity of this institution */
  adminPopularity?: Maybe<Scalars['Int']>;
  /**
   * Indicator of which account aggregator we are surfacing this institution from
   *
   * Example: `yodlee`
   */
  aggregatorType?: Maybe<MarketplaceAggregatorType>;
  /** The countries with which the institution is affiliated. */
  countryCodes?: Maybe<Array<InstitutionCountryCode>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  /**
   * The timestamp at which the institution was last deleted from marketplace, if applicable
   *
   * Example: `1563480626`
   */
  deletedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The status of the institution, typically used to determine whether to surface the institution or not
   *
   * Example: `ACTIVE`
   */
  displayStatus: AccountAggregationInstitutionDisplayStatus;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  /** Whether the institution is manually deactivated by an NW employee or not ??? */
  iavAdminDeactivated?: Maybe<Scalars['Boolean']>;
  /** Whether the institution supports IAV or not */
  iavEnabled: Scalars['Boolean'];
  id: Scalars['ID'];
  /**
   * The timestamp at which the institution was last updated in marketplace
   *
   * Example: `1563480626`
   */
  lastSyncedAt: Scalars['DateTime'];
  /**
   * The URL at which the user will be logged in, as provided by the relevant third-party account aggregator
   *
   * Example: `https://secure01c.chase.com/web/auth/dashboard`
   */
  loginUrl?: Maybe<Scalars['String']>;
  /**
   * The logo for the institution as provided by the relevant third-party account aggregator. This may either be
   * a full url, or a data-image representation of an image.
   *
   * Example: `https://yodlee-1.hs.llnwd.net/v1/LOGO/LOGO_643_1_2.SVG`
   */
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  /**
   * How popular this institution is for linking to in relation to others, equal to the number of successful
   * links with this institution in the past
   */
  popularity: Scalars['Int'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  /**
   * An alternate logo for the institution provided by NerdWallet that more clearly indicates which institution it is
   * (i.e. via text in the logo)
   */
  topInstitutionLogo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type AccountAggregationInstitutionByIdResponse = {
  __typename?: 'AccountAggregationInstitutionByIdResponse';
  institution?: Maybe<AccountAggregationInstitution>;
};

export const AccountAggregationInstitutionDisplayStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
  /**  This institution is not supported, but is a major institution that we want to show to the user anyway (with messaging)  */
  Unavailable: 'UNAVAILABLE',
} as const;

export type AccountAggregationInstitutionDisplayStatus =
  (typeof AccountAggregationInstitutionDisplayStatus)[keyof typeof AccountAggregationInstitutionDisplayStatus];
export type AccountAggregationInstitutionsResponse = {
  __typename?: 'AccountAggregationInstitutionsResponse';
  /** The list of institutions that match your query */
  institutions: Array<AccountAggregationInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
  /** The total number of institutions that match your query */
  total: Scalars['Int'];
};

export const AccountAggregationProductType = {
  Banking: 'BANKING',
  CreditCards: 'CREDIT_CARDS',
  InvestmentAccounts: 'INVESTMENT_ACCOUNTS',
  Mortgages: 'MORTGAGES',
  PersonalLoans: 'PERSONAL_LOANS',
  StudentLoans: 'STUDENT_LOANS',
} as const;

export type AccountAggregationProductType =
  (typeof AccountAggregationProductType)[keyof typeof AccountAggregationProductType];
export type AccountLinkingOpportunitiesResponse = {
  __typename?: 'AccountLinkingOpportunitiesResponse';
  creditCardLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
  eligibility: AccountLinkingOpportunityEligibilityEnum;
  loanLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
};

export type AccountLinkingOpportunity = {
  __typename?: 'AccountLinkingOpportunity';
  institutionCanonicalId?: Maybe<Scalars['ID']>;
  institutionCanonicalName?: Maybe<Scalars['String']>;
  institutionLogoUrl?: Maybe<Scalars['URL']>;
  numberOfAccounts: Scalars['Int'];
};

export const AccountLinkingOpportunityEligibilityEnum = {
  /** Denotes if a user is eligible to link all types of accounts. */
  All: 'ALL',
  /** Denotes if a user is eligible to link only credit cards or loans. */
  CcsAndLoans: 'CCS_AND_LOANS',
  /** Denotes if a user already has all types of accounts linked or no TU data. */
  None: 'NONE',
} as const;

export type AccountLinkingOpportunityEligibilityEnum =
  (typeof AccountLinkingOpportunityEligibilityEnum)[keyof typeof AccountLinkingOpportunityEligibilityEnum];
/**
 * The `AccountOfferInterface` is the shared fields between savings and investments
 * for the marketplace tab recommendations.
 */
export type AccountOfferInterface = {
  imageUrl?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  reviewUrl?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type AcknowledgeTermsOfServiceInput = {
  source: Scalars['String'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type AcknowledgeTermsOfServiceResponse = {
  __typename?: 'AcknowledgeTermsOfServiceResponse';
  success: Scalars['Boolean'];
};

/**
 * Wraps the add Net Worth Home - Integrated API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthHomeIntegratedResponse = {
  __typename?: 'AddNetWorthHomeIntegratedResponse';
  asset: NetWorthHomeIntegrated;
};

/**
 * Wraps the add Net Worth Real asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'AddNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

export type AddUserWalletCardInput = {
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']>;
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']>;
};

export type AddUserWalletCardResponse = {
  __typename?: 'AddUserWalletCardResponse';
  card: UserWalletCard;
};

export type AdvancedOffsetPaginationInfo = {
  __typename?: 'AdvancedOffsetPaginationInfo';
  /** The adjusted maximum number of results to return based on the request limit and result set token. */
  limit?: Maybe<Scalars['Int']>;
  /**
   * The adjusted start index of the results to return based on the request limit and result set token.
   * If underlying data has changed, this will be reset to 0 and results will start from the "beginning" of the list.
   */
  offset?: Maybe<Scalars['Int']>;
  /** The token associated with the result set, which may be different if the underlying data changed */
  resultSetToken?: Maybe<Scalars['String']>;
};

export type AdvancedOffsetPaginationInput = {
  /** The maximum number of results to return. Default is 500. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The start index of the results to return. */
  offset?: InputMaybe<Scalars['Int']>;
  /** The token associated with the result set, used to validate whether underlying data may have changed */
  resultSetToken?: InputMaybe<Scalars['String']>;
};

export type AgeRangeMap = {
  __typename?: 'AgeRangeMap';
  /** average insurance cost for a driver at age 20 */
  age20: Scalars['Float'];
  /** average insurance cost for a driver at age 25 */
  age25: Scalars['Float'];
  /** average insurance cost for a driver at age 30 */
  age30: Scalars['Float'];
  /** average insurance cost for a driver at age 35 */
  age35: Scalars['Float'];
  /** average insurance cost for a driver at age 40 */
  age40: Scalars['Float'];
  /** average insurance cost for a driver at age 45 */
  age45: Scalars['Float'];
  /** average insurance cost for a driver at age 50 */
  age50: Scalars['Float'];
  /** average insurance cost for a driver at age 55 */
  age55: Scalars['Float'];
  /** average insurance cost for a driver at age 60 */
  age60: Scalars['Float'];
  /** average insurance cost for a driver at age 65 */
  age65: Scalars['Float'];
  /** average insurance cost for a driver at age 70 */
  age70: Scalars['Float'];
  /** average insurance cost for a driver at age 75 */
  age75: Scalars['Float'];
  /** average insurance cost for a driver at age 80 */
  age80: Scalars['Float'];
};

export const AirlineChoice = {
  AlaskaAirlines: 'ALASKA_AIRLINES',
  AmericanAirlines: 'AMERICAN_AIRLINES',
  Delta: 'DELTA',
  Jetblue: 'JETBLUE',
  Other: 'OTHER',
  SouthwestAirlines: 'SOUTHWEST_AIRLINES',
  UnitedAirlines: 'UNITED_AIRLINES',
} as const;

export type AirlineChoice = (typeof AirlineChoice)[keyof typeof AirlineChoice];
export const AnnualFeesTravel = {
  Between_100And_300: 'BETWEEN_100_AND_300',
  LessThan_100: 'LESS_THAN_100',
  MoreThan_300: 'MORE_THAN_300',
} as const;

export type AnnualFeesTravel =
  (typeof AnnualFeesTravel)[keyof typeof AnnualFeesTravel];
export type AnnualPremiumByZipCode = {
  __typename?: 'AnnualPremiumByZipCode';
  /** Carrier's annual premium */
  annualPremium: Scalars['Float'];
  /** US zipCode */
  zipcode: Scalars['String'];
};

/**
 * The type used by Native and Web that describes how to handle a defined action.
 * On Mobile, it allows for a link that could deeplink or fall back to a webview if that deeplink
 * is not supported in the client version of the mobile app.
 * On Web, the action is determined using both targetType and the target.
 */
export type AppAction = {
  __typename?: 'AppAction';
  /** Indicates whether the provided target is a place where the user can fulfill the described action */
  leadsToUserActionFulfillment?: Maybe<Scalars['Boolean']>;
  /** A NerdWallet mobile app deep link */
  mobileTarget?: Maybe<Scalars['String']>;
  /** A string that describes the type of action (used for analytics). */
  name?: Maybe<Scalars['String']>;
  /** Typically a web URL. If mobileTarget is not specified or invalid, this will open in a webview. */
  target?: Maybe<Scalars['String']>;
  /** A string that tells the client how to handle this action. Only used on Web. */
  targetType?: Maybe<AppActionTargetType>;
  /** The user-facing copy on the action button/link */
  text: Scalars['String'];
};

export const AppActionTargetType = {
  Billshark: 'BILLSHARK',
  LinkAccount: 'LINK_ACCOUNT',
  LinkHome: 'LINK_HOME',
  MyBillsSuggested: 'MY_BILLS_SUGGESTED',
  Navigation: 'NAVIGATION',
  SelfReportedIncome: 'SELF_REPORTED_INCOME',
  TuActivation: 'TU_ACTIVATION',
  WebLink: 'WEB_LINK',
} as const;

export type AppActionTargetType =
  (typeof AppActionTargetType)[keyof typeof AppActionTargetType];
/** Enum used to determine the app type of a third party log in */
export const AppTypeEnum = {
  NerdwalletMobile: 'NERDWALLET_MOBILE',
  NerdwalletWeb: 'NERDWALLET_WEB',
  Nwadmin: 'NWADMIN',
} as const;

export type AppTypeEnum = (typeof AppTypeEnum)[keyof typeof AppTypeEnum];
export type AppleLoginInfoInput = {
  /** The app used to log in with Apple */
  appType: AppTypeEnum;
  /** The authorization code associated with the Apple log in/registration */
  authorizationCode: Scalars['String'];
  /** The client ID associated with the Apple log in/registration */
  clientId: Scalars['String'];
  /** The current user's email associated with the Apple log in/registration */
  email?: InputMaybe<Scalars['EmailAddress']>;
  /** The current user's first name associated with the Apple log in/registration */
  firstName?: InputMaybe<Scalars['String']>;
  /** The current user's last name associated with the Apple log in/registration */
  lastName?: InputMaybe<Scalars['String']>;
  /** The "number only used once" associated with the Apple log in/registration */
  nonce?: InputMaybe<Scalars['String']>;
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']>;
  /** The redirect URI ssociated with the Apple log in/registration */
  redirectUri?: InputMaybe<Scalars['String']>;
  /** Determines if the current user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type Article = ContentPageHeaderInterface &
  PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithEditorInterface &
  PostWithExcerptInterface &
  PostWithFaQsInterface &
  PostWithFeaturedImageInterface &
  PostWithHubLinks &
  PostWithInternationalVersionsInterface &
  PostWithPageTaxonomyInterface &
  PostWithReviewerInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'Article';
    /** Whether or not to show the advertiser disclosure. An empty value here indicates it should be shown. */
    advertiserDisclosure?: Maybe<Scalars['String']>;
    /** Type of advertiser disclosure to display (default credit_cards) */
    advertiserDisclosureType: Scalars['String'];
    /** The type of Article this is. */
    articleType?: Maybe<ArticleTypeEnum>;
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The banner to display on the article */
    banner?: Maybe<Banner>;
    /** Block group to be rendered below the content. */
    belowContent?: Maybe<BlockGroup>;
    /** The structured content to display below the main article content */
    bottomDocument?: Maybe<Scalars['StructuredContentDocument']>;
    /** The structured content to display at the bottom of the left or right sidebar under sidebarDocument and relatedLinks */
    bottomSidebarDocument?: Maybe<Scalars['StructuredContentDocument']>;
    /** A structured content component that is sticky to the bottom of the article when scrolling */
    bottomStickyDocument?: Maybe<Scalars['StructuredContentDocument']>;
    /** the breadcrumb to display on an article */
    breadcrumb?: Maybe<Breadcrumb>;
    /** A list of Category objects on the Article object. */
    categories?: Maybe<Array<Category>>;
    /** The Disqus thread ID for this content. */
    commentThreadId?: Maybe<Scalars['Int']>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** Content tags associated with the content. */
    contentTags?: Maybe<Array<Scalars['String']>>;
    /** The credit cards to display for the CCHeadToHead component. */
    creditCardsHeadToHead?: Maybe<Array<Maybe<MarketplaceEntityInterface>>>;
    /** The BlockGroups to use as custom content below the main content of the Article. */
    customBelowContent?: Maybe<BlockGroup>;
    /** The custom HouseAd to use on this Article. */
    customHouseAd?: Maybe<HouseAd>;
    /** The custom last modified date for the content. */
    customLastModifiedDate?: Maybe<Scalars['DateTime']>;
    /** The BlockGroups to use as the custom next steps for this Article. */
    customNextSteps?: Maybe<BlockGroup>;
    /** The BlockGroups to use as custom Related Links for this Article. */
    customRelatedLinks?: Maybe<BlockGroup>;
    /** The block group to use as the custom sidebar on this Article. */
    customSidebar?: Maybe<BlockGroup>;
    /** The custom title to use for this piece of content on a feed by feed basis. */
    customTitlesForRssFeeds?: Maybe<Array<ArticleCustomTitlesForRssFeed>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** The format to use when displaying the date. */
    dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** Display date based on flags and custom dates set on entity */
    displayDate?: Maybe<Scalars['DateTime']>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Editorial disclaimer setting to show, hide, or display a specific disclaimer. An empty value here indicates it should be shown. */
    editorialDisclaimer?: Maybe<Scalars['String']>;
    /** Type of article, which will determine what (if any) additional editorial standards message to display. */
    editorialDisclaimerType?: Maybe<Scalars['String']>;
    /** Whether or not to disable comments on this piece of content. */
    enableComments?: Maybe<Scalars['Boolean']>;
    /** The editorial excerpt of the resource. */
    excerpt?: Maybe<Scalars['String']>;
    /** The faqs to display on this piece of content. */
    faqs?: Maybe<Array<ContentFaq>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The structured content to use as Hero Banner for this Article */
    heroBannerDocument?: Maybe<Scalars['StructuredContentDocument']>;
    /** Whether or not to hide the Author information from the header of this piece of content. */
    hideAuthor?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the banner for this piece of content. */
    hideBanner?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the custom content to display below the main content for this Article. */
    hideBelowContent?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the date for this piece of content. */
    hideDate?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the featured image for this piece of content. */
    hideFeaturedImage?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the featured image on mobile/small screens. */
    hideFeaturedImageOnMobile?: Maybe<Scalars['Boolean']>;
    /** HouseAd to be rendered for house ad. */
    houseAd?: Maybe<HouseAd>;
    /** Collection of related hubs and subhubs. */
    hubLinks?: Maybe<Array<ContentHub>>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Information about alternate versions of the content that exist for other locales. */
    internationalVersions?: Maybe<Array<InternationalVersion>>;
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether the article's status is PUBLISHED or not. */
    isPublished: Scalars['Boolean'];
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent the content from getting syndicated to NerdWalletWire.com and other services that use our full-text feeds. */
    isSyndicationEligible?: Maybe<Scalars['Boolean']>;
    /** The layout to use for the content. */
    layout?: Maybe<ArticleLayoutEnum>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The structured content to use as the Marketplace Entity Logo Row Section for this Article */
    marketplaceEntityLogoRowDocument?: Maybe<
      Scalars['StructuredContentDocument']
    >;
    /** The block to use as the methodology for this piece of content. */
    methodology?: Maybe<Block>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Block group to be rendered as 'next steps'. */
    nextSteps?: Maybe<BlockGroup>;
    /** Whether to override the last modified date for the content using one of the available options. */
    overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
    /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
    pageTaxonomy?: Maybe<Scalars['JSON']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** User-facing label of the post type. */
    postTypeLabel: Scalars['String'];
    /** The primary category object for the content. */
    primaryCategory?: Maybe<Category>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** Block group to be rendered as related links. */
    relatedLinks?: Maybe<BlockGroup>;
    /** The product, offer, or institution name that the Article represents a review about. */
    reviewProductName?: Maybe<Scalars['String']>;
    /** The rating value to use with the Review schema type. */
    reviewRating?: Maybe<Scalars['Float']>;
    /** The reviewers that this Article has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** Whether or not to show the advertiser disclosure. */
    showAdvertiserDisclosure: Scalars['Boolean'];
    /** Whether or not to show the author box in the footer of this piece of content. */
    showAuthorBox?: Maybe<Scalars['Boolean']>;
    /** Boolean flag to show/hide author byline in the page header */
    showAuthorByline: Scalars['Boolean'];
    /** Whether or not to show the editorial disclaimer. */
    showEditorialDisclaimer: Scalars['Boolean'];
    /** Whether or not to display the FAQ's. */
    showFaqs?: Maybe<Scalars['Boolean']>;
    /** Whether or not to show the last modified date. */
    showLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Block group to be rendered as the sidebar. */
    sidebar?: Maybe<BlockGroup>;
    /** The structured content to display in right or left of the main article content; currently where relatedLinks is */
    sidebarDocument?: Maybe<Scalars['StructuredContentDocument']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['String']>;
    /** The structured content for the NerdyTakeaways component. */
    takeaways?: Maybe<Scalars['StructuredContentDocument']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Whether or not to use the custom content below the main content for this Article. */
    useCustomBelowContent?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use a custom House Ad on this Article. */
    useCustomHouseAd?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use a custom last modified date for this piece of content. */
    useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use the custom next steps for this Article. */
    useCustomNextSteps?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use the custom related links for this Article. */
    useCustomRelatedLinks?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use a custom sidebar for this Article. */
    useCustomSidebar?: Maybe<Scalars['Boolean']>;
    /** Whether the Article should use the Review schema type. */
    useReviewSchemaType?: Maybe<Scalars['Boolean']>;
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ArticleConnectionResponse = {
  __typename?: 'ArticleConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Article returned for the connection. */
  items?: Maybe<Array<Article>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the customTitlesForRssFeeds group of fields on the Article type. */
export type ArticleCustomTitlesForRssFeed = {
  __typename?: 'ArticleCustomTitlesForRssFeed';
  /** The title to show in this feed. */
  customTitle?: Maybe<Scalars['String']>;
  /** The feed this title should show on. */
  feedSlug?: Maybe<Scalars['String']>;
};

/** Query to fetch a collection of Article objects. */
export type ArticleFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Articles within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to items with the specified content tags. */
  contentTags?: InputMaybe<Array<Scalars['String']>>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Articles with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Articles with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Article type. */
export const ArticleLayoutEnum = {
  Default: 'DEFAULT',
  Full: 'FULL',
  Sidebar: 'SIDEBAR',
} as const;

export type ArticleLayoutEnum =
  (typeof ArticleLayoutEnum)[keyof typeof ArticleLayoutEnum];
export type ArticlePage = StructuredContentPageInterface & {
  __typename?: 'ArticlePage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/** Enum values for articleType field on Article type. */
export const ArticleTypeEnum = {
  GeneralAnswer: 'GENERAL_ANSWER',
  HeroBanner: 'HERO_BANNER',
  Listicle: 'LISTICLE',
  StepByStep: 'STEP_BY_STEP',
  TableOfContents: 'TABLE_OF_CONTENTS',
} as const;

export type ArticleTypeEnum =
  (typeof ArticleTypeEnum)[keyof typeof ArticleTypeEnum];
export type AuthenticateCreditProfileResponseUnion =
  | CreditProfileAuthStatusProfile
  | TuCreditReportIdentityProfile;

/** Interface that must be implemented by log in/register user responses */
export type AuthenticationResponseInterface = {
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
};

/** The WordPress author type. */
export type Author = {
  __typename?: 'Author';
  /** An organization the author is affiliated with. */
  affiliation?: Maybe<Scalars['String']>;
  /** The author's alma mater. */
  alumniOf?: Maybe<Scalars['String']>;
  /** The full media object to use for the user's avatar image. */
  avatar?: Maybe<MediaItem>;
  /** URLs to various avatar sizes. */
  avatarUrls?: Maybe<Array<AuthorAvatarUrl>>;
  /** An award the author has won. */
  award?: Maybe<Scalars['String']>;
  /** The email address to use to contact the author. */
  contactEmail?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the Author as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** Description for the author. */
  description?: Maybe<Scalars['String']>;
  /** The author's education history. */
  education?: Maybe<Scalars['String']>;
  /** Email address for the author. */
  email?: Maybe<Scalars['String']>;
  /** The author's previous experience. */
  experience?: Maybe<Scalars['String']>;
  /** Facebook URL for the author. */
  facebook?: Maybe<Scalars['URL']>;
  /** A collection of publications, organizations, etc. where the author has been featured in. */
  featuredIn?: Maybe<Array<AuthorFeaturedIn>>;
  /** The author's honorific suffix. eg: CFP, CPA */
  honorificSuffix?: Maybe<Scalars['String']>;
  /** The ID for the Author. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The author's job title. */
  jobTitle?: Maybe<Scalars['String']>;
  /** Full url for the author's archive page. */
  link?: Maybe<Scalars['URL']>;
  /** LinkedIn URL for the author. */
  linkedin?: Maybe<Scalars['URL']>;
  /** Marketplace bio for the author. */
  marketplaceBio?: Maybe<Scalars['String']>;
  /** Name of the author. */
  name?: Maybe<Scalars['String']>;
  /** The bio that we display for an author on a roundup page. */
  roundupBio?: Maybe<Scalars['String']>;
  /** URI slug for the author. */
  slug?: Maybe<Scalars['String']>;
  /** The social media links relevant to an author */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
  /** A comma-separated list of this author's areas of specialty. */
  specialties?: Maybe<Scalars['String']>;
  /** Tagline message for the author. */
  tagline?: Maybe<Scalars['String']>;
  /** Twitter handle for the author. */
  twitter?: Maybe<Scalars['String']>;
  /** External URL for the author. */
  url?: Maybe<Scalars['URL']>;
  /** User Page associated with this User. */
  userPage?: Maybe<ContentUserPage>;
};

/** The WordPress author type. */
export type AuthorAvatarUrlsArgs = {
  sizes?: InputMaybe<Array<AvatarSizeEnum>>;
};

/** Avatar URL Type for authors. */
export type AuthorAvatarUrl = {
  __typename?: 'AuthorAvatarUrl';
  /** The size of the image. */
  size?: Maybe<Scalars['Int']>;
  /** The url for the image. */
  url?: Maybe<Scalars['URL']>;
};

/** Type modeling the data within the featuredIn group of fields on the Author type. */
export type AuthorFeaturedIn = {
  __typename?: 'AuthorFeaturedIn';
  /** The name of the publication, organization, etc. where the author has been featured. */
  name?: Maybe<Scalars['String']>;
  /** The URL of the publication, organization, etc. where the author was featured. */
  url?: Maybe<Scalars['URL']>;
};

/** The input for retrieving a single author. */
export type AuthorItemInput = {
  /** The WordPress ID for the Author. */
  identifier: Scalars['ID'];
};

export type AuthorPage = StructuredContentPageInterface & {
  __typename?: 'AuthorPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/**
 * A social media link related to an author
 * Includes a type, a displayable name, and a URL to the social media
 */
export type AuthorSocialMediaLink = {
  __typename?: 'AuthorSocialMediaLink';
  /** Displayable name for social media link. */
  name: Scalars['String'];
  /** The type of social media link. */
  type: AuthorSocialMediaLinkTypeEnum;
  /** URL for social media link. */
  url: Scalars['String'];
};

export const AuthorSocialMediaLinkTypeEnum = {
  Email: 'email',
  Facebook: 'facebook',
  Linkedin: 'linkedin',
  Twitter: 'twitter',
} as const;

export type AuthorSocialMediaLinkTypeEnum =
  (typeof AuthorSocialMediaLinkTypeEnum)[keyof typeof AuthorSocialMediaLinkTypeEnum];
export type AutoInsuranceCarrier = {
  __typename?: 'AutoInsuranceCarrier';
  /** Carrier's annual premium */
  annualPremium?: Maybe<Scalars['Float']>;
  /** Name of a carrier */
  carrierName?: Maybe<Scalars['String']>;
  /** An Insurance offer */
  marketplaceOffer?: Maybe<InsuranceOfferV2>;
};

export type AutoInsuranceCitySummary = {
  __typename?: 'AutoInsuranceCitySummary';
  /** Array of cheapest companies and annual premiums within a city */
  avgByCarrier?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of average annual premium by zipCode within a city */
  avgByZipCode?: Maybe<Array<AnnualPremiumByZipCode>>;
  /** Average insurance annual premium across a city */
  avgForCity?: Maybe<Scalars['Float']>;
  /** Average insurance annual premium across a state */
  avgForState: Scalars['Float'];
  /** Array of cheapest companies and annual premiums for a driver at age 20 within a city */
  cheapestFor20YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 35 within a city */
  cheapestFor35YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 60 within a city */
  cheapestFor60YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with excellent credit score within a city */
  cheapestForExcellentCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with good credit score within a city */
  cheapestForGoodCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with poor credit score within a city */
  cheapestForPoorCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for an At Fault record within a city */
  cheapestWithAtFaultAccident?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a clean driving record within a city */
  cheapestWithCleanRecord?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a Dui record within a city */
  cheapestWithDui?: Maybe<Array<AutoInsuranceCarrier>>;
  /** US city name */
  cityName: Scalars['String'];
  /** Average insurance annual with minimum coverage across a state */
  minimumCoverageAvgForState: Scalars['Float'];
  /** US two-letter state abbreviation */
  stateCode: StateCodeEnum;
  /** US state name */
  stateName: Scalars['String'];
};

/** Particular prequal job with it's offers populated */
export type AutoInsuranceJobWithOffers = {
  __typename?: 'AutoInsuranceJobWithOffers';
  job?: Maybe<PrequalJob>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  status?: Maybe<PrequalOfferStatus>;
};

export type AutoInsurancePage = StructuredContentPageInterface & {
  __typename?: 'AutoInsurancePage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/** Auto Insurance Prequal Offer */
export type AutoInsurancePrequalOffer = PrequalOffer & {
  __typename?: 'AutoInsurancePrequalOffer';
  applyLink: Scalars['String'];
  /** consBullets is a list of disadvantages this offer provides, */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** The marketplace institution id for the offer */
  institutionId: Scalars['ID'];
  institutionLogo: Scalars['String'];
  institutionName: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  /** offerId indicates the corresponding marketplace id for the offer */
  offerId: Scalars['ID'];
  /** The marketplace product id for the offer */
  productId: Scalars['ID'];
  /** prosBullets is a list of advantages this offer provides, */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  providerId?: Maybe<Scalars['ID']>;
  /** rank tells the client what order the offers should be shown */
  rank: Scalars['Int'];
  /** reviewLink is the URL to the NerdWallet review of this offer */
  reviewLink?: Maybe<Scalars['URL']>;
};

/** Query variables for AutoInsurancePrequalOffers */
export type AutoInsurancePrequalOfferInput = {
  age?: InputMaybe<Scalars['Int']>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  contactName?: InputMaybe<PrequalUserNameInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  driversCount?: InputMaybe<Scalars['Int']>;
  email?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  isVeteran?: InputMaybe<Scalars['Boolean']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']>;
  zipCode: Scalars['String'];
};

/** Format of response to autoInsurancePrequalOffers (v2) query */
export type AutoInsurancePrequalOffersJobResponse = {
  __typename?: 'AutoInsurancePrequalOffersJobResponse';
  jobs?: Maybe<Array<PrequalJob>>;
  status?: Maybe<PrequalOfferStatus>;
};

/** Format of response to autoInsurancePrequalOffers (v2) offers */
export type AutoInsurancePrequalOffersResponseV2 = {
  __typename?: 'AutoInsurancePrequalOffersResponseV2';
  jobs?: Maybe<Array<AutoInsuranceJobWithOffers>>;
};

/** Enum of providerIds that are accepted by the auto insurance offers route */
export const AutoInsuranceProviderId = {
  Mock: 'MOCK',
  Quinstreet: 'QUINSTREET',
} as const;

export type AutoInsuranceProviderId =
  (typeof AutoInsuranceProviderId)[keyof typeof AutoInsuranceProviderId];
/** Input for Vehicle Information: Year, Make, Model */
export type AutoInsuranceVehicleInput = {
  make?: InputMaybe<Scalars['String']>;
  model?: InputMaybe<Scalars['String']>;
  year?: InputMaybe<Scalars['String']>;
};

export type AutoInsuranceVehiclePage = StructuredContentPageInterface & {
  __typename?: 'AutoInsuranceVehiclePage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

export type AutoInsuranceVehicleSummary = {
  __typename?: 'AutoInsuranceVehicleSummary';
  /** Array of years with average for each year */
  avgForModelYear?: Maybe<Array<VehiclePremiumByYear>>;
  /** Array of years for the vehicle, each with cheapest premiums */
  cheapestRatesByModelYear?: Maybe<Array<VehicleYearCheapestPremiums>>;
  /** The make of a vehicle */
  make?: Maybe<Scalars['String']>;
  /** The model of a vehicle */
  model?: Maybe<Scalars['String']>;
  /** The timestamp of the most recent update for the vehicle */
  mostRecentUpdate?: Maybe<Scalars['String']>;
  /** Other models for this make */
  otherModels?: Maybe<Array<Scalars['String']>>;
};

/** A Auto Loans institution */
export type AutoLoansInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'AutoLoansInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Auto Loans offer */
export type AutoLoansOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithQualificationsInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'AutoLoansOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver estimated apr associated with the entity */
    driverEstimatedApr?: Maybe<EntityPlacementDriver>;
    /** The driver loan amount associated with the entity */
    driverLoanAmount?: Maybe<EntityPlacementDriver>;
    /** The driver min credit score associated with the entity */
    driverMinCreditScore?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: AutoLoansProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** List of qualifications for the offer */
    qualificationsBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The overall editorial rating for this offer */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Auto Loans product */
export type AutoLoansProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'AutoLoansProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: AutoLoansInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** The list of avatar sizes available to choose from. */
export const AvatarSizeEnum = {
  Size_24: 'SIZE_24',
  Size_48: 'SIZE_48',
  Size_96: 'SIZE_96',
} as const;

export type AvatarSizeEnum =
  (typeof AvatarSizeEnum)[keyof typeof AvatarSizeEnum];
/** A Banking institution */
export type BankingInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'BankingInstitutionV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity. */
    displayName?: Maybe<Scalars['String']>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** The Banking Offer to use for related apply links (filtered based on monetizable status and geotargeting) */
    offerForCta?: Maybe<BankingOfferV2>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    /** Product type */
    productType: Scalars['String'];
    /** The editorial rating on the banking experience for the institution. */
    ratingBankExperience?: Maybe<Scalars['Float']>;
    /** The editorial rating on overdraft fees for the institution. */
    ratingOverdraftFee?: Maybe<Scalars['Float']>;
    /** The URL to the NerdWallet review of this institution. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The overall, editorial rating for the institution. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Banking institution */
export type BankingInstitutionV2OfferForCtaArgs = {
  userState?: InputMaybe<StateAbbreviationsEnum>;
};

/** A Banking offer */
export type BankingOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'BankingOfferV2';
    /** The additional details of an offer that are rendered in the 'See details' dropdown of an offer card.  The account details are typically a mix of promotions, disclaimers, and high level summaries of the offer */
    accountDetails?: Maybe<Array<Scalars['String']>>;
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    apy?: Maybe<Scalars['Float']>;
    apyAnnotation?: Maybe<Scalars['String']>;
    /** Information about limitations or constraints of ATM access whether free or not. */
    atmAccessDetails?: Maybe<Scalars['String']>;
    balanceToAvoidFees?: Maybe<Scalars['Float']>;
    /** List of the benefits associated with a given banking offer */
    benefits?: Maybe<Array<Scalars['String']>>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    bonusDetails?: Maybe<Scalars['String']>;
    /** The CD deposit term for a CD banking offer in days. */
    cdDepositTerm?: Maybe<Scalars['Int']>;
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** APY formatted for display in clients, with 2 decimal places and % symbol */
    displayApy?: Maybe<Scalars['String']>;
    /** The display name for the entity */
    displayName?: Maybe<Scalars['String']>;
    /** The array of display pages */
    displayPages?: Maybe<Array<Scalars['String']>>;
    /** The driver apy associated with the entity */
    driverApy?: Maybe<EntityPlacementDriver>;
    /** The driver bonus associated with the entity */
    driverBonus?: Maybe<EntityPlacementDriver>;
    /** The driver minimum balance associated with the entity */
    driverMinimumBalance?: Maybe<EntityPlacementDriver>;
    /** The driver monthly fee associated with the entity */
    driverMonthlyFee?: Maybe<EntityPlacementDriver>;
    /** The driver overdraft star rating associated with the entity */
    driverOverdraftStarRating?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** The annotation for the agency that federally insures the institution */
    federallyInsuredAnnotation?: Maybe<Scalars['String']>;
    feeAtm?: Maybe<Scalars['Float']>;
    feeEarlyClosure?: Maybe<Scalars['Float']>;
    feeMonthly?: Maybe<Scalars['Float']>;
    /** Holds the monthly fee sub copy such as 'Waived with one transaction per month' */
    feeMonthlySubCopy?: Maybe<Scalars['String']>;
    feeOverdraft?: Maybe<Scalars['Float']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** The URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Calculates if this offer is monetizing for a specific user (after taking throttling into account) */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Minimum deposit needed to open an account. */
    minOpeningDeposit?: Maybe<Scalars['Float']>;
    /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: BankingProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** The drivers for the entity in non structured content format */
    rawDrivers: Array<RawDriver>;
    /** The URL to the NerdWallet review of this offer's institution */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The slug associated with the product */
    slug?: Maybe<Scalars['String']>;
    /** The overall editorial rating for this Offer. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** State(s) where offer is available. If no states are specified, we will consider the offer to be nationally available */
    states?: Maybe<Array<StateAbbreviationsEnum>>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** String representing a product's subtype */
    subProductType?: Maybe<Scalars['String']>;
    /** Human readable string describing a product's subtype */
    subProductTypeLabel?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Banking offer */
export type BankingOfferV2RawDriversArgs = {
  minAccountBalance?: InputMaybe<Scalars['Int']>;
};

/** A Banking product */
export type BankingProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'BankingProductV2';
    /** Indicates whether wire transfers are offered by the bank account. */
    allowsWireTransfers?: Maybe<Scalars['Boolean']>;
    /** Entity type */
    entityType: Scalars['String'];
    /** Indicates whether bank charges a fee for depositing cash. */
    freeCashDeposits?: Maybe<Scalars['Boolean']>;
    /** Information about limitations or constraints of Cash Deposits whether free or not. */
    freeCashDepositsDetails?: Maybe<Scalars['String']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: BankingInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** Indicates whether account holders can execute an unlimited amount of transactions per month. */
    unlimitedTransactions?: Maybe<Scalars['Boolean']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
    /** Additional information about wire transfers (e.g. the incurred fees). */
    wireTransferDetails?: Maybe<Scalars['String']>;
  };

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type Banner = PostInterface &
  PostWithAuthorsInterface &
  PostWithTitleInterface & {
    __typename?: 'Banner';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The body text for the banner. */
    body?: Maybe<Scalars['StructuredContentDocument']>;
    /** The button text for the banner. */
    buttonText?: Maybe<Scalars['String']>;
    /** The url for the button in the banner. */
    buttonUrl?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The headline to use for the Banner. */
    headline?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_banner post type from WordPress. */
export type BannerTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BannerConnectionResponse = {
  __typename?: 'BannerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Banner returned for the connection. */
  items?: Maybe<Array<Banner>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Banner objects. */
export type BannerFilterInput = {
  /** Limit collection to Banners published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Banners with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPage = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithFaQsInterface &
  PostWithReviewerInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'BccPage';
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The Disqus thread ID for this content. */
    commentThreadId?: Maybe<Scalars['Int']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Editorial content for the page. */
    editorialLearnContent?: Maybe<Scalars['StructuredContentDocument']>;
    /** The faqs to display on this piece of content. */
    faqs?: Maybe<Array<ContentFaq>>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The aggregate list of all section categories. */
    imageForBccArticleSchema?: Maybe<Scalars['String']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** The Reviewers that this BccPage has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    sectionCategories: Array<BccPageSectionCategory>;
    sections?: Maybe<Array<BccPageSection>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** Whether or not to display the FAQ's. */
    showFaqs?: Maybe<Scalars['Boolean']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    summarySectionOffers: Array<BccPagePreferredSection>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCard = PostInterface &
  PostWithAuthorsInterface &
  PostWithTitleInterface & {
    __typename?: 'BccPageCard';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The bottom line text to display for the card. */
    bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
    /** The Marketplace entity UUID. */
    cardEntity?: Maybe<MarketplaceEntityInterface>;
    /** The Marketplace entity UUID. */
    cardId?: Maybe<Scalars['String']>;
    /**
     * Classic drivers associated with the entity, such as APR, that can be used in any context
     * @deprecated Consumers should specify their desired drivers via CreditCardsOfferV2. See the RFC on Placement Drivers for more info.
     */
    classicDrivers: Array<EntityPlacementDriver>;
    /** The credit card offer data for the BccPageCard */
    creditCardOffer?: Maybe<CreditCardsOfferV2>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The description text for the card. */
    description?: Maybe<Scalars['String']>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /**
     * Drivers associated with the entity that can be used within a rewards related context
     * @deprecated Consumers should specify their desired drivers via CreditCardsOfferV2. See the RFC on Placement Drivers for more info.
     */
    rewardsDrivers: Array<EntityPlacementDriver>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** Summary text for credit card for display in MORE ABOUT THE CARDS FEATURED ON THIS PAGE of BCC */
    summaryTableContent?: Maybe<Scalars['StructuredContentDocument']>;
    /** The summary table text to display for the card. */
    summaryTableText?: Maybe<Scalars['StructuredContentDocument']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageCardConnectionResponse = {
  __typename?: 'BccPageCardConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BccPageCard returned for the connection. */
  items?: Maybe<Array<BccPageCard>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BccPageCard objects. */
export type BccPageCardFilterInput = {
  /** Limit collection to BccPageCards published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageConnectionResponse = {
  __typename?: 'BccPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BccPage returned for the connection. */
  items?: Maybe<Array<BccPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BccPage objects. */
export type BccPageFilterInput = {
  /** Limit collection to BccPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to BccPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to BccPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type BccPagePreferredSection = {
  __typename?: 'BccPagePreferredSection';
  /** The BccPage section */
  section: BccPageSection;
  /** The preferred offer for the attached section */
  sectionOffer: Scalars['String'];
};

/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSection = {
  __typename?: 'BccPageSection';
  /** Cards to display within this section of the BCC page. */
  cards?: Maybe<Array<BccPageCard>>;
  /**
   * The Best Credit Cards page drivers for the section based on the identifier,
   * will optionally accept the category to return that category's drivers. We don't want this on the card
   * because it would be difficult to distinguish query wise for each card.
   */
  cardsDrivers?: Maybe<Array<BccPageSectionDriver>>;
  /**
   * The credit card offer data for the BccPageCard
   * @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info.
   */
  driversCategory: BccPageSectionDriversEnum;
  /** Unique identifier for distinguishing between sections on the front-end. */
  identifier?: Maybe<Scalars['String']>;
  /** Short title text for the current section. */
  shortTitle?: Maybe<Scalars['String']>;
  /** Title of the current section. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSectionCardsDriversArgs = {
  category?: InputMaybe<Scalars['String']>;
};

export type BccPageSectionCategory = {
  __typename?: 'BccPageSectionCategory';
  /** The camel-case identifier that uniquely identifies a section category. */
  identifier: Scalars['String'];
  /** The readable title for a given section category. */
  shortTitle: Scalars['String'];
};

export type BccPageSectionDriver = {
  __typename?: 'BccPageSectionDriver';
  /** @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  id: Scalars['ID'];
  identifier?: Maybe<Scalars['String']>;
};

/** BccPageSectionDriversEnum represents the mobile type of drivers to display for the cards categorized under this section */
export const BccPageSectionDriversEnum = {
  /** Indicates to display classic drivers such as APR */
  Classic: 'CLASSIC',
  /** Indicates to display reward related drivers such as Reward Rate */
  Rewards: 'REWARDS',
} as const;

export type BccPageSectionDriversEnum =
  (typeof BccPageSectionDriversEnum)[keyof typeof BccPageSectionDriversEnum];
/**
 * DEPRECATED: Should not be used outside of SavedPersonalLoansPrequalOffers.
 * Response that provides which prequal offers are "best bets" offers.
 */
export type BestBetsOffersResponse = {
  __typename?: 'BestBetsOffersResponse';
  /** Lowest APR best bets offer */
  lowestApr?: Maybe<PrequalPersonalLoansApiOffer>;
  /** Lowest monthly payment best bets offer */
  lowestMonthlyPayment?: Maybe<PrequalPersonalLoansApiOffer>;
};

export type BestOfAward = {
  __typename?: 'BestOfAward';
  /** The category in which the offer won */
  category: Scalars['String'];
  /** The year in which the offer won */
  year: Scalars['Int'];
};

export type Bill = {
  __typename?: 'Bill';
  /** Amount due */
  amount?: Maybe<Scalars['Int']>;
  /** Initial due date that was provided */
  baseDueDate?: Maybe<Scalars['Date']>;
  /** Who the bill is from (transaction merchant name) */
  biller?: Maybe<Scalars['String']>;
  /** Which financial category bill falls under */
  category: FinancialTransactionCategory;
  /** How frequent this bill appears */
  frequency: BillFrequency;
  /** Unique identifier for the bill */
  id: Scalars['ID'];
  /** User's ID */
  identityId?: Maybe<Scalars['ID']>;
  /** Name of the bill */
  name: Scalars['String'];
  /** Next due date, may have been marked as paid or not */
  nextDueDate?: Maybe<Scalars['Date']>;
  /** Next upcoming unpaid due date */
  nextUnpaidDueDate?: Maybe<Scalars['Date']>;
  /** Next several unpaid due dates */
  nextUnpaidDueDates?: Maybe<Array<Scalars['Date']>>;
  /** When the bill was paid */
  paidDate?: Maybe<Scalars['Date']>;
  /** Due dates in the past that were assumed to be paid */
  paidDueDates?: Maybe<Array<Scalars['Date']>>;
  /** Additional subcategory */
  subcategory?: Maybe<BillSubcategory>;
};

export const BillFrequency = {
  Annually: 'ANNUALLY',
  EveryOtherMonth: 'EVERY_OTHER_MONTH',
  EveryOtherWeek: 'EVERY_OTHER_WEEK',
  Monthly: 'MONTHLY',
  OneTime: 'ONE_TIME',
  Quarterly: 'QUARTERLY',
  TwiceAYear: 'TWICE_A_YEAR',
  Weekly: 'WEEKLY',
} as const;

export type BillFrequency = (typeof BillFrequency)[keyof typeof BillFrequency];
export const BillSubcategory = {
  Insurance: 'INSURANCE',
  Loan: 'LOAN',
} as const;

export type BillSubcategory =
  (typeof BillSubcategory)[keyof typeof BillSubcategory];
export type BillsResponse = {
  __typename?: 'BillsResponse';
  bills: Array<Bill>;
};

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type Block = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentInterface &
  PostWithTitleInterface & {
    __typename?: 'Block';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the Block object. */
    categories?: Maybe<Array<Category>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not the Block's content is inline compatible. */
    inlineCompatible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockConnectionResponse = {
  __typename?: 'BlockConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Block returned for the connection. */
  items?: Maybe<Array<Block>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Block objects. */
export type BlockFilterInput = {
  /** Limit collection to Blocks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to Blocks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroup = PostInterface &
  PostWithAuthorsInterface &
  PostWithTitleInterface & {
    __typename?: 'BlockGroup';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    blocks?: Maybe<Array<Maybe<CombinedBlockGroupBlock>>>;
    /** A list of Category objects on the BlockGroup object. */
    categories?: Maybe<Array<Category>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockGroupConnectionResponse = {
  __typename?: 'BlockGroupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The BlockGroup returned for the connection. */
  items?: Maybe<Array<BlockGroup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of BlockGroup objects. */
export type BlockGroupFilterInput = {
  /** Limit collection to BlockGroups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to BlockGroups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export const BonusCategories = {
  DrugStores: 'DRUG_STORES',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  HomeImprovement: 'HOME_IMPROVEMENT',
  OnlineShopping: 'ONLINE_SHOPPING',
  Restaurants: 'RESTAURANTS',
  Streaming: 'STREAMING',
  Travel: 'TRAVEL',
} as const;

export type BonusCategories =
  (typeof BonusCategories)[keyof typeof BonusCategories];
/** Breadcrumb to be used by global-nav */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  page?: Maybe<BreadcrumbPage>;
  slug?: Maybe<Scalars['String']>;
};

/** Breadcrumb Page object with a title */
export type BreadcrumbPage = {
  __typename?: 'BreadcrumbPage';
  title: Scalars['String'];
};

export type BuildSpec = {
  __typename?: 'BuildSpec';
  /** The name of the build spec, e.g. "NodeSpec" */
  name: Scalars['String'];
  /** The TARGET file of the spec, e.g. "package.json" */
  target: Scalars['String'];
};

export type BulkActionInput = {
  /** The ID before which to perform the action (inclusive). */
  beforeInclusive?: InputMaybe<Scalars['ID']>;
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']>;
};

export type BulkActionResponse = {
  __typename?: 'BulkActionResponse';
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

export type BulkDismissResponse = {
  __typename?: 'BulkDismissResponse';
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
  /** The operation id associated with the request. */
  operationId: Scalars['String'];
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

/** Controls whether the response is cacheable by clients and shared (proxy) caches. PRIVATE by default. */
export const CacheControlScope = {
  Private: 'PRIVATE',
  Public: 'PUBLIC',
} as const;

export type CacheControlScope =
  (typeof CacheControlScope)[keyof typeof CacheControlScope];
/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPage = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithEditorInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'CalculatorPage';
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the CalculatorPage object. */
    categories?: Maybe<Array<Category>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type CalculatorPageConnectionResponse = {
  __typename?: 'CalculatorPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The CalculatorPage returned for the connection. */
  items?: Maybe<Array<CalculatorPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of CalculatorPage objects. */
export type CalculatorPageFilterInput = {
  /** Limit collection to CalculatorPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to CalculatorPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to CalculatorPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to CalculatorPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type CanonicalInstitution = {
  __typename?: 'CanonicalInstitution';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  /**
   * The NerdWallet-maintained url for the square logo of the institution, if we have it
   *
   * Example: `https://www.nerdwallet.com/cdn/financial-institutions/american-express/amex_logo_square%404x.png`
   */
  squareLogoUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  /**
   * The NerdWallet-maintained list of lowercase synonyms for how this institution may show up on a TU credit report
   *
   * Example: [`amex`, `american express`]
   */
  tuCreditorSynonyms?: Maybe<Array<Scalars['String']>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
  /**
   * The NerdWallet-maintained mapping to a yodlee provider id
   *
   * Example: `175e9916-0ca9-4e32-ac2b-56f0c7e70196`
   */
  yodleeProviderId?: Maybe<Scalars['String']>;
};

export type CanonicalInstitutionsResponse = {
  __typename?: 'CanonicalInstitutionsResponse';
  /** The list of institutions that match your query */
  institutions: Array<CanonicalInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int'];
  /** The total number of institutions that match your query. */
  total: Scalars['Int'];
};

export type CardFinderGlobalMarkup = {
  __typename?: 'CardFinderGlobalMarkup';
  footer: Scalars['String'];
  head: Scalars['String'];
  header: Scalars['String'];
};

export type CardFinderUserData = {
  __typename?: 'CardFinderUserData';
  inputs?: Maybe<SavedQuizAnswers>;
  isReturnUser: Scalars['Boolean'];
  isSignedIn: Scalars['Boolean'];
  tuCreditScore?: Maybe<Scalars['Int']>;
  tuCreditScoreBand?: Maybe<CreditScore>;
};

export type CardImageDetails = {
  __typename?: 'CardImageDetails';
  /** Determines if the card image is a portrait or not */
  isPortrait: Scalars['Boolean'];
  /** Card image sources from small to large */
  source: Scalars['String'];
  sourceLarge?: Maybe<Scalars['String']>;
  sourceMedium: Scalars['String'];
};

export type CardsMarketplaceInstitution = {
  __typename?: 'CardsMarketplaceInstitution';
  details?: Maybe<CardsMarketplaceInstitutionDetails>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type CardsMarketplaceInstitutionDetails = {
  __typename?: 'CardsMarketplaceInstitutionDetails';
  enable_match_score_display?: Maybe<Scalars['Boolean']>;
  manual_entry?: Maybe<Scalars['Boolean']>;
};

export type CardsMarketplaceOffer = {
  __typename?: 'CardsMarketplaceOffer';
  derived_details: CardsMarketplaceOfferDerivedDetails;
  details: CardsMarketplaceOfferDetails;
  id: Scalars['ID'];
  name: Scalars['String'];
  product: CardsMarketplaceProduct;
  status: CardsMarketplaceStatus;
};

export type CardsMarketplaceOfferBestOfAwards = {
  __typename?: 'CardsMarketplaceOfferBestOfAwards';
  category?: Maybe<CardsMarketplaceOfferBestOfAwardsCategory>;
  year?: Maybe<Scalars['String']>;
};

export const CardsMarketplaceOfferBestOfAwardsCategory = {
  Best_0AprCreditCardForPurchases: 'BEST_0_APR_CREDIT_CARD_FOR_PURCHASES',
  Best_0IntroAprAndBalanceTransferCreditCard:
    'BEST_0_INTRO_APR_AND_BALANCE_TRANSFER_CREDIT_CARD',
  BestAirlineCreditCard: 'BEST_AIRLINE_CREDIT_CARD',
  BestAllPurposeTravelRewardsCreditCard:
    'BEST_ALL_PURPOSE_TRAVEL_REWARDS_CREDIT_CARD',
  BestBalanceTransferCreditCard: 'BEST_BALANCE_TRANSFER_CREDIT_CARD',
  BestBasicTravelRewardsCreditCard: 'BEST_BASIC_TRAVEL_REWARDS_CREDIT_CARD',
  BestCreditCardForBonusCashBack: 'BEST_CREDIT_CARD_FOR_BONUS_CASH_BACK',
  BestCreditCardForBuildingCredit: 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents: 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDining: 'BEST_CREDIT_CARD_FOR_DINING',
  BestCreditCardForEntertainment: 'BEST_CREDIT_CARD_FOR_ENTERTAINMENT',
  BestCreditCardForGas: 'BEST_CREDIT_CARD_FOR_GAS',
  BestCreditCardForGroceries: 'BEST_CREDIT_CARD_FOR_GROCERIES',
  BestCreditCardForSimpleCashBack: 'BEST_CREDIT_CARD_FOR_SIMPLE_CASH_BACK',
  BestCreditCardForTravelPerks: 'BEST_CREDIT_CARD_FOR_TRAVEL_PERKS',
  BestHotelCreditCard: 'BEST_HOTEL_CREDIT_CARD',
  BestPremiumTravelCreditCard: 'BEST_PREMIUM_TRAVEL_CREDIT_CARD',
  BestSmallBusinessCreditCard: 'BEST_SMALL_BUSINESS_CREDIT_CARD',
} as const;

export type CardsMarketplaceOfferBestOfAwardsCategory =
  (typeof CardsMarketplaceOfferBestOfAwardsCategory)[keyof typeof CardsMarketplaceOfferBestOfAwardsCategory];
export const CardsMarketplaceOfferBestOfBadgeWinner2020 = {
  Best_0IntroAprCreditCard: 'BEST_0_INTRO_APR_CREDIT_CARD',
  BestAirlineCreditCard: 'BEST_AIRLINE_CREDIT_CARD',
  BestBalanceTransferCreditCard: 'BEST_BALANCE_TRANSFER_CREDIT_CARD',
  BestBonusRewardsCashBackCreditCard:
    'BEST_BONUS_REWARDS_CASH_BACK_CREDIT_CARD',
  BestBonusRewardsTravelCreditCard: 'BEST_BONUS_REWARDS_TRAVEL_CREDIT_CARD',
  BestCreditCardForBuildingCredit: 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents: 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDiningAndEntertainment:
    'BEST_CREDIT_CARD_FOR_DINING_AND_ENTERTAINMENT',
  BestCreditCardForFairCredit: 'BEST_CREDIT_CARD_FOR_FAIR_CREDIT',
  BestCreditCardForFamilies: 'BEST_CREDIT_CARD_FOR_FAMILIES',
  BestCreditCardForInternationalStudents:
    'BEST_CREDIT_CARD_FOR_INTERNATIONAL_STUDENTS',
  BestFlatRateCashBackCreditCard: 'BEST_FLAT_RATE_CASH_BACK_CREDIT_CARD',
  BestFlatRateTravelCreditCard: 'BEST_FLAT_RATE_TRAVEL_CREDIT_CARD',
  BestGasCreditCard: 'BEST_GAS_CREDIT_CARD',
  BestHotelCreditCard: 'BEST_HOTEL_CREDIT_CARD',
  BestNoAnnualFeeTravelCreditCard: 'BEST_NO_ANNUAL_FEE_TRAVEL_CREDIT_CARD',
  BestPremiumCreditCard: 'BEST_PREMIUM_CREDIT_CARD',
  BestSmallBusinessCashBackCreditCard:
    'BEST_SMALL_BUSINESS_CASH_BACK_CREDIT_CARD',
  BestSmallBusinessTravelCreditCard: 'BEST_SMALL_BUSINESS_TRAVEL_CREDIT_CARD',
  BestStoreCreditCard: 'BEST_STORE_CREDIT_CARD',
} as const;

export type CardsMarketplaceOfferBestOfBadgeWinner2020 =
  (typeof CardsMarketplaceOfferBestOfBadgeWinner2020)[keyof typeof CardsMarketplaceOfferBestOfBadgeWinner2020];
export const CardsMarketplaceOfferBestOfBadgeWinner2021 = {
  Best_0IntroAprAndBalanceTransferCreditCard:
    'BEST_0_INTRO_APR_AND_BALANCE_TRANSFER_CREDIT_CARD',
  BestAirlineCreditCard: 'BEST_AIRLINE_CREDIT_CARD',
  BestBonusRewardsCashBackCreditCard:
    'BEST_BONUS_REWARDS_CASH_BACK_CREDIT_CARD',
  BestBonusRewardsTravelCreditCard: 'BEST_BONUS_REWARDS_TRAVEL_CREDIT_CARD',
  BestCreditCardForBuildingCredit: 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents: 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDiningOutOrOrderingIn:
    'BEST_CREDIT_CARD_FOR_DINING_OUT_OR_ORDERING_IN',
  BestCreditCardForGroceries: 'BEST_CREDIT_CARD_FOR_GROCERIES',
  BestCreditCardForStayingAtHome: 'BEST_CREDIT_CARD_FOR_STAYING_AT_HOME',
  BestFlatRateCashBackCreditCard: 'BEST_FLAT_RATE_CASH_BACK_CREDIT_CARD',
  BestFlatRateTravelCreditCard: 'BEST_FLAT_RATE_TRAVEL_CREDIT_CARD',
  BestHotelCreditCard: 'BEST_HOTEL_CREDIT_CARD',
  BestNoAnnualFeeTravelCreditCard: 'BEST_NO_ANNUAL_FEE_TRAVEL_CREDIT_CARD',
  BestSmallBusinessCashBackCreditCard:
    'BEST_SMALL_BUSINESS_CASH_BACK_CREDIT_CARD',
} as const;

export type CardsMarketplaceOfferBestOfBadgeWinner2021 =
  (typeof CardsMarketplaceOfferBestOfBadgeWinner2021)[keyof typeof CardsMarketplaceOfferBestOfBadgeWinner2021];
export const CardsMarketplaceOfferCardUser = {
  Business: 'BUSINESS',
  Personal: 'PERSONAL',
  Student: 'STUDENT',
} as const;

export type CardsMarketplaceOfferCardUser =
  (typeof CardsMarketplaceOfferCardUser)[keyof typeof CardsMarketplaceOfferCardUser];
export const CardsMarketplaceOfferCobrandAirline = {
  AlaskaAirlines: 'ALASKA_AIRLINES',
  AmericanAirlines: 'AMERICAN_AIRLINES',
  Delta: 'DELTA',
  Jetblue: 'JETBLUE',
  Other: 'OTHER',
  SouthwestAirlines: 'SOUTHWEST_AIRLINES',
  UnitedAirlines: 'UNITED_AIRLINES',
} as const;

export type CardsMarketplaceOfferCobrandAirline =
  (typeof CardsMarketplaceOfferCobrandAirline)[keyof typeof CardsMarketplaceOfferCobrandAirline];
export const CardsMarketplaceOfferCobrandHotel = {
  Hilton: 'HILTON',
  Hyatt: 'HYATT',
  Ihg: 'IHG',
  Marriott: 'MARRIOTT',
  Other: 'OTHER',
  Radisson: 'RADISSON',
  Wyndham: 'WYNDHAM',
} as const;

export type CardsMarketplaceOfferCobrandHotel =
  (typeof CardsMarketplaceOfferCobrandHotel)[keyof typeof CardsMarketplaceOfferCobrandHotel];
export const CardsMarketplaceOfferCompareCategories = {
  AirlineCreditCards: 'AIRLINE_CREDIT_CARDS',
  BadCreditCards: 'BAD_CREDIT_CARDS',
  BalanceTransferCreditCards: 'BALANCE_TRANSFER_CREDIT_CARDS',
  BusinessCreditCards: 'BUSINESS_CREDIT_CARDS',
  CashRewardsCreditCards: 'CASH_REWARDS_CREDIT_CARDS',
  CreditCardBonusOffers: 'CREDIT_CARD_BONUS_OFFERS',
  GasCreditCards: 'GAS_CREDIT_CARDS',
  HotelCreditCards: 'HOTEL_CREDIT_CARDS',
  LowInterestCreditCards: 'LOW_INTEREST_CREDIT_CARDS',
  NwSearch: 'NW_SEARCH',
  PersRecResults: 'PERS_REC_RESULTS',
  RecommendedPlacement: 'RECOMMENDED_PLACEMENT',
  RewardsCreditCards: 'REWARDS_CREDIT_CARDS',
  SecuredCreditCards: 'SECURED_CREDIT_CARDS',
  ShadowCard: 'SHADOW_CARD',
  StudentCreditCards: 'STUDENT_CREDIT_CARDS',
  TheBestCreditCards: 'THE_BEST_CREDIT_CARDS',
  TravelMilesCreditCards: 'TRAVEL_MILES_CREDIT_CARDS',
  ZeroPercentCreditCards: 'ZERO_PERCENT_CREDIT_CARDS',
} as const;

export type CardsMarketplaceOfferCompareCategories =
  (typeof CardsMarketplaceOfferCompareCategories)[keyof typeof CardsMarketplaceOfferCompareCategories];
export type CardsMarketplaceOfferDerivedDetails = {
  __typename?: 'CardsMarketplaceOfferDerivedDetails';
  apply_link?: Maybe<Scalars['String']>;
  approval_likelihood?: Maybe<Scalars['Float']>;
  balance_transfer_cfa?: Maybe<Scalars['Float']>;
  balance_transfer_interest_savings?: Maybe<Scalars['Float']>;
  category_dining?: Maybe<Scalars['Float']>;
  category_gas?: Maybe<Scalars['Float']>;
  category_grocery_drug?: Maybe<Scalars['Float']>;
  category_office?: Maybe<Scalars['Float']>;
  category_other?: Maybe<Scalars['Float']>;
  category_travel?: Maybe<Scalars['Float']>;
  debt_free_monthly_payment?: Maybe<Scalars['Float']>;
  estimated_ongoing_apr?: Maybe<Scalars['Float']>;
  fees?: Maybe<Scalars['Float']>;
  is_approval_likely?: Maybe<Scalars['Boolean']>;
  is_sponsored?: Maybe<Scalars['Boolean']>;
  match_score?: Maybe<Scalars['Int']>;
  monetizable?: Maybe<CardsMarketplaceOfferMonetizable>;
  net_rewards?: Maybe<Scalars['Float']>;
  purchase_cfa?: Maybe<Scalars['Float']>;
  purchase_interest_savings?: Maybe<Scalars['Float']>;
  reward_cents_per_unit?: Maybe<Scalars['Float']>;
  reward_cents_per_unit_string?: Maybe<Scalars['String']>;
  sign_up_bonus?: Maybe<Scalars['Float']>;
  spending_rewards?: Maybe<Scalars['Float']>;
  terms_and_fees_redirect_link?: Maybe<Scalars['String']>;
  total_balance_transfer_cost?: Maybe<Scalars['Float']>;
  total_balance_transfer_savings_ongoing_interest?: Maybe<Scalars['Float']>;
  total_balance_transfer_savings_time?: Maybe<Scalars['Int']>;
  total_purchase_savings_amount?: Maybe<Scalars['Float']>;
  total_purchase_savings_ongoing_interest?: Maybe<Scalars['Float']>;
  total_purchase_savings_time?: Maybe<Scalars['Int']>;
  total_savings_amount?: Maybe<Scalars['Float']>;
  true_balance_transfer_cost?: Maybe<Scalars['Float']>;
  true_interest_cost?: Maybe<Scalars['Float']>;
  visitor_approval_likelihood?: Maybe<Scalars['Float']>;
};

export type CardsMarketplaceOfferDetails = {
  __typename?: 'CardsMarketplaceOfferDetails';
  annual_fee: Scalars['Float'];
  annual_fee_details?: Maybe<Scalars['String']>;
  annual_fee_first_year: Scalars['Float'];
  apply_pay_per_call?: Maybe<Scalars['String']>;
  apr_average?: Maybe<Scalars['Float']>;
  apr_display_list: Array<Maybe<Scalars['String']>>;
  apr_excellent?: Maybe<Scalars['Float']>;
  apr_good?: Maybe<Scalars['Float']>;
  apr_intro_message?: Maybe<Scalars['String']>;
  apr_intro_message_list: Array<Maybe<Scalars['String']>>;
  apr_max?: Maybe<Scalars['Float']>;
  apr_min?: Maybe<Scalars['Float']>;
  apr_poor?: Maybe<Scalars['Float']>;
  balance_transfer_fee?: Maybe<Scalars['Float']>;
  balance_transfer_fee_description?: Maybe<Scalars['String']>;
  balance_transfer_intro_apr?: Maybe<Scalars['Float']>;
  balance_transfer_intro_fee_description?: Maybe<Scalars['String']>;
  balance_transfer_intro_time?: Maybe<Scalars['Int']>;
  banned_pages?: Maybe<Array<Maybe<Scalars['String']>>>;
  best_of_awards?: Maybe<Array<Maybe<CardsMarketplaceOfferBestOfAwards>>>;
  best_of_badge_winner_2020?: Maybe<
    Array<Maybe<CardsMarketplaceOfferBestOfBadgeWinner2020>>
  >;
  best_of_badge_winner_2021?: Maybe<
    Array<Maybe<CardsMarketplaceOfferBestOfBadgeWinner2021>>
  >;
  billing_cycle_units: Scalars['String'];
  canonical_url?: Maybe<Scalars['String']>;
  card_categories?: Maybe<Array<Maybe<Scalars['String']>>>;
  card_user?: Maybe<CardsMarketplaceOfferCardUser>;
  cash_advance_apr?: Maybe<Scalars['Float']>;
  cash_advance_fee?: Maybe<Scalars['Float']>;
  cobrand_airline?: Maybe<CardsMarketplaceOfferCobrandAirline>;
  cobrand_hotel?: Maybe<CardsMarketplaceOfferCobrandHotel>;
  compare_categories?: Maybe<
    Array<Maybe<CardsMarketplaceOfferCompareCategories>>
  >;
  cons_bullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_tips?: Maybe<Array<Maybe<Scalars['String']>>>;
  custom_details_list?: Maybe<Array<Maybe<Scalars['String']>>>;
  disclaimer?: Maybe<Scalars['String']>;
  disclaimer_text?: Maybe<Scalars['String']>;
  editorial_value_prop?: Maybe<Scalars['String']>;
  feed_id?: Maybe<Scalars['Int']>;
  feed_product_id?: Maybe<Scalars['String']>;
  foreign_transaction_fee: Scalars['Float'];
  foreign_transaction_fee_description?: Maybe<Scalars['String']>;
  image_alt_text: Scalars['String'];
  image_is_portrait: Scalars['Boolean'];
  image_source: Scalars['String'];
  image_source_large: Scalars['String'];
  image_source_medium: Scalars['String'];
  included_pages?: Maybe<Array<Maybe<Scalars['String']>>>;
  is_editorial_apply_link_disabled?: Maybe<Scalars['Boolean']>;
  is_fixed_rate: Scalars['Boolean'];
  is_monetizing?: Maybe<Scalars['Boolean']>;
  is_shown_on_tool: Scalars['Boolean'];
  issuer_info_page_url?: Maybe<Scalars['String']>;
  last_ingested_at?: Maybe<Scalars['Int']>;
  late_payment_fee?: Maybe<Scalars['Int']>;
  late_payment_fee_description?: Maybe<Scalars['String']>;
  legacy_id: Scalars['Int'];
  manual_entry?: Maybe<Scalars['Boolean']>;
  marketing_bullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  marketing_bullets_without_terms_and_fees_link?: Maybe<
    Array<Maybe<Scalars['String']>>
  >;
  max_fico: Scalars['Int'];
  meta_description?: Maybe<Scalars['String']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  meta_title?: Maybe<Scalars['String']>;
  min_fico: Scalars['Int'];
  minimum_deposit?: Maybe<Scalars['Float']>;
  minimum_deposit_description?: Maybe<Scalars['String']>;
  obsolete_referrals?: Maybe<Array<Maybe<Scalars['Int']>>>;
  offer_url?: Maybe<Scalars['String']>;
  ongoing_apr: Scalars['String'];
  ongoing_apr_annotated?: Maybe<Scalars['String']>;
  ongoing_apr_unannotated: Scalars['String'];
  penalty_apr?: Maybe<Scalars['Float']>;
  perks?: Maybe<Array<Maybe<CardsMarketplaceOfferPerks>>>;
  prequal_link?: Maybe<Scalars['String']>;
  prequal_link_text?: Maybe<Scalars['String']>;
  processing_network?: Maybe<CardsMarketplaceOfferProcessingNetwork>;
  pros_bullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  purchase_apr?: Maybe<Scalars['String']>;
  purchase_apr_annotated?: Maybe<Scalars['String']>;
  purchase_intro_apr?: Maybe<Scalars['Float']>;
  purchase_intro_time?: Maybe<Scalars['Int']>;
  rating_stars?: Maybe<Scalars['Float']>;
  redemption_complexity?: Maybe<Scalars['Int']>;
  redemptions?: Maybe<Array<Maybe<CardsMarketplaceOfferRedemptions>>>;
  related_card_ids?: Maybe<Array<Maybe<Scalars['Int']>>>;
  related_content?: Maybe<Array<Maybe<Scalars['String']>>>;
  review_link?: Maybe<Scalars['String']>;
  reward_categories_best_rates?: Maybe<
    Array<Maybe<CardsMarketplaceOfferRewardCategoriesBestRates>>
  >;
  reward_program_name?: Maybe<Scalars['String']>;
  reward_rate: Scalars['Float'];
  reward_rate_details: Scalars['String'];
  reward_rate_notes?: Maybe<Scalars['String']>;
  reward_type?: Maybe<Scalars['String']>;
  rewards?: Maybe<Array<Maybe<CardsMarketplaceOfferRewards>>>;
  seo_name?: Maybe<Scalars['String']>;
  sign_up_bonus: Scalars['Int'];
  sign_up_bonus_details: Scalars['String'];
  sign_up_bonus_details_annotation: Scalars['String'];
  sign_up_bonus_type?: Maybe<CardsMarketplaceOfferSignUpBonusType>;
  slug?: Maybe<Scalars['String']>;
  terms_and_fees_link?: Maybe<Scalars['String']>;
};

export const CardsMarketplaceOfferMonetizable = {
  No: 'NO',
  NoBecauseOfLimit: 'NO_BECAUSE_OF_LIMIT',
  YesAssumed: 'YES_ASSUMED',
} as const;

export type CardsMarketplaceOfferMonetizable =
  (typeof CardsMarketplaceOfferMonetizable)[keyof typeof CardsMarketplaceOfferMonetizable];
export const CardsMarketplaceOfferPerks = {
  HasAirportLoungeAccess: 'HAS_AIRPORT_LOUNGE_ACCESS',
  HasCompanionFareAnnualFlight: 'HAS_COMPANION_FARE_ANNUAL_FLIGHT',
  HasFreeAnnualHotelNight: 'HAS_FREE_ANNUAL_HOTEL_NIGHT',
  HasFreeCheckedBags: 'HAS_FREE_CHECKED_BAGS',
  HasGlobalentryTsaCredit: 'HAS_GLOBALENTRY_TSA_CREDIT',
  HasPrimaryRentalCarInsurance: 'HAS_PRIMARY_RENTAL_CAR_INSURANCE',
} as const;

export type CardsMarketplaceOfferPerks =
  (typeof CardsMarketplaceOfferPerks)[keyof typeof CardsMarketplaceOfferPerks];
export const CardsMarketplaceOfferProcessingNetwork = {
  AmericanExpress: 'AMERICAN_EXPRESS',
  Discover: 'DISCOVER',
  Mastercard: 'MASTERCARD',
  Visa: 'VISA',
} as const;

export type CardsMarketplaceOfferProcessingNetwork =
  (typeof CardsMarketplaceOfferProcessingNetwork)[keyof typeof CardsMarketplaceOfferProcessingNetwork];
export const CardsMarketplaceOfferRedemptions = {
  RedeemForAlaskaAirlines: 'REDEEM_FOR_ALASKA_AIRLINES',
  RedeemForAmericanAirlines: 'REDEEM_FOR_AMERICAN_AIRLINES',
  RedeemForDeltaAirlines: 'REDEEM_FOR_DELTA_AIRLINES',
  RedeemForHiltonHotel: 'REDEEM_FOR_HILTON_HOTEL',
  RedeemForHyattHotel: 'REDEEM_FOR_HYATT_HOTEL',
  RedeemForMarriottStarwoodHotel: 'REDEEM_FOR_MARRIOTT_STARWOOD_HOTEL',
  RedeemForMultipleAirlinesHotels: 'REDEEM_FOR_MULTIPLE_AIRLINES_HOTELS',
  RedeemForMutlipleAirlinesHotels: 'REDEEM_FOR_MUTLIPLE_AIRLINES_HOTELS',
  RedeemForSouthwestAirlines: 'REDEEM_FOR_SOUTHWEST_AIRLINES',
  RedeemForStatementCredit: 'REDEEM_FOR_STATEMENT_CREDIT',
  RedeemForUnitedAirlines: 'REDEEM_FOR_UNITED_AIRLINES',
} as const;

export type CardsMarketplaceOfferRedemptions =
  (typeof CardsMarketplaceOfferRedemptions)[keyof typeof CardsMarketplaceOfferRedemptions];
export type CardsMarketplaceOfferRewardCategoriesBestRates = {
  __typename?: 'CardsMarketplaceOfferRewardCategoriesBestRates';
  category: CardsMarketplaceOfferRewardCategoriesBestRatesCategory;
  rate: Scalars['Float'];
};

export const CardsMarketplaceOfferRewardCategoriesBestRatesCategory = {
  Airfare: 'AIRFARE',
  All: 'ALL',
  Bookstores: 'BOOKSTORES',
  Business: 'BUSINESS',
  CarRental: 'CAR_RENTAL',
  Charity: 'CHARITY',
  Dining: 'DINING',
  Discount: 'DISCOUNT',
  Drugstores: 'DRUGSTORES',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  HomeImprove: 'HOME_IMPROVE',
  Hotel: 'HOTEL',
  Lodging: 'LODGING',
  Movies: 'MOVIES',
  Office: 'OFFICE',
  Other: 'OTHER',
  Parking: 'PARKING',
  Playstation: 'PLAYSTATION',
  Telecom: 'TELECOM',
  Travel: 'TRAVEL',
  Utilities: 'UTILITIES',
  Wireless: 'WIRELESS',
} as const;

export type CardsMarketplaceOfferRewardCategoriesBestRatesCategory =
  (typeof CardsMarketplaceOfferRewardCategoriesBestRatesCategory)[keyof typeof CardsMarketplaceOfferRewardCategoriesBestRatesCategory];
export type CardsMarketplaceOfferRewards = {
  __typename?: 'CardsMarketplaceOfferRewards';
  cap?: Maybe<Scalars['Int']>;
  category: CardsMarketplaceOfferRewardsCategory;
  duration: Scalars['Int'];
  id?: Maybe<Scalars['String']>;
  is_custom?: Maybe<Scalars['Boolean']>;
  is_rotating?: Maybe<Scalars['Boolean']>;
  is_tiered: Scalars['Boolean'];
  period: CardsMarketplaceOfferRewardsPeriod;
  rate: Scalars['Float'];
  recommendation_category?: Maybe<CardsMarketplaceOfferRewardsRecommendationCategory>;
  version_id: Scalars['Int'];
};

export const CardsMarketplaceOfferRewardsCategory = {
  Airfare: 'AIRFARE',
  All: 'ALL',
  Bookstores: 'BOOKSTORES',
  Business: 'BUSINESS',
  CarRental: 'CAR_RENTAL',
  Charity: 'CHARITY',
  Dining: 'DINING',
  Discount: 'DISCOUNT',
  Drugstores: 'DRUGSTORES',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  HomeImprove: 'HOME_IMPROVE',
  Hotel: 'HOTEL',
  Lodging: 'LODGING',
  Movies: 'MOVIES',
  Office: 'OFFICE',
  Other: 'OTHER',
  Parking: 'PARKING',
  Playstation: 'PLAYSTATION',
  Telecom: 'TELECOM',
  Travel: 'TRAVEL',
  Utilities: 'UTILITIES',
  Wireless: 'WIRELESS',
} as const;

export type CardsMarketplaceOfferRewardsCategory =
  (typeof CardsMarketplaceOfferRewardsCategory)[keyof typeof CardsMarketplaceOfferRewardsCategory];
export const CardsMarketplaceOfferRewardsPeriod = {
  FirstYear: 'FIRST_YEAR',
  Monthly: 'MONTHLY',
  Quarterly: 'QUARTERLY',
  Yearly: 'YEARLY',
} as const;

export type CardsMarketplaceOfferRewardsPeriod =
  (typeof CardsMarketplaceOfferRewardsPeriod)[keyof typeof CardsMarketplaceOfferRewardsPeriod];
export const CardsMarketplaceOfferRewardsRecommendationCategory = {
  All: 'ALL',
  DrugStores: 'DRUG_STORES',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  HomeImprovement: 'HOME_IMPROVEMENT',
  OnlineShopping: 'ONLINE_SHOPPING',
  Restaurants: 'RESTAURANTS',
  Streaming: 'STREAMING',
  Travel: 'TRAVEL',
} as const;

export type CardsMarketplaceOfferRewardsRecommendationCategory =
  (typeof CardsMarketplaceOfferRewardsRecommendationCategory)[keyof typeof CardsMarketplaceOfferRewardsRecommendationCategory];
export const CardsMarketplaceOfferSignUpBonusType = {
  Cash: 'CASH',
  Miles: 'MILES',
  NoRewards: 'NO_REWARDS',
  Points: 'POINTS',
} as const;

export type CardsMarketplaceOfferSignUpBonusType =
  (typeof CardsMarketplaceOfferSignUpBonusType)[keyof typeof CardsMarketplaceOfferSignUpBonusType];
export type CardsMarketplaceProduct = {
  __typename?: 'CardsMarketplaceProduct';
  details?: Maybe<CardsMarketplaceProductDetails>;
  id: Scalars['ID'];
  institution: CardsMarketplaceInstitution;
  name: Scalars['String'];
};

export type CardsMarketplaceProductDetails = {
  __typename?: 'CardsMarketplaceProductDetails';
  manual_entry?: Maybe<Scalars['Boolean']>;
};

export const CardsMarketplaceStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;

export type CardsMarketplaceStatus =
  (typeof CardsMarketplaceStatus)[keyof typeof CardsMarketplaceStatus];
export type Carrier = {
  __typename?: 'Carrier';
  /** average insurance price */
  avgCost: Scalars['Float'];
  /** Carrier selected by Nerdwallet to feature as best car insurance companies for 2021 */
  best2021: Scalars['Boolean'];
  /** average insurance cost based on driver's age */
  byAgeRange: AgeRangeMap;
  /** average insurance cost for a good and poor credit score */
  byCreditRange: CreditRangeMap;
  /** Name of a Carrier */
  carrierName: Scalars['String'];
  /** Unique ID of a Carrier */
  id: Scalars['ID'];
  /** average insurance cost for a driver with a ACCIDENT history */
  withAccident: Scalars['Float'];
  /** average insurance cost for a driver with a DUI history */
  withDUI: Scalars['Float'];
  /** average insurance cost for a good driver (no ACCIDENT or DUI history) */
  withGoodDriver: Scalars['Float'];
};

export type CashFlowActivationStatusResponse =
  MembershipFeatureActivationStatusInterface & {
    __typename?: 'CashFlowActivationStatusResponse';
    id: MembershipFeatureEnum;
    status: MembershipFeatureActivationStatusEnum;
  };

export type CashFlowBreakdown = {
  __typename?: 'CashFlowBreakdown';
  /**
   * The user's estimated income for the month in dollars. Income is estimated
   * based on user self-reported values or if that is not provided, then based
   * on transactions in the income category.
   */
  estimatedIncome: Scalars['Float'];
  /**
   * Computed as (estimated income - spending - upcomingBillsTotalDue).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /** The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents. */
  upcomingBillsTotalDue: Scalars['Float'];
};

export type CashFlowHistoryBreakdown = {
  __typename?: 'CashFlowHistoryBreakdown';
  /**
   * The average of the 'remaining' fields in the breakdown, current month NOT included
   * A positive number means, on average, the user has saved more than they have spent.
   */
  averageSavingsRemaining?: Maybe<Scalars['Float']>;
  /** Month by month breakdown of historical cash flow, current month included */
  cashFlowHistoryBreakdown: Array<CashFlowHistoryMonthlyBreakdownDatum>;
};

export type CashFlowHistoryMonthlyBreakdownDatum = {
  __typename?: 'CashFlowHistoryMonthlyBreakdownDatum';
  /** A date in the month that this datum represents */
  date: Scalars['Date'];
  /**
   * The user's actual earning for the month, in dollars. Earning is credits minus
   * debits in the income category. Estimated income is based on user self-reported values
   * or if that is not provided, then based on transactions in the income category.
   */
  earning: Scalars['Float'];
  /**
   * The user's estimated income for the month, in dollars. It is only present for
   * the current month. Estimated income is based on user self-reported values or
   * if that is not provided, then based on transactions in the income category.
   */
  estimatedIncome?: Maybe<Scalars['Float']>;
  /**
   * Computed as ((earnings or estimatedIncome) - spending - upcomingBills (if any)).
   * Note: this value can be negative
   */
  remaining: Scalars['Float'];
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float'];
  /**
   * The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents.
   * Note: this value is only present for the currentMonth (otherwise there are no upcoming bills)
   */
  upcomingBills?: Maybe<Scalars['Float']>;
};

export type CashFlowTakeaway = {
  __typename?: 'CashFlowTakeaway';
  /**
   * A list of actions that the user can take related to this takeaway. These usually represent
   * links to another page or screen so the user can dig into the details of the takeaway. There's usually
   * 1 action per takeaway (but this is not a requirement).
   */
  actions: Array<AppAction>;
  /** The body of the takeaway - describes the takeaway for the user in more detail (user facing). */
  body: Scalars['String'];
  /**
   * Describes the sentiment of the takeaway and further helps distinguish when theme/subtheme are the same
   * (e.g. POSITIVE) (used for analytics).
   */
  condition?: Maybe<Scalars['String']>;
  /** A label describing the takeaway (user facing). */
  label?: Maybe<Scalars['String']>;
  /** A string that can further describe the type within the larger theme of the takeaway (used for analytics). */
  subtheme?: Maybe<Scalars['String']>;
  /** A string representing the takeaway name (used for analytics) */
  takeaway?: Maybe<Scalars['String']>;
  /** A string that describes the type of takeaway (e.g. ONBOARDING) (used for analytics). */
  theme?: Maybe<Scalars['String']>;
};

/** Type modeling the data for terms within the category taxonomy from WordPress. */
export type Category = TermInterface & {
  __typename?: 'Category';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The banner to display at the top of content within this category. */
  defaultBanner?: Maybe<Banner>;
  /** The default Block Group to use in the "Below Content" section for content in this category. */
  defaultBelowContent?: Maybe<BlockGroup>;
  /** The default House Ad to use for content in this category. */
  defaultHouseAd?: Maybe<HouseAd>;
  /** The default Block Group to use in the "Next Steps" section for content in this category. */
  defaultNextSteps?: Maybe<BlockGroup>;
  /** The default Block Group to use in the "Related Links" section for content in this category. */
  defaultRelatedLinks?: Maybe<BlockGroup>;
  /** The default Block Group to use as the sidebar for content in this category. */
  defaultSidebar?: Maybe<BlockGroup>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The Category object for the parent of this entity. */
  parent?: Maybe<Category>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

export type ClientEligibilityConfig = {
  __typename?: 'ClientEligibilityConfig';
  /** The list of native app versions to block for this user insight */
  blocklistedNativeAppVersions?: Maybe<Array<Scalars['String']>>;
  /** Which platforms to exclude the user insight from */
  excludePlatforms?: Maybe<Array<Maybe<UserInsightPlatformEnum>>>;
  /** The minimum native app version required to be eligible for this user insight */
  minNativeAppVersion?: Maybe<Scalars['String']>;
};

export type CombinedBlockGroupBlock = {
  __typename?: 'CombinedBlockGroupBlock';
  data?: Maybe<Scalars['JSON']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type CompareAutoInsuranceCarriers = {
  __typename?: 'CompareAutoInsuranceCarriers';
  /** Array of carriers */
  carriers: Array<Carrier>;
  /** Name of State */
  usState: Scalars['String'];
};

/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetails = {
  __typename?: 'ComparisonTableColumnDetails';
  /** The tracking params that should be appended to this column's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers to display for this column */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Whether or not the column contains the primary entity */
  isPrimaryEntity: Scalars['Boolean'];
  /** The marketplace entity associated with this column */
  marketplaceEntity: MarketplaceEntityInterface;
};

/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetailsCtaTrackingParamsArgs = {
  sourceUrl?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
};

/** Describes the details of the comparison table */
export type ComparisonTableDetails = {
  __typename?: 'ComparisonTableDetails';
  /** Data used for rendering the columns of the comparison table */
  columns?: Maybe<Array<ComparisonTableColumnDetails>>;
  /** Whether or not the comparison table should include compare rates */
  hasCompareRates: Scalars['Boolean'];
  /** The header text for the comparison table */
  heading?: Maybe<Scalars['String']>;
};

/** Describes the details of the comparison table */
export type ComparisonTableDetailsColumnsArgs = {
  userState?: InputMaybe<StateCodeEnum>;
};

export const ComparisonTableLocationEnum = {
  AboveFullReview: 'ABOVE_FULL_REVIEW',
  PageBottom: 'PAGE_BOTTOM',
  ReviewContentSections: 'REVIEW_CONTENT_SECTIONS',
} as const;

export type ComparisonTableLocationEnum =
  (typeof ComparisonTableLocationEnum)[keyof typeof ComparisonTableLocationEnum];
export const ContentCategory = {
  Advisors: 'ADVISORS',
  AirlineCreditCards: 'AIRLINE_CREDIT_CARDS',
  AutoInsurance: 'AUTO_INSURANCE',
  AutoLoans: 'AUTO_LOANS',
  BalanceTransferCreditCards: 'BALANCE_TRANSFER_CREDIT_CARDS',
  Banking: 'BANKING',
  BankingBasics: 'BANKING_BASICS',
  BankingNews: 'BANKING_NEWS',
  BanksAndCreditUnions: 'BANKS_AND_CREDIT_UNIONS',
  BestCreditCards: 'BEST_CREDIT_CARDS',
  Bills: 'BILLS',
  BlackFriday: 'BLACK_FRIDAY',
  BlackFridayAdLeaks: 'BLACK_FRIDAY_AD_LEAKS',
  Brokers: 'BROKERS',
  BusinessCreditCards: 'BUSINESS_CREDIT_CARDS',
  Careers: 'CAREERS',
  CarInsurancEstimates: 'CAR_INSURANC_ESTIMATES',
  CashBackCreditCards: 'CASH_BACK_CREDIT_CARDS',
  Cds: 'CDS',
  CellPhones: 'CELL_PHONES',
  CheckingAccounts: 'CHECKING_ACCOUNTS',
  CollegeSavings: 'COLLEGE_SAVINGS',
  CompareCardOffers: 'COMPARE_CARD_OFFERS',
  CorporateNews: 'CORPORATE_NEWS',
  CorporateTaxRates: 'CORPORATE_TAX_RATES',
  CreditCards: 'CREDIT_CARDS',
  CreditCardsAverageFairCredit: 'CREDIT_CARDS_AVERAGE_FAIR_CREDIT',
  CreditCardsBadCredit: 'CREDIT_CARDS_BAD_CREDIT',
  CreditCardBasics: 'CREDIT_CARD_BASICS',
  CreditCardData: 'CREDIT_CARD_DATA',
  CreditCardReviews: 'CREDIT_CARD_REVIEWS',
  CreditScore: 'CREDIT_SCORE',
  DailyDeals: 'DAILY_DEALS',
  EmployeeEqutiy: 'EMPLOYEE_EQUTIY',
  EnergyGasWater: 'ENERGY_GAS_WATER',
  EnergyTaxIncentives: 'ENERGY_TAX_INCENTIVES',
  EstatePlanning: 'ESTATE_PLANNING',
  Finance: 'FINANCE',
  FinancialPlanning: 'FINANCIAL_PLANNING',
  Finanzas: 'FINANZAS',
  FindingHealthInsurance: 'FINDING_HEALTH_INSURANCE',
  FindingRightMortgage: 'FINDING_RIGHT_MORTGAGE',
  GovernmentPolicy: 'GOVERNMENT_POLICY',
  Health: 'HEALTH',
  HolidayTipsNews: 'HOLIDAY_TIPS_NEWS',
  Homeownership: 'HOMEOWNERSHIP',
  HomeownershipCosts: 'HOMEOWNERSHIP_COSTS',
  HomeownersInsurance: 'HOMEOWNERS_INSURANCE',
  HomeAffordability: 'HOME_AFFORDABILITY',
  HomeSearch: 'HOME_SEARCH',
  HowToStartABusiness: 'HOW_TO_START_A_BUSINESS',
  IncomeTaxes: 'INCOME_TAXES',
  Insurance: 'INSURANCE',
  InternetTv: 'INTERNET_TV',
  Investing: 'INVESTING',
  InvestingData: 'INVESTING_DATA',
  InvestingStrategy: 'INVESTING_STRATEGY',
  Investments: 'INVESTMENTS',
  InvestmentTaxes: 'INVESTMENT_TAXES',
  Ira: 'IRA',
  LifeInsurance: 'LIFE_INSURANCE',
  Loans: 'LOANS',
  LowInterestNoFeeCreditCards: 'LOW_INTEREST_NO_FEE_CREDIT_CARDS',
  LoyaltyPrograms: 'LOYALTY_PROGRAMS',
  MakingMoney: 'MAKING_MONEY',
  ManagingHealthInsurance: 'MANAGING_HEALTH_INSURANCE',
  ManagingMedicalBills: 'MANAGING_MEDICAL_BILLS',
  ManagingMoney: 'MANAGING_MONEY',
  ManagingYourMortgage: 'MANAGING_YOUR_MORTGAGE',
  MedicalCosts: 'MEDICAL_COSTS',
  Money: 'MONEY',
  MoneyMarketAccounts: 'MONEY_MARKET_ACCOUNTS',
  MoneyTransfer: 'MONEY_TRANSFER',
  Mortgages: 'MORTGAGES',
  MortgageProcess: 'MORTGAGE_PROCESS',
  MortgageRates: 'MORTGAGE_RATES',
  MyNerdwallet: 'MY_NERDWALLET',
  OtherRetirementAccounts: 'OTHER_RETIREMENT_ACCOUNTS',
  OtherVehicleInsurance: 'OTHER_VEHICLE_INSURANCE',
  PaydayLoans: 'PAYDAY_LOANS',
  PayingOffDebt: 'PAYING_OFF_DEBT',
  Pensions: 'PENSIONS',
  PersonalFinance: 'PERSONAL_FINANCE',
  PersonalLoans: 'PERSONAL_LOANS',
  PersonalLoansReviews: 'PERSONAL_LOANS_REVIEWS',
  PersonalTaxes: 'PERSONAL_TAXES',
  PetInsurance: 'PET_INSURANCE',
  PrepaidDebitCards: 'PREPAID_DEBIT_CARDS',
  ProductComparisons: 'PRODUCT_COMPARISONS',
  Promos: 'PROMOS',
  PropertyTaxes: 'PROPERTY_TAXES',
  RefinanceAutoLoans: 'REFINANCE_AUTO_LOANS',
  RentersInsurance: 'RENTERS_INSURANCE',
  Retirement_401K: 'RETIREMENT_401K',
  RetirementIncome: 'RETIREMENT_INCOME',
  RetirementPlanning: 'RETIREMENT_PLANNING',
  RewardsCreditCards: 'REWARDS_CREDIT_CARDS',
  RewardOptimization: 'REWARD_OPTIMIZATION',
  RothIra: 'ROTH_IRA',
  RunningYourBusiness: 'RUNNING_YOUR_BUSINESS',
  SavingsAccounts: 'SAVINGS_ACCOUNTS',
  SellingYourHome: 'SELLING_YOUR_HOME',
  Shopping: 'SHOPPING',
  ShoppingNews: 'SHOPPING_NEWS',
  ShoppingTips: 'SHOPPING_TIPS',
  SmallBusiness: 'SMALL_BUSINESS',
  SmallBusinessLegal: 'SMALL_BUSINESS_LEGAL',
  SmallBusinessLoans: 'SMALL_BUSINESS_LOANS',
  SmallBusinessTaxes: 'SMALL_BUSINESS_TAXES',
  SocialSecurity: 'SOCIAL_SECURITY',
  StartingABusiness: 'STARTING_A_BUSINESS',
  StoreSavingsGuide: 'STORE_SAVINGS_GUIDE',
  StudentCreditCards: 'STUDENT_CREDIT_CARDS',
  StudentLoans: 'STUDENT_LOANS',
  Studies: 'STUDIES',
  Taxes: 'TAXES',
  Travel: 'TRAVEL',
  TravelCreditCards: 'TRAVEL_CREDIT_CARDS',
  TravelDeals: 'TRAVEL_DEALS',
  TravelInsurance: 'TRAVEL_INSURANCE',
  Utilities: 'UTILITIES',
  VacationAndTripPlanning: 'VACATION_AND_TRIP_PLANNING',
} as const;

export type ContentCategory =
  (typeof ContentCategory)[keyof typeof ContentCategory];
/** Type modeling the data within the faqs group of fields on the Article type. */
export type ContentFaq = {
  __typename?: 'ContentFaq';
  /** The FAQ Answer. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The FAQ Question. */
  question?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHub = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithFeaturedImageInterface &
  PostWithHubLinks &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'ContentHub';
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the ContentHub object. */
    categories?: Maybe<Array<Category>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** Collection of related Sub Hubs. */
    hubLinks?: Maybe<Array<ContentHub>>;
    /** Whether this is a Topic hub or Category hub. */
    hubType?: Maybe<ContentHubHubTypeEnum>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The ContentHub object for the parent of this entity. */
    parent?: Maybe<ContentHub>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Returns 'link' from the Hub. */
    url: Scalars['URL'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentHubConnectionResponse = {
  __typename?: 'ContentHubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentHub returned for the connection. */
  items?: Maybe<Array<ContentHub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of ContentHub objects. */
export type ContentHubFilterInput = {
  /** Limit collection to ContentHubs published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentHubs within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to ContentHubs with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to ContentHubs with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for hubType field on ContentHub type. */
export const ContentHubHubTypeEnum = {
  Category: 'CATEGORY',
  Topic: 'TOPIC',
} as const;

export type ContentHubHubTypeEnum =
  (typeof ContentHubHubTypeEnum)[keyof typeof ContentHubHubTypeEnum];
export type ContentHubPage = StructuredContentPageInterface & {
  __typename?: 'ContentHubPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPack = PostInterface &
  PostWithAuthorsInterface &
  PostWithTitleInterface & {
    __typename?: 'ContentPack';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the ContentPack object. */
    categories?: Maybe<Array<Category>>;
    /** The curation type for this Content Pack. */
    curationType?: Maybe<ContentPackCurationTypeEnum>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The heading for this Content Pack. */
    heading?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The content to display for this Content Pack. */
    items?: Maybe<Array<ContentPackItemsUnion>>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The display type to use for this Content Pack. */
    listDisplayType?: Maybe<ContentPackListDisplayTypeEnum>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The subtitle to display for this Content Pack. */
    subtitle?: Maybe<Scalars['String']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentPackConnectionResponse = {
  __typename?: 'ContentPackConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentPack returned for the connection. */
  items?: Maybe<Array<ContentPack>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for curationType field on ContentPack type. */
export const ContentPackCurationTypeEnum = {
  Default: 'DEFAULT',
  Manual: 'MANUAL',
  MobileContentRecs: 'MOBILE_CONTENT_RECS',
} as const;

export type ContentPackCurationTypeEnum =
  (typeof ContentPackCurationTypeEnum)[keyof typeof ContentPackCurationTypeEnum];
/** Query to fetch a collection of ContentPack objects. */
export type ContentPackFilterInput = {
  /** Limit collection to ContentPacks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentPacks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to ContentPacks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** The union containing the Type members that can be returned by the items field on the ContentPack type. */
export type ContentPackItemsUnion =
  | Article
  | ContentHub
  | Hub
  | LandingPage
  | Page
  | Post
  | Review
  | Roundup;

/** Enum values for listDisplayType field on ContentPack type. */
export const ContentPackListDisplayTypeEnum = {
  Card: 'CARD',
  Carousel: 'CAROUSEL',
  Default: 'DEFAULT',
} as const;

export type ContentPackListDisplayTypeEnum =
  (typeof ContentPackListDisplayTypeEnum)[keyof typeof ContentPackListDisplayTypeEnum];
/** Contains a content pack and its meta data */
export type ContentPackPlacement = {
  __typename?: 'ContentPackPlacement';
  /** A single content pack and its associated data */
  contentPack: ContentPack;
  /** The list of model execution IDs used in personalized/fallback content packs */
  modelExecutionIds?: Maybe<Array<Scalars['String']>>;
};

export type ContentPackResponse = {
  __typename?: 'ContentPackResponse';
  /** The list of content packs returned by the query */
  contentPackPlacements?: Maybe<Array<ContentPackPlacement>>;
};

export type ContentPacksOptionsInput = {
  /** If specified, returns either personalized content pack or interest-based content pack */
  includePersonalizedContentPack?: InputMaybe<Scalars['Boolean']>;
};

/** Common interface containing fields to display within the ContentPageHeader component. */
export type ContentPageHeaderInterface = {
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType?: Maybe<Scalars['String']>;
  authors?: Maybe<Array<Author>>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  primaryCategory?: Maybe<Category>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean'];
  title?: Maybe<Scalars['String']>;
};

export type ContentRecommendations = {
  __typename?: 'ContentRecommendations';
  personalised?: Maybe<Array<PostInterface>>;
  popular?: Maybe<Array<PostInterface>>;
  trending?: Maybe<Array<PostInterface>>;
};

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewer = PostInterface &
  PostWithAuthorsInterface &
  PostWithContactInfoInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface &
  PostWithUserInfoInterface & {
    __typename?: 'ContentReviewer';
    /** Organizations this Reviewer is an alumni of. */
    alumniOf?: Maybe<Array<Scalars['String']>>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** Description for this Reviewer. */
    description?: Maybe<Scalars['String']>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The email address for the Reviewer. */
    emailAddress?: Maybe<Scalars['EmailAddress']>;
    /** KnowsAbout schema data value for this Reviewer. */
    experience?: Maybe<Scalars['String']>;
    /** The facebook link for the Reviewer. */
    facebookLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The full name of the content reviewer. This isn't currently implemented, but is needed for PostWithUserInfoInterface. */
    fullName?: Maybe<Scalars['String']>;
    /** Honorific suffix for this Reviewer. */
    honorificSuffix?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Job title for this Reviewer. */
    jobTitle?: Maybe<Scalars['String']>;
    /**
     * DEPRECATED: Field containing the information that the content reviewer knows about.
     * @deprecated Use the 'experience' field instead.
     */
    knowsAbout?: Maybe<Scalars['String']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The facebook link for the Reviewer. */
    linkedinLink?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Name for this Reviewer. */
    name?: Maybe<Scalars['String']>;
    /** SameAs schema data value for this Reviewer. */
    sameAs?: Maybe<Scalars['URL']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The social media links for the content reviewer */
    socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The twitter link for the Reviewer. */
    twitterLink?: Maybe<Scalars['URL']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentReviewerConnectionResponse = {
  __typename?: 'ContentReviewerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentReviewer returned for the connection. */
  items?: Maybe<Array<ContentReviewer>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of ContentReviewer objects. */
export type ContentReviewerFilterInput = {
  /** Limit collection to ContentReviewers published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Input args to filter collections of content search results. */
export type ContentSearchFilterInput = {
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Articles published OR edited by user */
  authorOrEditor?: InputMaybe<Scalars['Int']>;
  /** Limit collection to search results within a specific Category. This field accepts an array of integer IDs or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to search results within specific content types. */
  contentTypes?: InputMaybe<Array<PostTypeEnum>>;
  /** Limit collection to search results with or without specific IDs. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Whether to return only content marked as news content. NOTE: Using this field means only articles will be returned. */
  onlyNews?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit result set to content containing a particular string of text. It should be noted that using this input field will cause a cache miss in the WP API and SHOULD NOT BE USED FOR CONSUMER FACING EXPERIENCES! */
  searchText?: InputMaybe<Scalars['String']>;
};

export type ContentSearchInput = {
  /** A set of content categories to match against */
  categories?: InputMaybe<Array<ContentCategory>>;
  /** The "format" of the content requested */
  contentTypes?: InputMaybe<Array<ContentType>>;
  /** A flag to include highlights - a snippet of copy */
  includeHighlights?: InputMaybe<Scalars['Boolean']>;
  /**
   * The WP Post type is not used to build query params but is used to filter content for requested post types, post-search
   *
   * This filters on nw_page.content_type, which maps to nw_content_type from the WP API
   * possible values include 'article', 'roundup', 'review' (supported here)
   * and 'calculator', 'marketplace', 'product_detail', & 'tool' (not yet supported)
   */
  postTypes?: InputMaybe<Array<PostType>>;
  /** A search string to find related content */
  query?: InputMaybe<Scalars['String']>;
  /** A map of content attributes to relative importance in weighing search result relevancy */
  queryFieldWeights?: InputMaybe<ContentSearchQueryFieldsWeightsInput>;
};

/**
 * Each available field carries a weight of 1 relative to it's counterparts. You can weigh certain attributes more than others
 * by supplying a weight. For example, a weight of 'Y' is Y times as important as another specified attribute
 */
export type ContentSearchQueryFieldsWeightsInput = {
  /** Weigh search results against author names */
  authorNames?: InputMaybe<Scalars['Int']>;
  /** Weight search results against category names */
  categoryNames?: InputMaybe<Scalars['Int']>;
  /** Weigh search results aginst the sanitized content */
  contentSanitized?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the content type */
  contentType?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the link URL */
  link?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the tag names */
  tagNames?: InputMaybe<Scalars['Int']>;
  /** Weigh search results against the sanitized title */
  titleSanitized?: InputMaybe<Scalars['Int']>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResult = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'ContentSearchResult';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The legacy synopsis field for a search result. Once we support structured content for the synopsis field we will return a structured content document. */
    legacySynopsis?: Maybe<Scalars['String']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The primary category object for the resource. */
    primaryCategory?: Maybe<Category>;
    /** The reviewers that this Article has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The synopsis of a search result. */
    synopsis?: Maybe<Scalars['StructuredContentDocument']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentSearchResultConnectionResponse = {
  __typename?: 'ContentSearchResultConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentSearchResult returned for the connection. */
  items?: Maybe<Array<ContentSearchResult>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

export const ContentSortDirection = {
  /** Sort posts in chronological order across all N search queries */
  Earliest: 'EARLIEST',
  /** Sort posts in reverse chronological order across all N search queries */
  MostRecent: 'MOST_RECENT',
} as const;

export type ContentSortDirection =
  (typeof ContentSortDirection)[keyof typeof ContentSortDirection];
export const ContentType = {
  Article: 'ARTICLE',
  Review: 'REVIEW',
  Roundup: 'ROUNDUP',
} as const;

export type ContentType = (typeof ContentType)[keyof typeof ContentType];
/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPage = PostInterface &
  PostWithAuthorsInterface &
  PostWithContactInfoInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface &
  PostWithUserInfoInterface & {
    __typename?: 'ContentUserPage';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** Awards for the user featured on this User Page. */
    awards?: Maybe<Array<Scalars['String']>>;
    /** Bio for this User Page. */
    bio?: Maybe<Scalars['StructuredContentDocument']>;
    /** Content picks to display on this User Page. */
    contentPicks?: Maybe<Array<ContentUserPageContentPicksUnion>>;
    /** Credentials for the user featured on this User Page. */
    credentials?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Education for the user featured on this User Page. */
    education?: Maybe<Array<Scalars['String']>>;
    /** The users's previous experience. */
    experience?: Maybe<Scalars['String']>;
    /** Expertise for the user featured on this User Page. */
    expertise?: Maybe<Array<Scalars['String']>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** First name for the user featured on this User Page. */
    firstName?: Maybe<Scalars['String']>;
    /** Full name for the user featured on this User Page. */
    fullName?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Job title for this User Page. */
    jobTitle?: Maybe<Scalars['String']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Organizations for the user featured on this User Page. */
    organizations?: Maybe<Array<Scalars['String']>>;
    /** Other publications for the user featured on this User Page. */
    otherPublications?: Maybe<Array<Scalars['String']>>;
    /** Page type for this User Page. */
    pageType?: Maybe<ContentUserPagePageTypeEnum>;
    /** Previous experience for the user featured on this User Page. */
    previousExperience?: Maybe<Array<Scalars['String']>>;
    /** A collection of articles, podcasts, and/or TV clips to display on this User Page. */
    quotesAndInterviews?: Maybe<Array<ContentUserPageQuotesAndInterview>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The social media links to display on the author/editor page. */
    socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** User represented by this User Page. */
    user?: Maybe<Author>;
    /** Field connecting to the UserPageVideo Type and all of its nested fields. */
    video?: Maybe<UserPageVideo>;
  };

/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentUserPageConnectionResponse = {
  __typename?: 'ContentUserPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The ContentUserPage returned for the connection. */
  items?: Maybe<Array<ContentUserPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** The union containing the Type members that can be returned by the contentPicks field on the ContentUserPage type. */
export type ContentUserPageContentPicksUnion =
  | Article
  | ContentHub
  | Hub
  | LandingPage
  | Page
  | Post
  | Review
  | Roundup;

/** Query to fetch a collection of ContentUserPage objects. */
export type ContentUserPageFilterInput = {
  /** Limit collection to ContentUserPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for pageType field on ContentUserPage type. */
export const ContentUserPagePageTypeEnum = {
  Author: 'AUTHOR',
  Editor: 'EDITOR',
} as const;

export type ContentUserPagePageTypeEnum =
  (typeof ContentUserPagePageTypeEnum)[keyof typeof ContentUserPagePageTypeEnum];
/** Type modeling the data within the quotesAndInterviews group of fields on the ContentUserPage type. */
export type ContentUserPageQuotesAndInterview = {
  __typename?: 'ContentUserPageQuotesAndInterview';
  /** Publication name for this quote/interview. */
  name?: Maybe<Scalars['String']>;
  /** Publication title for this quote/interview. */
  title?: Maybe<Scalars['String']>;
  /** URL for this quote/interview. */
  url?: Maybe<Scalars['URL']>;
};

/**
 * The `Cookie` type represents a cookie, with all the standard cookie properties.
 * See https://tools.ietf.org/html/rfc6265
 */
export type Cookie = {
  __typename?: 'Cookie';
  domain?: Maybe<Scalars['String']>;
  expires?: Maybe<Scalars['String']>;
  /**
   * A Set-Cookie header literal representing the Cookie
   *
   * Example: 'AWSALB=n2EKrJVwfmU1FJ0KMGnRY01LfTmkFJmLAF0dNjkuMoW/V7QPwdDatoDKrmzTjDP7j1fO7VTyl/MXjp8Tljq3yM8nmTs9HsSUcZi0f2ik77H9chfNR86RX2ud7zMl; Expires=Fri, 29 Mar 2019 18:47:06 GMT; Path=/'
   */
  headerString: Scalars['String'];
  httpOnly?: Maybe<Scalars['Boolean']>;
  maxAge?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  path?: Maybe<Scalars['String']>;
  secure?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type CreateManualTransactionAccountResponse = {
  __typename?: 'CreateManualTransactionAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreateMoneyTransferAccountResponse = {
  __typename?: 'CreateMoneyTransferAccountResponse';
  account: MoneyTransferAccount;
};

export type CreateMoneyTransferResponse = {
  __typename?: 'CreateMoneyTransferResponse';
  transfer: MoneyTransferTransfer;
};

export type CreateUserFinancialAccountResponse = {
  __typename?: 'CreateUserFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreditBoosterDataVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'CreditBoosterDataVisualization';
    /** User's credit score info dating back to a week */
    creditScoreChangeInfo: CreditScoreChangeInfo;
    /** This will always be CREDIT_BOOSTER */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  };

export type CreditCardApprovalOddsPrediction = {
  __typename?: 'CreditCardApprovalOddsPrediction';
  /** A user's likelihood of being approved for a credit card as a decimal value. */
  approvalOdds?: Maybe<Scalars['Float']>;
  /**
   * The ID of the credit card that the approval odds have been calculated for. This ID
   * corresponds to a CreditCardOfferV2's legacyId field.
   */
  id: Scalars['String'];
};

export type CreditCardApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardApprovalOddsPredictionResponse';
  predictions: Array<CreditCardApprovalOddsPrediction>;
};

/** Credit Card Institutions */
export type CreditCardInstitution = InstitutionInterface & {
  __typename?: 'CreditCardInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The persisted set of answers that the user submitted in the Credit Card Match quiz flow. */
export type CreditCardMatchQuizAnswersResponse = {
  __typename?: 'CreditCardMatchQuizAnswersResponse';
  answers?: Maybe<Scalars['JSON']>;
  quizVersion: Scalars['Int'];
};

export type CreditCardMatchQuizOffersResponse = {
  __typename?: 'CreditCardMatchQuizOffersResponse';
  fallbackOffers: Array<Maybe<CreditCardsOfferV2>>;
  offers: Array<Maybe<CreditCardsOfferV2>>;
  userCardOffers: Array<Maybe<CreditCardsOfferV2>>;
};

/** Credit card offer */
export type CreditCardOffer = OfferInterface & {
  __typename?: 'CreditCardOffer';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  derivedDetails?: Maybe<CreditCardOfferDerivedDetails>;
  details: CreditCardOfferDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institution: CreditCardInstitution;
  name: Scalars['String'];
  product?: Maybe<CreditCardProduct>;
  productType: Scalars['String'];
  /**
   * All active related card offers, must query for relatedCardIds in the parent details, and status in relatedCardOffers
   * For example
   *   creditCardOffer {
   *     details {
   *       relatedCardIds
   *     }
   *     relatedCardOffers {
   *       status
   *     }
   *   }
   */
  relatedCreditCardOffers?: Maybe<Array<CreditCardOffer>>;
  startsAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type CreditCardOfferBundlesResponse = {
  __typename?: 'CreditCardOfferBundlesResponse';
  bundles: Array<CreditCardRecommendationBundle>;
};

/** The derived detail section of a credit card offer */
export type CreditCardOfferDerivedDetails = {
  __typename?: 'CreditCardOfferDerivedDetails';
  /** Link to apply for a credit card offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** The likelihood of approval for the card based on the user's credit score bucket */
  approvalLikelihood?: Maybe<Scalars['Float']>;
  /** The monetary valuation (in cents) per reward point */
  rewardCentsPerUnit?: Maybe<Scalars['Float']>;
  /** The monetary valuation (in cents) per reward point in string format */
  rewardCentsPerUnitString?: Maybe<Scalars['String']>;
  /** Interstitial redirect terms and fees link */
  termsFeesRedirectLink?: Maybe<Scalars['URL']>;
};

/** The details section of a credit card offer */
export type CreditCardOfferDetails = {
  __typename?: 'CreditCardOfferDetails';
  /** The annual fee for the card */
  annualFee?: Maybe<Scalars['Float']>;
  /** The display string for annual fee */
  annualFeeDetails?: Maybe<Scalars['String']>;
  /** Phone number for some issuers that allow calling to apply */
  applyPayPerCall?: Maybe<Scalars['String']>;
  /**
   * The likelihood of approval for the card based on the user's credit score bucket
   * @deprecated Use `derivedDetails.approvalLikelihood`
   */
  approvalOdds?: Maybe<Scalars['Float']>;
  /** The maximum APR */
  aprMax?: Maybe<Scalars['Float']>;
  /** The minimum APR */
  aprMin?: Maybe<Scalars['Float']>;
  /** The balance transfer fee as a percentage of the transfer amount */
  balanceTransferFee?: Maybe<Scalars['Float']>;
  /** A more detailed description of balance transfer */
  balanceTransferFeeDescription?: Maybe<Scalars['String']>;
  /** The term of 'balanceTransferIntroApr', in months */
  balanceTransferInfoTime?: Maybe<Scalars['Int']>;
  /** The balance transfer APR */
  balanceTransferIntroApr?: Maybe<Scalars['Float']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  /** The display string for the unit the billing cycle is calculated in (e.g. "months") */
  billingCycleUnits?: Maybe<Scalars['String']>;
  /** A list of negative attributes about the card */
  consBullets?: Maybe<Array<Scalars['String']>>;
  /** Custom details like 'credit cards great for:...' */
  customDetailsList?: Maybe<Array<Scalars['String']>>;
  /** The foreign transaction fee as a percentage of the transaction  amount */
  foreignTransactionFee?: Maybe<Scalars['Float']>;
  /** URL of card image */
  imageSource?: Maybe<Scalars['String']>;
  /** URL of card image (larger format) */
  imageSourceLarge?: Maybe<Scalars['String']>;
  /** URL of card image (medium format) */
  imageSourceMedium?: Maybe<Scalars['String']>;
  /** Boolean flag indicating whether or not an offer is monetizing (revenue generating partnership) */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The card issuer's information page on their domain */
  issuerInfoUrl?: Maybe<Scalars['URL']>;
  legacyId: Scalars['Int'];
  /** A list of marketing strings about the card */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Marketing strings with terms and fees link removed from list */
  marketingBulletsWithoutTermsFeesLink?: Maybe<Array<Scalars['String']>>;
  /** The maximum FICO recommended for approval */
  maxFico?: Maybe<Scalars['Int']>;
  /** The minimum recommended FICO for approval */
  minFico?: Maybe<Scalars['Int']>;
  /** The regular APR rate after the intro APR offer expires */
  ongoingApr?: Maybe<Scalars['String']>;
  /** List of perks this credit card has */
  perks?: Maybe<Array<Scalars['String']>>;
  /** The program name */
  programName?: Maybe<Scalars['String']>;
  /** A list of positive attributes of the card */
  prosBullets?: Maybe<Array<Scalars['String']>>;
  /** User-friendly string representing the range of 'aprMin' - 'aprMax' */
  purchaseApr?: Maybe<Scalars['String']>;
  /** The introductory purchase APR for new card owners */
  purchaseIntroApr?: Maybe<Scalars['Float']>;
  /** The introductory length of the intro purchase APR in months (maps from purchase_intro_time) */
  purchaseIntroTerm?: Maybe<Scalars['Int']>;
  /** NerdWallet review star rating */
  rating?: Maybe<Scalars['Float']>;
  /** Cards related to this offer */
  relatedCardIds?: Maybe<Array<Scalars['Int']>>;
  /** URL to articles with related content to this card */
  relatedContent?: Maybe<Array<Scalars['String']>>;
  rewardCategoriesBestRates?: Maybe<Array<CreditCardOfferRewardCategories>>;
  /** More in depth detailed notes about the credit card offer */
  rewardRateNotes?: Maybe<Scalars['String']>;
  /** Type of reward units earned by this offer */
  rewardType?: Maybe<CreditCardOfferRewardType>;
  slug?: Maybe<Scalars['String']>;
  /** A link to the card's terms and fees, if applicable */
  termsFeesLink?: Maybe<Scalars['URL']>;
  /** Offer version id */
  versionId?: Maybe<Scalars['Int']>;
};

export type CreditCardOfferIdsWithApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardOfferIdsWithApprovalOddsPredictionResponse';
  offerIds: Array<Scalars['Int']>;
};

/** Breakdown of bonus categories for this credit card offer */
export type CreditCardOfferRewardCategories = {
  __typename?: 'CreditCardOfferRewardCategories';
  category: CreditCardOfferRewardCategoryType;
  rate: Scalars['Float'];
};

export type CreditCardOfferRewardCategoryRates = {
  __typename?: 'CreditCardOfferRewardCategoryRates';
  dining: Scalars['Float'];
  entertainment: Scalars['Float'];
  gas: Scalars['Float'];
  groceries: Scalars['Float'];
  shopping: Scalars['Float'];
  travel: Scalars['Float'];
};

/**
 * Bonus categories of credit card offers
 * https://finproservices.nerdwallet.biz/flask_admin/rewardcategory/
 */
export const CreditCardOfferRewardCategoryType = {
  Airfare: 'AIRFARE',
  All: 'ALL',
  Bookstores: 'BOOKSTORES',
  Business: 'BUSINESS',
  CarRental: 'CAR_RENTAL',
  CarWashes: 'CAR_WASHES',
  Charity: 'CHARITY',
  Dining: 'DINING',
  Discount: 'DISCOUNT',
  Drugstores: 'DRUGSTORES',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  HomeImprove: 'HOME_IMPROVE',
  Hotel: 'HOTEL',
  Lodging: 'LODGING',
  Movies: 'MOVIES',
  Office: 'OFFICE',
  Other: 'OTHER',
  Overall: 'OVERALL',
  Parking: 'PARKING',
  Playstation: 'PLAYSTATION',
  RentalCars: 'RENTAL_CARS',
  Telecom: 'TELECOM',
  Travel: 'TRAVEL',
  Utilities: 'UTILITIES',
  Wireless: 'WIRELESS',
} as const;

export type CreditCardOfferRewardCategoryType =
  (typeof CreditCardOfferRewardCategoryType)[keyof typeof CreditCardOfferRewardCategoryType];
/** Type of rewards this credit card offer gives */
export const CreditCardOfferRewardType = {
  Cash: 'CASH',
  Miles: 'MILES',
  NoRewards: 'NO_REWARDS',
  Points: 'POINTS',
} as const;

export type CreditCardOfferRewardType =
  (typeof CreditCardOfferRewardType)[keyof typeof CreditCardOfferRewardType];
/** Query variables for the credit card offers query */
export type CreditCardOffersParameters = {
  categorySpend?: InputMaybe<CreditCardOffersParametersCategorySpend>;
  debtPayment?: InputMaybe<Scalars['Int']>;
  existingCardApr?: InputMaybe<Scalars['Float']>;
  ficoScore?: InputMaybe<Scalars['Int']>;
  numberOfMonths?: InputMaybe<Scalars['Int']>;
  totalDebt?: InputMaybe<Scalars['Int']>;
};

/** Input parameters for credit card offers marketplace queries */
export type CreditCardOffersParametersCategorySpend = {
  dining?: InputMaybe<Scalars['Int']>;
  gas?: InputMaybe<Scalars['Int']>;
  groceries?: InputMaybe<Scalars['Int']>;
  office?: InputMaybe<Scalars['Int']>;
  other?: InputMaybe<Scalars['Int']>;
  travel?: InputMaybe<Scalars['Int']>;
};

/** The response from a credit card offer query. */
export type CreditCardOffersResponse = {
  __typename?: 'CreditCardOffersResponse';
  offers: Array<CreditCardOffer>;
  offset: Scalars['Int'];
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
};

/** The response from a credit card offer query. */
export type CreditCardOffersV2Response = {
  __typename?: 'CreditCardOffersV2Response';
  offers: Array<CreditCardsOfferV2>;
};

/**
 * Since there are overlapping fields across the cc-prequal and personal-loans-prequal
 * services, the inputs are split into 3 different parts for better code reusability.
 */
export type CreditCardPrequalInput = {
  /** Agrees to terms of service */
  agreeToTos: Scalars['Boolean'];
  city?: InputMaybe<Scalars['String']>;
  /** User's date of birth in MM/DD/YYYY format */
  dateOfBirth: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  /** Credit card issuers they would like to see offers from */
  issuers: Array<CreditCardPrequalIssuersEnum>;
  /** Last four digits of user's SSN */
  lastFour: Scalars['String'];
  lastName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddressLine2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

/** Enums for issuers. */
export const CreditCardPrequalIssuersEnum = {
  AmericanExpress: 'AMERICAN_EXPRESS',
  CapitalOne: 'CAPITAL_ONE',
  Chase: 'CHASE',
} as const;

export type CreditCardPrequalIssuersEnum =
  (typeof CreditCardPrequalIssuersEnum)[keyof typeof CreditCardPrequalIssuersEnum];
/** This creates the schema for a singular credit card/offer and refers to the response JSON. */
export type CreditCardPrequalOffer = {
  __typename?: 'CreditCardPrequalOffer';
  /** Apply now URL */
  applyNowUrl: Scalars['URL'];
  /** Balance transfer intro APR */
  balanceTransferIntroApr?: Maybe<Scalars['String']>;
  /** Balance transfer APR */
  balanceTransferRegApr?: Maybe<Scalars['String']>;
  /** The card's image details */
  cardImageDetails: CardImageDetails;
  /**
   * cc-prequal-service receives a lot of the necessary fields from marketplace, which is passed
   * into the CreditCardOffer type. The remaining fields above are from the actual cc-prequal-service
   */
  creditCardOffer: CreditCardOffer;
  /** Indicates if prescreen or prequal offer */
  isPrescreen: Scalars['Boolean'];
  /** Marketing bullets are used for bonus offer and additional info */
  marketingBullets?: Maybe<Array<Scalars['String']>>;
  /** Purchase introduction APR */
  purchaseIntroductionApr?: Maybe<Scalars['String']>;
  /** Purchase APR */
  purchaseRegularApr?: Maybe<Scalars['String']>;
  /** Issuer card identifier */
  sourceCode: Scalars['String'];
};

export type CreditCardPrequalOffersResponse = {
  __typename?: 'CreditCardPrequalOffersResponse';
  offers?: Maybe<Array<CreditCardPrequalOffer>>;
  /** In order to have working apply now links, we need to set the X-PREQUAL-COOKIE-ID cookie */
  prequalCookieId: Scalars['String'];
};

/** Credit Card Product */
export type CreditCardProduct = ProductInterface & {
  __typename?: 'CreditCardProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The `CreditCardRecommendationBundle` represents one recommendation bundle from recommendationServiceApi. */
export type CreditCardRecommendationBundle = {
  __typename?: 'CreditCardRecommendationBundle';
  creditCardOffers?: Maybe<Array<CreditCardOffer>>;
  details?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  primaryAction?: Maybe<AppAction>;
  teaser?: Maybe<Scalars['String']>;
  trackingId?: Maybe<Scalars['String']>;
};

export type CreditCardsCreditScoreComparisonContent = {
  __typename?: 'CreditCardsCreditScoreComparisonContent';
  /** The difference in points from the credit score to the offer preferred score and then padded with the 'points' or 'point' suffix. E.g. 1 point, 10 points */
  pointDifference: Scalars['String'];
  /** The label used to indicate to the user how relative their score is to the offer's preferred score. */
  relativeScoreLabel: Scalars['String'];
  /** The score used to compare. */
  scoreToCompare: Scalars['Int'];
};

/** A Credit Cards institution */
export type CreditCardsInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'CreditCardsInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Credit Cards offer */
export type CreditCardsOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'CreditCardsOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Numeric value of a product's annual fee. */
    annualFee?: Maybe<Scalars['Float']>;
    /** Stylized version of annual fee + annual_fee_first_year. ex. '$0*' or '$0 intro first year, then $95' */
    annualFeeDetails?: Maybe<Scalars['String']>;
    /** Numeric value of the product's first year annual fee. This should match annual_fee if the card doesn't have a special fee in the first year. */
    annualFeeFirstYear?: Maybe<Scalars['Float']>;
    /** The offer_url or issuer_info_page_url for this cc offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** The approval calculation for logged in members. */
    approvalLikelihood?: Maybe<Scalars['Float']>;
    /** Powers the shortcodes Content uses to discuss Intro Apr:  ex. '0% intro APR on Purchases for 15 months, and then the ongoing APR of 14.99% - 23.74% Variable APR' */
    aprIntroMessage?: Maybe<Scalars['String']>;
    /** Displays short version of intro text. Usually under 'Intro APR' field on Card Details and Product Cards */
    aprIntroMessageList?: Maybe<Array<Scalars['String']>>;
    /** Numeric value for high end of APR range. ex. '23.74' */
    aprMax?: Maybe<Scalars['Float']>;
    /** Numeric value for low end of APR range. ex. '14.99' */
    aprMin?: Maybe<Scalars['Float']>;
    /** Used to display greater details of a balance transfer fee. ex. 'Either $5 or 5% of the amount of each transfer, whichever is greater.' */
    balanceTransferFeeDescription?: Maybe<Scalars['String']>;
    /** Numeric value for the number of months the intro APR applies to a balance transfer */
    balanceTransferIntroTime?: Maybe<Scalars['Int']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** Categorizes cards and makes them eligible to show up in different site features, like site search, and compare marketplace. */
    compareCategories?: Maybe<Array<Scalars['String']>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The credit score comparison content used to display to the user information regarding how close the user is to the preferred offer score. */
    creditScoreComparisonContent?: Maybe<CreditCardsCreditScoreComparisonContent>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** Populates the 'great for' text on Marketplace Landing Pages. ex. 'Great for: Airline Miles and a Large Bonus' */
    customDetailsList?: Maybe<Array<Scalars['String']>>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver annual fee associated with the entity */
    driverAnnualFee?: Maybe<EntityPlacementDriver>;
    /** The driver balance transfer fee description associated with the entity */
    driverBalanceTransferFeeDescription?: Maybe<EntityPlacementDriver>;
    /** The driver bonus associated with the entity */
    driverBonus?: Maybe<EntityPlacementDriver>;
    /** The driver foreign transaction fee associated with the entity */
    driverForeignTransactionFee?: Maybe<EntityPlacementDriver>;
    /** The driver intro APR associated with the entity */
    driverIntroApr?: Maybe<EntityPlacementDriver>;
    /** The driver intro offer associated with the entity */
    driverIntroOffer?: Maybe<EntityPlacementDriver>;
    /** The driver minimum deposit associated with the entity */
    driverMinimumDeposit?: Maybe<EntityPlacementDriver>;
    /** The driver regular APR associated with the entity */
    driverRegularApr?: Maybe<EntityPlacementDriver>;
    /** The driver reward rate associated with the entity */
    driverRewardRate?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** Stylized version of foreign transaction fee ex. '0%' or '3% of each transaction in U.S. dollars' */
    foreignTransactionFeeDescription?: Maybe<Scalars['String']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Used to store product details page on issuer site. Particularly when that page is hard to locate. */
    issuerInfoPageUrl?: Maybe<Scalars['String']>;
    /** The late payment fee in dollars. */
    latePaymentFee?: Maybe<Scalars['Int']>;
    /** The late payment fee as as a string as provided by the partner. */
    latePaymentFeeDescription?: Maybe<Scalars['String']>;
    /** Legacy ID used by some Credit Card specific components. */
    legacyId?: Maybe<Scalars['Int']>;
    /** More information about the product. Appears under 'Card Details' or 'Product Details' depending on the experience. It does not include the 'See Rates and Fees' link when applicable. */
    marketingBullets?: Maybe<Array<Scalars['String']>>;
    /** Maximum reccommended FICO score */
    maxFico?: Maybe<Scalars['Int']>;
    /** Minimum reccommended FICO score */
    minFico?: Maybe<Scalars['Int']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Displays the range of the ongoing APR */
    ongoingApr?: Maybe<Scalars['String']>;
    /** A product's apply by phone telephone number, if applicable. Displays below the CTA on product cards, typically. */
    phoneNumber?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    /** Path for Prequal CTAs when applicable */
    prequalLink?: Maybe<Scalars['URL']>;
    /** Display text for Prequal CTA or Link */
    prequalLinkText?: Maybe<Scalars['String']>;
    product: CreditCardsProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** Numeric value for the number of months the intro APR applies to purchases */
    purchaseIntroTime?: Maybe<Scalars['Int']>;
    /** A secondary placement config CTA reserved for monetizing marketplace entities */
    ratesAndFeesCta?: Maybe<EntityPlacementCta>;
    /** The recommended credit score range text */
    recommendedCreditScoreRangeDetails?: Maybe<CreditCardsRecommendedCreditScoreRangeDetails>;
    /** Connection field to the review */
    review?: Maybe<MarketplaceEntityRelatedReviewUnion>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** Numeric value of the base reward rate of the product */
    rewardRate?: Maybe<Scalars['Float']>;
    /** String value of the rewards rate range for the product. ex. '1.5%-5%' */
    rewardRateDetails?: Maybe<Scalars['String']>;
    /** Full, detailed text of the rewards rates for the product. ex. 'Earn 5% cash back on grocery store purchases (not including Target® or Walmart® purchases) on up to $12,000 spent in the first year. Earn unlimited 1.5% cash back on all other purchases.' */
    rewardRateNotes?: Maybe<Scalars['String']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** Numeric value of the product's intro offer */
    signUpBonus?: Maybe<Scalars['Int']>;
    /** Please make sure the text in this field ends with a period. Description of terms to earn intro offer. ex. 'Earn a $200 Bonus after you spend $500 on purchases in your first 3 months from account opening.' */
    signUpBonusDetails?: Maybe<Scalars['String']>;
    /** Please make sure the text in this field ends with a period. Should match sign_up_bonus_details. Unless the product is from Discover and has a Match feature as an Intro Offer. */
    signUpBonusDetailsAnnotation?: Maybe<Scalars['String']>;
    /** The type of bonus received for signing up to this card. Can be different to the Reward bonus. */
    signUpBonusType?: Maybe<Scalars['String']>;
    /** Path to the product's card details page. Keep it simple, and avoid including payment network where possible. ex. 'chase-freedom-unlimited' or 'us-bank-altitude-go-card' */
    slug?: Maybe<Scalars['String']>;
    /** Numeric value of the rating Content has assigned the product */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Prefer this over terms_and_fees_link since this goes to interstitial-client. Link to a product's rates & fees. Should display Rates & fees on most product cards on the site. Marketing bullets require you to add the link directly there. */
    termsAndFeesLink?: Maybe<Scalars['URL']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Credit Cards product */
export type CreditCardsProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'CreditCardsProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: CreditCardsInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type CreditCardsRecommendedCreditScoreRangeDetails = {
  __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails';
  /** The recommended credit score range for the offer. */
  creditScoreRange?: Maybe<Scalars['String']>;
  /** The recommended credit score range description for the offer. */
  description?: Maybe<Scalars['String']>;
};

export type CreditCardsReviewPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsReviewPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

export type CreditCardsRoundupsPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsRoundupsPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

export type CreditFactor = {
  __typename?: 'CreditFactor';
  /** All common questions about this credit factor */
  commonQuestions?: Maybe<Array<CreditFactorCommonQuestion>>;
  /** Data about the core metric for this factor */
  coreMetric?: Maybe<CreditFactorCoreMetric>;
  /** The impact level of this factor on the user's credit score */
  impactLevel?: Maybe<CreditFactorImpactLevel>;
  /** All inquiry sections (only used in recentInquiries factor) */
  inquirySections?: Maybe<Array<CreditFactorInquirySection>>;
  /** A list of links to get more information about this factor */
  moreInfoLinks?: Maybe<Array<AppAction>>;
  /** The priority inquiry section (only used in recentInquiries factor) */
  priorityInquirySection?: Maybe<CreditFactorInquirySection>;
  /** The priority tradeline section (used in all factors other than recentInquiries) */
  priorityTradelineSection?: Maybe<CreditFactorTradelineSection>;
  /** The datetime the user's credit report was last pulled */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /** All tradeline sections (used in all factors other than recentInquiries) */
  tradelineSections?: Maybe<Array<CreditFactorTradelineSection>>;
};

export type CreditFactorCommonQuestion = {
  __typename?: 'CreditFactorCommonQuestion';
  /** The answer to the question, separated as paragraphs */
  answerParagraphs?: Maybe<Array<Scalars['String']>>;
  /** A unique identifier for this question */
  key?: Maybe<Scalars['String']>;
  /** An optional link to find out more (typically links to an article) */
  learnMoreLink?: Maybe<AppAction>;
  /** The question */
  question?: Maybe<Scalars['String']>;
};

export type CreditFactorCoreMetric = {
  __typename?: 'CreditFactorCoreMetric';
  /** The NerdWallet suggestion for the credit factor */
  commentary?: Maybe<Scalars['String']>;
  /** The tooltip description for the status of the credit factor */
  description?: Maybe<Scalars['String']>;
  /** The main headline figure for the core metric of the factor */
  displayName?: Maybe<Scalars['String']>;
  /** The label for the displayName */
  label?: Maybe<Scalars['String']>;
  /** An optional secondary value for some factors (for analytics purposes) */
  secondaryValue?: Maybe<Scalars['String']>;
  /** The primary value of the core metric (for analytics purposes) */
  value?: Maybe<Scalars['String']>;
};

export const CreditFactorImpactLevel = {
  High: 'HIGH',
  Highest: 'HIGHEST',
  Low: 'LOW',
  Medium: 'MEDIUM',
} as const;

export type CreditFactorImpactLevel =
  (typeof CreditFactorImpactLevel)[keyof typeof CreditFactorImpactLevel];
export type CreditFactorInquiry = {
  __typename?: 'CreditFactorInquiry';
  /** The bureau responsible for the inquiry */
  bureau?: Maybe<Scalars['String']>;
  /** A non-guaranteed unique identifier for this inquiry */
  compositeKey?: Maybe<Scalars['String']>;
  /** The industry the inquirer is in */
  industry?: Maybe<Scalars['String']>;
  /** The date of the inquiry */
  inquiredAt?: Maybe<Scalars['DateTime']>;
  /** The type of inquiry */
  inquiryType?: Maybe<Scalars['String']>;
  /** True if the inquiry has "fallen off" of the user's credit report: exists on their second-most-recent credit report, but not on their most recent credit report. */
  isNoLongerValid?: Maybe<Scalars['Boolean']>;
  /** The name of the creditor that made the inquiry */
  subscriberName?: Maybe<Scalars['String']>;
};

export type CreditFactorInquirySection = {
  __typename?: 'CreditFactorInquirySection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** The list of all inquiries on the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** True for groups of inquiries that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** The user-facing label describing the sentiment of the inquiry section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the inquiry section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The full length title for the section (only use in priority sections) */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
};

export const CreditFactorSentiment = {
  Negative: 'NEGATIVE',
  Positive: 'POSITIVE',
} as const;

export type CreditFactorSentiment =
  (typeof CreditFactorSentiment)[keyof typeof CreditFactorSentiment];
export type CreditFactorTip = {
  __typename?: 'CreditFactorTip';
  /** Condition for reporting the tip */
  condition?: Maybe<Scalars['String']>;
  /** Link to read more about the tip */
  cta?: Maybe<AppAction>;
  /** Reasons on why the tip may help */
  justification: Scalars['String'];
  /** Unique identifier */
  key: Scalars['String'];
  /** What to keep in mind */
  reminderParagraphs?: Maybe<Array<Scalars['String']>>;
  /** Steps on how to follow the tip */
  steps: Array<Scalars['String']>;
  /** The tip itself */
  title: Scalars['String'];
};

export type CreditFactorTips = {
  __typename?: 'CreditFactorTips';
  ageAndMixOfAccounts?: Maybe<Array<Maybe<CreditFactorTip>>>;
  balances?: Maybe<Array<Maybe<CreditFactorTip>>>;
  creditUtilization?: Maybe<Array<Maybe<CreditFactorTip>>>;
  paymentHistory?: Maybe<Array<Maybe<CreditFactorTip>>>;
  recentInquiries?: Maybe<Array<Maybe<CreditFactorTip>>>;
};

/** Metadata passed to analytics events */
export type CreditFactorTrackingMetadata = {
  __typename?: 'CreditFactorTrackingMetadata';
  /** The change in account status (used in the ageAndMixOfAccounts factor) */
  accountStatusChange?: Maybe<Scalars['String']>;
  /** The sentiment of the credit factor or "-" */
  highlightStatus?: Maybe<Scalars['String']>;
  /** The change in inquiry status (used in the recentInquiries factor) */
  inquiryStatusChange?: Maybe<Scalars['String']>;
  /** The derogatory payment type (optional) (used in the paymentHistory factor) */
  paymentDerogatoryType?: Maybe<Scalars['String']>;
  /** The change in payment status (used in the paymentHistory factor) */
  paymentStatusChange?: Maybe<Scalars['String']>;
  /** The current bucket of credit utilization, as defined by NW (used in the creditUtilization factor) */
  utilizationCurrentBucket?: Maybe<Scalars['String']>;
  /** The direction of change of credit utilization (used in the creditUtilization factor) */
  utilizationDirectionChange?: Maybe<Scalars['String']>;
};

export type CreditFactorTradeline = {
  __typename?: 'CreditFactorTradeline';
  /** The condition of the account */
  accountCondition?: Maybe<Scalars['String']>;
  /** The party responsible for the account (e.g. Individual) */
  accountDesignator?: Maybe<Scalars['String']>;
  accountDisplayType?: Maybe<Scalars['String']>;
  /** The last 4 digits on the account */
  accountNumberLast4?: Maybe<Scalars['String']>;
  /** The raw representation of the tradeline type */
  accountType?: Maybe<Scalars['String']>;
  /** The 1-character symbol for the account type */
  accountTypeSymbol?: Maybe<Scalars['String']>;
  /** The amount due on the due date */
  amountPastDue?: Maybe<Scalars['Float']>;
  /** A non-guaranteed unique identifier for this tradeline for this user */
  compositeKey?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  /** The user friendly name for the creditor */
  creditorDisplayName?: Maybe<Scalars['String']>;
  /** A URL for the logo of the creditor */
  creditorLogo?: Maybe<Scalars['String']>;
  /** The raw name of the creditor */
  creditorName?: Maybe<Scalars['String']>;
  /** The balance on the account */
  currentBalance?: Maybe<Scalars['Float']>;
  /** The date the account was opened */
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  /** The most recent date the account was reported */
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  /** The high balance on the account */
  highBalance?: Maybe<Scalars['Float']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  /** The monthly payment for the account */
  monthlyPayment?: Maybe<Scalars['Float']>;
  /** The normalized credit limit */
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  /** The number of months the account has been open */
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  /** The utilization on the account (decimal between 0 and 1) */
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  /** The open/closed symbol of the account */
  openClosedSymbol?: Maybe<CreditFactorTradelineOpenClosedSymbol>;
  /** The pay history of the account */
  payHistoryBreakDown?: Maybe<Array<CreditFactorTradelinePayHistoryDatum>>;
  /** The pay history of the account grouped by months */
  payHistoryBreakDownByMonth?: Maybe<
    Array<CreditFactorTradelinePayHistoryByMonthDatum>
  >;
  payHistoryStatus?: Maybe<Scalars['String']>;
  /** The current pay status of the account (raw) */
  payStatus?: Maybe<Scalars['String']>;
  /** The current pay status of the account (user-friendly) */
  payStatusDisplayName?: Maybe<Scalars['String']>;
  /** An optional remark on the account */
  remark?: Maybe<Scalars['String']>;
  /** The length of the loan in months */
  termMonths?: Maybe<Scalars['Int']>;
  /** The user-friendly name for the tradeline */
  tradelineDisplayName?: Maybe<Scalars['String']>;
  wasDisputed?: Maybe<Scalars['Boolean']>;
};

export const CreditFactorTradelineOpenClosedSymbol = {
  Closed: 'CLOSED',
  Open: 'OPEN',
} as const;

export type CreditFactorTradelineOpenClosedSymbol =
  (typeof CreditFactorTradelineOpenClosedSymbol)[keyof typeof CreditFactorTradelineOpenClosedSymbol];
export type CreditFactorTradelinePayHistoryByMonthDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryByMonthDatum';
  /**
   * The pay status codes for each month of the tradeline.
   *
   * `payStatusCodesByMonth` is a fixed array of 12 pay status codes, one per each month of the year. In the scenario where a pay status code does not exist for the month, null is used to represent that month in the array.
   */
  payStatusCodesByMonth?: Maybe<Array<Maybe<CreditHistoryPayStatusCode>>>;
  /** The year that the corresponding statuses were submitted */
  year?: Maybe<Scalars['String']>;
};

export type CreditFactorTradelinePayHistoryDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryDatum';
  /** The date that the corresponding status was submitted */
  date?: Maybe<Scalars['DateTime']>;
  /** The pay status for the tradeline */
  status?: Maybe<CreditHistoryPayStatusCode>;
};

export type CreditFactorTradelineSection = {
  __typename?: 'CreditFactorTradelineSection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']>;
  /** True for groups of tradelines that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']>;
  /** A unique identifier for the section */
  key?: Maybe<Scalars['String']>;
  /** The user-facing label describing the sentiment of the tradeline section */
  label?: Maybe<Scalars['String']>;
  /** The sentiment of the tradeline section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The subtitle describing the tradeline section */
  subtitle?: Maybe<Scalars['String']>;
  /** The title of the tradeline section */
  title?: Maybe<Scalars['String']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
  /** All tradelines associated with this section */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

export type CreditFactors = {
  __typename?: 'CreditFactors';
  ageAndMixOfAccounts?: Maybe<CreditFactor>;
  balances?: Maybe<CreditFactor>;
  creditUtilization?: Maybe<CreditFactor>;
  numTradelines?: Maybe<Scalars['Int']>;
  paymentHistory?: Maybe<CreditFactor>;
  recentInquiries?: Maybe<CreditFactor>;
};

export const CreditHistoryPayStatusCode = {
  CollectionChargeoff: 'COLLECTION_CHARGEOFF',
  Current: 'CURRENT',
  Late_30Days: 'LATE_30_DAYS',
  Late_60Days: 'LATE_60_DAYS',
  Late_90Days: 'LATE_90_DAYS',
  Late_120Days: 'LATE_120_DAYS',
  Late_150Days: 'LATE_150_DAYS',
  PaymentPlan: 'PAYMENT_PLAN',
  Repossession: 'REPOSSESSION',
  Unknown: 'UNKNOWN',
} as const;

export type CreditHistoryPayStatusCode =
  (typeof CreditHistoryPayStatusCode)[keyof typeof CreditHistoryPayStatusCode];
export type CreditProfileAuthAnswer = {
  __typename?: 'CreditProfileAuthAnswer';
  /** The ID of the answer */
  id: Scalars['String'];
  /** The order to show the answer */
  sequence: Scalars['Int'];
  /** The value of the answer */
  text: Scalars['String'];
};

export type CreditProfileAuthAnswerInput = {
  /** The ID of the answer */
  answerId: Scalars['String'];
  /** The ID of the question */
  questionId: Scalars['String'];
};

export type CreditProfileAuthCustomerInput = {
  /** User's date of birth in the format YYYY-MM-DD */
  dateOfBirth: Scalars['Date'];
  /** User's first name */
  firstName: Scalars['String'];
  /** User's full SSN (e.g. "123456789") */
  fullSsn?: InputMaybe<Scalars['String']>;
  /** User's last name */
  lastName: Scalars['String'];
  /** User's mailing address */
  mailingAddress: IdentityAddressInput;
  /** User's middle name */
  middleName?: InputMaybe<Scalars['String']>;
  /** User's last four of SSN (e.g. "1234") */
  partialSsn?: InputMaybe<Scalars['String']>;
  /** User's prefix */
  prefix?: InputMaybe<Scalars['String']>;
  /** User's previous address */
  previousAddress?: InputMaybe<IdentityAddressInput>;
  /** User's suffix */
  suffix?: InputMaybe<Scalars['String']>;
};

export type CreditProfileAuthQuestion = {
  __typename?: 'CreditProfileAuthQuestion';
  /** The list of answer choices */
  answers: Array<CreditProfileAuthAnswer>;
  /** The ID of the question */
  id: Scalars['String'];
  /** The order to show the question */
  sequence: Scalars['Int'];
  /** The question itself as text */
  text: Scalars['String'];
  /** The type of the question */
  type: Scalars['String'];
};

export const CreditProfileAuthStatus = {
  Active: 'ACTIVE',
  Authenticated: 'AUTHENTICATED',
  Blocked: 'BLOCKED',
  Deactivated: 'DEACTIVATED',
  Inactive: 'INACTIVE',
  Pending: 'PENDING',
} as const;

export type CreditProfileAuthStatus =
  (typeof CreditProfileAuthStatus)[keyof typeof CreditProfileAuthStatus];
/**
 * The `CreditProfileAuthStatusProfile` represents a TransUnion Authentication Status.
 * Github link (TUAuthenticationStatusProfile): https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type CreditProfileAuthStatusProfile = {
  __typename?: 'CreditProfileAuthStatusProfile';
  /** When was the profile activated at */
  activatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile authenticated at */
  authenticatedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile blocked at */
  blockedAt?: Maybe<Scalars['DateTime']>;
  /** When was the profile deactivated at */
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  /** More details on top of the message (e.g. User already has activated TU on same NW account) */
  description?: Maybe<Scalars['String']>;
  /** Indicates if the user has a thin file */
  hasThinFile?: Maybe<Scalars['Boolean']>;
  /** Is the user deceased */
  isDeceased?: Maybe<Scalars['Boolean']>;
  /** Short message about the status of the operation (TU Initialized, User Already Active, etc.) */
  message?: Maybe<Scalars['String']>;
  /** Indicates if there is not enough data */
  notEnoughData?: Maybe<Scalars['Boolean']>;
  /** Number of pulls in the past 24 hours */
  numPullsInPast24Hours?: Maybe<Scalars['Int']>;
  /** The previous status */
  previousStatus?: Maybe<CreditProfileAuthStatus>;
  /** List of questions to authenticate */
  questions?: Maybe<Array<CreditProfileAuthQuestion>>;
  /** When was the profile reactivated at */
  reactivatedAt?: Maybe<Scalars['DateTime']>;
  /** What is the status of the TU link (PENDING, ACTIVE, AUTHENTICATED, etc.) */
  status: CreditProfileAuthStatus;
  /** Reason for the thin file */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
  /** TU ID */
  tuId?: Maybe<Scalars['String']>;
};

export const CreditProfileAuthThinFileReason = {
  /** TU is enforcing rate limiting */
  Duplicate: 'DUPLICATE',
  /** User has been 'fuzzy matched' but something doesn't look right */
  FailVerification: 'FAIL_VERIFICATION',
  /** True ThinFile - user lacks enough data to generate exam */
  NoData: 'NO_DATA',
  /** Catch all */
  Other: 'OTHER',
} as const;

export type CreditProfileAuthThinFileReason =
  (typeof CreditProfileAuthThinFileReason)[keyof typeof CreditProfileAuthThinFileReason];
export type CreditRangeMap = {
  __typename?: 'CreditRangeMap';
  /** average insurance cost for a good credit score */
  withGoodCredit: Scalars['Float'];
  /** average insurance cost for a poor credit score */
  withPoorCredit: Scalars['Float'];
};

export const CreditScore = {
  Average: 'AVERAGE',
  Excellent: 'EXCELLENT',
  Good: 'GOOD',
  Poor: 'POOR',
} as const;

export type CreditScore = (typeof CreditScore)[keyof typeof CreditScore];
export type CreditScoreActivationStatusResponse =
  MembershipFeatureActivationStatusInterface & {
    __typename?: 'CreditScoreActivationStatusResponse';
    /** If the user is blocked from using the Credit Score feature, this field indicates the reason why. */
    blockedReason?: Maybe<CreditScoreBlockedReasonEnum>;
    id: MembershipFeatureEnum;
    status: MembershipFeatureActivationStatusEnum;
    /** If the user has a thin file, this field indicates the reason why. */
    thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
  };

export type CreditScoreActivationVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'CreditScoreActivationVisualization';
    /** This will always be CREDIT_SCORE_ACTIVATION */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  };

/**
 * This enum represents each of the possible reasons why the user might be blocked from using the Credit Score feature.
 *
 * Note that it intentionally deviates from the semantics of the underlying data model in order to better align
 * with the product experience.
 */
export const CreditScoreBlockedReasonEnum = {
  Deceased: 'DECEASED',
  DuplicateEmail: 'DUPLICATE_EMAIL',
  NotEnoughData: 'NOT_ENOUGH_DATA',
  RateLimited: 'RATE_LIMITED',
  ThinFile: 'THIN_FILE',
} as const;

export type CreditScoreBlockedReasonEnum =
  (typeof CreditScoreBlockedReasonEnum)[keyof typeof CreditScoreBlockedReasonEnum];
export type CreditScoreChangeInfo = {
  __typename?: 'CreditScoreChangeInfo';
  /** User's current credit bucket */
  currentBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's current credit score */
  currentScore?: Maybe<Scalars['Int']>;
  /** User's previous credit bucket */
  previousBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's previous credit score */
  previousScore?: Maybe<Scalars['Int']>;
  /** User's projected future credit bucket */
  projectedBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's projected future credit score */
  projectedScore?: Maybe<Scalars['Int']>;
};

/** A credit score history data point */
export type CreditScoreHistoryDatum = {
  __typename?: 'CreditScoreHistoryDatum';
  /** The date the credit score was pulled at */
  date?: Maybe<Scalars['DateTime']>;
  /** The credit score associated with the pull date */
  vantageScore3?: Maybe<Scalars['Int']>;
};

export type CreditScoreHistoryInput = {
  /** The end date to obtain the credit score history */
  endDate: Scalars['DateTime'];
  /** The interval to obtain the credit score history */
  interval: CreditScoreHistoryIntervalEnum;
  /** The start date to obtain the credit score history */
  startDate: Scalars['DateTime'];
};

/** Represents all possible credit score history intervals */
export const CreditScoreHistoryIntervalEnum = {
  All: 'ALL',
  Day: 'DAY',
  Month: 'MONTH',
  Week: 'WEEK',
} as const;

export type CreditScoreHistoryIntervalEnum =
  (typeof CreditScoreHistoryIntervalEnum)[keyof typeof CreditScoreHistoryIntervalEnum];
export type CreditScoreHistoryResponse = {
  __typename?: 'CreditScoreHistoryResponse';
  /** An array of credit score data points used to represent a user's credit score history */
  data?: Maybe<Array<CreditScoreHistoryDatum>>;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from credit-service
 */
export type CreditScoreInsight = UserInsightInterface & {
  __typename?: 'CreditScoreInsight';
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   * Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
};

export type CreditSimulationInput = {
  /** Simulates a credit score depending if child support is added */
  addChildSupport?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if a foreclosure is added */
  addForeclosure?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if tax lien is added */
  addTaxLien?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if wage garnishment is added */
  addWageGarnishment?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given all accounts are past due for a number of days (valid number of days: 30, 60 or 90 days) */
  allAccountsPastDueNumDays?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if a number of credit card is applied for */
  applyForNumberOfCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score depending if the user's oldest credit card is closed */
  closeOldestCreditCard?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user's credit balance is decreased by a certain amount */
  decreaseCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user's credit balance is increased by a certain amount */
  increaseCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user's credit card limit is increased by a certain amount */
  increaseCreditCardLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if an account is moved into collection */
  moveOneAccountIntoCollection?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user obtains an auto loan limit for a certain amount */
  obtainAutoLoanLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a credit card limit for a certain amount */
  obtainCreditCardLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a mortgage limit for a certain amount */
  obtainMortgageLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user obtains a personal loan limit for a certain amount */
  obtainPersonalLoanLimit?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user makes on time payments for a certain number of months (minimum months: 1, maximum months: 24) */
  onTimePaymentsNumMonths?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score given the user has one account past due for a certain number of days (valid number of days: 30, 60 or 90 days) */
  oneAccountPastDueNumDays?: InputMaybe<Scalars['Int']>;
  /** Simulates a credit score depending if all credit cards are paid off */
  payOffAllCreditCards?: InputMaybe<Scalars['Boolean']>;
  /** Simulates a credit score given the user transfers their credit balance for a certain amount */
  transferCreditBalanceAmount?: InputMaybe<Scalars['Int']>;
};

/** The object representing the size of the image. */
export type CroppedImageSize = {
  __typename?: 'CroppedImageSize';
  /** The file name for this crop size. */
  file?: Maybe<Scalars['String']>;
  /** The height of this crop size in pixels. */
  height?: Maybe<Scalars['Int']>;
  /** The mime type for this crop size. */
  mimeType?: Maybe<Scalars['String']>;
  /** The name of the crop size. */
  size: MediaItemImageSizeEnum;
  /** The full url path to the crop of this image. */
  sourceUrl?: Maybe<Scalars['URL']>;
  /** The width of this crop size in pixels. */
  width?: Maybe<Scalars['Int']>;
};

export const CurrentBalanceCompany = {
  BankOfAmerica: 'BANK_OF_AMERICA',
  CapitalOne: 'CAPITAL_ONE',
  Chase: 'CHASE',
  Citibank: 'CITIBANK',
  Discover: 'DISCOVER',
  Other: 'OTHER',
  UsBank: 'US_BANK',
  WellsFargo: 'WELLS_FARGO',
} as const;

export type CurrentBalanceCompany =
  (typeof CurrentBalanceCompany)[keyof typeof CurrentBalanceCompany];
export type CursorPaginationInput = {
  /** The ID of the item from which pagination should start reading forwards. */
  after?: InputMaybe<Scalars['ID']>;
  /** The ID of the item from which pagination should start reading backwards. */
  before?: InputMaybe<Scalars['ID']>;
  /** The number of items to return in the pagination */
  limit?: InputMaybe<Scalars['Int']>;
};

/** Enum values for dateDisplayFormat field on Article type. */
export const DateDisplayFormatEnum = {
  Default: 'DEFAULT',
  MonthAndYear: 'MONTH_AND_YEAR',
} as const;

export type DateDisplayFormatEnum =
  (typeof DateDisplayFormatEnum)[keyof typeof DateDisplayFormatEnum];
export const DebtActivationState = {
  Activated: 'Activated',
  BlockedDti: 'BlockedDTI',
  BlockedNoDebtTradelines: 'BlockedNoDebtTradelines',
  BlockedTu: 'BlockedTU',
  Unactivated: 'Unactivated',
  Unknown: 'Unknown',
} as const;

export type DebtActivationState =
  (typeof DebtActivationState)[keyof typeof DebtActivationState];
export type DebtRecentChange = {
  __typename?: 'DebtRecentChange';
  actions?: Maybe<Array<AppAction>>;
  body?: Maybe<Scalars['String']>;
  condition: Scalars['String'];
  debtType?: Maybe<DebtTypes>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
  takeaway?: Maybe<Scalars['String']>;
};

export type DebtSummary = {
  __typename?: 'DebtSummary';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activationState?: Maybe<DebtActivationState>;
  annualGrossIncome?: Maybe<Scalars['Float']>;
  /**
   * A user-friendly approximation of how much time until they will be debt-free
   *
   * Example: `9¾ years`
   */
  debtFreeDateDisplayString?: Maybe<Scalars['String']>;
  debtFreeDateFormat?: Maybe<Scalars['DateTime']>;
  isRecentlyActivatedUser?: Maybe<Scalars['Boolean']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  previousTotalDebtAmount?: Maybe<Scalars['Float']>;
  primaryDebtMotivation?: Maybe<Scalars['String']>;
  recentChanges?: Maybe<Array<DebtRecentChange>>;
  totalDebtAmount?: Maybe<Scalars['Float']>;
  /** The percent change from the user’s previous total debt amount to their current total debt amount */
  totalDebtChangePercent?: Maybe<Scalars['Float']>;
};

export const DebtTypes = {
  AutoLoan: 'auto_loan',
  CreditCard: 'credit_card',
  Deferred: 'deferred',
  PersonalLoan: 'personal_loan',
  StudentLoan: 'student_loan',
} as const;

export type DebtTypes = (typeof DebtTypes)[keyof typeof DebtTypes];
/** declinePersonalLoanOffersSearch response */
export type DeclinePersonalLoanOffers = {
  __typename?: 'DeclinePersonalLoanOffers';
  /** List of marketplace entities that match the query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
  /** The total number of offers map to the loan purpose. */
  total: Scalars['Int'];
};

/** Input for decline results offers query */
export type DeclineResultsQueryInputs = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
};

export type DeleteFinancialPortalResponse = {
  __typename?: 'DeleteFinancialPortalResponse';
  success: Scalars['Boolean'];
};

export type DeleteFinancialTransactionResponse = {
  __typename?: 'DeleteFinancialTransactionResponse';
  success: Scalars['Boolean'];
};

/** Wraps the delete net worth real API response, which allows for adding fields at a later date */
export type DeleteNetWorthRealAssetResponse = {
  __typename?: 'DeleteNetWorthRealAssetResponse';
  success: Scalars['Boolean'];
};

export type DeleteUserFinancialAccountResponse = {
  __typename?: 'DeleteUserFinancialAccountResponse';
  success: Scalars['Boolean'];
};

/** Types of drivers variations for a Roundup section */
export const DriversVariationTypeEnum = {
  DefaultDrivers: 'DEFAULT_DRIVERS',
  NativeDrivers: 'NATIVE_DRIVERS',
} as const;

export type DriversVariationTypeEnum =
  (typeof DriversVariationTypeEnum)[keyof typeof DriversVariationTypeEnum];
/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacement = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentInterface &
  PostWithTitleInterface & {
    __typename?: 'DynamicPlacement';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type DynamicPlacementConnectionResponse = {
  __typename?: 'DynamicPlacementConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The DynamicPlacement returned for the connection. */
  items?: Maybe<Array<DynamicPlacement>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of DynamicPlacement objects. */
export type DynamicPlacementFilterInput = {
  /** Limit collection to DynamicPlacements published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to DynamicPlacements with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to DynamicPlacements with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * Wraps the edit Net Worth Real Asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type EditNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'EditNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

/** A Education Loans institution */
export type EducationLoansInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'EducationLoansInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** The overall editorial rating for the institution. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Education Loans offer */
export type EducationLoansOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithQualificationsInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'EducationLoansOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** Available term lengths for the offer */
    availableTermLengths?: Maybe<Scalars['String']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** Disclaimer for the offer */
    disclaimer?: Maybe<Scalars['String']>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver fixed apr with annotation associated with the entity */
    driverFixedAprWithAnnotation?: Maybe<EntityPlacementDriver>;
    /** The driver min credit score associated with the entity */
    driverMinCreditScore?: Maybe<EntityPlacementDriver>;
    /** The driver variable apr with annotation associated with the entity */
    driverVariableAprWithAnnotation?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: EducationLoansProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** List of qualifications for the offer */
    qualificationsBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The overall editorial rating for this Offer. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Education Loans product */
export type EducationLoansProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'EducationLoansProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: EducationLoansInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type EmailOnlyRegisteredUserActivationStatusResponse =
  MembershipFeatureActivationStatusInterface & {
    __typename?: 'EmailOnlyRegisteredUserActivationStatusResponse';
    id: MembershipFeatureEnum;
    status: MembershipFeatureActivationStatusEnum;
  };

/** A type that represents an empty object. */
export type EmptyObject = {
  __typename?: 'EmptyObject';
  _empty?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPost = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithEditorInterface &
  PostWithExcerptInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'EngineeringPost';
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The editorial excerpt of the resource. */
    excerpt?: Maybe<Scalars['String']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type EngineeringPostConnectionResponse = {
  __typename?: 'EngineeringPostConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The EngineeringPost returned for the connection. */
  items?: Maybe<Array<EngineeringPost>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of EngineeringPost objects. */
export type EngineeringPostFilterInput = {
  /** Limit collection to EngineeringPosts published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to EngineeringPosts with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to EngineeringPosts with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type EntityPlacementAnalyticsProps = {
  __typename?: 'EntityPlacementAnalyticsProps';
  /**
   * Boolean indicating if the entity can log a legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  hasLegacyImpression: Scalars['Boolean'];
  /** The marketplace UUID for the associated institution. */
  institutionId: Scalars['ID'];
  /**
   * Additional data to be sent to legacy impression events. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyAdditionalEventData?: Maybe<Scalars['JSON']>;
  /**
   * The entity's issuer name. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacyIssuer: Scalars['String'];
  /**
   * The entity slug. This is only used for legacy analytics and can be removed after
   * the Bedrock cutover.
   */
  legacySlug?: Maybe<Scalars['String']>;
  /**
   * The vertical name to use to map to the legacy impression. This is only used for legacy
   * analytics and can be removed after the Bedrock cutover.
   */
  legacyVertical?: Maybe<Scalars['String']>;
  /** The marketplace UUID for the associated offer. Null for institutions and products. */
  offerId?: Maybe<Scalars['ID']>;
  /** The marketplace UUID for the associated product. Null for institutions. */
  productId?: Maybe<Scalars['ID']>;
};

export type EntityPlacementCta = {
  __typename?: 'EntityPlacementCTA';
  /** The destination url of the CTA */
  link: Scalars['URL'];
  /** Whether or not to show the icon in the CTA */
  showIcon: Scalars['Boolean'];
  /** The text to show underneath the CTA button */
  subtext?: Maybe<Scalars['String']>;
  /** The button/link text to show for the CTA */
  text: Scalars['String'];
  /** The ultimate destination type of the CTA */
  type: EntityPlacementCtaTypeEnum;
};

export const EntityPlacementCtaTypeEnum = {
  ApplyNow: 'APPLY_NOW',
  Prequal: 'PREQUAL',
  ReadReview: 'READ_REVIEW',
} as const;

export type EntityPlacementCtaTypeEnum =
  (typeof EntityPlacementCtaTypeEnum)[keyof typeof EntityPlacementCtaTypeEnum];
export type EntityPlacementDriver = {
  __typename?: 'EntityPlacementDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver id */
  id: Scalars['String'];
  /** The driver label */
  label: Scalars['String'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']>;
  /** The driver tooltip */
  tooltip?: Maybe<Scalars['StructuredContentDocument']>;
  /** The driver value */
  value?: Maybe<Scalars['String']>;
  /** The driver tooltip (no SC) */
  valueTooltip?: Maybe<Scalars['String']>;
  /** Whether or not the value tooltip has HTML in it */
  valueTooltipHasHtml: Scalars['Boolean'];
};

export type EntityPlacementImage = {
  __typename?: 'EntityPlacementImage';
  /** The alt text that will accompany the logo */
  alt?: Maybe<Scalars['String']>;
  /** The height of the image, in px */
  height?: Maybe<Scalars['Int']>;
  /**
   * The relative image path for CloudFlare's image optimization service.
   * Can be used to build an image URL with custom height/width/quality.
   */
  resizableImagePath?: Maybe<Scalars['String']>;
  /** The URL for the logo */
  source?: Maybe<Scalars['URL']>;
  /** The URL for the large-size logo */
  sourceLarge?: Maybe<Scalars['URL']>;
  /** The URL for the medium-size logo */
  sourceMedium?: Maybe<Scalars['URL']>;
  /** The width of the image, in px */
  width?: Maybe<Scalars['Int']>;
};

export type ExpandedMarketplaceStaticOffer = {
  __typename?: 'ExpandedMarketplaceStaticOffer';
  /** Loan amount retrieved from the user's profile */
  loanAmount: Scalars['Float'];
  /** Loan term months is hardcoded to 24 because we don't have an input asking for loan term, but we need loan term to calculate monthly payment */
  loanTermMonths: Scalars['Int'];
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
};

export type Experiment = {
  __typename?: 'Experiment';
  /**
   * The ID of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariant: Scalars['String'];
  /**
   * The name of the variant the requesting user is bucketed into.
   * This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariantName: Scalars['String'];
  /** The ID of the experiment */
  experimentId: Scalars['String'];
  /** The name of the experiment */
  experimentName: Scalars['String'];
  /** Is the variant forced via query param. Variants can be forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\` */
  isForcedVariant: Scalars['Boolean'];
  rampNum: Scalars['Int'];
  usesEEE: Scalars['Boolean'];
  variants: Array<Maybe<Variant>>;
};

export type ExperimentDecision = {
  __typename?: 'ExperimentDecision';
  /**
   * The name of the variant the requesting user is bucketed into. If the given experimentName is not found,
   * this value is empty. This is different from a valid default variant, which is usually called 'control'.
   */
  assignedVariantName: Scalars['String'];
  /** The name of the experiment. */
  experimentName: Scalars['String'];
  /**
   * The UUIDs of the MODEL_EXECUTED events associated with this decision.
   * These should be used in downstream event headers; for more details
   * see: https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/model_executed.yaml
   */
  modelExecutionIds: Array<Scalars['ID']>;
};

/** FacetCategory represents the category name, the number of matched WP entites, and whether it was selected */
export type FacetCategory = {
  __typename?: 'FacetCategory';
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
  value: Scalars['String'];
};

/** FacetContentType represents more about the WP entities returned by the search */
export type FacetContentType = {
  __typename?: 'FacetContentType';
  count: Scalars['Int'];
  selected: Scalars['Boolean'];
  value: Scalars['String'];
};

/** Facets are metadata about the search results, particularly a list of results grouped by category and content type */
export type Facets = {
  __typename?: 'Facets';
  /** The name of the category */
  category?: Maybe<Array<FacetCategory>>;
  /** The content-type */
  contentType?: Maybe<Array<FacetContentType>>;
};

export type FeatureDiscoveryResponse = {
  __typename?: 'FeatureDiscoveryResponse';
  details?: Maybe<WebFeatureDiscoveryDetails>;
  isEnabled: Scalars['Boolean'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /**
   * Extra feature data
   * This accounts for values forced using a request header or query param on the originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  extraData?: Maybe<Scalars['JSON']>;
  /**
   * Is the value or extraData forced.
   * values can be forced using a request header or query param on the originating URL of the form `feat_[featurename]=[true|false]`
   * extraData can be forced using a request header or query param on the originating URL of the form `feat_[featurename]_data=<stringified_json>`
   */
  isForced: Scalars['Boolean'];
  /** The name of the feature flag */
  name: Scalars['String'];
  /**
   * The value of the feature flag.
   * This accounts for values forced using a request header or query param on the originating URL of the form `feat_[featurename]=[true|false]`
   */
  value: Scalars['Boolean'];
};

/** The `FeedCard` represents the card JSON shape. */
export type FeedCard = {
  __typename?: 'FeedCard';
  cardTemplate?: Maybe<FeedCardTemplate>;
  displayPlatforms?: Maybe<Scalars['String']>;
  fields?: Maybe<FeedCardFields>;
  id: Scalars['Int'];
  indexInStatement?: Maybe<Scalars['Int']>;
  recommendation?: Maybe<FeedCardRecommendation>;
  slug?: Maybe<Scalars['String']>;
};

/** The `FeedCardAction` type represents shape each item in the primary_actions JSON array takes. */
export type FeedCardAction = {
  __typename?: 'FeedCardAction';
  href?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
};

/**
 * The `FeedCardFields` represents the fields JSON shape. Data contains all fields not shared
 * by all card templates. cardActions will be renamed primaryActions to match the JSON response once the apollo plural codegen error is resolved.
 */
export type FeedCardFields = {
  __typename?: 'FeedCardFields';
  cardActions?: Maybe<Array<Maybe<FeedCardAction>>>;
  data?: Maybe<Scalars['JSON']>;
  primaryAction?: Maybe<FeedCardPrimaryAction>;
  primaryCta?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from the Feed CMS (includes feed cards and Nerds-Eye View items)
 */
export type FeedCardInsight = UserInsightInterface & {
  __typename?: 'FeedCardInsight';
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /**
   * The number of days after which a FeedCardInsight can be considered "new" to the user.
   * Clients should disregard all local user engagement data that is older than this value.
   * @deprecated All returned UIAs should be considered non-expired.
   */
  expiresInDays?: Maybe<Scalars['Int']>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   * Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
};

/** The `FeedCardPrimaryAction` represents the primary_action JSON shape. */
export type FeedCardPrimaryAction = {
  __typename?: 'FeedCardPrimaryAction';
  mobileTarget?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** The `FeedCardRecommendation` represents the recommendation JSON shape. */
export type FeedCardRecommendation = {
  __typename?: 'FeedCardRecommendation';
  actionMobileTarget?: Maybe<Scalars['String']>;
  actionTarget?: Maybe<Scalars['String']>;
  actionText?: Maybe<Scalars['String']>;
  actionType?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** The `FeedCardTemplate` represents the card_template JSON shape. */
export type FeedCardTemplate = {
  __typename?: 'FeedCardTemplate';
  id?: Maybe<Scalars['String']>;
  renderId?: Maybe<Scalars['String']>;
};

/** The `FeedStatement` represents the statement JSON shape. */
export type FeedStatement = {
  __typename?: 'FeedStatement';
  id: Scalars['Int'];
  priority?: Maybe<Scalars['Int']>;
  slug?: Maybe<Scalars['String']>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/accounts
 */
export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  autoRefreshRequired?: Maybe<Scalars['Boolean']>;
  /**  The "cent-normalized" account balance as an integer. e.g. 100 equals $1.00  */
  balance?: Maybe<Scalars['BigInt']>;
  createdAt: Scalars['DateTime'];
  /**  The currency code that transactions on the account are in  */
  currency?: Maybe<Scalars['FinancialCurrency']>;
  /**  JSON Formatted fields related to specific account types: APR, CreditLimit, etc  */
  extra?: Maybe<Scalars['JSON']>;
  /**  The financial portal under which the account resides  */
  financialPortal?: Maybe<FinancialPortal>;
  /**  IAV verification status flag  */
  iavVerified?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  /**  Whether the account is included in calculations and visible to the user  */
  isHidden?: Maybe<Scalars['Boolean']>;
  /**  The date at which the account was last synced  */
  lastSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  Account mask  */
  mask?: Maybe<Scalars['String']>;
  /**  Account name  */
  name?: Maybe<Scalars['String']>;
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  Account status  */
  status?: Maybe<FinancialAccountStatus>;
  /**  Account sub-type  */
  subtype?: Maybe<FinancialAccountSubtype>;
  /**  Account sub-type details, e.g. "CHECKING_ACCOUNT", "PREPAID_CARD", "FSA"  */
  subtypeDetails?: Maybe<Scalars['String']>;
  /**  Timestamp of the last transactions sync for the account  */
  transactionsSyncedAt?: Maybe<Scalars['DateTime']>;
  /**  The type of account, e.g. "bank" or "investment"  */
  type?: Maybe<FinancialAccountType>;
  updatedAt: Scalars['DateTime'];
  /**  Verification state of the account  */
  verificationState?: Maybe<Scalars['String']>;
};

export const FinancialAccountAccountNames = {
  NwManualTransactionAccount: 'NW_MANUAL_TRANSACTION_ACCOUNT',
} as const;

export type FinancialAccountAccountNames =
  (typeof FinancialAccountAccountNames)[keyof typeof FinancialAccountAccountNames];
export type FinancialAccountSnapshot = {
  __typename?: 'FinancialAccountSnapshot';
  account_id: Scalars['ID'];
  amount: Scalars['Int'];
  created_at: Scalars['DateTime'];
  date: Scalars['DateTime'];
  identity_id: Scalars['ID'];
  updated_at: Scalars['DateTime'];
};

export const FinancialAccountStatus = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;

export type FinancialAccountStatus =
  (typeof FinancialAccountStatus)[keyof typeof FinancialAccountStatus];
export const FinancialAccountSubtype = {
  Bill: 'BILL',
  Checking: 'CHECKING',
  CreditCard: 'CREDIT_CARD',
  Invalid: 'INVALID',
  Investment: 'INVESTMENT',
  Loan: 'LOAN',
  Other: 'OTHER',
  RealEstate: 'REAL_ESTATE',
  Retirement: 'RETIREMENT',
  Reward: 'REWARD',
  Savings: 'SAVINGS',
  Stuff: 'STUFF',
  Vehicle: 'VEHICLE',
} as const;

export type FinancialAccountSubtype =
  (typeof FinancialAccountSubtype)[keyof typeof FinancialAccountSubtype];
export const FinancialAccountType = {
  Bank: 'BANK',
  Bill: 'BILL',
  CreditCard: 'CREDIT_CARD',
  Insurance: 'INSURANCE',
  Investment: 'INVESTMENT',
  Loan: 'LOAN',
  Other: 'OTHER',
  RealEstate: 'REAL_ESTATE',
  Reward: 'REWARD',
  Stuff: 'STUFF',
  Vehicle: 'VEHICLE',
} as const;

export type FinancialAccountType =
  (typeof FinancialAccountType)[keyof typeof FinancialAccountType];
export type FinancialAccountTypeSumsResponse = {
  __typename?: 'FinancialAccountTypeSumsResponse';
  /**  Sum of ALL assets, i.e. bank balances + investments in cents  */
  assets: Scalars['BigInt'];
  /**  Sum of bank balances in cents  */
  banks: Scalars['BigInt'];
  /**  Sum of bill balances in cents  */
  bills: Scalars['BigInt'];
  /**  Sum of credit card balances (unsigned) in cents  */
  creditCards: Scalars['BigInt'];
  /**  Sum of ALL debts (unsigned), i.e. credit card balances + loan balances in cents  */
  debts: Scalars['BigInt'];
  /**  Sum of investments in cents  */
  investments: Scalars['BigInt'];
  /**  Sum of loans (unsigned) in cents  */
  loans: Scalars['BigInt'];
  /**  Sum of other account balances in cents  */
  other: Scalars['BigInt'];
};

export type FinancialAccountsActivationVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'FinancialAccountsActivationVisualization';
    /** This will always be FINANCIAL_ACCOUNTS_ACTIVATION */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  };

export type FinancialAccountsIavDetailsResponse = {
  __typename?: 'FinancialAccountsIAVDetailsResponse';
  details: Array<IavDetailsResponse>;
};

export const FinancialDataSource = {
  Nerdwallet: 'NERDWALLET',
  Plaid: 'PLAID',
  Qa: 'QA',
  Redfin: 'REDFIN',
  User: 'USER',
  Yodlee: 'YODLEE',
} as const;

export type FinancialDataSource =
  (typeof FinancialDataSource)[keyof typeof FinancialDataSource];
/** The `FinancialIdentityDebtTypes` type represents debt types of a user */
export type FinancialIdentityDebtTypes = {
  __typename?: 'FinancialIdentityDebtTypes';
  autoLoanDebt?: Maybe<Scalars['Boolean']>;
  creditDebt?: Maybe<Scalars['Boolean']>;
  medicalDebt?: Maybe<Scalars['Boolean']>;
  mortgageDebt?: Maybe<Scalars['Boolean']>;
  otherDebt?: Maybe<Scalars['Boolean']>;
  paydayLoanDebt?: Maybe<Scalars['Boolean']>;
  personalLoanDebt?: Maybe<Scalars['Boolean']>;
  studentLoanDebt?: Maybe<Scalars['Boolean']>;
};

/** The `FinancialIdentityProfile` type represents the user's financial profile */
export type FinancialIdentityProfile = {
  __typename?: 'FinancialIdentityProfile';
  accounts?: Maybe<Array<Maybe<UserReportedFinancialAccount>>>;
  amountOwed?: Maybe<Scalars['Int']>;
  annualIncome?: Maybe<Scalars['Float']>;
  cashSavingPattern?: Maybe<Scalars['String']>;
  creditScore?: Maybe<Scalars['Int']>;
  creditScoreRange?: Maybe<Scalars['String']>;
  currentSpendingPattern?: Maybe<Scalars['String']>;
  currentSpousesAnnualIncome?: Maybe<Scalars['Int']>;
  debtTypes?: Maybe<FinancialIdentityDebtTypes>;
  employmentType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  monthlyHousingCost?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
  residenceOwnershipType?: Maybe<Scalars['String']>;
  savingTypes?: Maybe<FinancialIdentitySavingTypes>;
  totalSavings?: Maybe<Scalars['Int']>;
};

/** The `FinancialIdentitySavingTypes` type represents saving types of a user */
export type FinancialIdentitySavingTypes = {
  __typename?: 'FinancialIdentitySavingTypes';
  carExpenses?: Maybe<Scalars['Boolean']>;
  creditCardInterest?: Maybe<Scalars['Boolean']>;
  homeCosts?: Maybe<Scalars['Boolean']>;
  monthlyBills?: Maybe<Scalars['Boolean']>;
  studentLoans?: Maybe<Scalars['Boolean']>;
  travel?: Maybe<Scalars['Boolean']>;
};

/** A user insight sourced from financial-insights service */
export type FinancialInsight = UserInsightInterface & {
  __typename?: 'FinancialInsight';
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   * Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
};

/** Correlates to each of the "products" Plaid offers. Plaid breaks down the status of an institution on a per product basis. */
export type FinancialInstitutionStatusByProduct = {
  __typename?: 'FinancialInstitutionStatusByProduct';
  auth?: Maybe<FinancialInstitutionStatusByProductDetails>;
  balance?: Maybe<FinancialInstitutionStatusByProductDetails>;
  identity?: Maybe<FinancialInstitutionStatusByProductDetails>;
  itemLogins?: Maybe<FinancialInstitutionStatusByProductDetails>;
  transactionsUpdates?: Maybe<FinancialInstitutionStatusByProductDetails>;
};

export type FinancialInstitutionStatusByProductDetails = {
  __typename?: 'FinancialInstitutionStatusByProductDetails';
  lastStatusChange?: Maybe<Scalars['DateTime']>;
  status?: Maybe<PlaidInstitutionHealthStatus>;
};

export type FinancialInstitutionStatusResponse = {
  __typename?: 'FinancialInstitutionStatusResponse';
  status?: Maybe<FinancialInstitutionStatusByProduct>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/financial_portals
 */
export type FinancialPortal = {
  __typename?: 'FinancialPortal';
  /**  The financial accounts associated with this portal  */
  accounts?: Maybe<Array<FinancialAccount>>;
  /**  Accounts synchronization state for the portal  */
  accountsState?: Maybe<FinancialPortalProductState>;
  /**  A portal's migration state  */
  activeMigration?: Maybe<Scalars['Boolean']>;
  /**  The alert message returned by the souce.  */
  alertMessage?: Maybe<FinancialPortalAlertMessage>;
  /**  The type of alert returned  */
  alertName?: Maybe<Scalars['String']>;
  /**  The priority of the alert  */
  alertPriority?: Maybe<Scalars['String']>;
  /**  Authentication state of the portal  */
  authState?: Maybe<FinancialPortalAuthState>;
  /**  The time at which the authentication state was set (ms precision)  */
  authStateSetAt?: Maybe<Scalars['DateTime']>;
  /**  The id of the canonical institution this portal is associated with  */
  canonicalInstitutionId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  /**  The error message returned by the source if auth state went into "ERROR"  */
  errorMessage?: Maybe<FinancialPortalErrorMessage>;
  /**  The type of error returned if the auth state went into "ERROR"  */
  errorName?: Maybe<Scalars['String']>;
  /**  The priority of the error  */
  errorPriority?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  /**  Whether the portal's data is being fetched for the first time  */
  isActiveSync?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being automatically refreshed  */
  isAutoRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal's balance is being refreshed  */
  isBalanceRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the financial portal is being manually refreshed  */
  isManualRefreshing?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is refreshable  */
  isRefreshable?: Maybe<Scalars['Boolean']>;
  /**  Whether the portal is current refreshing (an OR of all types of refreshing)  */
  isRefreshing?: Maybe<Scalars['Boolean']>;
  /**  The time at which the portal was last refreshed  */
  lastRefreshedAt?: Maybe<Scalars['DateTime']>;
  /**  The account aggregation institution this portal is associated with  */
  marketplaceInstitution?: Maybe<AccountAggregationInstitution>;
  /**
   * The id of the acct agg institution this portal is associated with. This can be used instead of
   * marketplaceInstitution.id to avoid an extra network request to marketplace
   */
  marketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  Information on the state of a portal being migrated from vendor to vendor, if relevant  */
  migrationDetails?: Maybe<FinancialPortalMigrationDetails>;
  /**  The primary action for a client to take for an institution in a sub-optimal state  */
  primaryClientAction?: Maybe<FinancialPortalPrimaryClientAction>;
  primarySource?: Maybe<FinancialDataSource>;
  /**  The secondary action for a client to take for an institution in a sub-optimal state  */
  secondaryClientAction?: Maybe<Scalars['String']>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  The source institution id for the portal  */
  sourceInstitutionId: Scalars['String'];
  /**  Contains metadata about the portal. Requires elevated permissions to query.  */
  sourceMeta?: Maybe<FinancialPortalSourceMeta>;
  /**  The transactions synchronization state for the portal  */
  transactionsState?: Maybe<FinancialPortalProductState>;
  updatedAt: Scalars['DateTime'];
};

export const FinancialPortalAlertMessage = {
  NewAccount: 'NEW_ACCOUNT',
} as const;

export type FinancialPortalAlertMessage =
  (typeof FinancialPortalAlertMessage)[keyof typeof FinancialPortalAlertMessage];
export const FinancialPortalAuthState = {
  Authenticated: 'AUTHENTICATED',
  Error: 'ERROR',
  Init: 'INIT',
  Null: 'NULL',
  UserActionRequired: 'USER_ACTION_REQUIRED',
} as const;

export type FinancialPortalAuthState =
  (typeof FinancialPortalAuthState)[keyof typeof FinancialPortalAuthState];
export const FinancialPortalErrorMessage = {
  DataNotReady: 'DATA_NOT_READY',
  DataRetrievalFailed: 'DATA_RETRIEVAL_FAILED',
  InstitutionDown: 'INSTITUTION_DOWN',
  InstitutionNotSupported: 'INSTITUTION_NOT_SUPPORTED',
  InstitutionRequiresUserAction: 'INSTITUTION_REQUIRES_USER_ACTION',
  InternalError: 'INTERNAL_ERROR',
  InvalidCredentials: 'INVALID_CREDENTIALS',
  InvalidMfa: 'INVALID_MFA',
  InvalidMicrodepositAmount: 'INVALID_MICRODEPOSIT_AMOUNT',
  LoginRequired: 'LOGIN_REQUIRED',
  MfaNotSupported: 'MFA_NOT_SUPPORTED',
  MfaRequired: 'MFA_REQUIRED',
  NoDataOrAccount: 'NO_DATA_OR_ACCOUNT',
  NoEligibleAccounts: 'NO_ELIGIBLE_ACCOUNTS',
  NoInvestmentAccounts: 'NO_INVESTMENT_ACCOUNTS',
  NoLiabilityAccounts: 'NO_LIABILITY_ACCOUNTS',
  NoPropertyValue: 'NO_PROPERTY_VALUE',
  OtherError: 'OTHER_ERROR',
  PortalBlocked: 'PORTAL_BLOCKED',
  PortalLocked: 'PORTAL_LOCKED',
  ProductNotSupported: 'PRODUCT_NOT_SUPPORTED',
  TooManyVerificationAttempts: 'TOO_MANY_VERIFICATION_ATTEMPTS',
} as const;

export type FinancialPortalErrorMessage =
  (typeof FinancialPortalErrorMessage)[keyof typeof FinancialPortalErrorMessage];
/**
 * Used to filter a financial portal by fields such as its institution ID. The fields listed here are a subset of the complete list found here:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listFinancialPortals
 */
export type FinancialPortalFilterInput = {
  mpInstitutionId?: InputMaybe<Scalars['ID']>;
};

export type FinancialPortalMessageResponse = {
  __typename?: 'FinancialPortalMessageResponse';
  portal?: Maybe<FinancialPortal>;
  success: Scalars['Boolean'];
};

export type FinancialPortalMigrationDetails = {
  __typename?: 'FinancialPortalMigrationDetails';
  /**  A map of previous account id to new account id  */
  accountsMapping?: Maybe<Scalars['JSON']>;
  /**  Whether the user has confirmed the migration is acceptable or not  */
  hasUserConfirmed: Scalars['Boolean'];
  /**  Whether data for the new portal is currently being ported over   */
  isDataPortInProgress: Scalars['Boolean'];
  /**  Whether data for the new portal has been retrieved  */
  isDataRetrieved: Scalars['Boolean'];
  /**  The id of the portal being migrated from  */
  migratedFromFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  The id of the portal being migrated to  */
  migratedToFinancialPortalId?: Maybe<Scalars['ID']>;
  /**  List of new account ids  */
  newAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  List of old account ids  */
  oldAccountIds?: Maybe<Array<Scalars['ID']>>;
  /**  The id of the marketplace account aggregation institution to migrate to, if a canonical id mapping exists  */
  recommendedMarketplaceInstitutionId?: Maybe<Scalars['ID']>;
  /**  The source (e.g. Plaid) id of the institution to migrate to  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

export const FinancialPortalPrimaryClientAction = {
  Fix: 'FIX',
  GoToSite: 'GO_TO_SITE',
  LegacyFix: 'LEGACY_FIX',
  Migrate: 'MIGRATE',
  Refresh: 'REFRESH',
  SearchToMigrate: 'SEARCH_TO_MIGRATE',
  TryOtherInstitution: 'TRY_OTHER_INSTITUTION',
  Unlink: 'UNLINK',
  UserConfirmation: 'USER_CONFIRMATION',
} as const;

export type FinancialPortalPrimaryClientAction =
  (typeof FinancialPortalPrimaryClientAction)[keyof typeof FinancialPortalPrimaryClientAction];
export const FinancialPortalProductState = {
  DataRetrieved: 'DATA_RETRIEVED',
  Null: 'NULL',
  PartialDataRetrieved: 'PARTIAL_DATA_RETRIEVED',
  RetrievalFailed: 'RETRIEVAL_FAILED',
  RetrievalInProgress: 'RETRIEVAL_IN_PROGRESS',
} as const;

export type FinancialPortalProductState =
  (typeof FinancialPortalProductState)[keyof typeof FinancialPortalProductState];
export type FinancialPortalSourceMeta = {
  __typename?: 'FinancialPortalSourceMeta';
  /**  Failed login attempts in the past 30 days  */
  failedLoginAttemptsPast30Days?: Maybe<Scalars['Int']>;
  /**  Failed login attempts in the past hour  */
  failedLoginAttemptsPastHour?: Maybe<Scalars['Int']>;
  /**  Date of last failed login  */
  lastFailedLogin?: Maybe<Scalars['DateTime']>;
  /**  Date of last successful login  */
  lastSuccessfulLogin?: Maybe<Scalars['DateTime']>;
  /**  The previous auth state  */
  portalPreviousAuthState?: Maybe<FinancialPortalAuthState>;
  /**  The Yodlee status code  */
  portalStatusCode?: Maybe<Scalars['String']>;
  /**  The Yodlee status message  */
  portalStatusMessage?: Maybe<Scalars['String']>;
  /**  The source access token  */
  sourceAccessToken?: Maybe<Scalars['String']>;
  /**  The source entity id  */
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  The Yodlee username (corresponds to the owner of this portal)  */
  username?: Maybe<Scalars['String']>;
};

/** The expected payload for the updateFinancialPriorities mutation */
export type FinancialPrioritiesInput = {
  buildCredit?: InputMaybe<Scalars['Boolean']>;
  buildWealth?: InputMaybe<Scalars['Boolean']>;
  buyCar?: InputMaybe<Scalars['Boolean']>;
  buyHome?: InputMaybe<Scalars['Boolean']>;
  createAndFollowBudget?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  maximizeCreditCardRewards?: InputMaybe<Scalars['Boolean']>;
  payForHomeImprovements?: InputMaybe<Scalars['Boolean']>;
  reduceDebt?: InputMaybe<Scalars['Boolean']>;
  saveForCollege?: InputMaybe<Scalars['Boolean']>;
  saveForEmergencies?: InputMaybe<Scalars['Boolean']>;
  saveForRetirement?: InputMaybe<Scalars['Boolean']>;
  startOrGrowBusiness?: InputMaybe<Scalars['Boolean']>;
  travel?: InputMaybe<Scalars['Boolean']>;
};

/**
 * List of all financial priorities
 * The boolean value denotes whether or not the user has selected the priority.
 */
export type FinancialPrioritiesResponse = {
  __typename?: 'FinancialPrioritiesResponse';
  buildCredit?: Maybe<Scalars['Boolean']>;
  buildWealth?: Maybe<Scalars['Boolean']>;
  buyCar?: Maybe<Scalars['Boolean']>;
  buyHome?: Maybe<Scalars['Boolean']>;
  createAndFollowBudget?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  maximizeCreditCardRewards?: Maybe<Scalars['Boolean']>;
  payForHomeImprovements?: Maybe<Scalars['Boolean']>;
  reduceDebt?: Maybe<Scalars['Boolean']>;
  saveForCollege?: Maybe<Scalars['Boolean']>;
  saveForEmergencies?: Maybe<Scalars['Boolean']>;
  saveForRetirement?: Maybe<Scalars['Boolean']>;
  startOrGrowBusiness?: Maybe<Scalars['Boolean']>;
  travel?: Maybe<Scalars['Boolean']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/transactions
 */
export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  /**  The financial account under which the transaction resides  */
  account?: Maybe<FinancialAccount>;
  /**  The ID of the account associated with this transaction. Useful if you need the id but don't want to invoke an extra network request to fetch accounts  */
  accountId?: Maybe<Scalars['ID']>;
  /**  The type of account, e.g. "bank" or "investment"  */
  accountType?: Maybe<FinancialAccountType>;
  /**  The "cent-normalized" amount of the transaction as an integer. e.g. 100 equals $1.00  */
  amount: Scalars['Int'];
  /**
   *  The NW category of the transaction. Nullable if reading an enrichment, otherwise guaranteed
   * @deprecated Deprecated in favor of the categoryId field which returns a V2 category ID.
   */
  category?: Maybe<FinancialTransactionCategory>;
  /**  The NW V2 category ID of the transaction. Nullable if reading an enrichment, otherwise guaranteed  */
  categoryId?: Maybe<Scalars['ID']>;
  createdAt: Scalars['DateTime'];
  /**  The currency of the account to which the transaction belongs  */
  currency?: Maybe<Scalars['FinancialCurrency']>;
  /**  The date that the transaction took place  */
  date: Scalars['DateTime'];
  /**  A short description of the transaction  */
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  /**  Whether or not the transaction is hidden. */
  isHidden?: Maybe<Scalars['Boolean']>;
  /**  Whether or not the transaction is in a pending status, or if it has posted.  */
  isPending?: Maybe<Scalars['Boolean']>;
  /**  The name of the merchant associated to the transaction  */
  merchantName?: Maybe<Scalars['String']>;
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']>;
  /**  Used to label additional information about a transaction. e.g. REFUND  */
  tags?: Maybe<Array<FinancialTransactionTag>>;
  /**  Generally, whether this is a credit or a debt  */
  type?: Maybe<FinancialTransactionType>;
  updatedAt: Scalars['DateTime'];
};

export type FinancialTransactionCategoriesResponse = {
  __typename?: 'FinancialTransactionCategoriesResponse';
  categories: Array<FinancialTransactionCategoryConfig>;
};

export const FinancialTransactionCategory = {
  Childcare: 'CHILDCARE',
  Donations: 'DONATIONS',
  Entertainment: 'ENTERTAINMENT',
  Fees: 'FEES',
  Groceries: 'GROCERIES',
  Health: 'HEALTH',
  Housing: 'HOUSING',
  Income: 'INCOME',
  Insurance: 'INSURANCE',
  Other: 'OTHER',
  Pets: 'PETS',
  Restaurants: 'RESTAURANTS',
  Shopping: 'SHOPPING',
  Subscriptions: 'SUBSCRIPTIONS',
  Transfers: 'TRANSFERS',
  Transport: 'TRANSPORT',
  Travel: 'TRAVEL',
  Uncategorized: 'UNCATEGORIZED',
  Utilities: 'UTILITIES',
} as const;

export type FinancialTransactionCategory =
  (typeof FinancialTransactionCategory)[keyof typeof FinancialTransactionCategory];
export type FinancialTransactionCategoryConfig = {
  __typename?: 'FinancialTransactionCategoryConfig';
  displayName: Scalars['String'];
  iconUri: Scalars['String'];
  id: Scalars['ID'];
};

export const FinancialTransactionSortField = {
  Amount: 'AMOUNT',
  Date: 'DATE',
} as const;

export type FinancialTransactionSortField =
  (typeof FinancialTransactionSortField)[keyof typeof FinancialTransactionSortField];
export const FinancialTransactionSortOrder = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type FinancialTransactionSortOrder =
  (typeof FinancialTransactionSortOrder)[keyof typeof FinancialTransactionSortOrder];
export const FinancialTransactionTag = {
  AccountFee: 'ACCOUNT_FEE',
  AccountFeeAnnual: 'ACCOUNT_FEE_ANNUAL',
  BankFeeAtm: 'BANK_FEE_ATM',
  BankFeeOverdraft: 'BANK_FEE_OVERDRAFT',
  CashWithdrawal: 'CASH_WITHDRAWAL',
  CheckPayment: 'CHECK_PAYMENT',
  Deposit: 'DEPOSIT',
  Education: 'EDUCATION',
  InvestmentIncome: 'INVESTMENT_INCOME',
  PayrollDeposit: 'PAYROLL_DEPOSIT',
  RebalanceTransfer: 'REBALANCE_TRANSFER',
  Refund: 'REFUND',
  RentPayment: 'RENT_PAYMENT',
  TaxRefund: 'TAX_REFUND',
} as const;

export type FinancialTransactionTag =
  (typeof FinancialTransactionTag)[keyof typeof FinancialTransactionTag];
export const FinancialTransactionType = {
  Credit: 'CREDIT',
  Debit: 'DEBIT',
} as const;

export type FinancialTransactionType =
  (typeof FinancialTransactionType)[keyof typeof FinancialTransactionType];
export type FinancialTransactionsAverageSpendingByDayOfTheMonth = {
  __typename?: 'FinancialTransactionsAverageSpendingByDayOfTheMonth';
  averageSpendingByDayOfTheMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsBudgetBreakdown = {
  __typename?: 'FinancialTransactionsBudgetBreakdown';
  needs: FinancialTransactionsBudgetBreakdownItem;
  savingsAndDebt: FinancialTransactionsBudgetBreakdownItem;
  wants: FinancialTransactionsBudgetBreakdownItem;
};

export type FinancialTransactionsBudgetBreakdownBucketsAmount = {
  __typename?: 'FinancialTransactionsBudgetBreakdownBucketsAmount';
  needs: Scalars['Float'];
  savingsAndDebt: Scalars['Float'];
  total?: Maybe<Scalars['Float']>;
  wants: Scalars['Float'];
};

export type FinancialTransactionsBudgetBreakdownByMonthResponse = {
  __typename?: 'FinancialTransactionsBudgetBreakdownByMonthResponse';
  /** Holds the average percent of income per bucket */
  averageIncomePercents: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Holds the average amount over the goal per bucket */
  averageOverGoalAmounts: FinancialTransactionsBudgetBreakdownBucketsAmount;
  budgetBreakdownByMonth: Array<FinancialTransactionsBudgetBreakdownMonth>;
  /** Holds how many months met the budget per bucket */
  monthsMetBudget: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Number of months requested by the client */
  requestedMonths: Scalars['Int'];
  /** Holds the total amount per bucket */
  totals: FinancialTransactionsBudgetBreakdownBucketsAmount;
};

export type FinancialTransactionsBudgetBreakdownItem = {
  __typename?: 'FinancialTransactionsBudgetBreakdownItem';
  /** Amount spent/saved over the goal amount */
  amountOverGoal: Scalars['Float'];
  categories: Array<FinancialTransactionsCategorySpendingAmount>;
  /** Goal amount spent/saved */
  goal: Scalars['Float'];
  /** Percent of the income spent/saved */
  incomePercent: Scalars['Float'];
  /** If the income percent is over the percent threshold */
  isIncomePercentOverThreshold: Scalars['Boolean'];
  total: Scalars['Float'];
};

export type FinancialTransactionsBudgetBreakdownMonth = {
  __typename?: 'FinancialTransactionsBudgetBreakdownMonth';
  bucketBreakdown: FinancialTransactionsBudgetBreakdown;
  /** Total income in the month */
  income: Scalars['Float'];
  /** If the month is within the recommended savings guidelines */
  isInGuidelines: Scalars['Boolean'];
  month: Scalars['Int'];
  /** Total amount saved in the month */
  saved: Scalars['Float'];
  /** Total amount spent in the month */
  spend: Scalars['Float'];
  year: Scalars['Int'];
};

export type FinancialTransactionsCashInCashOutMonthItem = {
  __typename?: 'FinancialTransactionsCashInCashOutMonthItem';
  cashIn: Scalars['Float'];
  cashOut: Scalars['Float'];
  date: Scalars['DateTime'];
  net: Scalars['Float'];
};

export type FinancialTransactionsCashInCashOutSummary = {
  __typename?: 'FinancialTransactionsCashInCashOutSummary';
  averagePreviousMonths: Scalars['Float'];
  monthlySummaries?: Maybe<
    Array<Maybe<FinancialTransactionsCashInCashOutMonthItem>>
  >;
};

export type FinancialTransactionsCategorySpendingAmount = {
  __typename?: 'FinancialTransactionsCategorySpendingAmount';
  amount: Scalars['Float'];
  category: FinancialTransactionCategory;
};

/**
 * Note: this is not a complete set of available filters of the underlying API
 *
 * See docs for full support: https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listTransactions
 */
export type FinancialTransactionsFilterInput = {
  /** The account ID by which to filter the transactions. */
  accountId?: InputMaybe<Scalars['ID']>;
  /**
   * To be deprecated. Please use "accountTypes".
   * Only return transactions from an account with one of these types.
   */
  accountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Only return transactions from an account with one of these types. */
  accountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /** The V2 category IDs to filter transactions by. */
  categoryIds?: InputMaybe<Array<Scalars['ID']>>;
  /** The end bound of the transaction date (ISO 8601) */
  endDate?: InputMaybe<Scalars['DateTime']>;
  /**
   * To be deprecated. Please use "excludeAccountTypes".
   * Exclude transactions from any accounts with one of these types.
   */
  excludeAccountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Exclude transactions from any accounts with one of these types. */
  excludeAccountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /** The V2 category IDs to exclude when filtering transactions. */
  excludeCategoryIds?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** Whether or not to include transactions marked as hidden. Defaults to false. */
  excludeHiddenTransactions?: InputMaybe<Scalars['Boolean']>;
  /** Exclude transactions with any one of these tags. */
  excludeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** Whether or not to include accounts marked as disabled. Defaults to false. */
  includeDisabledAccounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include transactions for hidden accounts. */
  includeHiddenAccounts?: InputMaybe<Scalars['Boolean']>;
  /** Whether or not to include pending transactions. Defaults to false. */
  includePending?: InputMaybe<Scalars['Boolean']>;
  /** Only return transactions with one of these tags. */
  includeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** The merchant by which to filter the transactions. */
  merchantName?: InputMaybe<Scalars['String']>;
  /** The merchant names by which to filter the transactions. */
  merchantNames?: InputMaybe<Array<Scalars['String']>>;
  /** The beginning bound of the transaction date (ISO 8601) */
  startDate?: InputMaybe<Scalars['DateTime']>;
  /** The type by which to filter the transactions. */
  type?: InputMaybe<Scalars['String']>;
  /** Transactions that have been modified since this date (ISO 8601). */
  updatedSince?: InputMaybe<Scalars['DateTime']>;
};

export type FinancialTransactionsMerchantSpendingAmount = {
  __typename?: 'FinancialTransactionsMerchantSpendingAmount';
  amount: Scalars['Float'];
  merchantName: Scalars['String'];
};

export type FinancialTransactionsProjectionForMonth = {
  __typename?: 'FinancialTransactionsProjectionForMonth';
  earning: Scalars['Float'];
};

export type FinancialTransactionsSortInput = {
  /** The field to sort the transactions by. */
  field?: InputMaybe<FinancialTransactionSortField>;
  /** The order to sort the transactions by (default DESC). */
  order?: InputMaybe<FinancialTransactionSortOrder>;
};

export type FinancialTransactionsSpendingAndEarning = {
  __typename?: 'FinancialTransactionsSpendingAndEarning';
  earning: Scalars['Float'];
  spending: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningByMonth = {
  __typename?: 'FinancialTransactionsSpendingAndEarningByMonth';
  spendingAndEarningByMonth: Array<FinancialTransactionsSpendingAndEarningForDate>;
};

export type FinancialTransactionsSpendingAndEarningForDate = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForDate';
  date: Scalars['Date'];
  earning: Scalars['Float'];
  spending: Scalars['Float'];
};

export type FinancialTransactionsSpendingAndEarningForMonthRangeResponse = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse';
  spendingAndEarningForMonthRange: FinancialTransactionsSpendingAndEarning;
};

export type FinancialTransactionsSpendingByCategory = {
  __typename?: 'FinancialTransactionsSpendingByCategory';
  entertainment: Scalars['Float'];
  fees: Scalars['Float'];
  groceries: Scalars['Float'];
  health: Scalars['Float'];
  housing: Scalars['Float'];
  income: Scalars['Float'];
  other: Scalars['Float'];
  restaurants: Scalars['Float'];
  shopping: Scalars['Float'];
  transfers: Scalars['Float'];
  transport: Scalars['Float'];
  travel: Scalars['Float'];
  utilities: Scalars['Float'];
};

export type FinancialTransactionsSpendingByCategoryForMonth = {
  __typename?: 'FinancialTransactionsSpendingByCategoryForMonth';
  spendingByCategoryForMonth: FinancialTransactionsSpendingByCategory;
};

export type FinancialTransactionsSpendingByDate = {
  __typename?: 'FinancialTransactionsSpendingByDate';
  amount: Scalars['Float'];
  date: Scalars['String'];
  /**
   * The interval for which the amounts roll up
   * e.g. WEEK would result in a total amount per week
   */
  dateInterval: FinancialTransactionsSpendingComparisonDateIntervalEnum;
  /**
   * The day/week of the selected date period
   * e.g. would be 1 if the date is 01/01/2023 for a month period
   */
  intervalPosition: Scalars['Int'];
};

export type FinancialTransactionsSpendingByDayOfTheMonthForMonth = {
  __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth';
  spendingByDayOfTheMonthForPriorMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
  spendingByDayOfTheMonthForTargetMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsSpendingByMonth = {
  __typename?: 'FinancialTransactionsSpendingByMonth';
  spendingByMonth: Array<FinancialTransactionsSpendingOnDate>;
};

export const FinancialTransactionsSpendingComparisonDateIntervalEnum = {
  Day: 'DAY',
  Week: 'WEEK',
} as const;

export type FinancialTransactionsSpendingComparisonDateIntervalEnum =
  (typeof FinancialTransactionsSpendingComparisonDateIntervalEnum)[keyof typeof FinancialTransactionsSpendingComparisonDateIntervalEnum];
export const FinancialTransactionsSpendingComparisonDatePeriodEnum = {
  Month: 'MONTH',
  Quarter: 'QUARTER',
  Week: 'WEEK',
  Year: 'YEAR',
} as const;

export type FinancialTransactionsSpendingComparisonDatePeriodEnum =
  (typeof FinancialTransactionsSpendingComparisonDatePeriodEnum)[keyof typeof FinancialTransactionsSpendingComparisonDatePeriodEnum];
export type FinancialTransactionsSpendingForDayOfTheMonth = {
  __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth';
  amount: Scalars['Float'];
  dayOfTheMonth: Scalars['Int'];
};

export type FinancialTransactionsSpendingOnDate = {
  __typename?: 'FinancialTransactionsSpendingOnDate';
  amount: Scalars['Float'];
  date: Scalars['Date'];
};

export type FinancialTransactionsSpendingPeriodComparisonResponse = {
  __typename?: 'FinancialTransactionsSpendingPeriodComparisonResponse';
  currentPeriodSpending: Array<FinancialTransactionsSpendingByDate>;
  previousPeriodSpending: Array<FinancialTransactionsSpendingByDate>;
};

export type FinancialTransactionsTopCategoriesBySpending = {
  __typename?: 'FinancialTransactionsTopCategoriesBySpending';
  topCategoriesBySpending: Array<FinancialTransactionsCategorySpendingAmount>;
};

export type FinancialTransactionsTopMerchantsBySpending = {
  __typename?: 'FinancialTransactionsTopMerchantsBySpending';
  topMerchantsBySpending: Array<FinancialTransactionsMerchantSpendingAmount>;
};

export type FinancialUserMeta = {
  __typename?: 'FinancialUserMeta';
  /** The Source (YODLEE, PLAID, etc) */
  source?: Maybe<FinancialDataSource>;
  /** The Source username */
  username?: Maybe<Scalars['String']>;
};

export type FinishPortalMigrationResponse = {
  __typename?: 'FinishPortalMigrationResponse';
  portal?: Maybe<FinancialPortal>;
};

/** The expected payload for the "updateGamificationChecklist" mutation */
export type GamificationChecklistInput = {
  checkingLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  creditCardLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  creditScoreActivatedStatus?: InputMaybe<GamificationChecklistStatus>;
  emailStatus?: InputMaybe<GamificationChecklistStatus>;
  investmentLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  savingsLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
};

/** List of gamification checklist items and their current state of completion */
export type GamificationChecklistResponse = {
  __typename?: 'GamificationChecklistResponse';
  checkingLinkedStatus: GamificationChecklistStatus;
  creditCardLinkedStatus: GamificationChecklistStatus;
  creditScoreActivatedStatus: GamificationChecklistStatus;
  emailStatus: GamificationChecklistStatus;
  investmentLinkedStatus: GamificationChecklistStatus;
  savingsLinkedStatus: GamificationChecklistStatus;
};

/**
 * Comprehensive list of states that gamification checklist items can be in, errored items
 * are not considered completed.
 */
export const GamificationChecklistStatus = {
  Completed: 'COMPLETED',
  Dismissed: 'DISMISSED',
  Skipped: 'SKIPPED',
  Todo: 'TODO',
} as const;

export type GamificationChecklistStatus =
  (typeof GamificationChecklistStatus)[keyof typeof GamificationChecklistStatus];
export const GenderEnum = {
  Female: 'FEMALE',
  Male: 'MALE',
  NonBinary: 'NON_BINARY',
} as const;

export type GenderEnum = (typeof GenderEnum)[keyof typeof GenderEnum];
/** Input to determine if geotargeting test is active and it's marketing region */
export type GeotargetingAbTestInput = {
  isTestActive?: InputMaybe<Scalars['Boolean']>;
  marketingRegion?: InputMaybe<Scalars['String']>;
};

export type GetFinancialAccountsResponse = {
  __typename?: 'GetFinancialAccountsResponse';
  accounts?: Maybe<Array<FinancialAccount>>;
};

export type GetFinancialUserMetaResponse = {
  __typename?: 'GetFinancialUserMetaResponse';
  users?: Maybe<Array<FinancialUserMeta>>;
};

export type GetInstitutionHealthDetailsResponse = {
  __typename?: 'GetInstitutionHealthDetailsResponse';
  institution?: Maybe<FinancialInstitutionStatusResponse>;
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  /** List of notifications in reverse chronological order. */
  items?: Maybe<Array<Notification>>;
  /** The newest notification ID is used as the "after" value in subsequent queries. */
  newest?: Maybe<Scalars['ID']>;
  /** The oldest notification ID is used as the "before" value in subsequent queries. */
  oldest?: Maybe<Scalars['ID']>;
  /** The number of unread notifications for the user. */
  unreadCount?: Maybe<Scalars['Int']>;
};

export type GetPortalsResponse = {
  __typename?: 'GetPortalsResponse';
  portals?: Maybe<Array<FinancialPortal>>;
};

export type GetStateFromZipCodeResponse = {
  __typename?: 'GetStateFromZipCodeResponse';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type GetTransactionsResponse = {
  __typename?: 'GetTransactionsResponse';
  /**
   * The pagination metadata associated with the request. If underlying data has changed, this will not match the
   * requested pagination (offset will be set to 0 and a new result set token will be generated)
   */
  pagination: AdvancedOffsetPaginationInfo;
  /**  The list of transactions associated with this result set  */
  transactions: Array<FinancialTransaction>;
};

/** The `GlobalIdentityProfile` type represents the global identity profile */
export type GlobalIdentityProfile = {
  __typename?: 'GlobalIdentityProfile';
  age?: Maybe<Scalars['Int']>;
  ageBucket?: Maybe<Scalars['String']>;
  citizenship?: Maybe<Scalars['String']>;
  currentLocation?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  education?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  legalFirstName?: Maybe<Scalars['String']>;
  mailingAddress?: Maybe<IdentityAddress>;
  maritalStatus?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  previousAddress?: Maybe<IdentityAddress>;
};

/**
 * Options accepted by the GlobalMarkupOptions component.
 * These are generally the options passed to nlOpts when configuring nw-app-module
 */
export type GlobalMarkupOptions = {
  __typename?: 'GlobalMarkupOptions';
  /** The canonical URL of the page */
  canonicalUrl?: Maybe<Scalars['String']>;
  /** The description of the page */
  description?: Maybe<Scalars['String']>;
  /** Page meta tags */
  dynamicMeta?: Maybe<Array<GlobalMarkupOptionsDynamicMeta>>;
  /** Props to pass directly to the global nav React component */
  globalNavProps?: Maybe<GlobalMarkupOptionsGlobalNavProps>;
  /** Facebook Open Graph tags */
  ogTags?: Maybe<GlobalMarkupOptionsOgTags>;
  /** Taxonomy data for SEO */
  pageTaxonomy?: Maybe<GlobalMarkupOptionsPageTaxonomy>;
  /** robots commands */
  robots?: Maybe<GlobalMarkupOptionsRobots>;
  /** The title of the page */
  title?: Maybe<Scalars['String']>;
};

export type GlobalMarkupOptionsDynamicMeta = {
  __typename?: 'GlobalMarkupOptionsDynamicMeta';
  content: Scalars['String'];
  name: Scalars['String'];
  property?: Maybe<Scalars['String']>;
};

export type GlobalMarkupOptionsGlobalNavProps = {
  __typename?: 'GlobalMarkupOptionsGlobalNavProps';
  /** Navigational breadcrumbs to display below the global header */
  breadcrumbs?: Maybe<Breadcrumb>;
  /** Whether the global footer should be disabled */
  disableFooter?: Maybe<Scalars['Boolean']>;
  /** Whether the global header should be disabled */
  disableHeader?: Maybe<Scalars['Boolean']>;
};

export type GlobalMarkupOptionsOgTags = {
  __typename?: 'GlobalMarkupOptionsOgTags';
  /** A brief description of the content. This will displayed below the title of the post on Facebook. */
  description?: Maybe<Scalars['String']>;
  /** The URL of the image that should appear when someone shares the content to Facebook */
  image?: Maybe<Scalars['URL']>;
  /** Height of image in pixels */
  image_height?: Maybe<Scalars['Int']>;
  /** https:// URL for the image */
  image_secure_url?: Maybe<Scalars['URL']>;
  /** Width of image in pixels */
  image_width?: Maybe<Scalars['Int']>;
  /** The locale of the resource */
  locale?: Maybe<Scalars['String']>;
  /** The title of your article without any branding such as your site name. */
  title?: Maybe<Scalars['String']>;
  /** The type of media of your content. This tag impacts how your content shows up in News Feed. */
  type?: Maybe<Scalars['String']>;
  /** The canonical URL for the page */
  url?: Maybe<Scalars['URL']>;
};

export type GlobalMarkupOptionsPageTaxonomy = {
  __typename?: 'GlobalMarkupOptionsPageTaxonomy';
  /** Page topic */
  attrTopic?: Maybe<Scalars['String']>;
  /** Page vertical */
  attrVertical?: Maybe<Scalars['String']>;
  /** Other secondary content clusters for the page */
  otherContentClusters: Array<Scalars['String']>;
  /** Primary content cluster for the page */
  primaryContentCluster?: Maybe<Scalars['String']>;
};

export type GlobalMarkupOptionsRobots = {
  __typename?: 'GlobalMarkupOptionsRobots';
  /** Do not follow the links on this page */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Do not show this page, media, or resource in search results */
  noindex?: Maybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItem = PostInterface &
  PostWithTitleInterface & {
    __typename?: 'GlobalNavItem';
    /** Global Nav L0 item's L1 children. */
    children?: Maybe<Array<GlobalNavItem>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Global Nav item link. */
    itemLink?: Maybe<GlobalNavItemItemLinkUnion>;
    /** Global Nav item level. */
    level?: Maybe<GlobalNavItemLevelEnum>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** Global Nav mobile config. */
    mobileConfig?: Maybe<Array<GlobalNavItemMobileConfig>>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Global Nav L1 item sections. */
    sections?: Maybe<Array<GlobalNavItemSection>>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** Global Nav item sub text. */
    subText?: Maybe<Scalars['String']>;
    /** Global Nav item text. */
    text?: Maybe<Scalars['String']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type GlobalNavItemConnectionResponse = {
  __typename?: 'GlobalNavItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The GlobalNavItem returned for the connection. */
  items?: Maybe<Array<GlobalNavItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of GlobalNavItem objects. */
export type GlobalNavItemFilterInput = {
  /** Limit collection to GlobalNavItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** The union containing the Type members that can be returned by the itemLink field on the GlobalNavItem type. */
export type GlobalNavItemItemLinkUnion =
  | Article
  | CalculatorPage
  | ContentHub
  | Hub
  | InsurancePage
  | LandingPage
  | Page
  | Post
  | Review
  | Roundup
  | UrlRecord;

/** Enum values for level field on GlobalNavItem type. */
export const GlobalNavItemLevelEnum = {
  Default: 'DEFAULT',
  L0: 'L0',
  L1: 'L1',
  L2: 'L2',
  L3: 'L3',
} as const;

export type GlobalNavItemLevelEnum =
  (typeof GlobalNavItemLevelEnum)[keyof typeof GlobalNavItemLevelEnum];
/** Type modeling the data within the mobileConfig group of fields on the GlobalNavItem type. */
export type GlobalNavItemMobileConfig = {
  __typename?: 'GlobalNavItemMobileConfig';
  backgroundColor?: Maybe<Scalars['String']>;
  foregroundColor?: Maybe<Scalars['String']>;
  /** Global Nav mobile config supported icons are Calculator, CreditCard, StudentLoans, Wallet */
  icon?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the sections group of fields on the GlobalNavItem type. */
export type GlobalNavItemSection = {
  __typename?: 'GlobalNavItemSection';
  /** Global Nav L1 item's L2 section children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** Global Nav L1 item section label. */
  label?: Maybe<Scalars['String']>;
};

export type GoogleLoginInfoInput = {
  /** The app used to log in with Google */
  appType: AppTypeEnum;
  /** The google OAuth token required for log in/registration */
  googleOAuthToken: Scalars['String'];
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']>;
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type GreenhouseDepartment = {
  __typename?: 'GreenhouseDepartment';
  /** Unique ID of a GreenhouseDepartment */
  id: Scalars['ID'];
  /** List of jobs available within a GreenhouseDepartment */
  jobs?: Maybe<Array<GreenhouseJob>>;
  /** Kebab Name of a GreenhouseDepartment */
  kebabName: Scalars['String'];
  /** Name of a GreenhouseDepartment */
  name: Scalars['String'];
};

export type GreenhouseJob = {
  __typename?: 'GreenhouseJob';
  /** URL to the job page on nerdwallet.com, of the form `http://www.nerdwallet.com/careers/job/2930840?gh_jid=2930840` */
  absoluteUrl: Scalars['URL'];
  /** Content body of a GreenhouseJob. Contains html-encoded html, e.g. `&lt;p&gt;&lt;span style=&quot;font-weight: 400;&quot;&gt;` */
  content?: Maybe<Scalars['String']>;
  /** Department name */
  department?: Maybe<GreenhouseDepartment>;
  /** Unique ID of a GreenhouseJob */
  id: Scalars['ID'];
  /** Location of the GreenhouseJob */
  location?: Maybe<Scalars['String']>;
  /** Title of a GreenhouseJob */
  title: Scalars['String'];
  /** Last update date */
  updatedAt: Scalars['DateTime'];
};

/** Metadata properties for the given HealthabilityReport */
export type HealthabilityMeta = {
  __typename?: 'HealthabilityMeta';
  /** Indy version used to generate the HealthabilityReport */
  indyVersion: Scalars['String'];
  /** Name of the repo Healthability ran on to generate the given HealthabilityReport */
  repoName: Scalars['String'];
  /** Repo version Healthability ran on to generate the given HealthabilityReport */
  repoVersion: Scalars['String'];
  /** Time when the HealthabilityReport was generated */
  time: Scalars['String'];
};

/** Generated report containing Healthability information for a given repo */
export type HealthabilityReport = {
  __typename?: 'HealthabilityReport';
  /** An array containing all the BuildSpecs that were active when Healthability ran */
  buildSpecs?: Maybe<Array<BuildSpec>>;
  /** The number of views that this application received in the last 30 days, if applicable */
  cumulativeViewCount?: Maybe<Scalars['Int']>;
  /** Metadata properties for the given HealthabilityReport */
  meta?: Maybe<HealthabilityMeta>;
  /** An array of HealthabilitySpecs containing information about the given repo */
  specs?: Maybe<Array<HealthabilitySpec>>;
};

export type HealthabilityRepository = {
  __typename?: 'HealthabilityRepository';
  cumulativeViewCount?: Maybe<Scalars['Int']>;
  name: Scalars['ID'];
};

/** Encapsulate information regarding a specific type of technical debt */
export type HealthabilitySpec = {
  __typename?: 'HealthabilitySpec';
  /** Detailed feedback surfacing detected technical debt and suggested improvements for the given HealthabilitySpec */
  comments: Scalars['String'];
  /** Indicates whether the results of the HealthabilitySpec is displayed to console, and on PR comments */
  disabled: Scalars['Boolean'];
  /** Indicates whether the HealthabilitySpec errored during execution */
  errored: Scalars['Boolean'];
  /** Maximum points possible for the given HealthabilitySpec */
  maxPoints: Scalars['Int'];
  /** Name of the HealthabilitySpec */
  name: Scalars['String'];
  /** Points achieved by the repo for the given HealthabilitySpec */
  points: Scalars['Int'];
  /** Indicates whether the HealthabilitySpec is scored or unscored */
  scored: Scalars['Boolean'];
  /** Optional summary of the comments for the spec */
  summary?: Maybe<Scalars['String']>;
  /** Human-readable title of the HealthabilitySpec */
  title: Scalars['String'];
};

export type HomeInsuranceOfferInput = {
  contactName?: InputMaybe<UserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Query variables for InsurancePrequalOffers */
export type HomeInsurancePrequalOfferInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['String']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type HomeLeadMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']>;
};

export const HotelChoice = {
  Hilton: 'HILTON',
  Hyatt: 'HYATT',
  Ihg: 'IHG',
  Marriott: 'MARRIOTT',
  Other: 'OTHER',
  Radisson: 'RADISSON',
  Wyndham: 'WYNDHAM',
} as const;

export type HotelChoice = (typeof HotelChoice)[keyof typeof HotelChoice];
/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAd = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'HouseAd';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The body text for the house ad. */
    body?: Maybe<Scalars['String']>;
    /** The auth link for the house ad CTA. */
    ctaAuthLink?: Maybe<Scalars['StructuredContentDocument']>;
    /** CTA text for the house ad. */
    ctaText?: Maybe<Scalars['String']>;
    /** The type of CTA for the house ad. Either web link or auth link. */
    ctaType?: Maybe<HouseAdCtaTypeEnum>;
    /** The web url for the house ad CTA link. */
    ctaUrl?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The headline to use for the house ad. */
    headline?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** Which template to use for the house ad. */
    template?: Maybe<HouseAdTemplateEnum>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HouseAdConnectionResponse = {
  __typename?: 'HouseAdConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The HouseAd returned for the connection. */
  items?: Maybe<Array<HouseAd>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for ctaType field on HouseAd type. */
export const HouseAdCtaTypeEnum = {
  AuthLink: 'AUTH_LINK',
  WebLink: 'WEB_LINK',
} as const;

export type HouseAdCtaTypeEnum =
  (typeof HouseAdCtaTypeEnum)[keyof typeof HouseAdCtaTypeEnum];
/** Query to fetch a collection of HouseAd objects. */
export type HouseAdFilterInput = {
  /** Limit collection to HouseAds published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to HouseAds with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Enum values for template field on HouseAd type. */
export const HouseAdTemplateEnum = {
  Card: 'CARD',
  EntryBanner: 'ENTRY_BANNER',
  Horizontal: 'HORIZONTAL',
  Vertical: 'VERTICAL',
} as const;

export type HouseAdTemplateEnum =
  (typeof HouseAdTemplateEnum)[keyof typeof HouseAdTemplateEnum];
export const HowCashBack = {
  Categories: 'CATEGORIES',
  SameRate: 'SAME_RATE',
} as const;

export type HowCashBack = (typeof HowCashBack)[keyof typeof HowCashBack];
export const HowLongToPayOffDebt = {
  LessThan_18Months: 'LESS_THAN_18_MONTHS',
  MoreThan_18Months: 'MORE_THAN_18_MONTHS',
} as const;

export type HowLongToPayOffDebt =
  (typeof HowLongToPayOffDebt)[keyof typeof HowLongToPayOffDebt];
export const HowMuchTransferFee = {
  Between_3And_5: 'BETWEEN_3_AND_5',
  LessThan_3: 'LESS_THAN_3',
} as const;

export type HowMuchTransferFee =
  (typeof HowMuchTransferFee)[keyof typeof HowMuchTransferFee];
export const HowOftenTravel = {
  FourToNine: 'FOUR_TO_NINE',
  MoreThan_10: 'MORE_THAN_10',
  OneToThree: 'ONE_TO_THREE',
} as const;

export type HowOftenTravel =
  (typeof HowOftenTravel)[keyof typeof HowOftenTravel];
/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type Hub = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'Hub';
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The custom content to display below the featured boxes. */
    customContentBelowFeaturedBoxes?: Maybe<
      Scalars['StructuredContentDocument']
    >;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The boxes to display on the Hub. */
    featuredBoxes?: Maybe<Array<HubFeaturedBox>>;
    /** Represents each of the content sections on the page. */
    featuredContent?: Maybe<Array<HubFeaturedContent>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The content to display in the header of the hub below the title. */
    headerSubtitle?: Maybe<Scalars['StructuredContentDocument']>;
    /** Whether this is a Topic hub or Category hub. */
    hubType?: Maybe<HubTypeEnum>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The categories to display the latest content from. */
    latestContentCategories?: Maybe<Array<Scalars['String']>>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The marketplace entities to display for this hub. */
    marketplaceEntities?: Maybe<Array<HubMarketplaceEntity>>;
    /** The title of the Marketplace section. */
    marketplaceSectionTitle?: Maybe<Scalars['String']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The post types to display the latest content from. */
    postTypes?: Maybe<Array<PostTypeEnum>>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** The Q&A to display on this Hub. */
    questions?: Maybe<Array<HubQuestion>>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** The section title for the reviews section. */
    reviewSectionTitle?: Maybe<Scalars['String']>;
    /** The curated list of reviews to display. */
    reviews?: Maybe<Array<Review>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HubConnectionResponse = {
  __typename?: 'HubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Hub returned for the connection. */
  items?: Maybe<Array<Hub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Type modeling the data within the featuredBoxes group of fields on the Hub type. */
export type HubFeaturedBox = {
  __typename?: 'HubFeaturedBox';
  /** The description text for the featured box. */
  description?: Maybe<Scalars['String']>;
  /** The icon to display within the featured box. */
  icon?: Maybe<Scalars['String']>;
  /** The label text for the featured box. */
  iconLabel?: Maybe<Scalars['String']>;
  /** The post entity the featured box should link to. */
  link?: Maybe<HubLinkUnion>;
  /** The content this featured box should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The title text for the featured box. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the featuredContent group of fields on the Hub type. */
export type HubFeaturedContent = {
  __typename?: 'HubFeaturedContent';
  /** The category the latest content in this section should be displayed from. */
  category?: Maybe<Category>;
  /** The content to display in this section. */
  content?: Maybe<Array<ContentSearchResult>>;
  /** The selected display layout for the section */
  layout?: Maybe<HubLayoutEnum>;
  title?: Maybe<Scalars['String']>;
  /** Whether to display a curated list of content for the section or a latest list of content in a particular category. */
  whatToShow?: Maybe<HubWhatToShowEnum>;
};

/** Query to fetch a collection of Hub objects. */
export type HubFilterInput = {
  /** Limit collection to Hubs published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to Hubs with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to Hubs with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for layout field on Hub type. */
export const HubLayoutEnum = {
  Default: 'DEFAULT',
  FeatureVertical: 'FEATURE_VERTICAL',
  ThreeInline: 'THREE_INLINE',
  TwoInline: 'TWO_INLINE',
} as const;

export type HubLayoutEnum = (typeof HubLayoutEnum)[keyof typeof HubLayoutEnum];
/** The union containing the Type members that can be returned by the link field on the Hub type. */
export type HubLinkUnion =
  | Article
  | CalculatorPage
  | ContentHub
  | Hub
  | InsurancePage
  | LandingPage
  | Page
  | Post
  | Review
  | Roundup
  | UrlRecord;

/** Type modeling the data within the marketplaceEntities group of fields on the Hub type. */
export type HubMarketplaceEntity = {
  __typename?: 'HubMarketplaceEntity';
  /** The entity id. */
  entity?: Maybe<MarketplaceEntityInterface>;
  /** The entity id. */
  id?: Maybe<Scalars['String']>;
  /** The entity title. */
  title?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the questions group of fields on the Hub type. */
export type HubQuestion = {
  __typename?: 'HubQuestion';
  /** The answer for the question prompt. */
  answer?: Maybe<Scalars['StructuredContentDocument']>;
  /** The content this question should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The question prompt. */
  question?: Maybe<Scalars['String']>;
};

/** Enum values for hubType field on Hub type. */
export const HubTypeEnum = {
  Category: 'CATEGORY',
  Topic: 'TOPIC',
} as const;

export type HubTypeEnum = (typeof HubTypeEnum)[keyof typeof HubTypeEnum];
/** Enum values for whatToShow field on Hub type. */
export const HubWhatToShowEnum = {
  Default: 'DEFAULT',
  LatestContent: 'LATEST_CONTENT',
  Manual: 'MANUAL',
} as const;

export type HubWhatToShowEnum =
  (typeof HubWhatToShowEnum)[keyof typeof HubWhatToShowEnum];
export type IavDetailsResponse = {
  __typename?: 'IAVDetailsResponse';
  accountNumber: Scalars['String'];
  holderNames: Array<Scalars['String']>;
  routingNumber: Scalars['String'];
};

/** The input for filtering results by ID. */
export type IdFilterInput = {
  /** Exclude items with specific IDs from the collection. */
  exclude?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to items with specific IDs. */
  include?: InputMaybe<Array<Scalars['Int']>>;
};

/** The `IdentityAddress` type represents the address for a global identity profile */
export type IdentityAddress = {
  __typename?: 'IdentityAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  isValidated?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  state: Scalars['String'];
  validatedAt?: Maybe<Scalars['String']>;
  validatedBy?: Maybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

/** The `IdentityAddressInput` input defines the ingress Address model. */
export type IdentityAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  isValidated?: InputMaybe<Scalars['Boolean']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  state: Scalars['String'];
  validatedAt?: InputMaybe<Scalars['String']>;
  validatedBy?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type InitializeLinkTokenResponse = {
  __typename?: 'InitializeLinkTokenResponse';
  token: Scalars['String'];
};

export const InstitutionCountryCode = {
  Ca: 'CA',
  Us: 'US',
} as const;

export type InstitutionCountryCode =
  (typeof InstitutionCountryCode)[keyof typeof InstitutionCountryCode];
/** Institution contains the common base fields for all institutions. */
export type InstitutionInterface = {
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type InsuranceAirField = {
  __typename?: 'InsuranceAirField';
  format?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

export type InsuranceAirList = {
  __typename?: 'InsuranceAirList';
  data: Array<InsuranceAirListItem>;
  listName?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['String']>;
};

export type InsuranceAirListItem = {
  __typename?: 'InsuranceAirListItem';
  annualPremium: Scalars['Int'];
  company: Scalars['String'];
  monthlyPremium: Scalars['Int'];
};

/** A Insurance institution */
export type InsuranceInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'InsuranceInstitutionV2';
    /** Cons bullet points */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Pros bullet points */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** The overall editorial rating for the institution */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** Short summary of why NerdWallet recommends this insurance provider */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** Particular prequal job with it's offers populated (v2) */
export type InsuranceJobWithOffers = {
  __typename?: 'InsuranceJobWithOffers';
  job?: Maybe<PrequalJob>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  status?: Maybe<PrequalOfferStatus>;
};

/** A Insurance offer */
export type InsuranceOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'InsuranceOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** Short summary of why NerdWallet recommends this insurance provider */
    bottomLineText?: Maybe<Scalars['String']>;
    /** Cons bullet points */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity */
    displayName?: Maybe<Scalars['String']>;
    /** The tooltip value that should be displayed alongside the entity name */
    displayNameTooltip?: Maybe<Scalars['String']>;
    /** The driver can buy online associated with the entity */
    driverCanBuyOnline?: Maybe<EntityPlacementDriver>;
    /** The driver coverage options associated with the entity */
    driverCoverageOptions?: Maybe<EntityPlacementDriver>;
    /** The driver discounts associated with the entity */
    driverDiscounts?: Maybe<EntityPlacementDriver>;
    /** The driver ease of use associated with the entity */
    driverEaseOfUse?: Maybe<EntityPlacementDriver>;
    /** The driver financial strength rating associated with the entity */
    driverFinancialStrengthRating?: Maybe<EntityPlacementDriver>;
    /** The driver NAIC complaints associated with the entity */
    driverNAICComplaints?: Maybe<EntityPlacementDriver>;
    /** The driver policies offered associated with the entity */
    driverPoliciesOffered?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Phone number by carrier */
    phoneNumber?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: InsuranceProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** Pros bullet points */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer's product. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The overall editorial rating for this Offer. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this insurance provider */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** Format of response to qsInsuranceOffers query (v1) */
export type InsuranceOffersResponse = {
  __typename?: 'InsuranceOffersResponse';
  offers?: Maybe<Array<InsuranceOfferV2>>;
};

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePage = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'InsurancePage';
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the InsurancePage object. */
    categories?: Maybe<Array<Category>>;
    /** The city the content on the insurance page is for. */
    city?: Maybe<Scalars['String']>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The type of insurance page. */
    insurancePageType?: Maybe<InsurancePageTypeEnum>;
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The make of the car this insurance page is for. */
    make?: Maybe<Scalars['String']>;
    /** The model of the car this insurance page is for. */
    model?: Maybe<Scalars['String']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The pricing code for an insurance page. Default: 665689. */
    pricingCode?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The state the content on the insurance page is for. */
    state?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['StructuredContentDocument']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** The URL path to query for Insurance Pages by. */
    url?: Maybe<Scalars['URL']>;
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type InsurancePageConnectionResponse = {
  __typename?: 'InsurancePageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The InsurancePage returned for the connection. */
  items?: Maybe<Array<InsurancePage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of InsurancePage objects. */
export type InsurancePageFilterInput = {
  /** Limit collection to InsurancePages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsurancePages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to InsurancePages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to InsurancePages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']>;
};

/** Enum values for insurancePageType field on InsurancePage type. */
export const InsurancePageTypeEnum = {
  City: 'CITY',
  MakeModel: 'MAKE_MODEL',
} as const;

export type InsurancePageTypeEnum =
  (typeof InsurancePageTypeEnum)[keyof typeof InsurancePageTypeEnum];
/** Format of response to insurancePrequalOffersByJobIdResponse (v2) */
export type InsurancePrequalOffersByJobIdResponse = {
  __typename?: 'InsurancePrequalOffersByJobIdResponse';
  jobs?: Maybe<Array<InsuranceJobWithOffers>>;
};

/** Format of response to insurancePrequalOffersJob query (v2) */
export type InsurancePrequalOffersJobResponse = {
  __typename?: 'InsurancePrequalOffersJobResponse';
  jobs?: Maybe<Array<PrequalJob>>;
  status?: Maybe<PrequalOfferStatus>;
};

/** Format of response to insurancePrequalOffers query (v1) */
export type InsurancePrequalOffersResponse = {
  __typename?: 'InsurancePrequalOffersResponse';
  offers?: Maybe<Array<InsuranceOfferV2>>;
  status?: Maybe<PrequalOfferStatus>;
};

/** A Insurance product */
export type InsuranceProductV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceProductInterface & {
    __typename?: 'InsuranceProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: InsuranceInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Phone number by carrier */
    phoneNumber?: Maybe<Scalars['String']>;
    /** Product type */
    productType: Scalars['String'];
    /** The URL to the NerdWallet review of this product. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** Enum of providerIds that are accepted by the insurance offers routes */
export const InsuranceProviderEnum = {
  Mock: 'MOCK',
  Quinstreet: 'QUINSTREET',
} as const;

export type InsuranceProviderEnum =
  (typeof InsuranceProviderEnum)[keyof typeof InsuranceProviderEnum];
/** Enum to differentiate between different verticals for the v1 insurance endpoint */
export const InsuranceVerticalEnum = {
  AutoInsurance: 'AUTO_INSURANCE',
  HomeInsurance: 'HOME_INSURANCE',
  LifeInsurance: 'LIFE_INSURANCE',
} as const;

export type InsuranceVerticalEnum =
  (typeof InsuranceVerticalEnum)[keyof typeof InsuranceVerticalEnum];
/** Type modeling the data within the internationalVersions group of fields on the Article type. */
export type InternationalVersion = {
  __typename?: 'InternationalVersion';
  /** Locale associated with this alternate version. */
  locale?: Maybe<Scalars['String']>;
  /** URL for this content in the associated locale. */
  url?: Maybe<Scalars['URL']>;
};

/** A Investing institution */
export type InvestingInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'InvestingInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** The overall, editorial rating for the institution. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Investing offer */
export type InvestingOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'InvestingOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** Short description of what the offer is best for e.g. customer service */
    bestForBullets?: Maybe<Array<Scalars['String']>>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** A list of brokerage features for this offer such as promotion, low cost, advisor, etc. */
    brokerageFeatures?: Maybe<Array<Scalars['String']>>;
    /** Brokerage feature for this offer such as self or robo management. */
    brokerageManagement?: Maybe<Scalars['String']>;
    /** The categories that apply to this investing offer. */
    categories?: Maybe<Array<Scalars['String']>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver account minimum associated with the entity */
    driverAccountMinimum?: Maybe<EntityPlacementDriver>;
    /** The driver fees associated with the entity */
    driverFees?: Maybe<EntityPlacementDriver>;
    /** The options contract driver fees associated with the entity */
    driverOptionsContractFee?: Maybe<EntityPlacementDriver>;
    /** The driver promotion associated with the entity */
    driverPromotion?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Checks if the current investing offer is a Fidelity Offer */
    isFidelityOffer?: Maybe<Scalars['Boolean']>;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Checks if the current investing offer is an RIA (registered investment advisor) offer */
    isRiaOffer?: Maybe<Scalars['Boolean']>;
    /**
     * Renders an Investing Offer Driver in non structured content format.
     * TODO: We eventually want to be consistent and use structured content
     * formatting going forward.  However this most likely will not be implemented
     * until we have our Currency OfferCard completed
     */
    legacyDrivers: Array<LegacyDriver>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** The month and year range the reviewedAtDate covers */
    periodConsideredDate?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: InvestingProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer's product */
    reviewLink?: Maybe<Scalars['URL']>;
    /** The month and date that an offer was reviewed in string format */
    reviewedAtDate?: Maybe<Scalars['String']>;
    /** The disclaimer text that should be rendered for RIA offers */
    riaDisclaimerText?: Maybe<Scalars['String']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The overall editorial rating for this Offer. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short sentence summary of the Investing Offer */
    summaryShort?: Maybe<Scalars['String']>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    tagline?: Maybe<Scalars['String']>;
    /** Trading frequency such as weekly, monthly or occasionally. */
    tradingFrequency?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Investing product */
export type InvestingProductV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceProductInterface & {
    __typename?: 'InvestingProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: InvestingInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** The URL to the NerdWallet review of this product. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type InvestmentAccountInstitution = InstitutionInterface & {
  __typename?: 'InvestmentAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type InvestmentAccountOffer = AccountOfferInterface &
  OfferInterface & {
    __typename?: 'InvestmentAccountOffer';
    advisorFee?: Maybe<Scalars['String']>;
    applyLink?: Maybe<Scalars['URL']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    dataHash?: Maybe<Scalars['String']>;
    details?: Maybe<InvestmentAccountOfferDetails>;
    endsAt?: Maybe<Scalars['DateTime']>;
    entityType: Scalars['String'];
    externalId?: Maybe<Scalars['String']>;
    flatTradePrice?: Maybe<Scalars['Float']>;
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    institution?: Maybe<InvestmentAccountInstitution>;
    isMonetizing?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    productId?: Maybe<Scalars['ID']>;
    productType: Scalars['String'];
    providerName?: Maybe<Scalars['String']>;
    rating?: Maybe<Scalars['Float']>;
    reviewUrl?: Maybe<Scalars['String']>;
    slug?: Maybe<Scalars['String']>;
    status: Scalars['String'];
    tags: Array<Scalars['String']>;
    updatedAt?: Maybe<Scalars['DateTime']>;
    versionId?: Maybe<Scalars['ID']>;
  };

export type InvestmentAccountOfferDetails = {
  __typename?: 'InvestmentAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type ItemizedScore = {
  __typename?: 'ItemizedScore';
  availablePoints?: Maybe<Scalars['Int']>;
  awardedPoints?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
};

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPage = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithEditorInterface &
  PostWithFeaturedImageInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'LandingPage';
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the LandingPage object. */
    categories?: Maybe<Array<Category>>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['String']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LandingPageConnectionResponse = {
  __typename?: 'LandingPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LandingPage returned for the connection. */
  items?: Maybe<Array<LandingPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LandingPage objects. */
export type LandingPageFilterInput = {
  /** Limit collection to LandingPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to LandingPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to LandingPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data within a particular column in the layout */
export type LayoutColumn = {
  __typename?: 'LayoutColumn';
  /** The structured content document to render within this column */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** Name of the column within the row. This will be used for analytics purposes and debugging */
  name: Scalars['String'];
  /** How the contents within the column should be aligned vertically */
  verticalAlign?: Maybe<LayoutVerticalAlignEnum>;
  /** The width properties for the column */
  width?: Maybe<LayoutColumnWidth>;
};

/** Type containing the width settings for the column. */
export type LayoutColumnWidth = {
  __typename?: 'LayoutColumnWidth';
  /** The width of the column within the desktop breakpoint */
  desktop?: Maybe<Scalars['Int']>;
  /** The width of the column within the mobile breakpoint */
  mobile?: Maybe<Scalars['Int']>;
};

/** Type modelling the fields for a row within a page layout */
export type LayoutRow = {
  __typename?: 'LayoutRow';
  /** The columns to display within the row. */
  columns?: Maybe<Array<LayoutColumn>>;
  /** Param to toggle full width or centered container */
  fullWidth?: Maybe<Scalars['Boolean']>;
  /** The name of the section in the layout. This will be used for analytics purposes */
  name: Scalars['String'];
};

/** The vertical alignment options for a column */
export const LayoutVerticalAlignEnum = {
  Bottom: 'BOTTOM',
  Center: 'CENTER',
  Top: 'TOP',
} as const;

export type LayoutVerticalAlignEnum =
  (typeof LayoutVerticalAlignEnum)[keyof typeof LayoutVerticalAlignEnum];
export type LegacyDriver = {
  __typename?: 'LegacyDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /** The driver label */
  label: Scalars['String'];
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']>;
  /** The value of the driver */
  value?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLender = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'LegacyLender';
    applyDisclaimerText?: Maybe<Scalars['String']>;
    applyText?: Maybe<Scalars['String']>;
    applyUrl?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the LegacyLender object. */
    categories?: Maybe<Array<Category>>;
    /** The negative bullet points about the product. */
    cons?: Maybe<Array<Scalars['String']>>;
    /** The custom URL to use for linking to a review. */
    customReviewUrl?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    lenderId?: Maybe<Scalars['String']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** Field connecting to the LegacyLenderMaxLTV Type and all of its nested fields. */
    maxLTV?: Maybe<LegacyLenderMaxLtv>;
    /** Field connecting to the LegacyLenderMinCreditScore Type and all of its nested fields. */
    minCreditScore?: Maybe<LegacyLenderMinCreditScore>;
    /** Field connecting to the LegacyLenderMinDownPayment Type and all of its nested fields. */
    minDownPayment?: Maybe<LegacyLenderMinDownPayment>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Field connecting to the LegacyLenderNationalRegional Type and all of its nested fields. */
    nationalRegional?: Maybe<LegacyLenderNationalRegional>;
    personalizedRatesEnabled?: Maybe<Scalars['Boolean']>;
    productEntity?: Maybe<MarketplaceEntityInterface>;
    productId?: Maybe<Scalars['String']>;
    /** The positive bullet points about the product. */
    pros?: Maybe<Array<Scalars['String']>>;
    /** The NerdWallet rating for the product. */
    rating?: Maybe<Scalars['Float']>;
    /** Reviews associated with this content. */
    review?: Maybe<LegacyLenderReviewUnion>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    whyWeLikeIt?: Maybe<Scalars['String']>;
  };

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LegacyLenderConnectionResponse = {
  __typename?: 'LegacyLenderConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The LegacyLender returned for the connection. */
  items?: Maybe<Array<LegacyLender>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of LegacyLender objects. */
export type LegacyLenderFilterInput = {
  /** Limit collection to LegacyLenders published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit collection to LegacyLenders with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

export type LegacyLenderMaxLtv = {
  __typename?: 'LegacyLenderMaxLTV';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinCreditScore = {
  __typename?: 'LegacyLenderMinCreditScore';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  hel?: Maybe<Scalars['String']>;
  heloc?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  usda?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderMinDownPayment = {
  __typename?: 'LegacyLenderMinDownPayment';
  conventional?: Maybe<Scalars['String']>;
  fha?: Maybe<Scalars['String']>;
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
  va?: Maybe<Scalars['String']>;
};

export type LegacyLenderNationalRegional = {
  __typename?: 'LegacyLenderNationalRegional';
  header?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

/** The union containing the Type members that can be returned by the review field on the LegacyLender type. */
export type LegacyLenderReviewUnion = Post | Review;

export const LicenseStatusEnum = {
  NoLicense: 'NO_LICENSE',
  Permit: 'PERMIT',
  Suspended: 'SUSPENDED',
  Temporary: 'TEMPORARY',
  Valid: 'VALID',
} as const;

export type LicenseStatusEnum =
  (typeof LicenseStatusEnum)[keyof typeof LicenseStatusEnum];
/** Query variables for qsInsuranceOffers */
export type LifeInsuranceOfferInput = {
  age?: InputMaybe<Scalars['Int']>;
  tobaccoUse?: InputMaybe<Scalars['Boolean']>;
};

/** Query variables for InsurancePrequalOffers */
export type LifeInsurancePrequalOfferInput = {
  age?: InputMaybe<Scalars['Int']>;
  tobaccoUse?: InputMaybe<Scalars['Boolean']>;
};

export type LogInUserResponse = AuthenticationResponseInterface & {
  __typename?: 'LogInUserResponse';
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
};

export type LogOutUserResponse = {
  __typename?: 'LogOutUserResponse';
  /** Determines whether user log out was successful */
  success: Scalars['Boolean'];
};

export type MarkNotificationAsDismissedResponse = {
  __typename?: 'MarkNotificationAsDismissedResponse';
  /** The updated notification that has been marked as dismissed. */
  item: Notification;
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

export type MarkNotificationAsPinnedResponse = {
  __typename?: 'MarkNotificationAsPinnedResponse';
  /** The updated notification that has been marked as pinned. */
  item: Notification;
};

export type MarkNotificationAsReadResponse = {
  __typename?: 'MarkNotificationAsReadResponse';
  /** The updated notification that has been marked as read. */
  item: Notification;
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

export type MarkNotificationAsUndismissedResponse = {
  __typename?: 'MarkNotificationAsUndismissedResponse';
  /** The updated notification that has been marked as undismissed. */
  item: Notification;
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

export type MarkNotificationAsUnpinnedResponse = {
  __typename?: 'MarkNotificationAsUnpinnedResponse';
  /** The updated notification that has been marked as unpinned. */
  item: Notification;
};

export type MarkNotificationAsUnreadResponse = {
  __typename?: 'MarkNotificationAsUnreadResponse';
  /** The updated notification that has been marked as unread. */
  item: Notification;
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int'];
};

/** The aggregator type should only be one of a subset of all marketplace institution types */
export const MarketplaceAggregatorType = {
  Plaid: 'plaid',
  Unknown: 'unknown',
  Yodlee: 'yodlee',
} as const;

export type MarketplaceAggregatorType =
  (typeof MarketplaceAggregatorType)[keyof typeof MarketplaceAggregatorType];
/** Interface for all Marketplace entity types (Institution, Product, and Offer) */
export type MarketplaceEntityInterface = {
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export type MarketplaceEntityRelatedReviewUnion = Review | ReviewRedirect;

export const MarketplaceEntityStatusEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;

export type MarketplaceEntityStatusEnum =
  (typeof MarketplaceEntityStatusEnum)[keyof typeof MarketplaceEntityStatusEnum];
/** Enum values for entityType field on Review type. */
export const MarketplaceEntityTypeEnum = {
  Default: 'DEFAULT',
  Institutions: 'INSTITUTIONS',
  Offers: 'OFFERS',
  Products: 'PRODUCTS',
} as const;

export type MarketplaceEntityTypeEnum =
  (typeof MarketplaceEntityTypeEnum)[keyof typeof MarketplaceEntityTypeEnum];
/** Common interface for marketplace entities that can win a Best Of Awards Badge for 2021 */
export type MarketplaceEntityWithBestOfAwards2021Interface = {
  /**
   * The list of NW Best-Of Awards this offer has won for 2021
   * @deprecated This year specific best of badge field is now succeeded by a generic best of awards field. Use the bestOfAwards field on the MarketplaceEntityWithBestOfAwardsInterface interface instead.
   */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

/** Common interface for marketplace entities that can win a Best Of Awards Badge */
export type MarketplaceEntityWithBestOfAwardsInterface = {
  /** The list of NW Best Of Awards this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
};

/** Common interface for marketplace entities that can be used in a placement */
export type MarketplaceEntityWithPlacementInterface = {
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String'];
  /** The drivers associated with the entity */
  placementDrivers: Array<Maybe<EntityPlacementDriver>>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean'];
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean'];
};

/** Common interface for marketplace entities with qualification bullets */
export type MarketplaceEntityWithQualificationsInterface = {
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']>>;
};

/** Common interface for marketplace entities with review links */
export type MarketplaceEntityWithReviewInterface = {
  reviewLink?: Maybe<Scalars['URL']>;
};

/** Common interface for marketplace entities with a star rating */
export type MarketplaceEntityWithStarRatingInterface = {
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPoint = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'MarketplaceEntryPoint';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The body text to use in this Marketplace Entry Point. */
    body?: Maybe<Scalars['String']>;
    /** The CTA annotation to use in this Marketplace Entry Point. */
    ctaAnnotation?: Maybe<Scalars['String']>;
    /** The CTA text to use in this Marketplace Entry Point. */
    ctaText?: Maybe<Scalars['String']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The heading text to use in this Marketplace Entry Point. */
    heading?: Maybe<Scalars['String']>;
    /** The text to use in the Highlights section in this Marketplace Entry Point. */
    highlights?: Maybe<Array<Scalars['String']>>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The Marketplace entity associated with this Marketplace Entry Point. */
    marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
    /** The Marketplace entity associated with this Marketplace Entry Point. */
    marketplaceEntityId?: Maybe<Scalars['String']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The short body text to use in this Marketplace Entry Point. Rendered in the "Minimal" template only. */
    shortBody?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The template to use for this entry point. */
    template?: Maybe<MarketplaceEntryPointTemplateEnum>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MarketplaceEntryPointConnectionResponse = {
  __typename?: 'MarketplaceEntryPointConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The MarketplaceEntryPoint returned for the connection. */
  items?: Maybe<Array<MarketplaceEntryPoint>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of MarketplaceEntryPoint objects. */
export type MarketplaceEntryPointFilterInput = {
  /** Limit collection to MarketplaceEntryPoints published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MarketplaceEntryPoints with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Enum values for template field on MarketplaceEntryPoint type. */
export const MarketplaceEntryPointTemplateEnum = {
  Card: 'CARD',
  Default: 'DEFAULT',
  Detailed: 'DETAILED',
  Horizontal: 'HORIZONTAL',
  Minimal: 'MINIMAL',
  Vertical: 'VERTICAL',
} as const;

export type MarketplaceEntryPointTemplateEnum =
  (typeof MarketplaceEntryPointTemplateEnum)[keyof typeof MarketplaceEntryPointTemplateEnum];
/** marketplaceField query response */
export type MarketplaceFieldResponse = {
  __typename?: 'MarketplaceFieldResponse';
  /** The timestamp for when the entity was created. */
  createdAt: Scalars['DateTime'];
  /** The entity type. */
  entityType: Scalars['String'];
  /** Boolean value that indicates if the marketplace entity is active */
  isActive: Scalars['Boolean'];
  /** The timestamp for when the entity was last ingested. */
  lastIngested?: Maybe<Scalars['DateTime']>;
  /** Name of the marketplace entity */
  name: Scalars['String'];
  /** The type of product for the entity. */
  productType: Scalars['String'];
  /** The timestamp for when the entity was last updated. */
  updatedAt: Scalars['DateTime'];
  /** A string value of the requested marketplace field. */
  value: Scalars['String'];
};

/** Interface for all Marketplace institution types */
export type MarketplaceInstitutionInterface = {
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
};

/** Interface for all Marketplace Offer types */
export type MarketplaceOfferInterface = {
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** The parent Product of this Offer */
  product: MarketplaceProductInterface;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']>;
};

/** Interface for all Marketplace Product types */
export type MarketplaceProductInterface = {
  /** The parent Institution of this Product */
  institution: MarketplaceEntityInterface;
};

/** Enum values for productType field on Review type. */
export const MarketplaceProductTypeEnum = {
  AutoLoans: 'AUTO_LOANS',
  Banking: 'BANKING',
  CreditCards: 'CREDIT_CARDS',
  Default: 'DEFAULT',
  EducationLoans: 'EDUCATION_LOANS',
  Expansion: 'EXPANSION',
  FirstTimeHomeBuyerPrograms: 'FIRST_TIME_HOME_BUYER_PROGRAMS',
  Insurance: 'INSURANCE',
  Investing: 'INVESTING',
  Mortgages: 'MORTGAGES',
  Moving: 'MOVING',
  PersonalLoans: 'PERSONAL_LOANS',
  SmallMediumBusinessLoans: 'SMALL_MEDIUM_BUSINESS_LOANS',
  Software: 'SOFTWARE',
  Taxes: 'TAXES',
  Utilities: 'UTILITIES',
} as const;

export type MarketplaceProductTypeEnum =
  (typeof MarketplaceProductTypeEnum)[keyof typeof MarketplaceProductTypeEnum];
/** Input for marketplace query */
export type MarketplaceQueryInput = {
  field: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['JSON'];
};

/** marketplaceSearch query response */
export type MarketplaceSearchResponse = {
  __typename?: 'MarketplaceSearchResponse';
  /** List of marketplace entities that match your query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
  /** The total number of marketplace entities that match your query. */
  total: Scalars['Int'];
};

/** Input for marketplace sort */
export type MarketplaceSortInput = {
  field: Scalars['String'];
  order: OrderDirectionEnum;
};

export const MarketplaceStatusEnum = {
  Active: 'ACTIVE',
  Inactive: 'INACTIVE',
} as const;

export type MarketplaceStatusEnum =
  (typeof MarketplaceStatusEnum)[keyof typeof MarketplaceStatusEnum];
/** The media details type for media items. */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /**
   * The file path to the image within the uploads directory.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * A unique ID. A hash of the 'file' key.
   * This is necessary in order for ApolloClient 3 to cache the object
   */
  id: Scalars['ID'];
  /**
   * All of the different image crop sizes for a particular media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sizes?: Maybe<Array<MediaSize>>;
  /**
   * A srcSet string including the image sizes requested
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  srcSet?: Maybe<Scalars['String']>;
  /**
   * The width of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
};

/** The media details type for media items. */
export type MediaDetailsSizesArgs = {
  sizes?: InputMaybe<Array<Scalars['String']>>;
};

/** The media details type for media items. */
export type MediaDetailsSrcSetArgs = {
  sizes?: InputMaybe<Array<Scalars['String']>>;
};

/** The WordPress media item type. */
export type MediaItem = PostInterface &
  PostWithAuthorsInterface &
  PostWithTitleInterface & {
    __typename?: 'MediaItem';
    /** The alt text for the image. */
    altText?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** List of available image sizes for a particular image. */
    availableSizes: Array<Scalars['String']>;
    /** The caption for the image. */
    caption?: Maybe<Scalars['String']>;
    /** The cropped version of an image filtered by size. */
    croppedImage?: Maybe<CroppedImageSize>;
    /** An array of cropped versions of an image filtered by size. */
    croppedImages?: Maybe<Array<CroppedImageSize>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The height of the original image in pixels. */
    height?: Maybe<Scalars['Int']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /**
     * Details about the media item.
     * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
     */
    mediaDetails?: Maybe<MediaDetails>;
    /** The type of media. */
    mediaType?: Maybe<Scalars['String']>;
    /** The mime type of media item. */
    mimeType?: Maybe<Scalars['String']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The permalink for where the image lives. */
    sourceUrl?: Maybe<Scalars['URL']>;
    /** A srcSet string including the image sizes requested */
    srcSet?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** The width of the original image in pixels. */
    width?: Maybe<Scalars['Int']>;
  };

/** The WordPress media item type. */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The WordPress media item type. */
export type MediaItemCroppedImageArgs = {
  size?: InputMaybe<MediaItemImageSizeEnum>;
};

/** The WordPress media item type. */
export type MediaItemCroppedImagesArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};

/** The WordPress media item type. */
export type MediaItemDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The WordPress media item type. */
export type MediaItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The WordPress media item type. */
export type MediaItemSrcSetArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};

/** The WordPress media item type. */
export type MediaItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MediaItemConnectionResponse = {
  __typename?: 'MediaItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The MediaItem returned for the connection. */
  items?: Maybe<Array<MediaItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of MediaItem objects. */
export type MediaItemFilterInput = {
  /** Limit collection to MediaItems published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Image crop sizes supported by WP */
export const MediaItemImageSizeEnum = {
  BbArticle: 'BB_ARTICLE',
  Full: 'FULL',
  Large: 'LARGE',
  Medium: 'MEDIUM',
  MediumLarge: 'MEDIUM_LARGE',
  PrimaryL: 'PRIMARY_L',
  PrimaryLUncropped: 'PRIMARY_L_UNCROPPED',
  PrimaryM: 'PRIMARY_M',
  PrimaryMUncropped: 'PRIMARY_M_UNCROPPED',
  PrimaryS: 'PRIMARY_S',
  PrimarySUncropped: 'PRIMARY_S_UNCROPPED',
  PrimaryXl: 'PRIMARY_XL',
  PrimaryXlUncropped: 'PRIMARY_XL_UNCROPPED',
  PrimaryXs: 'PRIMARY_XS',
  PrimaryXsUncropped: 'PRIMARY_XS_UNCROPPED',
  PrimaryXxl: 'PRIMARY_XXL',
  PrimaryXxs: 'PRIMARY_XXS',
  PrimaryXxsUncropped: 'PRIMARY_XXS_UNCROPPED',
  PrimaryXxxl: 'PRIMARY_XXXL',
  Square: 'SQUARE',
  Square_160: 'SQUARE_160',
  Square_350: 'SQUARE_350',
} as const;

export type MediaItemImageSizeEnum =
  (typeof MediaItemImageSizeEnum)[keyof typeof MediaItemImageSizeEnum];
/** Type modeling the data for terms within the nw_media_site taxonomy from WordPress. */
export type MediaSite = TermInterface & {
  __typename?: 'MediaSite';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The logo to display for the media site. */
  logo?: Maybe<MediaItem>;
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The MediaSite object for the parent of this entity. */
  parent?: Maybe<MediaSite>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

/** The media size type for media details. */
export type MediaSize = {
  __typename?: 'MediaSize';
  /**
   * The file name for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']>;
  /**
   * The height of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']>;
  /**
   * The mime type for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mimeType?: Maybe<Scalars['String']>;
  /**
   * The name of the crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  size?: Maybe<Scalars['String']>;
  /**
   * The full url path to the crop of this image.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sourceUrl?: Maybe<Scalars['URL']>;
  /**
   * The width of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']>;
};

/** The expected payload for the `updateMembershipAppActivity` mutation. */
export type MembershipAppActivityInput = {
  activationChecklistLastSessionAt?: InputMaybe<Scalars['DateTime']>;
  activationChecklistSessionCount?: InputMaybe<Scalars['Int']>;
  budget503020ActivatedAt?: InputMaybe<Scalars['DateTime']>;
  budget503020BannerDismissedAt?: InputMaybe<Scalars['DateTime']>;
  creditCardMatchBannerDismissedAt?: InputMaybe<Scalars['DateTime']>;
  creditFactorChangesSeenAt?: InputMaybe<Scalars['DateTime']>;
  downloadAppQrTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']>;
  hideTransactionTipSeenAt?: InputMaybe<Scalars['DateTime']>;
  isTransactionsFilterTooltipSeen?: InputMaybe<Scalars['Boolean']>;
  netWorthGhostCtasDismissed?: InputMaybe<Scalars['JSON']>;
  netWorthHideAccountTipDismissedAt?: InputMaybe<Scalars['DateTime']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: InputMaybe<
    Scalars['DateTime']
  >;
  netWorthSnapshotNotificationDismissedAt?: InputMaybe<Scalars['DateTime']>;
  studentLoanHubBannerDismissedAt?: InputMaybe<Scalars['DateTime']>;
  valuePropTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']>;
};

/**
 * The MembershipAppActivityResponse type records "activity" within the app,
 * such as feature dismissal, or flow progress.
 */
export type MembershipAppActivityResponse = {
  __typename?: 'MembershipAppActivityResponse';
  activationChecklistLastSessionAt?: Maybe<Scalars['DateTime']>;
  activationChecklistSessionCount?: Maybe<Scalars['Int']>;
  budget503020ActivatedAt?: Maybe<Scalars['DateTime']>;
  budget503020BannerDismissedAt?: Maybe<Scalars['DateTime']>;
  creditCardMatchBannerDismissedAt?: Maybe<Scalars['DateTime']>;
  creditFactorChangesSeenAt?: Maybe<Scalars['DateTime']>;
  downloadAppQrTakeoverDismissedAt?: Maybe<Scalars['DateTime']>;
  hideTransactionTipSeenAt?: Maybe<Scalars['DateTime']>;
  isTransactionsFilterTooltipSeen?: Maybe<Scalars['Boolean']>;
  netWorthGhostCtasDismissed?: Maybe<Scalars['JSON']>;
  netWorthHideAccountTipDismissedAt?: Maybe<Scalars['DateTime']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: Maybe<
    Scalars['DateTime']
  >;
  netWorthSnapshotNotificationDismissedAt?: Maybe<Scalars['DateTime']>;
  studentLoanHubBannerDismissedAt?: Maybe<Scalars['DateTime']>;
  valuePropTakeoverDismissedAt?: Maybe<Scalars['DateTime']>;
};

/** This enum represents the possible activation statuses of a particular feature */
export const MembershipFeatureActivationStatusEnum = {
  Activated: 'ACTIVATED',
  Blocked: 'BLOCKED',
  Degraded: 'DEGRADED',
  Unactivated: 'UNACTIVATED',
} as const;

export type MembershipFeatureActivationStatusEnum =
  (typeof MembershipFeatureActivationStatusEnum)[keyof typeof MembershipFeatureActivationStatusEnum];
export type MembershipFeatureActivationStatusInterface = {
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

/**
 * The set of NerdWallet features.  This enum should be a superset of the _enrollable_ features, which are defined in
 * the feature_enrollment_changed analytics event:
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/feature_enrollment_changed.yaml
 */
export const MembershipFeatureEnum = {
  AppLock: 'APP_LOCK',
  AutoValue: 'AUTO_VALUE',
  Bills: 'BILLS',
  Billshark: 'BILLSHARK',
  CardLinkedOffers: 'CARD_LINKED_OFFERS',
  CashFlow: 'CASH_FLOW',
  CreditScore: 'CREDIT_SCORE',
  Debt: 'DEBT',
  EmailNotifications: 'EMAIL_NOTIFICATIONS',
  Eoru: 'EORU',
  FinancialAccountAggregation: 'FINANCIAL_ACCOUNT_AGGREGATION',
  GeolocationBrowser: 'GEOLOCATION_BROWSER',
  GeolocationNative: 'GEOLOCATION_NATIVE',
  HomeEquity: 'HOME_EQUITY',
  HomeValue: 'HOME_VALUE',
  Membership: 'MEMBERSHIP',
  MoneyTransfer: 'MONEY_TRANSFER',
  NetWorth: 'NET_WORTH',
  PlayYourCardsRight: 'PLAY_YOUR_CARDS_RIGHT',
  PushNotifications: 'PUSH_NOTIFICATIONS',
} as const;

export type MembershipFeatureEnum =
  (typeof MembershipFeatureEnum)[keyof typeof MembershipFeatureEnum];
export type MigrateFinancialPortalResponse = {
  __typename?: 'MigrateFinancialPortalResponse';
  portal?: Maybe<FinancialPortal>;
};

/** The `MobileAppIdentityProfile` type represents the user's registered devices */
export type MobileAppIdentityProfile = {
  __typename?: 'MobileAppIdentityProfile';
  devices: Array<MobileAppProfileDevice>;
  id?: Maybe<Scalars['String']>;
  newestAppVersionUsed?: Maybe<Scalars['String']>;
  newestAppVersionUsedOnDeviceType?: Maybe<Scalars['String']>;
};

/** The `MobileAppProfileDevice` type represents a device a user has */
export type MobileAppProfileDevice = {
  __typename?: 'MobileAppProfileDevice';
  appVersion: Scalars['String'];
  deviceId: Scalars['String'];
  deviceLastLogin?: Maybe<Scalars['String']>;
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: Maybe<Scalars['Boolean']>;
};

/** The expected payload for the `addMobileAppDevice` mutations */
export type MobileAppProfileDeviceInput = {
  appVersion: Scalars['String'];
  deviceId: Scalars['String'];
  deviceLastLogin?: InputMaybe<Scalars['String']>;
  deviceType: Scalars['String'];
  pushNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type MoneyTransferAccount = {
  __typename?: 'MoneyTransferAccount';
  /** The computed status for this account (combination of money-management + ach statuses) */
  computedStatus?: Maybe<MoneyTransferAccountStatusEnum>;
  /** The identifier found in FDP or legacy-Yodlee */
  financialAccountId: Scalars['ID'];
  /** The last four digits of the account number */
  financialAccountLastFour?: Maybe<Scalars['String']>;
  /** The type of this account (CHECKING or SAVINGS) */
  financialAccountType: MoneyTransferFinancialAccountTypeEnum;
  /** The unique identifier for this linked-account in money-management */
  id: Scalars['ID'];
  /** The institution name (e.g. Wells Fargo) */
  institutionName?: Maybe<Scalars['String']>;
  /** Indicates whether the account passed the holder name match check */
  nameMatchSuccess?: Maybe<Scalars['Boolean']>;
};

export type MoneyTransferAccountEligibility = {
  __typename?: 'MoneyTransferAccountEligibility';
  eligibility: MoneyTransferAccountEligibilityStatusEnum;
  financialAccountType?: Maybe<MoneyTransferFinancialAccountTypeEnum>;
  id: Scalars['ID'];
};

export type MoneyTransferAccountEligibilityResponse = {
  __typename?: 'MoneyTransferAccountEligibilityResponse';
  accounts: Array<MoneyTransferAccountEligibility>;
};

export const MoneyTransferAccountEligibilityStatusEnum = {
  AccountDetailsUnavailable: 'ACCOUNT_DETAILS_UNAVAILABLE',
  AccountNameNotMatching: 'ACCOUNT_NAME_NOT_MATCHING',
  AccountNotVerified: 'ACCOUNT_NOT_VERIFIED',
  Eligible: 'ELIGIBLE',
  InsufficientIavData: 'INSUFFICIENT_IAV_DATA',
  Unknown: 'UNKNOWN',
  UnsupportedAccountType: 'UNSUPPORTED_ACCOUNT_TYPE',
  UnsupportedMoneyMarketAccount: 'UNSUPPORTED_MONEY_MARKET_ACCOUNT',
} as const;

export type MoneyTransferAccountEligibilityStatusEnum =
  (typeof MoneyTransferAccountEligibilityStatusEnum)[keyof typeof MoneyTransferAccountEligibilityStatusEnum];
export const MoneyTransferAccountStatusEnum = {
  AccountAchUnverified: 'ACCOUNT_ACH_UNVERIFIED',
  AccountInactive: 'ACCOUNT_INACTIVE',
  AccountNameMatchFailed: 'ACCOUNT_NAME_MATCH_FAILED',
  AccountNotInAchSystem: 'ACCOUNT_NOT_IN_ACH_SYSTEM',
  AccountReady: 'ACCOUNT_READY',
  AccountRemovedInAch: 'ACCOUNT_REMOVED_IN_ACH',
  AccountUninitialized: 'ACCOUNT_UNINITIALIZED',
  AccountUnlinked: 'ACCOUNT_UNLINKED',
  Unknown: 'UNKNOWN',
} as const;

export type MoneyTransferAccountStatusEnum =
  (typeof MoneyTransferAccountStatusEnum)[keyof typeof MoneyTransferAccountStatusEnum];
export type MoneyTransferCancelTransferResponse = {
  __typename?: 'MoneyTransferCancelTransferResponse';
  success: Scalars['Boolean'];
};

export type MoneyTransferCreateUserInput = {
  address: Scalars['String'];
  birthdate: Scalars['String'];
  city: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullSsn?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  postalCode: Scalars['String'];
  shortSsn: Scalars['String'];
  state: Scalars['String'];
};

export type MoneyTransferCreateUserResponse = {
  __typename?: 'MoneyTransferCreateUserResponse';
  user?: Maybe<MoneyTransferUser>;
};

export type MoneyTransferDefaultTransferLimits = {
  __typename?: 'MoneyTransferDefaultTransferLimits';
  balanceCheckBufferAmountDollars: Scalars['Int'];
  balanceCheckBufferAmountDollarsWarning: Scalars['Int'];
  checkingAccountDailyLimit: Scalars['Int'];
  checkingAccountMonthlyLimit: Scalars['Int'];
  checkingAccountWeeklyLimit: Scalars['Int'];
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
  minSingleTransferAmountDollars: Scalars['Int'];
  savingsAccountDailyLimit: Scalars['Int'];
  savingsAccountMonthlyLimit: Scalars['Int'];
  savingsAccountWeeklyLimit: Scalars['Int'];
  userDailyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
};

export type MoneyTransferFinancialAccountTransferLimits = {
  __typename?: 'MoneyTransferFinancialAccountTransferLimits';
  dayLimit: Scalars['Int'];
  id: Scalars['ID'];
  maxTransferAmountDollars: Scalars['Int'];
  monthLimit: Scalars['Int'];
  weekLimit: Scalars['Int'];
};

export const MoneyTransferFinancialAccountTypeEnum = {
  Checking: 'CHECKING',
  Savings: 'SAVINGS',
} as const;

export type MoneyTransferFinancialAccountTypeEnum =
  (typeof MoneyTransferFinancialAccountTypeEnum)[keyof typeof MoneyTransferFinancialAccountTypeEnum];
export type MoneyTransferKbaAnswer = {
  __typename?: 'MoneyTransferKbaAnswer';
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type MoneyTransferKbaQuestion = {
  __typename?: 'MoneyTransferKbaQuestion';
  answers: Array<MoneyTransferKbaAnswer>;
  id: Scalars['ID'];
  text: Scalars['String'];
};

export type MoneyTransferKbaQuestionsResponse = {
  __typename?: 'MoneyTransferKbaQuestionsResponse';
  questions: Array<MoneyTransferKbaQuestion>;
};

export type MoneyTransferTransfer = {
  __typename?: 'MoneyTransferTransfer';
  /** A JSON blob with additional transfer details */
  achData?: Maybe<Scalars['JSON']>;
  /** The transfer amount in USD */
  amount: Scalars['Float'];
  /** Indicates if the user can still cancel this transfer */
  canCancel?: Maybe<Scalars['Boolean']>;
  /** The destination account to where the money is deposited */
  destinationAccount: MoneyTransferAccount;
  /** The unique identifier for this transfer in money-management */
  id: Scalars['ID'];
  /** Timestamp indicating when the (high-level) status was last updated */
  lastStatusUpdatedAt: Scalars['DateTime'];
  /** The source account from where the money is retrieved */
  sourceAccount: MoneyTransferAccount;
  /** The current (high-level) status for this transfer (combination of money-management + ach statuses) */
  status: MoneyTransferTransferStatusEnum;
  /**
   * The status histories define when and what state changes occurred over the lifecycle
   * of the transfer
   */
  statusHistory: Array<MoneyTransferTransferStatusHistory>;
  /** Indicates the speed of the transfer */
  type?: Maybe<MoneyTransferTransferTypeEnum>;
  /** Timestamp indicating when the user attempted to initiate the transfer */
  userInitiatedAt: Scalars['DateTime'];
};

export type MoneyTransferTransferLimits = {
  __typename?: 'MoneyTransferTransferLimits';
  defaultLimits: MoneyTransferDefaultTransferLimits;
  financialAccountLimits: Array<MoneyTransferFinancialAccountTransferLimits>;
  userLimits: MoneyTransferUserTransferLimits;
};

export type MoneyTransferTransferLimitsResponse = {
  __typename?: 'MoneyTransferTransferLimitsResponse';
  transferLimits: MoneyTransferTransferLimits;
};

export const MoneyTransferTransferStatusEnum = {
  Cancelled: 'CANCELLED',
  CancelInitiatedBySecurity: 'CANCEL_INITIATED_BY_SECURITY',
  CancelInitiatedByUser: 'CANCEL_INITIATED_BY_USER',
  Completed: 'COMPLETED',
  Created: 'CREATED',
  Failed: 'FAILED',
  FailedDuringActivation: 'FAILED_DURING_ACTIVATION',
  MockTransfer: 'MOCK_TRANSFER',
  Pending: 'PENDING',
  PendingBalanceCheck: 'PENDING_BALANCE_CHECK',
  Uninitialized: 'UNINITIALIZED',
} as const;

export type MoneyTransferTransferStatusEnum =
  (typeof MoneyTransferTransferStatusEnum)[keyof typeof MoneyTransferTransferStatusEnum];
export type MoneyTransferTransferStatusHistory = {
  __typename?: 'MoneyTransferTransferStatusHistory';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  status: MoneyTransferTransferStatusEnum;
  transferId: Scalars['ID'];
};

export const MoneyTransferTransferTypeEnum = {
  NextDay: 'NEXT_DAY',
  Standard: 'STANDARD',
} as const;

export type MoneyTransferTransferTypeEnum =
  (typeof MoneyTransferTransferTypeEnum)[keyof typeof MoneyTransferTransferTypeEnum];
export type MoneyTransferUser = {
  __typename?: 'MoneyTransferUser';
  /** Computed status for this user (combination of money-management + ach statuses) */
  computedStatus: MoneyTransferUserStatus;
  /** KYC first name */
  firstName: Scalars['String'];
  /** KYC last name */
  lastName: Scalars['String'];
};

export const MoneyTransferUserStatus = {
  Unknown: 'UNKNOWN',
  UserAchDisabled: 'USER_ACH_DISABLED',
  UserAchEnabled: 'USER_ACH_ENABLED',
  UserAchKba: 'USER_ACH_KBA',
  UserAchRetryWithFullSsn: 'USER_ACH_RETRY_WITH_FULL_SSN',
  UserInactive: 'USER_INACTIVE',
  UserNotInAchSystem: 'USER_NOT_IN_ACH_SYSTEM',
  UserReady: 'USER_READY',
  UserUninitialized: 'USER_UNINITIALIZED',
} as const;

export type MoneyTransferUserStatus =
  (typeof MoneyTransferUserStatus)[keyof typeof MoneyTransferUserStatus];
export type MoneyTransferUserTransferLimits = {
  __typename?: 'MoneyTransferUserTransferLimits';
  maxMonthlyTransferAmountDollars: Scalars['Int'];
  maxSingleTransferAmountDollars: Scalars['Int'];
  userDailyLimit: Scalars['Int'];
  userMonthlyLimit: Scalars['Int'];
  userWeeklyLimit: Scalars['Int'];
};

/** Employment type */
export const MortgageEmploymentTypeEnum = {
  FullTime: 'FULL_TIME',
  PartTime: 'PART_TIME',
  SelfEmployed: 'SELF_EMPLOYED',
  Unemployed: 'UNEMPLOYED',
} as const;

export type MortgageEmploymentTypeEnum =
  (typeof MortgageEmploymentTypeEnum)[keyof typeof MortgageEmploymentTypeEnum];
/** Inputs for Mortgage lender match logic.  Subset of Mortgage OSX inputs */
export type MortgageLenderMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Should we match FHA loans? */
  fha?: InputMaybe<Scalars['Boolean']>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** Offer loan_type */
  loanType?: InputMaybe<MortgagesOfferV2LoanTypeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']>;
};

export type MortgageLicensed = {
  __typename?: 'MortgageLicensed';
  /** Whether NerdWallet a licensed mortgage broker */
  isLicensed: Scalars['Boolean'];
  /** State looked up from user's zipCode */
  state?: Maybe<Scalars['String']>;
};

/** FIXME: this violates enum best practices by having lowercase values */
export const MortgageLoanPurposeEnum = {
  Purchase: 'purchase',
  Refinance: 'refinance',
} as const;

export type MortgageLoanPurposeEnum =
  (typeof MortgageLoanPurposeEnum)[keyof typeof MortgageLoanPurposeEnum];
/** The `MortgageProduct` type contains mortgage specific fields from marketplace */
export type MortgageProduct = ProductInterface & {
  __typename?: 'MortgageProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  details?: Maybe<MortgageProductDetails>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type MortgageProductDetails = {
  __typename?: 'MortgageProductDetails';
  lenderId?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
};

/** Property purpose */
export const MortgagePropertyPurposeEnum = {
  Investment: 'INVESTMENT',
  Primary: 'PRIMARY',
  Secondary: 'SECONDARY',
} as const;

export type MortgagePropertyPurposeEnum =
  (typeof MortgagePropertyPurposeEnum)[keyof typeof MortgagePropertyPurposeEnum];
export type MortgageSavedLeadMatchInput = {
  id?: InputMaybe<Scalars['ID']>;
};

/** Response type for a list of mortgage offers */
export type MortgageSavedLendersResponse = {
  __typename?: 'MortgageSavedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** Response type for a list of mortgage offers */
export type MortgageSavedRecommendedLendersResponse = {
  __typename?: 'MortgageSavedRecommendedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** Partial address, currently only supports zipCode */
export type MortgageUserAddressInput = {
  zipCode: Scalars['String'];
};

/** A Mortgages institution */
export type MortgagesInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'MortgagesInstitutionV2';
    /** Lender name to display */
    displayName?: Maybe<Scalars['String']>;
    /** Entity type */
    entityType: Scalars['String'];
    /** Loan programs and types to feature for the lender */
    featuredLoanAttributes?: Maybe<Array<Scalars['String']>>;
    /** Lead form enabled? */
    hasLeadForm?: Maybe<Scalars['Boolean']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Are personalized rates enabled? */
    isRatesEnabled?: Maybe<Scalars['Boolean']>;
    /** The API provider name for mortgage lenders that support lead form or lead match */
    leadProviderName?: Maybe<Scalars['String']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** NMLS Unique Identifier */
    nmlsId?: Maybe<Scalars['String']>;
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Mortgages offer */
export type MortgagesOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'MortgagesOfferV2';
    /** Long-form text about the lender, each item is a paragraph */
    aboutLender?: Maybe<Array<Scalars['String']>>;
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    applyLink?: Maybe<Scalars['URL']>;
    /** Short description of what the lender is best for e.g. customer service */
    bestForBullets?: Maybe<Array<Scalars['String']>>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** Coverage area for the lender */
    coverageArea?: Maybe<Scalars['String']>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity */
    displayName?: Maybe<Scalars['String']>;
    /** The driver max loan amount associated with the entity */
    driverMaxLoanAmount?: Maybe<EntityPlacementDriver>;
    /** The driver max ltv associated with the entity */
    driverMaxLtv?: Maybe<EntityPlacementDriver>;
    /** The driver min credit score associated with the entity */
    driverMinCreditScore?: Maybe<EntityPlacementDriver>;
    /** The driver min down payment associated with the entity */
    driverMinDownPayment?: Maybe<EntityPlacementDriver>;
    /** The driver national regional associated with the entity */
    driverNationalRegional?: Maybe<EntityPlacementDriver>;
    /** Which drivers should be highlighted for this offer */
    drivers?: Maybe<Array<Scalars['String']>>;
    /** Entity type */
    entityType: Scalars['String'];
    /** US States that the lender will not service */
    excludedStates?: Maybe<Array<Scalars['String']>>;
    /** Short tagline that specifies what is the lender good for (max: 1 line) */
    goodFor?: Maybe<Scalars['String']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Used to determine if placement is monetizing */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Loan type this offer represents */
    loanType?: Maybe<MortgagesOfferV2LoanTypeEnum>;
    /** Maximum loan amount */
    maxLoanAmount?: Maybe<Scalars['Float']>;
    /** Overrides tooltip value for max loan amount */
    maxLoanAmountTooltip?: Maybe<Scalars['String']>;
    /** Display value for maximum loan-to-value */
    maxLtv?: Maybe<Scalars['String']>;
    /** Overrides tooltip value for maximum loan-to-value */
    maxLtvTooltip?: Maybe<Scalars['String']>;
    /** Display value for minimum credit score */
    minCreditScore?: Maybe<Scalars['String']>;
    /** Overrides tooltip value for minimum credit score */
    minCreditScoreTooltip?: Maybe<Scalars['String']>;
    /** Display value for minimum down payment. Only applicable to PURCHASE loans */
    minDownPayment?: Maybe<Scalars['String']>;
    /** Overrides tooltip value for minimum down payment */
    minDownPaymentTooltip?: Maybe<Scalars['String']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** NMLS (Nationwide Mortgage Licensing System and Registry) Unique Identifier */
    nmlsId?: Maybe<Scalars['String']>;
    /** Bullet points providing an overview of the lender */
    overview?: Maybe<Array<Scalars['String']>>;
    /** Lender's phone number */
    payPerCall?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: MortgagesProductV2;
    /** The overview associated with the product */
    productOverview?: Maybe<Array<Maybe<Scalars['String']>>>;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** Disclaimer for the NerdWallet rating */
    ratingDisclaimer?: Maybe<Scalars['String']>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** NerdWallet review rating stars */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this lender */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export const MortgagesOfferV2LoanTypeEnum = {
  Cashout: 'CASHOUT',
  Conventional: 'CONVENTIONAL',
  Fha: 'FHA',
  Hel: 'HEL',
  Heloc: 'HELOC',
  Jumbo: 'JUMBO',
  Usda: 'USDA',
  Va: 'VA',
  VaCashout: 'VA_CASHOUT',
} as const;

export type MortgagesOfferV2LoanTypeEnum =
  (typeof MortgagesOfferV2LoanTypeEnum)[keyof typeof MortgagesOfferV2LoanTypeEnum];
export type MortgagesOfferWithRates = {
  __typename?: 'MortgagesOfferWithRates';
  marketplaceOffer?: Maybe<MortgagesOfferV2>;
  placementId?: Maybe<Scalars['String']>;
};

/** A Mortgages product */
export type MortgagesProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'MortgagesProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: MortgagesInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** The lender's phone number */
    phoneNumber?: Maybe<Scalars['String']>;
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The type of loan */
    type?: Maybe<MortgagesProductV2TypeEnum>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export const MortgagesProductV2TypeEnum = {
  HomeEquity: 'HOME_EQUITY',
  Purchase: 'PURCHASE',
  Refinance: 'REFINANCE',
} as const;

export type MortgagesProductV2TypeEnum =
  (typeof MortgagesProductV2TypeEnum)[keyof typeof MortgagesProductV2TypeEnum];
/** Empty field. Not to be used. */
export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  /** Acknowledges the specified terms of service */
  acknowledgeTermsOfService?: Maybe<AcknowledgeTermsOfServiceResponse>;
  addMobileAppDevice?: Maybe<MobileAppIdentityProfile>;
  /**
   * Accepts the data object representing a linked Real Asset of type Home in Wealth Recommender and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthHomeIntegrated?: Maybe<AddNetWorthHomeIntegratedResponse>;
  /**
   * Accepts an asset type, nickname, and amount and attempts to add it.
   * If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthRealAssetSelfReported?: Maybe<AddNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the a set of Project ted flow answers and attempts to persist it,
   * writes a new record in Airtable.
   * If this is successful, the response will return with the set of answers and a success status
   */
  addProjectTedForm: ProjectTedFormResponse;
  /** Add new credit cards to a list of self-reported cards a user owns. */
  addUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Adds a new wallet card to the user's cards in the my cards service */
  addUserWalletCard?: Maybe<AddUserWalletCardResponse>;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   * If this is successful, the user will be put in status = AUTHENTICATED.
   * Next it will attempt to enroll the user. If this is successful, then
   * the user will be put in status = ACTIVE and the credit report will
   * be returned.
   * @deprecated This mutation does not correctly reflect the response type from Identity, which can return two different response objects.  Use authenticateCreditProfileQuestions instead.
   */
  authenticateCreditProfile: TuCreditReportIdentityProfile;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   * If this is successful, the user will be put in status = AUTHENTICATED.
   * Next it will attempt to enroll the user. If this is successful, then
   * the user will be put in status = ACTIVE and the credit report (TuCreditReportIdentityProfile) will
   * be returned.  If there are additional verification questions a user must continue to answer,
   * then a CreditProfileAuthStatusProfile will be returned.
   */
  authenticateCreditProfileQuestions: AuthenticateCreditProfileResponseUnion;
  /** Delete all of the user's Recently Viewed history */
  clearRecentlyViewedHistory?: Maybe<Scalars['Boolean']>;
  /** Creates a FinancialTransaction and links it to the account given by accountId. */
  createFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Create a "user" financial account that will be associated with manual transactions. */
  createManualTransactionAccount?: Maybe<CreateManualTransactionAccountResponse>;
  /**
   * Retrieves a unique "trust session ID" for the user from Transunion, which is stamped onto future requests and
   * helps protect against fraudulent use of NerdWallet's TU integration.
   */
  createTrustSessionId: TrustSessionIdResponse;
  /** Create a "user" financial account. */
  createUserFinancialAccount?: Maybe<CreateUserFinancialAccountResponse>;
  /** Deactivates the user's TU credit profile. If successful, then the user will be put in status = DEACTIVATED. */
  deactivateCreditProfile: CreditProfileAuthStatusProfile;
  /** Deactivates the current user's account */
  deactivateUser?: Maybe<Scalars['Boolean']>;
  /** Delete a financial portal (for unlinking) */
  deleteFinancialPortal?: Maybe<DeleteFinancialPortalResponse>;
  /** Attempts to delete a FinancialTransaction by id. */
  deleteFinancialTransaction?: Maybe<DeleteFinancialTransactionResponse>;
  /**
   * Accepts the id of the real asset in Wealth Recommender and attempts to delete it.
   * If this is successful, the response will be an object containing a boolean "success"
   * property.
   */
  deleteNetWorthRealAsset?: Maybe<DeleteNetWorthRealAssetResponse>;
  /** Delete a "user" financial account. */
  deleteUserFinancialAccount?: Maybe<DeleteUserFinancialAccountResponse>;
  /**
   * Accepts a new nickname and/or amount and attempts to update the asset with
   * id netWorthRealAssetId.
   * If this is successful, the response will return with the updated asset object.
   */
  editNetWorthRealAssetSelfReported?: Maybe<EditNetWorthRealAssetSelfReportedResponse>;
  /**
   * This is only needed if authenticateCreditProfile left the user in
   * status = AUTHENTICATED (instead of ACTIVE).
   */
  enrollCreditProfile: TuCreditReportIdentityProfile;
  experimentTrackEvents?: Maybe<Scalars['Boolean']>;
  /** Finishes the migration of a portal to a new primary source despite data loss */
  finishPortalMigration?: Maybe<FinishPortalMigrationResponse>;
  /** Generate a one-time transfer token for a cookie id */
  generateOneTimeCookieIdTransferToken?: Maybe<Scalars['Boolean']>;
  /** Generate a one-time login token for the current user */
  generateOneTimeLoginToken?: Maybe<Scalars['Boolean']>;
  /**
   * Accepts the users details and attempts to initialize their TU profile.
   * If this is successful, TU will return security questions to present to
   * the user and put the user in status = PENDING.
   */
  initializeCreditProfile: CreditProfileAuthStatusProfile;
  /** Initializes a CSRF session for the current user */
  initializeCsrfSession?: Maybe<Scalars['Boolean']>;
  /** Create a portal for a particular institution */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /**
   * Initiate prequal jobs, which can be polled by ID, from user input to personal
   * loans prequal service. The underlying service adds any personal loan offers
   * to the user profile.
   */
  initiatePersonalLoansPrequalRequest: Array<PrequalJob>;
  /** Log in an existing user via first party credentials */
  logInUser?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Apple credentials */
  logInUserViaApple?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Google credentials */
  logInUserViaGoogle?: Maybe<LogInUserResponse>;
  /** Log in an existing user via a refresh token */
  logInUserViaRefreshToken?: Maybe<LogInUserResponse>;
  /** Logs out the current user */
  logOutUser?: Maybe<LogOutUserResponse>;
  /**
   * Marks all of notifications as dismissed.
   * Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   * Output is the updated notifications, the updated unread count and the associated operation ID.
   */
  markAllNotificationsAsDismissed: BulkDismissResponse;
  /**
   * Marks all of notifications as read.
   * Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   * Output is the updated notifications and the updated unread count.
   */
  markAllNotificationsAsRead: BulkActionResponse;
  /**
   * Marks a notification as dismissed.
   * Input is the ID of the notification to mark as dismissed.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsDismissed: MarkNotificationAsDismissedResponse;
  /**
   * Marks a notification as pinned.
   * Input is the ID of the notification to mark as pinned.
   * Output is the updated notification.
   */
  markNotificationAsPinned: MarkNotificationAsPinnedResponse;
  /**
   * Marks a notification as read.
   * Input is the ID of the notification to mark as read.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsRead: MarkNotificationAsReadResponse;
  /**
   * Marks a notification as undismissed.
   * Input is the ID of the notification to mark as undismissed.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsUndismissed: MarkNotificationAsUndismissedResponse;
  /**
   * Marks a notification as unpinned.
   * Input is the ID of the notification to mark as unpinned.
   * Output is the updated notification.
   */
  markNotificationAsUnpinned: MarkNotificationAsUnpinnedResponse;
  /**
   * Marks a notification as unread.
   * Input is the ID of the notification to mark as unread.
   * Output is the updated notification and the updated unread count.
   */
  markNotificationAsUnread: MarkNotificationAsUnreadResponse;
  /** Initializes the migration of a portal to a new primary source */
  migrateFinancialPortal?: Maybe<MigrateFinancialPortalResponse>;
  /** Cancels a transfer */
  moneyTransferCancelTransfer?: Maybe<MoneyTransferCancelTransferResponse>;
  /** Creates a money transfer account to be used in a money transfer */
  moneyTransferCreateAccount?: Maybe<CreateMoneyTransferAccountResponse>;
  /** Creates a transfer */
  moneyTransferCreateTransfer?: Maybe<CreateMoneyTransferResponse>;
  moneyTransferCreateUser?: Maybe<MoneyTransferCreateUserResponse>;
  /**
   * Publish a CRM Event
   *
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishCRMEvent: PublishYakMessageResult;
  /**
   * Sends information to the appropriate plugin for the financial portal. Typically used for
   * facilitating and sending progress on the linking flow.
   * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event
   */
  publishFinancialDataLinkEvent?: Maybe<FinancialPortalMessageResponse>;
  /**
   * Publish a simple CRM event (CRM events that just have identity_id in its payload)
   * publishSimpleCRMEvent will be deprecated and replaced by publishCRMEvent, which can handle payloads with just identity_id, and payloads with identity_id and other custom fields.
   *
   * Publish messages to a private Yak exchange.
   * If message fails to publish due to an error, the mutation will result in an error located at
   * `errors[0].message` indicating why the message failed.
   */
  publishSimpleCRMEvent: PublishYakMessageResult;
  publishViewedPYCRExperience: Scalars['String'];
  /**
   * Publish messages to a Yak exchange.
   *
   * If any message fails to publish due to an error, the mutation will result in an error with an
   * array of results (of equal length as the messages input) located at
   * `errors[0].extensions.exception.results` indicating which message(s) failed and why.
   */
  publishYakMessages: Array<PublishYakMessageResult>;
  /** Refreshes the user's TU credit profile. If successful, then the refreshed credit report will be returned. */
  refreshCreditProfile: TuCreditReportIdentityProfile;
  /** Attempt to trigger a refresh of the data associated with a financial portal */
  refreshFinancialPortal?: Maybe<FinancialPortal>;
  /** Registers a new user via first party credentials */
  registerUser?: Maybe<RegisterUserResponse>;
  /** Reinitialize a portal for fixing a broken link */
  reinitializeFinancialPortal?: Maybe<ReinitializeFinancialPortalResponse>;
  /** Remove all self-reported credit cards from the user profile */
  removeAllUserReportedCreditCards: RewardsMutationSuccessResponse;
  /** Remove an individual card from the list of self-reported credit cards a user owns. */
  removeUserReportedCreditCard?: Maybe<RemoveUserReportedCreditCardResult>;
  /** Removes a wallet card from the user's cards in the my cards service */
  removeUserWalletCard?: Maybe<RemoveUserWalletCardResponse>;
  /** Resets the current user's password */
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Send a password reset email to the provided email */
  sendPasswordResetEmail?: Maybe<Scalars['Boolean']>;
  /** Sets the user's security question and answer */
  setSecurityQuestion?: Maybe<Scalars['Boolean']>;
  /**
   * Update in full, the list of self-reported cards a user owns.
   * This will replace the current list of cards a user has reported owning.
   */
  setUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /**
   * Undoes the last bulk action performed by the user.
   * Inputs are the IDs of the notifications known to the frontend, and the operation ID of the bulk action to undo.
   * Output is the updated notifications and the updated unread count.
   */
  undoMarkAllNotificationsAsDismissed: BulkActionResponse;
  /** Unsubscribes from a specific notification type */
  unsubscribeFromNotification?: Maybe<SubscriptionIdentityProfile>;
  /**
   * Accepts the new set of Credit Card Match quiz flow answers and attempts to persist it,
   * either replacing a previous set of answers or writing it new.
   * If this is successful, the response will return with the set of answers.
   */
  updateCreditCardMatchQuizAnswers: CreditCardMatchQuizAnswersResponse;
  updateDismissAccountAggCta?: Maybe<AccountAggCtaDismissedResponse>;
  /** Update whether a financial account is hidden. */
  updateFinancialAccountVisibility?: Maybe<FinancialAccount>;
  /**
   * Updates the category of a merchant.
   * All transactions for that merchant will be given the category of the merchant, unless they have their
   * own respective transaction category override specified.
   * @deprecated replaced in the product with the Edit feature that uses updateFinancialTransaction. Can be removed once all clients are on the latest release
   */
  updateFinancialMerchantTransactionCategory?: Maybe<UpdateFinancialMerchantTransactionCategoryResponse>;
  updateFinancialPriorities?: Maybe<FinancialPrioritiesResponse>;
  /** Updates the amount, category, and date fields of the transaction given by transactionId. */
  updateFinancialTransaction?: Maybe<FinancialTransaction>;
  /**  Updates the category of a transaction.  */
  updateFinancialTransactionCategory?: Maybe<FinancialTransaction>;
  /**
   * Updates the visibility of a transaction.
   * Transactions that are hidden are excluded from transaction calculations and aggregations.
   */
  updateFinancialTransactionVisibility?: Maybe<FinancialTransaction>;
  updateGamificationChecklist?: Maybe<GamificationChecklistResponse>;
  /** Update the user's income information. */
  updateIncome: UpdateIncomeResponse;
  /** Update my_nerdwallet_profile fields for the user. */
  updateMembershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  /** Update the user's name. */
  updateName: UpdateNameResponse;
  /**
   * Accepts the account hidden value and attempts to patch the account in Wealth Recommender.
   * If this is successful, the response will return with the updated account object.
   */
  updateNetWorthAccountVisibility?: Maybe<UpdateNetWorthAccountVisibilityResponse>;
  /**
   * Accepts the new real asset isHiddenFromNetWorth value and attempts to update it.
   * If this is successful, the response will return with the updated asset object.
   */
  updateNetWorthRealAssetIsHiddenFromNetWorth?: Maybe<UpdateNetWorthRealAssetResponse>;
  /** Updates the current user's password */
  updatePassword?: Maybe<Scalars['Boolean']>;
  /** Update subscription_profile_v3 of the user. Only changed fields are required. */
  updateSubscriptionProfile?: Maybe<SubscriptionIdentityProfile>;
  /** Update subscription settings for a user via a one time use token path. */
  updateSubscriptionWithoutIdentity?: Maybe<SubscriptionIdentityProfile>;
  /** Update a "user" financial account. */
  updateUserFinancialAccount?: Maybe<UpdateFinancialAccountResponse>;
  /** Updates an existing wallet card from the user's cards in the my cards service */
  updateUserWalletCard?: Maybe<UpdateUserWalletCardResponse>;
  /** Returns the user's weekly_insights_completed_at array. If the weeklyInsightsCompletedDate is not in the same week of the most recent completion date of weekly insights, then mutates and appends the user's weekly_insights_completed_at array with weeklyInsightsCompletedDate */
  updateWeeklyInsightsCurrentStreak: UpdateWeeklyInsightsCurrentStreakResponse;
};

/** Empty field. Not to be used. */
export type MutationAcknowledgeTermsOfServiceArgs = {
  input: AcknowledgeTermsOfServiceInput;
};

/** Empty field. Not to be used. */
export type MutationAddMobileAppDeviceArgs = {
  device: MobileAppProfileDeviceInput;
};

/** Empty field. Not to be used. */
export type MutationAddNetWorthHomeIntegratedArgs = {
  address: NetWorthHomeIntegratedAddressInput;
  externalInfo: NetWorthHomeIntegratedExternalInfoInput;
};

/** Empty field. Not to be used. */
export type MutationAddNetWorthRealAssetSelfReportedArgs = {
  amount: Scalars['Float'];
  nickname: Scalars['String'];
  type: NetWorthRealAssetTypeEnum;
};

/** Empty field. Not to be used. */
export type MutationAddProjectTedFormArgs = {
  form?: InputMaybe<Scalars['JSON']>;
};

/** Empty field. Not to be used. */
export type MutationAddUserReportedCreditCardsArgs = {
  cards: Array<UserReportedCreditCardInput>;
};

/** Empty field. Not to be used. */
export type MutationAddUserWalletCardArgs = {
  input: AddUserWalletCardInput;
};

/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};

/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileQuestionsArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};

/** Empty field. Not to be used. */
export type MutationCreateFinancialTransactionArgs = {
  accountId: Scalars['ID'];
  amount: Scalars['Int'];
  category: FinancialTransactionCategory;
  date: Scalars['DateTime'];
  description?: InputMaybe<Scalars['String']>;
  merchantName: Scalars['String'];
  type: FinancialTransactionType;
};

/** Empty field. Not to be used. */
export type MutationCreateTrustSessionIdArgs = {
  input: TrustSessionIdInput;
};

/** Empty field. Not to be used. */
export type MutationCreateUserFinancialAccountArgs = {
  balance: Scalars['BigInt'];
  name: Scalars['String'];
  subtype: FinancialAccountSubtype;
  subtypeDetails: Scalars['String'];
  type: FinancialAccountType;
};

/** Empty field. Not to be used. */
export type MutationDeleteFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationDeleteFinancialTransactionArgs = {
  transactionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationDeleteNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationDeleteUserFinancialAccountArgs = {
  financialAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationEditNetWorthRealAssetSelfReportedArgs = {
  amount?: InputMaybe<Scalars['Float']>;
  netWorthRealAssetId: Scalars['ID'];
  nickname?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type MutationExperimentTrackEventsArgs = {
  trackEvents: Array<TrackEventInput>;
};

/** Empty field. Not to be used. */
export type MutationFinishPortalMigrationArgs = {
  financialPortalId: Scalars['ID'];
  shouldMigrate?: InputMaybe<Scalars['Boolean']>;
};

/** Empty field. Not to be used. */
export type MutationInitializeCreditProfileArgs = {
  customer: CreditProfileAuthCustomerInput;
  trustSessionId?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type MutationInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationInitiatePersonalLoansPrequalRequestArgs = {
  providerIds: Array<InputMaybe<PersonalLoansPrequalProviderIdEnum>>;
  userInput: PersonalLoansPrequalOfferInput;
};

/** Empty field. Not to be used. */
export type MutationLogInUserArgs = {
  loginInfo: NwLoginInfoInput;
};

/** Empty field. Not to be used. */
export type MutationLogInUserViaAppleArgs = {
  loginInfo: AppleLoginInfoInput;
};

/** Empty field. Not to be used. */
export type MutationLogInUserViaGoogleArgs = {
  loginInfo: GoogleLoginInfoInput;
};

/** Empty field. Not to be used. */
export type MutationLogInUserViaRefreshTokenArgs = {
  loginInfo: RefreshTokenLoginInfoInput;
};

/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsDismissedArgs = {
  beforeInclusive?: InputMaybe<Scalars['ID']>;
  track: Array<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsReadArgs = {
  beforeInclusive?: InputMaybe<Scalars['ID']>;
  track: Array<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsDismissedArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsPinnedArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUndismissedArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUnpinnedArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUnreadArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMigrateFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  marketplaceInstitutionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMoneyTransferCancelTransferArgs = {
  transferId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateAccountArgs = {
  financialAccountId: Scalars['ID'];
  financialAccountSource: FinancialDataSource;
  moneyTransferAccountType: MoneyTransferFinancialAccountTypeEnum;
};

/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateTransferArgs = {
  amount: Scalars['Int'];
  destinationMoneyTransferAccountId: Scalars['ID'];
  idempotencyKey: Scalars['ID'];
  sourceMoneyTransferAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateUserArgs = {
  userInput: MoneyTransferCreateUserInput;
};

/** Empty field. Not to be used. */
export type MutationPublishCrmEventArgs = {
  customPayload?: InputMaybe<Scalars['JSON']>;
  eventName: Scalars['String'];
};

/** Empty field. Not to be used. */
export type MutationPublishFinancialDataLinkEventArgs = {
  event: ProxyEventType;
  eventBody?: InputMaybe<Scalars['JSON']>;
  financialPortalId?: InputMaybe<Scalars['ID']>;
  isMigrate?: InputMaybe<Scalars['Boolean']>;
  linkToken?: InputMaybe<Scalars['String']>;
  migrationMarketplaceInstitutionId?: InputMaybe<Scalars['ID']>;
  source?: InputMaybe<FinancialDataSource>;
  sourceEntityId?: InputMaybe<Scalars['ID']>;
  sourceInstitutionId?: InputMaybe<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type MutationPublishSimpleCrmEventArgs = {
  eventName: Scalars['String'];
};

/** Empty field. Not to be used. */
export type MutationPublishYakMessagesArgs = {
  messages: Array<YakMessageInput>;
};

/** Empty field. Not to be used. */
export type MutationRefreshFinancialPortalArgs = {
  financialPortalId: Scalars['ID'];
  isAutoRefresh?: InputMaybe<Scalars['Boolean']>;
};

/** Empty field. Not to be used. */
export type MutationRegisterUserArgs = {
  registerInfo: NwRegisterInfoInput;
};

/** Empty field. Not to be used. */
export type MutationReinitializeFinancialPortalArgs = {
  androidPackageName?: InputMaybe<Scalars['String']>;
  financialPortalId: Scalars['ID'];
  redirectUri?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type MutationRemoveUserReportedCreditCardArgs = {
  cardId: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type MutationRemoveUserWalletCardArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationResetPasswordArgs = {
  resetInfo: ResetPasswordInfoInput;
};

/** Empty field. Not to be used. */
export type MutationSendPasswordResetEmailArgs = {
  resetInfo: SendResetPasswordEmailInfoInput;
};

/** Empty field. Not to be used. */
export type MutationSetSecurityQuestionArgs = {
  securityInfo: SecurityQuestionInfoInput;
};

/** Empty field. Not to be used. */
export type MutationSetUserReportedCreditCardsArgs = {
  cards?: InputMaybe<Array<UserReportedCreditCardInput>>;
};

/** Empty field. Not to be used. */
export type MutationUndoMarkAllNotificationsAsDismissedArgs = {
  operationId: Scalars['ID'];
  track: Array<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type MutationUnsubscribeFromNotificationArgs = {
  subscriptionField: SubscriptionTypeEnum;
  unsubscribeToken: Scalars['String'];
};

/** Empty field. Not to be used. */
export type MutationUpdateCreditCardMatchQuizAnswersArgs = {
  answers?: InputMaybe<Scalars['JSON']>;
  quizVersion: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type MutationUpdateDismissAccountAggCtaArgs = {
  dismissAccountAggCta: AccountAggCtaDismissedInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialAccountVisibilityArgs = {
  financialAccountId: Scalars['ID'];
  isHidden: Scalars['Boolean'];
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialMerchantTransactionCategoryArgs = {
  category: FinancialTransactionCategory;
  merchantName: Scalars['String'];
  transactionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialPrioritiesArgs = {
  financialPriorities: FinancialPrioritiesInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  category?: InputMaybe<FinancialTransactionCategory>;
  date?: InputMaybe<Scalars['DateTime']>;
  merchantName?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['ID'];
  type?: InputMaybe<FinancialTransactionType>;
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionCategoryArgs = {
  category: FinancialTransactionCategory;
  transactionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionVisibilityArgs = {
  isHidden: Scalars['Boolean'];
  transactionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationUpdateGamificationChecklistArgs = {
  gamificationChecklist: GamificationChecklistInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateIncomeArgs = {
  input: UpdateIncomeInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateMembershipAppActivityArgs = {
  membershipAppActivity: MembershipAppActivityInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateNameArgs = {
  input: UpdateNameInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateNetWorthAccountVisibilityArgs = {
  isHiddenFromNetWorth: Scalars['Boolean'];
  netWorthAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationUpdateNetWorthRealAssetIsHiddenFromNetWorthArgs = {
  isHiddenFromNetWorth: Scalars['Boolean'];
  netWorthRealAssetId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type MutationUpdatePasswordArgs = {
  passwordInfo: UpdatePasswordInfoInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionProfileArgs = {
  identityId: Scalars['String'];
  subscriptionProfile: UpdateSubscriptionProfileInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionWithoutIdentityArgs = {
  subscriptionSettings: UpdateSubscriptionProfileInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateUserFinancialAccountArgs = {
  balance?: InputMaybe<Scalars['BigInt']>;
  financialAccountId: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  subtype?: InputMaybe<FinancialAccountSubtype>;
  subtypeDetails?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<FinancialAccountType>;
};

/** Empty field. Not to be used. */
export type MutationUpdateUserWalletCardArgs = {
  input: UpdateUserWalletCardInput;
};

/** Empty field. Not to be used. */
export type MutationUpdateWeeklyInsightsCurrentStreakArgs = {
  weeklyInsightsCompletedDate?: InputMaybe<Scalars['DateTime']>;
};

export type MyCardsActivationVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'MyCardsActivationVisualization';
    /** This will always be MY_CARDS_ACTIVATION */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  };

export type NwLoginInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type NwRegisterInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress'];
  /** The password used to register an account */
  password: Scalars['String'];
  /** The tracking metadata to include with registration */
  trackingMetadata?: InputMaybe<RegistrationTrackingMetadata>;
};

/** The data shape of an account in Wealth Recommender. This is not an exhaustive set of properties. */
export type NetWorthAccount = {
  __typename?: 'NetWorthAccount';
  /**
   * Note: Id is used here instead of a GQL relation because of the current state of how clients
   * source and access financial accounts. In future it would be better practice to resolve the
   * financial account along with these annotation fields in the same query.
   */
  financialAccountId: Scalars['ID'];
  id: Scalars['ID'];
  isHiddenFromNetWorth: Scalars['Boolean'];
};

/** Wraps the net worth account API response for flexibility in future property expansion */
export type NetWorthAccountResponse = {
  __typename?: 'NetWorthAccountResponse';
  account: NetWorthAccount;
};

/**
 * Wraps the set of net worth accounts and leaves the schema open for the addition of metadata or
 * other supplemental data fields in the future
 */
export type NetWorthAccountsResponse = {
  __typename?: 'NetWorthAccountsResponse';
  accounts: Array<NetWorthAccount>;
};

export type NetWorthActivationStatusResponse =
  MembershipFeatureActivationStatusInterface & {
    __typename?: 'NetWorthActivationStatusResponse';
    id: MembershipFeatureEnum;
    status: MembershipFeatureActivationStatusEnum;
  };

export type NetWorthBalances = {
  __typename?: 'NetWorthBalances';
  /** An object containing the sums of balances in each asset account type */
  assetSums: NetWorthBalancesAssetSums;
  /** An object containing the sums of balances in each debt account type */
  debtSums: NetWorthBalancesDebtSums;
  /**
   * The sum of all balances in asset accounts (checking, savings, investment, retirement)
   * (based on the account's nw_type) for a user. This sum excludes the sum of the user's
   * home assets.
   * Null if a user does not have any linked asset accounts.
   */
  totalAssets?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total monetary assets as well as home asset values.
   * Null if a user does not have any linked asset accounts nor home assets.
   */
  totalAssetsIncludingHomeValues?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in debt accounts (loans, credit cards) (based on the account's
   * nw_type) for a user. This sum includes the sum of the user's mortgage account balances.
   * Null if a user does not have any linked debt accounts.
   */
  totalDebts?: Maybe<Scalars['Float']>;
  /**
   * The updated sum of all total debts, subtracting the balances of mortgage accounts. This is
   * for the product scenario where we want to display mortgages alongside their associated home
   * values, while still showing non-mortgage debts elsewhere.
   * Null if a user does not have any linked non-mortgage debt accounts.
   */
  totalDebtsExcludingMortgages?: Maybe<Scalars['Float']>;
  /**
   * The total value of homes subtract mortgage debts.
   * Null if a user does not have any home assets nor linked mortgage accounts.
   */
  totalHomeEquity?: Maybe<Scalars['Float']>;
  /**
   * Defined as totalAssets - totalDebts. This does not include the value of the user's home
   * equity.
   * Null if a user does not have any linked accounts.
   */
  totalNetWorth?: Maybe<Scalars['Float']>;
  /**
   * The updated net worth value, which includes home asset values.
   * Null if a user does not have any linked accounts nor homes.
   */
  totalNetWorthIncludingHomeEquity?: Maybe<Scalars['Float']>;
};

export type NetWorthBalancesAssetSums = {
  __typename?: 'NetWorthBalancesAssetSums';
  /**
   * The sum of all auto asset values.
   * Null if a user does not have any auto assets.
   */
  autoValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in checking accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked checking accounts.
   */
  checkingSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all home asset values.
   * Null if a user does not have any linked home assets.
   */
  homeValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in investment accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked investment accounts.
   */
  investmentSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all personal property asset values.
   * Null if a user does not have any personal property assets.
   */
  personalPropertyValueSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in retirement accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked retirement accounts.
   */
  retirementSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in savings accounts (based on each account's
   * nw_type) for a user.
   * Null if a user does not have any linked savings accounts.
   */
  savingsSum?: Maybe<Scalars['Float']>;
};

export type NetWorthBalancesDebtSums = {
  __typename?: 'NetWorthBalancesDebtSums';
  /**
   * The sum of all balances in credit card accounts for a user.
   * Null if a user does not have any linked credit card accounts.
   */
  creditCardSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in loan accounts for a user.
   * Null if a user does not have any linked loan accounts.
   */
  loanSum?: Maybe<Scalars['Float']>;
  /**
   * The sum of all balances in mortgage accounts for a user.
   * Null if a user does not have any linked mortgage accounts.
   */
  mortgageSum?: Maybe<Scalars['Float']>;
  /**
   * The updated loan sum, excluding mortgage accounts.
   * Null if a user does not have any linked non-mortgage loan accounts.
   */
  nonMortgageLoanSum?: Maybe<Scalars['Float']>;
};

export type NetWorthContribution = {
  __typename?: 'NetWorthContribution';
  amount: Scalars['Float'];
  contributionId: Scalars['ID'];
  date: Scalars['Date'];
  destinationFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  sourceFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  status?: Maybe<NetWorthContributionStatus>;
  transferId?: Maybe<Scalars['ID']>;
  type?: Maybe<NetWorthContributionType>;
};

export type NetWorthContributionFinancialAccount = {
  __typename?: 'NetWorthContributionFinancialAccount';
  financialAccount?: Maybe<FinancialAccount>;
  financialAccountId?: Maybe<Scalars['ID']>;
  financialAccountLastFour?: Maybe<Scalars['String']>;
  financialAccountName?: Maybe<Scalars['String']>;
  financialAccountTransactionDate?: Maybe<Scalars['Date']>;
  financialAccountTransactionId?: Maybe<Scalars['ID']>;
  financialAccountType?: Maybe<NetWorthContributionFinancialAccountType>;
};

export const NetWorthContributionFinancialAccountType = {
  Checking: 'CHECKING',
  Investment: 'INVESTMENT',
  Retirement: 'RETIREMENT',
  Savings: 'SAVINGS',
} as const;

export type NetWorthContributionFinancialAccountType =
  (typeof NetWorthContributionFinancialAccountType)[keyof typeof NetWorthContributionFinancialAccountType];
export const NetWorthContributionStatus = {
  Cancelled: 'CANCELLED',
  Completed: 'COMPLETED',
  Failed: 'FAILED',
  Pending: 'PENDING',
} as const;

export type NetWorthContributionStatus =
  (typeof NetWorthContributionStatus)[keyof typeof NetWorthContributionStatus];
export type NetWorthContributionSummaries = {
  __typename?: 'NetWorthContributionSummaries';
  contributionSummaries: Array<NetWorthContributionSummary>;
};

export type NetWorthContributionSummary = {
  __typename?: 'NetWorthContributionSummary';
  completedContributionSum?: Maybe<Scalars['Float']>;
  contributions: Array<NetWorthContribution>;
  date?: Maybe<Scalars['Date']>;
  month?: Maybe<Scalars['String']>;
  pendingContributionSum?: Maybe<Scalars['Float']>;
  totalContributionSum?: Maybe<Scalars['Float']>;
};

export const NetWorthContributionType = {
  Contribution: 'CONTRIBUTION',
  Deposit: 'DEPOSIT',
  Invalid: 'INVALID',
  Rebalance: 'REBALANCE',
} as const;

export type NetWorthContributionType =
  (typeof NetWorthContributionType)[keyof typeof NetWorthContributionType];
export type NetWorthHistoryDataPoint = {
  __typename?: 'NetWorthHistoryDataPoint';
  date: Scalars['Date'];
  value: Scalars['Float'];
};

export const NetWorthHistoryFiltersEnum = {
  Cash: 'CASH',
  CreditCards: 'CREDIT_CARDS',
  Investments: 'INVESTMENTS',
  Loans: 'LOANS',
  Property: 'PROPERTY',
  Total: 'TOTAL',
} as const;

export type NetWorthHistoryFiltersEnum =
  (typeof NetWorthHistoryFiltersEnum)[keyof typeof NetWorthHistoryFiltersEnum];
export type NetWorthHistoryResponse = {
  __typename?: 'NetWorthHistoryResponse';
  history: Array<Maybe<NetWorthHistoryDataPoint>>;
  netWorthFilter: NetWorthHistoryFiltersEnum;
};

export type NetWorthHistorySnapshotNotificationResponse = {
  __typename?: 'NetWorthHistorySnapshotNotificationResponse';
  showSnapshotNotification: Scalars['Boolean'];
};

/**
 * The data shape of a Home — integrated with Redfin, in Wealth Recommender. "Integrated"
 * describes the fact that this asset's data is sourced from a 3rd-party integration with a data
 * provider, e.g. Redfin. This is meant to be a differentiator for self-reported Home values.
 */
export type NetWorthHomeIntegrated = NetWorthRealAsset & {
  __typename?: 'NetWorthHomeIntegrated';
  address: NetWorthHomeIntegratedAddress;
  amount?: Maybe<Scalars['Float']>;
  externalInfo?: Maybe<NetWorthHomeIntegratedExternalInfo>;
  id: Scalars['ID'];
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  isSelfReported: Scalars['Boolean'];
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  type: NetWorthRealAssetTypeEnum;
};

export type NetWorthHomeIntegratedAddress = {
  __typename?: 'NetWorthHomeIntegratedAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type NetWorthHomeIntegratedAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeIntegratedExternalInfo = {
  __typename?: 'NetWorthHomeIntegratedExternalInfo';
  source: NetWorthHomeValueResultSourceEnum;
  value?: Maybe<Scalars['Float']>;
};

/**
 * These fields are the same as the fields in the NetWorthHomeValueResultResponse type. The client
 * takes these values from the search response and pipes them into the addNetWorthHomeIntegrated
 * mutation.
 */
export type NetWorthHomeIntegratedExternalInfoInput = {
  propertyId?: InputMaybe<Scalars['String']>;
  source: NetWorthHomeValueResultSourceEnum;
  url?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type NetWorthHomeValuePossibilityResponseData =
  NetWorthHomeValueResultResponseDataInterface & {
    __typename?: 'NetWorthHomeValuePossibilityResponseData';
    /** The list of possible home values for ambiguous cases */
    possibilities?: Maybe<Array<NetWorthHomeValueResultResponseData>>;
    /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Possibility. */
    type: NetWorthHomeValueResultTypeEnum;
  };

export type NetWorthHomeValueResultAddressInput = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultByPropertyIdResponse = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponse';
  /**
   * The data shape for this query will not return "type", "address", nor "url" unlike the other
   * queries that POST to the same data source endpoint. This is because Redfin's API doesn't
   * return these fields when querying by "property_id".
   */
  data: NetWorthHomeValueResultByPropertyIdResponseData;
};

export type NetWorthHomeValueResultByPropertyIdResponseData = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponseData';
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   * home values for snapshotting.
   */
  propertyId: Scalars['String'];
  /**
   * This field denotes which data provider is associated with the search result that is returned
   * to the client. This is a no-cost schema addition that grants us flexibility for a future
   * where we may have multiple providers with different prioritizations (e.g. Zillow search
   * result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /** The value of the home related to the provided address. */
  value: Scalars['Float'];
};

export type NetWorthHomeValueResultResponse = {
  __typename?: 'NetWorthHomeValueResultResponse';
  /**
   * The response from the search data source is actually an array of results, but for the current
   * iteration of our clients we only support 1 set of search results. This schema represents the
   * highest priority search result from the array.
   */
  data?: Maybe<NetWorthHomeValueResultResponseData>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

export type NetWorthHomeValueResultResponseAddress = {
  __typename?: 'NetWorthHomeValueResultResponseAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
};

export type NetWorthHomeValueResultResponseData =
  NetWorthHomeValueResultResponseDataInterface & {
    __typename?: 'NetWorthHomeValueResultResponseData';
    address?: Maybe<NetWorthHomeValueResultResponseAddress>;
    /**
     * The source provider's ID for the given home value. This is used by WR to request updated
     * home values for snapshotting.
     */
    propertyId?: Maybe<Scalars['String']>;
    /**
     * This field denotes which data provider is associated with the search result that is returned
     * to the client. This is a no-cost schema addition that grants us flexibility for a future
     * where we may have multiple providers with different prioritizations (e.g. Zillow search
     * result over Redfin).
     */
    source: NetWorthHomeValueResultSourceEnum;
    /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Result. */
    type: NetWorthHomeValueResultTypeEnum;
    /** The browser URL that maps to the property's posting. */
    url?: Maybe<Scalars['String']>;
    /** The value of the home related to the provided address. */
    value?: Maybe<Scalars['Float']>;
  };

export type NetWorthHomeValueResultResponseDataInterface = {
  type: NetWorthHomeValueResultTypeEnum;
};

/**
 * The representation of the error data that the client will need in order to make UX decisions.
 * Currently only contains the error type.
 */
export type NetWorthHomeValueResultResponseError = {
  __typename?: 'NetWorthHomeValueResultResponseError';
  errorType: NetWorthHomeValueResultResponseErrorTypeEnum;
};

/**
 * The set of canonicalized error types that WR handles.
 * FIXME: this violates enum best practices by having lowercase values
 */
export const NetWorthHomeValueResultResponseErrorTypeEnum = {
  HomeAlreadyExistsError: 'HomeAlreadyExistsError',
  HomeSourceApiFatalError: 'HomeSourceApiFatalError',
  HomeSourceApiInputError: 'HomeSourceApiInputError',
  /**
   * This is an error that is created within the resolver based on more specific error fields.
   * In the future if we support the ability to present users with ambiguous address options,
   * we should get rid of this error.
   */
  HomeSourceApiMultipleResultsError: 'HomeSourceApiMultipleResultsError',
  HomeSourceApiNoResultError: 'HomeSourceApiNoResultError',
  /** These enums represent error types that return from WR */
  HomeSourceApiRetryError: 'HomeSourceApiRetryError',
  HomeSourceApiServiceError: 'HomeSourceApiServiceError',
  InvalidInputError: 'InvalidInputError',
} as const;

export type NetWorthHomeValueResultResponseErrorTypeEnum =
  (typeof NetWorthHomeValueResultResponseErrorTypeEnum)[keyof typeof NetWorthHomeValueResultResponseErrorTypeEnum];
/**
 * This enum represents the set of supported home value data source providers. Currently we only
 * support Redfin but our schemas are meant to be shaped for extensibility.
 */
export const NetWorthHomeValueResultSourceEnum = {
  Redfin: 'REDFIN',
} as const;

export type NetWorthHomeValueResultSourceEnum =
  (typeof NetWorthHomeValueResultSourceEnum)[keyof typeof NetWorthHomeValueResultSourceEnum];
/** The two types of results that may return from an address search */
export const NetWorthHomeValueResultTypeEnum = {
  /**
   * Denotes that one or more low-confidence possible results have been found based on the
   * provided address
   */
  Possibility: 'POSSIBILITY',
  /** Denotes that an exact home value match has been found based on the provided address */
  Result: 'RESULT',
} as const;

export type NetWorthHomeValueResultTypeEnum =
  (typeof NetWorthHomeValueResultTypeEnum)[keyof typeof NetWorthHomeValueResultTypeEnum];
export type NetWorthHomeValueResultWithPossibilitiesResponse = {
  __typename?: 'NetWorthHomeValueResultWithPossibilitiesResponse';
  data?: Maybe<NetWorthHomeValueResultResponseDataInterface>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   * is to be handled gracefully. It contains the error data that the client needs in order to
   * make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

/**
 * This interface will represent the amalgamation of the various asset types supported by Wealth
 * Recommender.
 */
export type NetWorthRealAsset = {
  amount?: Maybe<Scalars['Float']>;
  /**
   * Real assets have been migrated from WR to FDP, so this client-facing ID now refers to the FDP
   * account ID.
   */
  id: Scalars['ID'];
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  /** For helping the client determine if the home is self-reported or not */
  isSelfReported: Scalars['Boolean'];
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  type: NetWorthRealAssetTypeEnum;
};

/** Wraps the Net Worth Real Asset API response, which allows for adding fields at a later date */
export type NetWorthRealAssetResponse = {
  __typename?: 'NetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

/**
 * The data shape of a Real Asset — self-reported by the user, in Wealth Recommender. This is a
 * different data model from the "Integrated" version of homes, which are synced with Redfin and
 * have their own set of requirements.
 */
export type NetWorthRealAssetSelfReported = NetWorthRealAsset & {
  __typename?: 'NetWorthRealAssetSelfReported';
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']>;
  isSelfReported: Scalars['Boolean'];
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']>;
  /**
   * The unique identifier for a self-reported asset in the UX. For contrast, NetWorthIntegrated
   * we use the address fields for uniqueness.
   */
  nickname: Scalars['String'];
  type: NetWorthRealAssetTypeEnum;
};

/** This enum represents the set of Real Asset types that the backend, WR, currently supports. */
export const NetWorthRealAssetTypeEnum = {
  Auto: 'AUTO',
  Home: 'HOME',
  PersonalProperty: 'PERSONAL_PROPERTY',
} as const;

export type NetWorthRealAssetTypeEnum =
  (typeof NetWorthRealAssetTypeEnum)[keyof typeof NetWorthRealAssetTypeEnum];
/** Wraps the set of Net Worth Real Assets, which allows for adding fields at a later date */
export type NetWorthRealAssetsResponse = {
  __typename?: 'NetWorthRealAssetsResponse';
  assets: Array<NetWorthRealAsset>;
};

export type NetWorthRecommendation = {
  __typename?: 'NetWorthRecommendation';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  details?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  identityId: Scalars['ID'];
  secureDetails?: Maybe<Scalars['JSON']>;
  status: NetWorthRecommendationStatus;
  type: NetWorthRecommendationType;
  updatedAt: Scalars['DateTime'];
  version: Scalars['Int'];
};

export const NetWorthRecommendationCategory = {
  All: 'ALL',
  BigPictureMoves: 'BIG_PICTURE_MOVES',
  Iao: 'IAO',
  QuickWins: 'QUICK_WINS',
} as const;

export type NetWorthRecommendationCategory =
  (typeof NetWorthRecommendationCategory)[keyof typeof NetWorthRecommendationCategory];
export const NetWorthRecommendationStatus = {
  Completed: 'COMPLETED',
  Dismissed: 'DISMISSED',
  InProgress: 'IN_PROGRESS',
  New: 'NEW',
} as const;

export type NetWorthRecommendationStatus =
  (typeof NetWorthRecommendationStatus)[keyof typeof NetWorthRecommendationStatus];
export const NetWorthRecommendationType = {
  CheckingToSavings: 'CHECKING_TO_SAVINGS',
  IntegratedAccountOpening: 'INTEGRATED_ACCOUNT_OPENING',
  LeftoverIncome: 'LEFTOVER_INCOME',
  NewDeposit: 'NEW_DEPOSIT',
  Refund: 'REFUND',
  SavingsToInvestment: 'SAVINGS_TO_INVESTMENT',
} as const;

export type NetWorthRecommendationType =
  (typeof NetWorthRecommendationType)[keyof typeof NetWorthRecommendationType];
export type NetWorthRecommendations = {
  __typename?: 'NetWorthRecommendations';
  /** @deprecated The underlying endpoint has been deprecated */
  recommendations: Array<NetWorthRecommendation>;
};

export type NetWorthRecommendationsFilterInput = {
  category: NetWorthRecommendationCategory;
};

/** Notifications contain actionable information relevent to the user that NerdWallet sends via a notification channel. */
export type Notification = {
  __typename?: 'Notification';
  /** The action to be performed in the app when the user engages with the notification (CTA that navigates to L1, L2). */
  action?: Maybe<AppAction>;
  /**
   * The user-facing copy that describes the notification.
   *
   * This is *not* the CTA text -- that should be supplied in action.text
   */
  body?: Maybe<Scalars['String']>;
  /** The name of the CRM campaign this notification belongs to. */
  campaignName?: Maybe<Scalars['String']>;
  /** The creation time in UTC of the notification. */
  createdAt: Scalars['DateTime'];
  /**
   * The primary identifier for the notification.
   *
   * Primarily used for interacting with the API - id will now match the "newest" and "oldest" fields.
   */
  id: Scalars['ID'];
  /** The image details for the notification. */
  imageDetails?: Maybe<NotificationImageDetails>;
  /** The isDismissed flag denotes if a notification has been "dismissed" by the user. */
  isDismissed: Scalars['Boolean'];
  /**
   * The isRead flag denotes if a notification has been "read" by the user.
   *
   * A notification can be marked as "read" by interacting with the CTA, or manually by the user.
   */
  isRead: Scalars['Boolean'];
  /** The pin status and time when this update occurred. */
  pinDetails?: Maybe<NotificationPinDetails>;
  /**
   * A human-readable identifier for a particular notification.
   *
   * Note that the slug field is the same across all instances of a particular notification (whereas the id field is unique).
   */
  slug?: Maybe<Scalars['String']>;
  /** The name of the Blueshift template used for this notification. */
  templateName?: Maybe<Scalars['String']>;
  /** The update history of a notification. */
  updates?: Maybe<Array<NotificationUpdate>>;
};

/**
 * The medium by which notifications are sent to users.
 *
 * Currently only includes NotificationCenter, but may be expanded to include email and/or push, as needed.
 */
export const NotificationChannelEnum = {
  NotificationCenter: 'NOTIFICATION_CENTER',
} as const;

export type NotificationChannelEnum =
  (typeof NotificationChannelEnum)[keyof typeof NotificationChannelEnum];
export type NotificationImageDetails = {
  __typename?: 'NotificationImageDetails';
  /** The alternative text to describe the image. */
  altText?: Maybe<Scalars['String']>;
  /** The image source URL from the CDN domain. */
  sourceUrl: Scalars['String'];
};

export type NotificationPinDetails = {
  __typename?: 'NotificationPinDetails';
  /**
   * The isPinned flag denotes if a notification has been "pinned" by the user.
   *
   * A notification can be marked as "pinned" by clicking the pin option in the notification menu.
   */
  isPinned: Scalars['Boolean'];
  /** The time when this update occurred. */
  updatedAt: Scalars['DateTime'];
};

export type NotificationUpdate = {
  __typename?: 'NotificationUpdate';
  /** The type of update (e.g. dismiss, undismiss, mark_as_read, mark_as_unread, pin, unpin) */
  update: Scalars['String'];
  /** The time when this update occurred. */
  updatedAt: Scalars['DateTime'];
};

export type NotificationsInput = {
  /** Specifies the channel of notifications to retrieve from */
  channel: NotificationChannelEnum;
  /**
   * The Identity ID to fetch notifications for (for admin use).
   * If the ID isn't the same as the requesting user's ID, some fields will not be available.
   */
  identityId?: InputMaybe<Scalars['ID']>;
  /** Whether to include notifications that have been dismissed by the user. */
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
  /** Contains parameters that assist with pagination, such as: after, before, limit. */
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type OfferDriverInfoInput = {
  age?: InputMaybe<Scalars['Int']>;
  bundleAutoHome?: InputMaybe<Scalars['Boolean']>;
  contactAddress?: InputMaybe<UserAddressInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  driversCount?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']>;
  isVeteran?: InputMaybe<Scalars['Boolean']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']>;
};

/** OfferInterface contains the common base fields for all offers. */
export type OfferInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Insurance user input that is shared among verticals */
export type OfferUserInfoInput = {
  contactName?: InputMaybe<UserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  pricingCodeExpiration?: InputMaybe<Scalars['Date']>;
  pricingCodeExpirationDateTime?: InputMaybe<Scalars['DateTime']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type OffsetPaginationInput = {
  /** The maximum number of results to return. */
  limit?: InputMaybe<Scalars['Int']>;
  /** The start index of the results to return. Useful for pagination. */
  offset?: InputMaybe<Scalars['Int']>;
};

/** Enum values to express which field to order collection query results by. */
export const OrderByFieldEnum = {
  Date: 'DATE',
  Id: 'ID',
  Include: 'INCLUDE',
  ModifiedDate: 'MODIFIED_DATE',
  Slug: 'SLUG',
} as const;

export type OrderByFieldEnum =
  (typeof OrderByFieldEnum)[keyof typeof OrderByFieldEnum];
/** The direction in which to order query results. */
export const OrderDirectionEnum = {
  Asc: 'ASC',
  Desc: 'DESC',
} as const;

export type OrderDirectionEnum =
  (typeof OrderDirectionEnum)[keyof typeof OrderDirectionEnum];
/** The input type for ordering results. */
export type OrderInput = {
  /** Sort collection by object attribute. */
  field?: OrderByFieldEnum;
  /** Order sort attribute ascending or descending. */
  sortDirection?: OrderDirectionEnum;
};

/** Enum values for overrideLastModifiedDateWithCurrentDate field on Article type. */
export const OverrideLastModifiedDateEnum = {
  Default: 'DEFAULT',
  UseCurrentDay: 'USE_CURRENT_DAY',
  UseCurrentMonth: 'USE_CURRENT_MONTH',
} as const;

export type OverrideLastModifiedDateEnum =
  (typeof OverrideLastModifiedDateEnum)[keyof typeof OverrideLastModifiedDateEnum];
/** Type modeling the data for posts within the page post type from WordPress. */
export type Page = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'Page';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the Page object. */
    categories?: Maybe<Array<Category>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The Page object for the parent of this entity. */
    parent?: Maybe<Page>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the page post type from WordPress. */
export type PageDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the page post type from WordPress. */
export type PageModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the page post type from WordPress. */
export type PageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Data related to the top level page impression event that should be fired */
export type PageImpressionData = {
  __typename?: 'PageImpressionData';
  /** Whether or not to fire the top level page impression event */
  enabled?: Maybe<Scalars['Boolean']>;
  /** Name of the top level page impression event that should be fired */
  event: Scalars['String'];
  /** Data payload to pass into the top level page impression event */
  payload?: Maybe<Scalars['JSON']>;
};

/** Layout information for Structured Content Client to use */
export type PageLayout = {
  __typename?: 'PageLayout';
  /** The name of the template the page is using. This will be used for analytics purposes */
  name: Scalars['String'];
  /** The row config for the page layout */
  rows?: Maybe<Array<LayoutRow>>;
};

/** Personal Loan Institutions */
export type PersonalLoanInstitution = InstitutionInterface & {
  __typename?: 'PersonalLoanInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  /** There were no details when this schema was constructed. */
  details: EmptyObject;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Personal Loan Offers */
export type PersonalLoanOffer = OfferInterface & {
  __typename?: 'PersonalLoanOffer';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  derivedDetails: PersonalLoanOfferDerivedDetails;
  details: PersonalLoanOfferDetails;
  endsAt?: Maybe<Scalars['DateTime']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isMonetizing?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  product: PersonalLoanProduct;
  productId?: Maybe<Scalars['ID']>;
  productType: Scalars['String'];
  startsAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/**
 * Derived details about the personal loan offer.
 * Note: This are dependent on having the following query variables supplied:
 * - annualIncome
 * - loanAmount
 * - minCreditScore
 * - maxCreditScore
 * - zipCode
 */
export type PersonalLoanOfferDerivedDetails = {
  __typename?: 'PersonalLoanOfferDerivedDetails';
  applyLink?: Maybe<Scalars['URL']>;
  avgNarrowApr?: Maybe<Scalars['Float']>;
  isAllowedForZipCode?: Maybe<Scalars['Boolean']>;
  maxNarrowApr?: Maybe<Scalars['Float']>;
  minNarrowApr?: Maybe<Scalars['Float']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
};

/** Details about the personal loan offer */
export type PersonalLoanOfferDetails = {
  __typename?: 'PersonalLoanOfferDetails';
  aprTooltip?: Maybe<Scalars['String']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
  consBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  delinquencies?: Maybe<Array<Scalars['String']>>;
  disclaimer?: Maybe<Scalars['String']>;
  excludedCitizenshipStatus: Array<Scalars['String']>;
  excludedHousing: Array<Scalars['String']>;
  excludedLoanPurpose: Array<PersonalLoanPurpose>;
  feesBullets?: Maybe<Array<Scalars['String']>>;
  imageAltText?: Maybe<Scalars['String']>;
  imageIsPortrait: Scalars['Boolean'];
  imageSource?: Maybe<Scalars['URL']>;
  imageSourceLarge?: Maybe<Scalars['URL']>;
  imageSourceMedium?: Maybe<Scalars['URL']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']>>;
  legacyId?: Maybe<Scalars['String']>;
  loanTermList: Array<Scalars['Int']>;
  loanTermType: Scalars['String'];
  maxApr: Scalars['Int'];
  maxFico: Scalars['Int'];
  maxHardInquiries?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  maxHardInquiriesTimeSpanMonths?: Maybe<Scalars['Int']>;
  maxLoanAmount?: Maybe<Scalars['Int']>;
  maxLoanTerm?: Maybe<Scalars['Int']>;
  maxNumberBankruptcies?: Maybe<Scalars['Int']>;
  /** The time unit is months. */
  maxNumberBankruptciesTimeSpanMonths?: Maybe<Scalars['Int']>;
  minApr: Scalars['Int'];
  /** The time unit is months. */
  minCreditHistoryMonths?: Maybe<Scalars['Int']>;
  minFico: Scalars['Int'];
  minFicoAnnotation?: Maybe<Scalars['String']>;
  minFicoDisplayed: Scalars['Int'];
  minFicoTooltip?: Maybe<Scalars['String']>;
  minIncome: Scalars['Int'];
  minLoanAmount?: Maybe<Scalars['Int']>;
  minLoanTermMonths?: Maybe<Scalars['Int']>;
  /** This time unit is months. */
  phoneNumberDesktop?: Maybe<Scalars['String']>;
  phoneNumberMobile?: Maybe<Scalars['String']>;
  primaryOffer: Scalars['Boolean'];
  prosBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  qualificationsBullets?: Maybe<Array<Maybe<Scalars['String']>>>;
  ratingStars?: Maybe<Scalars['Float']>;
  reviewLink?: Maybe<Scalars['String']>;
  reviewTitle?: Maybe<Scalars['String']>;
  simplifyApr?: Maybe<Scalars['Boolean']>;
  timeToFund?: Maybe<Scalars['Float']>;
};

/**
 * Query variables for the personal loan queries.
 * Note that some of these are required for the
 * query to work, since this query retrieves all
 * fields from the Offer API.
 */
export type PersonalLoanOffersParameters = {
  annualIncome: Scalars['Int'];
  loanAmount: Scalars['Int'];
  loanPurpose?: InputMaybe<PersonalLoanPurpose>;
  maxCreditScore: Scalars['Int'];
  minCreditScore: Scalars['Int'];
  /**
   * The zipCode variable is required if requesting the
   * isAllowedForZipCode field.
   */
  zipCode?: InputMaybe<Scalars['String']>;
};

/** The response from a personal loan offer query. */
export type PersonalLoanOffersResponse = {
  __typename?: 'PersonalLoanOffersResponse';
  offers: Array<PersonalLoanOffer>;
  offset: Scalars['Int'];
  /** The total number of offers that match your query. */
  total: Scalars['Int'];
};

/** Personal Loan Products */
export type PersonalLoanProduct = ProductInterface & {
  __typename?: 'PersonalLoanProduct';
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  details: PersonalLoanProductDetails;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  institution: PersonalLoanInstitution;
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** Details about the personal loan product */
export type PersonalLoanProductDetails = {
  __typename?: 'PersonalLoanProductDetails';
  allowsPrequal: Scalars['Boolean'];
};

/** Valid options for the personal loan's purpose */
export const PersonalLoanPurpose = {
  Business: 'BUSINESS',
  ConsolidateDebt: 'CONSOLIDATE_DEBT',
  EmergencyExpense: 'EMERGENCY_EXPENSE',
  HomeImprovement: 'HOME_IMPROVEMENT',
  Moving: 'MOVING',
  Other: 'OTHER',
  RefinanceCreditCard: 'REFINANCE_CREDIT_CARD',
  Vacation: 'VACATION',
} as const;

export type PersonalLoanPurpose =
  (typeof PersonalLoanPurpose)[keyof typeof PersonalLoanPurpose];
/** A Personal Loans institution */
export type PersonalLoansInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'PersonalLoansInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Personal Loans offer */
export type PersonalLoansOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwards2021Interface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithQualificationsInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'PersonalLoansOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Apply link for the offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** Available term lengths for the entity */
    availableTermLengths?: Maybe<Scalars['String']>;
    /** Average narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
    avgNarrowApr?: Maybe<Scalars['Float']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of NW Best-Of Awards this offer has won for 2021 */
    bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** Disclaimer for the offer */
    disclaimer?: Maybe<Scalars['String']>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver estimated apr associated with the entity */
    driverEstimatedApr?: Maybe<EntityPlacementDriver>;
    /** The driver loan amount associated with the entity */
    driverLoanAmount?: Maybe<EntityPlacementDriver>;
    /** The driver min credit score associated with the entity */
    driverMinCreditScore?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** Category used to group offers on the expanded marketplace */
    expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
    /** List of fees associated with the offer */
    feesBullets?: Maybe<Array<Scalars['String']>>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** Provider's logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** Provider's logo (large) */
    imageSourceLarge?: Maybe<Scalars['URL']>;
    /** Provider's logo (medium) */
    imageSourceMedium?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
    isExpandedMarketplaceOffer?: Maybe<Scalars['Boolean']>;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Flag indiciating whether or not prequal is allowed for this offer */
    isPrequalOffer?: Maybe<Scalars['Boolean']>;
    keyFactsBullets?: Maybe<Array<Scalars['String']>>;
    /** Maximum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
    maxApr?: Maybe<Scalars['Float']>;
    /** Maximum loan amount */
    maxLoanAmount?: Maybe<Scalars['Float']>;
    /** Maximum loan term */
    maxLoanTerm?: Maybe<Scalars['Int']>;
    /** Maximum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
    maxNarrowApr?: Maybe<Scalars['Float']>;
    /** Minimum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
    minApr?: Maybe<Scalars['Float']>;
    /** Text for overriding the 'min_fico' value. */
    minFicoOverrideText?: Maybe<Scalars['String']>;
    /** Minimum loan amount */
    minLoanAmount?: Maybe<Scalars['Float']>;
    /** Minimum loan term in months */
    minLoanTermMonths?: Maybe<Scalars['Int']>;
    /** Minimum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
    minNarrowApr?: Maybe<Scalars['Float']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Estimated monthly payment */
    monthlyPayment?: Maybe<Scalars['Float']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Phone number that users can call to reach out to the partner on desktop, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
    phoneNumberDesktop?: Maybe<Scalars['String']>;
    /** Phone number that users can call to reach out to the partner on mobile, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
    phoneNumberMobile?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: PersonalLoansProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** List of qualifications for the offer */
    qualificationsBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** Star rating */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this provider */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export const PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum = {
  Bankruptcy: 'BANKRUPTCY',
  BorrowAndGrow: 'BORROW_AND_GROW',
  BuyNowPayLater: 'BUY_NOW_PAY_LATER',
  Contingent: 'CONTINGENT',
  CoSignLoans: 'CO_SIGN_LOANS',
  CreditBuilderLoans: 'CREDIT_BUILDER_LOANS',
  CreditCounseling: 'CREDIT_COUNSELING',
  DebtManagementPlans: 'DEBT_MANAGEMENT_PLANS',
  DebtSettlement: 'DEBT_SETTLEMENT',
  FriendsFamilyLoans: 'FRIENDS_FAMILY_LOANS',
  HighInterestPersonalLoans: 'HIGH_INTEREST_PERSONAL_LOANS',
  HomeEquityLoans: 'HOME_EQUITY_LOANS',
  LineOfCredit: 'LINE_OF_CREDIT',
  PaycheckAdvance: 'PAYCHECK_ADVANCE',
  SecuredLoans: 'SECURED_LOANS',
} as const;

export type PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum =
  (typeof PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum)[keyof typeof PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum];
/** The possible "Best Bets" categories for Personal Loans Prequal Offers. */
export const PersonalLoansPrequalBestBets = {
  LowestApr: 'LOWEST_APR',
  LowestMonthlyPayment: 'LOWEST_MONTHLY_PAYMENT',
} as const;

export type PersonalLoansPrequalBestBets =
  (typeof PersonalLoansPrequalBestBets)[keyof typeof PersonalLoansPrequalBestBets];
export const PersonalLoansPrequalLoanPurposeEnum = {
  Business: 'BUSINESS',
  ConsolidateDebt: 'CONSOLIDATE_DEBT',
  EmergencyExpense: 'EMERGENCY_EXPENSE',
  HomeImprovement: 'HOME_IMPROVEMENT',
  Moving: 'MOVING',
  Other: 'OTHER',
  RefinanceCreditCard: 'REFINANCE_CREDIT_CARD',
  Vacation: 'VACATION',
} as const;

export type PersonalLoansPrequalLoanPurposeEnum =
  (typeof PersonalLoansPrequalLoanPurposeEnum)[keyof typeof PersonalLoansPrequalLoanPurposeEnum];
/** Input from the personal loans prequal interface to be sent to providers */
export type PersonalLoansPrequalOfferInput = {
  address: PrequalUserAddressInput;
  annualIncome: Scalars['Int'];
  citizenshipStatus?: InputMaybe<PrequalCitizenshipStatusEnum>;
  coApplicantIncome?: InputMaybe<Scalars['Int']>;
  creditScoreRange: TuVantageScore3Buckets;
  dateOfBirth: Scalars['Date'];
  degreeType?: InputMaybe<PrequalDegreeTypeEnum>;
  discoverAB?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['EmailAddress'];
  employmentType: PrequalEmploymentTypeEnum;
  hasCoApplicant?: InputMaybe<Scalars['Boolean']>;
  loanAmount: Scalars['Int'];
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
  loggerMetadata?: InputMaybe<Scalars['JSON']>;
  name: PrequalUserNameInput;
  residencyOwnership: PrequalResidencyOwnershipEnum;
  ssn: Scalars['String'];
};

/** Provider IDs */
export const PersonalLoansPrequalProviderIdEnum = {
  Avant: 'AVANT',
  Bestegg: 'BESTEGG',
  Discover: 'DISCOVER',
  Freedomplus: 'FREEDOMPLUS',
  Goldmansachs: 'GOLDMANSACHS',
  Lendingclub: 'LENDINGCLUB',
  Lendingpoint: 'LENDINGPOINT',
  Lightstream: 'LIGHTSTREAM',
  Onemain: 'ONEMAIN',
  Opploans: 'OPPLOANS',
  Payoff: 'PAYOFF',
  Penfed: 'PENFED',
  Prosper: 'PROSPER',
  Sofi: 'SOFI',
  Universalcredit: 'UNIVERSALCREDIT',
  Upgrade: 'UPGRADE',
  Upstart: 'UPSTART',
} as const;

export type PersonalLoansPrequalProviderIdEnum =
  (typeof PersonalLoansPrequalProviderIdEnum)[keyof typeof PersonalLoansPrequalProviderIdEnum];
/** A Personal Loans product */
export type PersonalLoansProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'PersonalLoansProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: PersonalLoansInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type PlaidAccountInput = {
  balances?: InputMaybe<Array<PlaidBalanceInput>>;
  id: Scalars['String'];
  mask?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /**
   * There are a huge number of possible subtypes, and it depends on which type it is so for simplicity we're just accepting any string
   * See https://plaid.com/docs/#account-subtypes
   */
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PlaidAccountType>;
  verificationStatus?: InputMaybe<PlaidVerificationStatus>;
};

/**  See https://plaid.com/docs/#account-types  */
export const PlaidAccountType = {
  Credit: 'CREDIT',
  Depository: 'DEPOSITORY',
  Investment: 'INVESTMENT',
  Loan: 'LOAN',
  Other: 'OTHER',
} as const;

export type PlaidAccountType =
  (typeof PlaidAccountType)[keyof typeof PlaidAccountType];
export type PlaidBalanceInput = {
  available?: InputMaybe<Scalars['Int']>;
  current?: InputMaybe<Scalars['Int']>;
};

export const PlaidInstitutionHealthStatus = {
  Degraded: 'DEGRADED',
  Down: 'DOWN',
  Healthy: 'HEALTHY',
} as const;

export type PlaidInstitutionHealthStatus =
  (typeof PlaidInstitutionHealthStatus)[keyof typeof PlaidInstitutionHealthStatus];
export type PlaidInstitutionInput = {
  /** The plaid id of an institution, e.g. `ins_4` */
  institutionId: Scalars['String'];
  name: Scalars['String'];
};

/**  Documentation taken from Plaid docs: https://plaid.com/docs/#onsuccess-callback  */
export const PlaidVerificationStatus = {
  /**  an Item was successfully manually verified  */
  ManuallyVerified: 'MANUALLY_VERIFIED',
  /**  an Item is pending automated microdeposit verfication  */
  PendingAutomaticVerification: 'PENDING_AUTOMATIC_VERIFICATION',
  /**  an Item is pending manual microdeposit verification  */
  PendingManualVerification: 'PENDING_MANUAL_VERIFICATION',
} as const;

export type PlaidVerificationStatus =
  (typeof PlaidVerificationStatus)[keyof typeof PlaidVerificationStatus];
/** Type modeling the data for posts within the post post type from WordPress. */
export type Post = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'Post';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the Post object. */
    categories?: Maybe<Array<Category>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the post post type from WordPress. */
export type PostDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the post post type from WordPress. */
export type PostModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the post post type from WordPress. */
export type PostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The input for fetching a single forked post. */
export type PostForkItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier: Scalars['Int'];
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']>;
  /** The slug for the entity this fork was created from or the WordPress ID. */
  identifier: Scalars['ID'];
  /** The security nonce for viewing the entity. */
  wpnonce?: InputMaybe<Scalars['String']>;
};

/** The Post interface for modeling other custom post types. */
export type PostInterface = {
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String'];
  /** The WordPress post_type for the resource. */
  type: Scalars['String'];
};

/** The Post interface for modeling other custom post types. */
export type PostInterfaceDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The Post interface for modeling other custom post types. */
export type PostInterfaceModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** The input for retrieving a single resource. */
export type PostItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier?: InputMaybe<Scalars['Int']>;
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']>;
  /** The slug for the post or the WordPress ID. */
  identifier: Scalars['ID'];
  /** Whether or not to retrieve the preview of the post. */
  preview?: InputMaybe<Scalars['Boolean']>;
  /** The security nonce for viewing a preview. */
  wpnonce?: InputMaybe<Scalars['ID']>;
};

export const PostType = {
  Article: 'ARTICLE',
  Post: 'POST',
} as const;

export type PostType = (typeof PostType)[keyof typeof PostType];
/** WordPress post types supported in GraphQL. */
export const PostTypeEnum = {
  Article: 'ARTICLE',
  Banner: 'BANNER',
  BccPage: 'BCC_PAGE',
  BccPageCard: 'BCC_PAGE_CARD',
  Block: 'BLOCK',
  BlockGroup: 'BLOCK_GROUP',
  Calculator: 'CALCULATOR',
  CalcPage: 'CALC_PAGE',
  ContentPack: 'CONTENT_PACK',
  EngPost: 'ENG_POST',
  GnavItem: 'GNAV_ITEM',
  HouseAd: 'HOUSE_AD',
  Hub: 'HUB',
  HubNew: 'HUB_NEW',
  InsPage: 'INS_PAGE',
  Landing: 'LANDING',
  Lender: 'LENDER',
  MktEntry: 'MKT_ENTRY',
  Page: 'PAGE',
  Placement: 'PLACEMENT',
  Post: 'POST',
  PressRelease: 'PRESS_RELEASE',
  Review: 'REVIEW',
  Reviewer: 'REVIEWER',
  Roundup: 'ROUNDUP',
  TablepressTable: 'TABLEPRESS_TABLE',
  UrlRecord: 'URL_RECORD',
  UserPage: 'USER_PAGE',
} as const;

export type PostTypeEnum = (typeof PostTypeEnum)[keyof typeof PostTypeEnum];
/** The interface for post types that support authors. */
export type PostWithAuthorsInterface = {
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
};

/** The interface for content types that exposes social media links. */
export type PostWithContactInfoInterface = {
  /** The social media link fields to display for the content type. */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};

export type PostWithContentClassificationInterface = {
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']>>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']>>;
};

/** The interface for post types that support the content field. */
export type PostWithContentInterface = {
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
};

export type PostWithEditorInterface = {
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
};

/** The interface for post types that support excerpts. */
export type PostWithExcerptInterface = {
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']>;
};

/** The interface for post types that support excerpts. */
export type PostWithExcerptInterfaceExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

export type PostWithFaQsInterface = {
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']>;
};

/** The interface for post types that support featured images. */
export type PostWithFeaturedImageInterface = {
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
};

/** The interface for PostWithHubLinks that exposes related Hubs and subhubs links. */
export type PostWithHubLinks = {
  /** Collection of related hubs and subhubs. */
  hubLinks?: Maybe<Array<ContentHub>>;
};

export type PostWithInternationalVersionsInterface = {
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
};

/** The interface for post types that support gms page taxonomy. */
export type PostWithPageTaxonomyInterface = {
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']>;
};

export type PostWithReviewerInterface = {
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
};

export type PostWithSeoInterface = {
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
};

/** The interface for post types that support the title field. */
export type PostWithTitleInterface = {
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']>;
};

/** The interface for post types that support the title field. */
export type PostWithTitleInterfaceTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The interface for content types that exposes user information. */
export type PostWithUserInfoInterface = {
  /** The users's previous experience. */
  experience?: Maybe<Scalars['String']>;
  /** The user's full name */
  fullName?: Maybe<Scalars['String']>;
  /** The user's job title */
  jobTitle?: Maybe<Scalars['String']>;
};

export const PrequalCitizenshipStatusEnum = {
  Citizen: 'CITIZEN',
  Other: 'OTHER',
  PermanentResident: 'PERMANENT_RESIDENT',
} as const;

export type PrequalCitizenshipStatusEnum =
  (typeof PrequalCitizenshipStatusEnum)[keyof typeof PrequalCitizenshipStatusEnum];
export const PrequalDegreeTypeEnum = {
  Associate: 'ASSOCIATE',
  Bachelors: 'BACHELORS',
  Dds: 'DDS',
  HighSchoolDiploma: 'HIGH_SCHOOL_DIPLOMA',
  Jd: 'JD',
  Masters: 'MASTERS',
  Mba: 'MBA',
  Md: 'MD',
  Pharmd: 'PHARMD',
  Phd: 'PHD',
} as const;

export type PrequalDegreeTypeEnum =
  (typeof PrequalDegreeTypeEnum)[keyof typeof PrequalDegreeTypeEnum];
export const PrequalEmploymentTypeEnum = {
  FullTime: 'FULL_TIME',
  Military: 'MILITARY',
  Other: 'OTHER',
  PartTime: 'PART_TIME',
  Retired: 'RETIRED',
  SelfEmployed: 'SELF_EMPLOYED',
  Unemployed: 'UNEMPLOYED',
} as const;

export type PrequalEmploymentTypeEnum =
  (typeof PrequalEmploymentTypeEnum)[keyof typeof PrequalEmploymentTypeEnum];
export type PrequalJob = {
  __typename?: 'PrequalJob';
  jobId: Scalars['ID'];
  path: Scalars['String'];
  service: PrequalServiceIdEnum;
};

export type PrequalJobInput = {
  jobId: Scalars['ID'];
  path: Scalars['String'];
  service: PrequalServiceIdEnum;
};

export type PrequalJobStatusResponse = {
  __typename?: 'PrequalJobStatusResponse';
  status: PrequalOfferStatus;
  totalResults: Scalars['Int'];
};

/** Generic Prequal Offer interface */
export type PrequalOffer = {
  applyLink: Scalars['String'];
  institutionLogo: Scalars['String'];
  institutionName: Scalars['String'];
  nwRating?: Maybe<Scalars['Float']>;
  providerId?: Maybe<Scalars['ID']>;
};

export type PrequalOfferDriverInfoInput = {
  age?: InputMaybe<Scalars['Int']>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  driversCount?: InputMaybe<Scalars['Int']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']>;
  isVeteran?: InputMaybe<Scalars['Boolean']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']>;
};

export type PrequalOfferJobIdStatus = {
  __typename?: 'PrequalOfferJobIdStatus';
  /** Current status of job id */
  jobId: Scalars['ID'];
  status: PrequalOverallStatusTypesEnum;
};

/** Generic Prequal Offer Status object */
export type PrequalOfferStatus = {
  __typename?: 'PrequalOfferStatus';
  jobIds?: Maybe<Array<Maybe<PrequalOfferJobIdStatus>>>;
  /** Overall status of fetching all offers */
  overall: PrequalOverallStatusTypesEnum;
};

/** Insurance user input that is shared among verticals */
export type PrequalOfferUserInfoInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['Date']>;
  email?: InputMaybe<Scalars['EmailAddress']>;
  inventoryType?: InputMaybe<Scalars['String']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']>;
  isMarried?: InputMaybe<Scalars['Boolean']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']>;
  pricingCodeExpiration?: InputMaybe<Scalars['Date']>;
  pricingCodeExpirationDateTime?: InputMaybe<Scalars['DateTime']>;
  qsClickKey?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

/** Prequal offers overall status types */
export const PrequalOverallStatusTypesEnum = {
  /**
   * An error occurred at the overall request level
   * If an error occurred for an individual provider, that will be reflected in status.providers
   */
  Error: 'ERROR',
  /** Results are pending */
  Pending: 'PENDING',
  /** All results are resolved (regardless of success or error) */
  Resolved: 'RESOLVED',
} as const;

export type PrequalOverallStatusTypesEnum =
  (typeof PrequalOverallStatusTypesEnum)[keyof typeof PrequalOverallStatusTypesEnum];
/**
 * An offer that combines fields from marketplace, the prequal-service, and the
 * user's profile.  This is also referred to as a "personal loans prequal offer"
 */
export type PrequalPersonalLoansApiOffer = {
  __typename?: 'PrequalPersonalLoansApiOffer';
  /** The apply link is generated based on the marketplace offer ID, the prequal ID, and the offer's redirect URL */
  applyLink: Scalars['URL'];
  /** The "best bets" categories for which the offer is eligible. */
  bestBets?: Maybe<Array<PersonalLoansPrequalBestBets>>;
  /** Date and time indicating when the offer was created */
  createdAt: Scalars['String'];
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']>;
  /** The value of expanded marketplace category is "null" if the offer is not an expanded marketplace offer */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** Date and time indicating when the offer expires */
  expiredAt?: Maybe<Scalars['String']>;
  /** Unique prequal identifier */
  id: Scalars['ID'];
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer: Scalars['Boolean'];
  /** Flag indicating whether the APR rate is variable */
  isVariableRate: Scalars['Boolean'];
  /** Offered loan amount */
  loanAmount: Scalars['Float'];
  /** The loan APR is calculated as the offer's APR divided by 100 */
  loanApr: Scalars['Float'];
  /** The id of the lender offering the loan */
  loanLenderId?: Maybe<Scalars['String']>;
  /** The name of the lender offering the loan */
  loanLenderProvider?: Maybe<Scalars['String']>;
  /** Includes principal loan balance and interest each month over the life of the loan */
  loanMonthlyPayment: Scalars['Float'];
  /** The offer level NW star rating for the personal loan offer */
  loanStarRating?: Maybe<Scalars['Float']>;
  /** Length of time it will take for the user to pay off the loan in months */
  loanTermMonths: Scalars['Int'];
  /** The offer's origination fee */
  loanTotalFees: Scalars['Float'];
  /** Total interest on the loan */
  loanTotalInterest: Scalars['Float'];
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The number of days remaining before the offer expires */
  numberOfDaysBeforeOfferExpiration?: Maybe<Scalars['Int']>;
  /** The drivers for the prequal offer in non structured content format */
  rawDrivers: Array<RawDriver>;
  /** Type of residency ownership */
  residencyOwnership: PrequalResidencyOwnershipEnum;
};

export const PrequalResidencyOwnershipEnum = {
  OwnFully: 'OWN_FULLY',
  OwnMortgage: 'OWN_MORTGAGE',
  Rent: 'RENT',
} as const;

export type PrequalResidencyOwnershipEnum =
  (typeof PrequalResidencyOwnershipEnum)[keyof typeof PrequalResidencyOwnershipEnum];
export const PrequalServiceIdEnum = {
  CcPrequalService: 'CC_PREQUAL_SERVICE',
  Homeownership: 'HOMEOWNERSHIP',
  PersonalLoansService: 'PERSONAL_LOANS_SERVICE',
  PrequalService: 'PREQUAL_SERVICE',
  StudentLoansService: 'STUDENT_LOANS_SERVICE',
} as const;

export type PrequalServiceIdEnum =
  (typeof PrequalServiceIdEnum)[keyof typeof PrequalServiceIdEnum];
export type PrequalUserAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export type PrequalUserNameInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressRelease = PostInterface &
  PostWithAuthorsInterface &
  PostWithFeaturedImageInterface &
  PostWithTitleInterface & {
    __typename?: 'PressRelease';
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Whether or not this Press Release is considered featured. */
    featured?: Maybe<Scalars['Boolean']>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** A list of MediaSite objects on the PressRelease object. */
    mediaSites?: Maybe<Array<MediaSite>>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** The external URL for this Press Release. */
    url?: Maybe<Scalars['URL']>;
  };

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type PressReleaseConnectionResponse = {
  __typename?: 'PressReleaseConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The PressRelease returned for the connection. */
  items?: Maybe<Array<PressRelease>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of PressRelease objects. */
export type PressReleaseFilterInput = {
  /** Limit collection to PressReleases published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to Press Releases with a specific featured status. */
  featured?: InputMaybe<Scalars['Boolean']>;
  /** Limit collection to PressReleases with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to PressReleases within a specific MediaSite. This field accepts an array of integer ID's or slugs. */
  mediaSiteIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
};

export const PrimaryGoal = {
  BigPurchase: 'BIG_PURCHASE',
  BuildCredit: 'BUILD_CREDIT',
  CashBack: 'CASH_BACK',
  Debt: 'DEBT',
  Travel: 'TRAVEL',
} as const;

export type PrimaryGoal = (typeof PrimaryGoal)[keyof typeof PrimaryGoal];
/** Types of Product Cards for a Roundup */
export const ProductCardComponentEnum = {
  Institution: 'INSTITUTION',
  Keto: 'KETO',
  MarketplaceProductCard: 'MARKETPLACE_PRODUCT_CARD',
  Slim: 'SLIM',
} as const;

export type ProductCardComponentEnum =
  (typeof ProductCardComponentEnum)[keyof typeof ProductCardComponentEnum];
/** Types of tabbed content that may appear within Roundup product cards. */
export const ProductCardContentTabEnum = {
  KeyFacts: 'KEY_FACTS',
  ProductDetails: 'PRODUCT_DETAILS',
  ProsCons: 'PROS_CONS',
  WhyWeLikeIt: 'WHY_WE_LIKE_IT',
} as const;

export type ProductCardContentTabEnum =
  (typeof ProductCardContentTabEnum)[keyof typeof ProductCardContentTabEnum];
/** ProductInterface contains the common base fields for all products. */
export type ProductInterface = {
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

/** The persisted set of answers that the user submitted in the User reseach flow for project ted. */
export type ProjectTedFormResponse = {
  __typename?: 'ProjectTedFormResponse';
  formStatus?: Maybe<ProjectTedFormStatusEnum>;
};

export const ProjectTedFormStatusEnum = {
  Error: 'ERROR',
  Success: 'SUCCESS',
} as const;

export type ProjectTedFormStatusEnum =
  (typeof ProjectTedFormStatusEnum)[keyof typeof ProjectTedFormStatusEnum];
export type Provider = {
  __typename?: 'Provider';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The number of prequal offers provided by this provider is a calculated field */
  numOffers: Scalars['Int'];
};

/**  See https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event  */
export const ProxyEventType = {
  AuthenticationSuccess: 'AUTHENTICATION_SUCCESS',
  Exit: 'EXIT',
  FlowClosed: 'FLOW_CLOSED',
  FlowOpened: 'FLOW_OPENED',
  InstitutionSearched: 'INSTITUTION_SEARCHED',
  ResetLogin: 'RESET_LOGIN',
  SourceEvent: 'SOURCE_EVENT',
} as const;

export type ProxyEventType =
  (typeof ProxyEventType)[keyof typeof ProxyEventType];
/** The return type of publish a single Yak message */
export type PublishYakMessageResult = {
  __typename?: 'PublishYakMessageResult';
  /** Whether the message was published successfully */
  success: Scalars['Boolean'];
};

/** Empty field. Not to be used. */
export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  abExperiments?: Maybe<Array<Maybe<Experiment>>>;
  accountAggCtaDismissedFlags?: Maybe<AccountAggCtaDismissedResponse>;
  accountAggregationInstitutionById?: Maybe<AccountAggregationInstitutionByIdResponse>;
  accountLinkingOpportunities?: Maybe<AccountLinkingOpportunitiesResponse>;
  /** Query to fetch a single Article object. */
  article?: Maybe<Article>;
  /** Query to fetch a single Article object. */
  articleFork?: Maybe<Article>;
  /** Query to fetch multiple Article objects. */
  articles?: Maybe<ArticleConnectionResponse>;
  /**
   * The `authCookies` query returns the cookies returned when querying auth info. This could include cookies
   * such as csrf_token, access_token, jwt_access_token, refresh_token
   */
  authCookies: Array<Cookie>;
  /** Query to fetch a single Author object. */
  author?: Maybe<Author>;
  /** Return autoInsuranceCitySummary json */
  autoInsuranceCitySummary?: Maybe<AutoInsuranceCitySummary>;
  /** Get auto insurance prequal offers */
  autoInsurancePrequalOffers?: Maybe<AutoInsurancePrequalOffersResponse>;
  /** Get auto insurance prequal offers without cache (v2) */
  autoInsurancePrequalOffersJobIds?: Maybe<AutoInsurancePrequalOffersJobResponse>;
  /** Get offers response from a list of Prequal Jobs */
  autoInsurancePrequalOffersV2?: Maybe<AutoInsurancePrequalOffersResponseV2>;
  /** Return autoInsuranceVehicleSummary json */
  autoInsuranceVehicleSummary?: Maybe<AutoInsuranceVehicleSummary>;
  /** Query to fetch a single Banner object. */
  banner?: Maybe<Banner>;
  /** Query to fetch multiple Banner objects. */
  banners?: Maybe<BannerConnectionResponse>;
  /** Query to fetch a single BccPage object. */
  bccPage?: Maybe<BccPage>;
  /** Query to fetch a single BccPageCard object. */
  bccPageCard?: Maybe<BccPageCard>;
  /** Query to fetch multiple BccPageCard objects. */
  bccPageCards?: Maybe<BccPageCardConnectionResponse>;
  /** The (Filtered) BCC Page Sections for a given post. */
  bccPageSections: Array<BccPageSection>;
  /** Query to fetch multiple BccPage objects. */
  bccPages?: Maybe<BccPageConnectionResponse>;
  /** Query to fetch a single Block object. */
  block?: Maybe<Block>;
  /** Query to fetch a single BlockGroup object. */
  blockGroup?: Maybe<BlockGroup>;
  /** Query to fetch multiple BlockGroup objects. */
  blockGroups?: Maybe<BlockGroupConnectionResponse>;
  /** Query to fetch multiple Block objects. */
  blocks?: Maybe<BlockConnectionResponse>;
  /** Query to fetch a single CalculatorPage object. */
  calculatorPage?: Maybe<CalculatorPage>;
  /** Query to fetch a single CalculatorPage object. */
  calculatorPageFork?: Maybe<CalculatorPage>;
  /** Query to fetch multiple CalculatorPage objects. */
  calculatorPages?: Maybe<CalculatorPageConnectionResponse>;
  /** Search for canonical institution by keyword, with the use case of an autocomplete input in mind */
  canonicalInstitutionsByKeyword?: Maybe<CanonicalInstitutionsResponse>;
  cardFinderGlobalMarkup: CardFinderGlobalMarkup;
  cardFinderUserData: CardFinderUserData;
  /** Returns the activation status of the CashFlow feature */
  cashFlowActivationStatus?: Maybe<CashFlowActivationStatusResponse>;
  /**
   * The breakdown of cash flow this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be passed to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   */
  cashFlowBreakdown?: Maybe<CashFlowBreakdown>;
  cashFlowHistoryBreakdown: CashFlowHistoryBreakdown;
  /** A user's top takeaways with regards to their cash flow based on the current date */
  cashFlowTopTakeaways?: Maybe<Array<CashFlowTakeaway>>;
  /** Query to fetch a single Category object. */
  category?: Maybe<Category>;
  /** Return compareAutoInsuranceCarriers json */
  compareAutoInsuranceCarriers?: Maybe<CompareAutoInsuranceCarriers>;
  /** Query to fetch a single ContentHub object. */
  contentHub?: Maybe<ContentHub>;
  /** Query to fetch a single ContentHub object. */
  contentHubFork?: Maybe<ContentHub>;
  /** Query to fetch multiple ContentHub objects. */
  contentHubs?: Maybe<ContentHubConnectionResponse>;
  /** Query to fetch a single ContentPack object. */
  contentPack?: Maybe<ContentPack>;
  /** Query to fetch multiple ContentPack objects. */
  contentPacks?: Maybe<ContentPackConnectionResponse>;
  /** Retrieves a list of all the WP recommended posts from the ML recommendation pipeline. */
  contentRecommendationPosts?: Maybe<ContentRecommendations>;
  /** Query to fetch a single ContentReviewer object. */
  contentReviewer?: Maybe<ContentReviewer>;
  /** Query to fetch multiple ContentReviewer objects. */
  contentReviewers?: Maybe<ContentReviewerConnectionResponse>;
  /** Query to fetch a collection of content search results. */
  contentSearch?: Maybe<ContentSearchResultConnectionResponse>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPage?: Maybe<ContentUserPage>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPageFork?: Maybe<ContentUserPage>;
  /** Query to fetch multiple ContentUserPage objects. */
  contentUserPages?: Maybe<ContentUserPageConnectionResponse>;
  /**
   * Retrieves a list of all credit cards that the ML API supports calculating approval
   * odds predictions for.
   */
  creditCardApprovalOddsPrediction?: Maybe<CreditCardApprovalOddsPredictionResponse>;
  /**
   * Returns the user's persisted set of quiz flow answers for the Credit Card Match quiz.
   * Datasource endpoint: recommendation-service/api/quiz-recommendations/user-answers/v1
   */
  creditCardMatchQuizAnswers?: Maybe<CreditCardMatchQuizAnswersResponse>;
  creditCardMatchQuizOffers?: Maybe<CreditCardMatchQuizOffersResponse>;
  /**
   * Get a single credit card offer by its legacy ID
   * Returns null if it cannot be found
   */
  creditCardOfferByLegacyId?: Maybe<CreditCardOffer>;
  /** Retrieves a list of all of the credit card IDs that support approval odds. */
  creditCardOfferIdsWithApprovalOddsPrediction?: Maybe<CreditCardOfferIdsWithApprovalOddsPredictionResponse>;
  /**
   * Search for credit card offers by keyword,
   * with the use case of an autocomplete input in mind
   */
  creditCardOffersByKeyword?: Maybe<CreditCardOffersResponse>;
  creditCardOffersByLegacyIds?: Maybe<CreditCardOffersResponse>;
  creditCardOffersByNamedQuery?: Maybe<CreditCardOffersResponse>;
  /**
   * Returns credit card offers associated with the account aggregation institution first by
   * checking for offers with a credit card institution matching the canonical institution ID of the account aggregation institution
   * and falling back to a search by offer name using the account aggregation institution name.
   */
  creditCardOffersForAccountAggregationInstitution?: Maybe<CreditCardOffersV2Response>;
  creditCardPrequalOffers: CreditCardPrequalOffersResponse;
  creditCardsQuiz: QuizResponse;
  creditFactorTips?: Maybe<CreditFactorTips>;
  creditFactors?: Maybe<CreditFactors>;
  /** Returns the activation status of the CreditScore feature */
  creditScoreActivationStatus?: Maybe<CreditScoreActivationStatusResponse>;
  /** The user's credit history represented by their credit scores for a time range */
  creditScoreHistory?: Maybe<CreditScoreHistoryResponse>;
  /**
   * Total sum of a user checking, investing, savings, retirement account balances on the passed-in date.
   * Example: Return value is `86000.56`
   */
  csirBalanceOnDate?: Maybe<Scalars['Float']>;
  debtSummary?: Maybe<DebtSummary>;
  /** Search for decline loan offers that match the relevant expanded marketplace category */
  declinePersonalLoanOffersSearch?: Maybe<DeclinePersonalLoanOffers>;
  /** Return drcCitySummary json */
  drcCitySummary?: Maybe<AutoInsuranceCitySummary>;
  /** Return drcVehicleSummary json */
  drcVehicleSummary?: Maybe<AutoInsuranceVehicleSummary>;
  /** Query to fetch a single DynamicPlacement object. */
  dynamicPlacement?: Maybe<DynamicPlacement>;
  /** Query to fetch multiple DynamicPlacement objects. */
  dynamicPlacements?: Maybe<DynamicPlacementConnectionResponse>;
  /**
   * Returns the activation status of an EORU (Email-only Registered User).
   * "Activated" means their visitor_profile is associated with an email address.
   */
  emailOnlyRegisteredUserStatus?: Maybe<EmailOnlyRegisteredUserActivationStatusResponse>;
  /** Query to fetch a single EngineeringPost object. */
  engineeringPost?: Maybe<EngineeringPost>;
  /** Query to fetch multiple EngineeringPost objects. */
  engineeringPosts?: Maybe<EngineeringPostConnectionResponse>;
  experimentDecisions?: Maybe<Array<ExperimentDecision>>;
  featureFlag?: Maybe<FeatureFlag>;
  /**
   * The appName argument is not being used. The "X-Caller-Client-ID" request header is being used
   * to fetch the feature flags for the appropriate platform.
   * Update: I made the 'appName' input arg not required so that we can safely deprecate it's usage
   * in the native app startup queries
   */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  /** Fetches a user's financial account by financial account ID. */
  financialAccountById?: Maybe<FinancialAccount>;
  financialAccountTypeSums?: Maybe<FinancialAccountTypeSumsResponse>;
  financialAccounts?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsByPortal?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsIAVDetails?: Maybe<FinancialAccountsIavDetailsResponse>;
  financialIdentityProfile?: Maybe<FinancialIdentityProfile>;
  /** Fetches a user's financial portal by financial portal ID. */
  financialPortalById?: Maybe<FinancialPortal>;
  /** Retrieves a financial portal by the provided marketplace institution ID */
  financialPortalByInstitutionId?: Maybe<FinancialPortal>;
  financialPortals?: Maybe<GetPortalsResponse>;
  financialPriorities?: Maybe<FinancialPrioritiesResponse>;
  /**  Returns a transaction for a user by transaction ID.  */
  financialTransactionById?: Maybe<FinancialTransaction>;
  financialTransactionCategories?: Maybe<FinancialTransactionCategoriesResponse>;
  /**  A generic query to fetch the transactions pre-filtered for what we expect  */
  financialTransactions?: Maybe<GetTransactionsResponse>;
  /**
   * Returns a user's mean average spending by day of the month for the target month range.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily/average
   */
  financialTransactionsAverageSpendingByDayOfTheMonth?: Maybe<FinancialTransactionsAverageSpendingByDayOfTheMonth>;
  /**
   * Returns a user's budget breakdown for the last month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsBudgetBreakdown?: Maybe<FinancialTransactionsBudgetBreakdown>;
  /**
   * Returns a user's budget breakdown separated by month for a specified range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsBudgetBreakdownByMonth?: Maybe<FinancialTransactionsBudgetBreakdownByMonthResponse>;
  /** Returns a user's cash in and cash out monthly summary for the current month and previous months */
  financialTransactionsCashInCashOutSummary?: Maybe<FinancialTransactionsCashInCashOutSummary>;
  /**
   * Returns a user's projected earning for the target month.
   *  Datasource endpoint: financial_accounts/transactions/cash_flow/projection
   */
  financialTransactionsProjectionForMonth?: Maybe<FinancialTransactionsProjectionForMonth>;
  /** Returns a user's spending and earning by month for a given date range. */
  financialTransactionsSpendingAndEarningByMonth?: Maybe<FinancialTransactionsSpendingAndEarningByMonth>;
  /**
   * Returns a user's spending and earning for a given month range.
   * Datasource endpoint: /api/v1/financial_accounts/transactions/cash_flow
   */
  financialTransactionsSpendingAndEarningForMonthRange?: Maybe<FinancialTransactionsSpendingAndEarningForMonthRangeResponse>;
  /**
   * Returns a user's spending totals by category for a target month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/by_categories
   */
  financialTransactionsSpendingByCategoryForMonth?: Maybe<FinancialTransactionsSpendingByCategoryForMonth>;
  /**
   * Returns a user's spending totals by date for a target month and the month prior to that month.
   * Datasource endpoint: /financial_accounts/transactions/cash_flow/daily
   */
  financialTransactionsSpendingByDateForMonth?: Maybe<FinancialTransactionsSpendingByDayOfTheMonthForMonth>;
  /**
   * Returns a user's spending by month in a target month range.
   * Datasource endpoint: financial_accounts/transactions/spending/monthly
   */
  financialTransactionsSpendingByMonth?: Maybe<FinancialTransactionsSpendingByMonth>;
  /**
   * Returns a user's spending in the current selected time period compared to the previous.
   * Ex. spending up to the current date of the month, vs the same date for last month
   * Ex. spending up to the current week of the quarter, vs the same week for last quarter
   * Datasource endpoint: /financial_accounts_transactions/cash_flow/daily
   */
  financialTransactionsSpendingPeriodComparison?: Maybe<FinancialTransactionsSpendingPeriodComparisonResponse>;
  /**
   * Returns a user's top categories by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopCategoriesBySpending?: Maybe<FinancialTransactionsTopCategoriesBySpending>;
  /**
   * Returns a user's top merchants by spending for the target month range.
   *  Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopMerchantsBySpending?: Maybe<FinancialTransactionsTopMerchantsBySpending>;
  /** Fetches FDP user meta data for UserOps Dashboard */
  financialUsersForIdentityId?: Maybe<GetFinancialUserMetaResponse>;
  gamificationChecklist?: Maybe<GamificationChecklistResponse>;
  getAvailableAirFieldIdentifiers: Array<Scalars['String']>;
  getContent: SearchServiceContentSearchResults;
  getInsuranceAirField?: Maybe<InsuranceAirField>;
  getInsuranceAirList?: Maybe<InsuranceAirList>;
  /** Fetch the state from zipCode */
  getStateFromZipCode?: Maybe<GetStateFromZipCodeResponse>;
  getUserOpsCommsSubscriptionPreferencesWrapperList: Array<UserOpsCommsSubscriptionPreferencesWrapper>;
  getUserOpsFDPLinkingErrorEvents: Array<UserOpsPaoEventDetails>;
  getUserOpsMessagingActivityEventsList: Array<
    Maybe<UserOpsMessagingActivityEvent>
  >;
  /**
   * Mutation-esque query
   * Returns the user's current streak. If the current date is not in the same week or the consecutive week of the most recent completion date of weekly insights, then mutates the user's weekly_insights_completed_at array to be empty
   */
  getWeeklyInsightsCurrentStreak: WeeklyInsightsCurrentStreakResponse;
  globalIdentityProfile?: Maybe<GlobalIdentityProfile>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItem?: Maybe<GlobalNavItem>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItemFork?: Maybe<GlobalNavItem>;
  /** Query to fetch multiple GlobalNavItem objects. */
  globalNavItems?: Maybe<GlobalNavItemConnectionResponse>;
  /**
   * Accepts an id, name, or kebabName field to filter for a GreenhouseDepartment.
   * If multiple fields are present, the priority is id -> name -> kebabName.
   */
  greenhouseDepartment?: Maybe<GreenhouseDepartment>;
  greenhouseDepartments?: Maybe<Array<GreenhouseDepartment>>;
  greenhouseJob?: Maybe<GreenhouseJob>;
  hasLinkedFinancialAccounts: Scalars['Boolean'];
  /** Retrieve array of HealthabilityReports from the trunk branch of all repos */
  healthability?: Maybe<Array<Maybe<HealthabilityReport>>>;
  healthabilityReports?: Maybe<Array<Maybe<HealthabilityReport>>>;
  healthabilityRepositories?: Maybe<Array<Maybe<HealthabilityRepository>>>;
  homeLeadMatch: Array<MortgagesOfferWithRates>;
  /** Query to fetch a single HouseAd object. */
  houseAd?: Maybe<HouseAd>;
  /** Query to fetch multiple HouseAd objects. */
  houseAds?: Maybe<HouseAdConnectionResponse>;
  /** Query to fetch a single Hub object. */
  hub?: Maybe<Hub>;
  /** Query to fetch a single Hub object. */
  hubFork?: Maybe<Hub>;
  /** Query to fetch multiple Hub objects. */
  hubs?: Maybe<HubConnectionResponse>;
  /**
   * Create a portal if one does not exist for a particular institution
   * @deprecated Moved to a mutation
   */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /**
   * Initializes a short lived, one-time use token that should be unique for each Plaid Link session
   * on the client.
   */
  initializeLinkToken?: Maybe<InitializeLinkTokenResponse>;
  /** Retrieves institution status health data for the financial portal ID and identity id specified. */
  institutionHealthDetailsByPortalId?: Maybe<GetInstitutionHealthDetailsResponse>;
  /**
   * Search for account aggregation institutions by keyword, with the use case of an autocomplete input for users
   * linking accounts in mind
   */
  institutionsForAccountLinkingByKeyword?: Maybe<AccountAggregationInstitutionsResponse>;
  /** Query to fetch a single InsurancePage object. */
  insurancePage?: Maybe<InsurancePage>;
  /** Query to return an insurance page by the current page path. */
  insurancePageByPath?: Maybe<InsurancePage>;
  /** Query to fetch multiple InsurancePage objects. */
  insurancePages?: Maybe<InsurancePageConnectionResponse>;
  /** Get insurance prequal offers (v1) */
  insurancePrequalOffers?: Maybe<InsurancePrequalOffersResponse>;
  /** Get offers response from a list of Prequal Jobs (v2) */
  insurancePrequalOffersByJobId?: Maybe<InsurancePrequalOffersByJobIdResponse>;
  /** Get insurance prequal offers without cache (v2) */
  insurancePrequalOffersJobIds?: Maybe<InsurancePrequalOffersJobResponse>;
  /** Checks if the user is in a state where NerdWallet is a licensed mortgage broker */
  isNerdWalletMortgageLicensed: MortgageLicensed;
  /** Query to fetch a single LandingPage object. */
  landingPage?: Maybe<LandingPage>;
  /** Query to fetch a single LandingPage object. */
  landingPageFork?: Maybe<LandingPage>;
  /** Query to fetch multiple LandingPage objects. */
  landingPages?: Maybe<LandingPageConnectionResponse>;
  latestHealthabilityReports?: Maybe<Array<Maybe<HealthabilityReport>>>;
  /** Query to fetch a single LegacyLender object. */
  legacyLender?: Maybe<LegacyLender>;
  /** Query to fetch multiple LegacyLender objects. */
  legacyLenders?: Maybe<LegacyLenderConnectionResponse>;
  /**
   * Fetches all portals that are not in the INIT state. This is useful for clients because
   * portals in the INIT state have not been fully linked by the user and should not be shown in the UI
   */
  linkedFinancialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Search for Marketplace entities by keyword
   * using Marketplace's Autocomplete endpoint.
   * https://docs.nerdwallet.io/marketplace/branches/master/api.full_text.html
   */
  marketplaceAutocompleteSearch?: Maybe<Array<MarketplaceEntityInterface>>;
  marketplaceEntitiesV2: Array<Maybe<MarketplaceEntityInterface>>;
  marketplaceEntityV2?: Maybe<MarketplaceEntityInterface>;
  /** Query to fetch a single MarketplaceEntryPoint object. */
  marketplaceEntryPoint?: Maybe<MarketplaceEntryPoint>;
  /** Query to fetch multiple MarketplaceEntryPoint objects. */
  marketplaceEntryPoints?: Maybe<MarketplaceEntryPointConnectionResponse>;
  /** Get a specific marketplace field value based on entity id and field's raw path */
  marketplaceField?: Maybe<MarketplaceFieldResponse>;
  /**
   * Search for Marketplace entities
   * using Marketplace's product search endpoint.
   */
  marketplaceSearch: MarketplaceSearchResponse;
  /** Query to fetch a single MediaItem object. */
  mediaItem?: Maybe<MediaItem>;
  /** Query to fetch multiple MediaItem objects. */
  mediaItems?: Maybe<MediaItemConnectionResponse>;
  /** Query to fetch a single MediaSite object. */
  mediaSite?: Maybe<MediaSite>;
  /** Returns a list of content packs containing relevant content */
  memberHomeContentPacks?: Maybe<ContentPackResponse>;
  membershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  mobileAppIdentityProfile?: Maybe<MobileAppIdentityProfile>;
  /**
   * Returns the money management eligibility for a financial portal's accounts. AS part of
   * determining the eligibility, the money management service goes through the process of attempting
   * to IAV verify the accounts.
   */
  moneyTransferAccountEligibility?: Maybe<MoneyTransferAccountEligibilityResponse>;
  /**
   * Returns the KBA questions used by an onboarding money transfer user
   * to identify themselves if we weren't able to from SSN alone:
   * // https://nerdwallet.atlassian.net/wiki/spaces/PRODUCT/pages/620134583/KBA+in+Money+Management
   */
  moneyTransferKbaQuestions?: Maybe<MoneyTransferKbaQuestionsResponse>;
  /** Return the transfer limits for the user */
  moneyTransferTransferLimits?: Maybe<MoneyTransferTransferLimitsResponse>;
  /** Find matching offers based on Mortgage OSX inputs */
  mortgageLenderMatch: Array<MortgagesOfferV2>;
  /** Retrieve Home Lead Match offer based on offerId or legacy productId */
  mortgageSavedLeadMatch?: Maybe<MortgagesOfferV2>;
  /** Retrieve Home Lead Match offers given offer ids */
  mortgageSavedLeadMatches?: Maybe<MortgageSavedLendersResponse>;
  /** Retrieve Home Lead Match recommended lenders offers based on offerIds or legacy productIds */
  mortgageSavedRecommendedLenders?: Maybe<MortgageSavedRecommendedLendersResponse>;
  /** User's list of bills */
  myBills: BillsResponse;
  /**
   * Returns the user's net worth account pertaining to the provided financial account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccountByFinancialAccountId?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided net worth account ID.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts/<net_worth_account_id>
   */
  netWorthAccountById?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth accounts. The fields provided by Wealth Recommender are
   * annotations on the accounts supplied by Identity/FDP.
   * Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccounts?: Maybe<NetWorthAccountsResponse>;
  /** Returns the activation status of the NetWorth feature */
  netWorthActivationStatus?: Maybe<NetWorthActivationStatusResponse>;
  /**
   * Net worth breakdown balances, with account grouping logic based upon "nw_type"
   * @deprecated the new UI should use netWorthBalancesByFinancialAccountCategorization
   */
  netWorthBalances?: Maybe<NetWorthBalances>;
  /** Net worth breakdown balances, with account grouping logic based upon FDP account type/subtype */
  netWorthBalancesByFinancialDataCategorization?: Maybe<NetWorthBalances>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthContributionSummaries?: Maybe<NetWorthContributionSummaries>;
  /**
   * Returns the user's net worth contributions summary.
   * Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthHistory?: Maybe<NetWorthHistoryResponse>;
  /**
   * Returns boolean that denotes whether or not to show the snapshot notification.
   * Show the notification to users who linked accounts or assets before the respective cutoff dates.
   */
  netWorthHistorySnapshotNotification?: Maybe<NetWorthHistorySnapshotNotificationResponse>;
  /**
   * Returns the provider home value pertaining to the specified address. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v1/home_value
   * @deprecated the new UI should be using netWorthHomeValueResultWithPossibilitiesByAddress
   */
  netWorthHomeValueResultByAddress?: Maybe<NetWorthHomeValueResultResponse>;
  /**
   * Returns the provider home value pertaining to the specified property_id. Currently only
   * returns the Redfin home value, but could potentially be extended to include Zillow.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultByPropertyId?: Maybe<NetWorthHomeValueResultByPropertyIdResponse>;
  /**
   * Returns the provider home value result pertaining to the specified address, or a list of
   * possible home value results. Currently only returns Redfin home values, but could potentially
   * be extended to include Zillow. This query effectively replaces
   * netWorthHomeValueResultByAddress.
   * Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultWithPossibilitiesByAddress?: Maybe<NetWorthHomeValueResultWithPossibilitiesResponse>;
  /**
   * Returns the user's net worth real asset, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets/<net_worth_real_asset_id>
   */
  netWorthRealAsset?: Maybe<NetWorthRealAssetResponse>;
  /**
   * Returns the user's net worth real assets, which depicts their non-monetary assets
   * Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets
   */
  netWorthRealAssets?: Maybe<NetWorthRealAssetsResponse>;
  /**
   * NOTE: The underlying endpoint has been deprecated. Please do not make any new requests.
   * This query will be removed after traffic has ceased.
   *
   * Returns the user's net worth recommendations.
   * Datasource endpoint: wealth-recommender/recommendations/v1/identities/me/recommendations
   */
  netWorthRecommendations?: Maybe<NetWorthRecommendations>;
  /**
   * Returns a list of cards that should be displayed in the AWAL (Also Worth A Look) section of Member Home.
   * (The term "feed" is a legacy PFM feature that predates the modern Member Home experience).
   */
  nonInsightFeedCards?: Maybe<Array<FeedCard>>;
  /**
   * Returns a list of notifications, along with newest/oldest IDs to assist with pagination,
   * and the unread notifications count.
   */
  notifications: GetNotificationsResponse;
  /** Query to fetch a single Page object. */
  page?: Maybe<Page>;
  /** Request a single personal loan offer by providing the offer's id. */
  personalLoanOffer?: Maybe<PersonalLoanOffer>;
  /** Search for all active Personal Loan Offers. */
  personalLoanOffers?: Maybe<PersonalLoanOffersResponse>;
  /** Query to fetch a single Post object. */
  post?: Maybe<Post>;
  /** Query for a single post-like object from WP given its ID. */
  postById?: Maybe<PostInterface>;
  /** Query for a collection of post-like objects from WP given their IDs. */
  postsById?: Maybe<Array<PostInterface>>;
  /** Get status of prequal jobs by specifiying a job ID, the prequal serivce, and the path */
  prequalJobStatus: PrequalJobStatusResponse;
  /** Query to fetch a single PressRelease object. */
  pressRelease?: Maybe<PressRelease>;
  /** Query to fetch multiple PressRelease objects. */
  pressReleases?: Maybe<PressReleaseConnectionResponse>;
  qsInsuranceOffers?: Maybe<InsuranceOffersResponse>;
  rawIdentity?: Maybe<RawIdentity>;
  rawIdentityProfile?: Maybe<RawIdentityProfile>;
  /** Return a list of Recently Viewed posts */
  recentlyViewed?: Maybe<Array<RecentlyViewed>>;
  /** Returns recommended credit card offer bundles for the user. */
  recommendedCreditCardOfferBundles: CreditCardOfferBundlesResponse;
  recommendedGuidance: Array<RecommendationGuidance>;
  /**
   * Query to fetch a collection of related articles.
   * This query is meant to be a temporary implementation to support a use-case
   * in article-client. The intention is to replace it with a more robust solution
   * and remove it entirely soon after.
   */
  relatedArticles?: Maybe<Array<Article>>;
  /** Query to fetch a single Review object. */
  review?: Maybe<Review>;
  /** Query to fetch a single Review object. */
  reviewFork?: Maybe<Review>;
  /** Query to fetch multiple Review objects. */
  reviews?: Maybe<ReviewConnectionResponse>;
  rewardAccounts?: Maybe<Array<RewardAccount>>;
  /** Retrieve content related to the given keywords from WP via the search service */
  rewardsContent: SearchServiceContentSearchResults;
  /** Query to fetch a single Roundup object. */
  roundup?: Maybe<Roundup>;
  /** Query to fetch a single Roundup object. */
  roundupFork?: Maybe<Roundup>;
  /** Query to fetch multiple Roundup objects. */
  roundups?: Maybe<RoundupConnectionResponse>;
  /** Return saved personal loans prequal offer data for the given user */
  savedPersonalLoansPrequalOffers?: Maybe<SavedPersonalLoansPrequalOffers>;
  savingsAccountOfferBySlug?: Maybe<SavingsAccountOffer>;
  savingsAccountOffersByNamedQuery: SavingsAccountOffersByNamedQueryResponse;
  /** Gets the current user's security questions */
  securityQuestions?: Maybe<Array<Scalars['String']>>;
  /** Returns a simulated credit score given a value amount of a credit simulation type */
  simulateCreditScore?: Maybe<SimulateCreditScoreResponse>;
  /** Query to get the info banner details from the feature flag service */
  sitewideInfoBanner: SitewideInfoBannerResponse;
  /** Query to fetch a single StructuredContentCalculator object. */
  structuredContentCalculator?: Maybe<StructuredContentCalculator>;
  /** Query to fetch multiple StructuredContentCalculator objects. */
  structuredContentCalculators?: Maybe<StructuredContentCalculatorConnectionResponse>;
  /** Query for the data to render a page with structured content client */
  structuredContentPage: StructuredContentPageInterface;
  /**
   * The `subscriptionIdentityProfile` query returns subscription_profile_v3, the query/type is not versioned
   * because of recommended GraphQL best practices
   */
  subscriptionIdentityProfile?: Maybe<SubscriptionIdentityProfile>;
  /** Get suggested bills based on transactions meeting relevant criteria */
  suggestedBills: BillsResponse;
  /** Query to fetch a single Table object. */
  table?: Maybe<Table>;
  /** Query to fetch multiple Table objects. */
  tables?: Maybe<TableConnectionResponse>;
  termsOfServiceIdentityProfile?: Maybe<TermsOfServiceIdentityProfile>;
  /** Get a list of the top institutions used for account linking */
  topInstitutionsForAccountLinking?: Maybe<TopInstitutionsForLinkingResponse>;
  /**
   * The total amount of money spent this month from the first day to the current day in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentCurrentMonth?: Maybe<Scalars['Float']>;
  /**
   * The total amount of money spent last month from the first day to the same current day last month in dollars.
   * Optionally, currentDate variable can be pass to the query to override the user current date
   * used to calculate total amount, if not present it will default to the server current date.
   * Example: Return value is `6000.56`
   */
  totalAmountSpentPreviousMonthToDate?: Maybe<Scalars['Float']>;
  tuAuthenticationStatusProfile?: Maybe<CreditProfileAuthStatusProfile>;
  /** The user's TU credit report. */
  tuCreditReport?: Maybe<TuCreditReport>;
  tuCreditReportIdentityProfile?: Maybe<TuCreditReportIdentityProfile>;
  /** Query to fetch a single UrlRecord object. */
  urlRecord?: Maybe<UrlRecord>;
  /** Query to return a URL Record by current URL. */
  urlRecordByUrl?: Maybe<UrlRecord>;
  /** Query to fetch multiple UrlRecord objects. */
  urlRecords?: Maybe<UrlRecordConnectionResponse>;
  userBestCreditCardRecommendations?: Maybe<UserBestCreditCardRecommendations>;
  /** Return a list of UserInsights to be surfaced in a particular UX context (as expressed via the filter param) */
  userInsights: UserInsightsResponse;
  userReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Retrieves all the of the user's wallet cards associated with their identity from the my cards service. */
  userWalletCards?: Maybe<UserWalletCardsResponse>;
  /**
   * Returns the wealth recommender user. Creates it if it doesn't already exist.
   * Datasource endpoint: wealth-recommender/users/v1/identities/me/users
   */
  wealthRecommenderUser?: Maybe<WealthRecommenderUser>;
  /** Query to get the feature discovery for web membership experience */
  webFeatureDiscovery?: Maybe<FeatureDiscoveryResponse>;
  youtubeVideo?: Maybe<YoutubeVideo>;
};

/** Empty field. Not to be used. */
export type QueryAbExperimentsArgs = {
  testNames: Array<InputMaybe<Scalars['String']>>;
  uuid?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryAccountAggregationInstitutionByIdArgs = {
  accountAggregationInstitutionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryArticleArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryArticleForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryAuthorArgs = {
  input?: InputMaybe<AuthorItemInput>;
};

/** Empty field. Not to be used. */
export type QueryAutoInsuranceCitySummaryArgs = {
  cityName: Scalars['String'];
  stateCode: StateCodeEnum;
};

/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};

/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};

/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersV2Args = {
  prequalJobs: Array<PrequalJobInput>;
};

/** Empty field. Not to be used. */
export type QueryAutoInsuranceVehicleSummaryArgs = {
  make: Scalars['String'];
  model: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryBannerArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBannersArgs = {
  filter?: InputMaybe<BannerFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryBccPageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBccPageCardArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBccPageCardsArgs = {
  filter?: InputMaybe<BccPageCardFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryBccPageSectionsArgs = {
  filteredSectionIdentifiers?: InputMaybe<Array<Scalars['String']>>;
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBccPagesArgs = {
  filter?: InputMaybe<BccPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryBlockArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBlockGroupArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryBlockGroupsArgs = {
  filter?: InputMaybe<BlockGroupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryBlocksArgs = {
  filter?: InputMaybe<BlockFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryCalculatorPageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryCalculatorPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryCalculatorPagesArgs = {
  filter?: InputMaybe<CalculatorPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryCanonicalInstitutionsByKeywordArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  queryFields?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<Array<Scalars['String']>>;
};

/** Empty field. Not to be used. */
export type QueryCashFlowBreakdownArgs = {
  currentDate: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryCashFlowHistoryBreakdownArgs = {
  currentDate: Scalars['Date'];
  numPreviousMonthsToInclude: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type QueryCashFlowTopTakeawaysArgs = {
  currentDate: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryCategoryArgs = {
  input?: InputMaybe<TermItemInput>;
};

/** Empty field. Not to be used. */
export type QueryCompareAutoInsuranceCarriersArgs = {
  carrierA: Scalars['String'];
  carrierB: Scalars['String'];
  state: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryContentHubArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentHubForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentHubsArgs = {
  filter?: InputMaybe<ContentHubFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryContentPackArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentPacksArgs = {
  filter?: InputMaybe<ContentPackFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryContentReviewerArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentReviewersArgs = {
  filter?: InputMaybe<ContentReviewerFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryContentSearchArgs = {
  filter?: InputMaybe<ContentSearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  wpNonce?: InputMaybe<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type QueryContentUserPageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentUserPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryContentUserPagesArgs = {
  filter?: InputMaybe<ContentUserPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizAnswersArgs = {
  quizVersion: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizOffersArgs = {
  quizVersion: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type QueryCreditCardOfferByLegacyIdArgs = {
  id: Scalars['Int'];
  input?: InputMaybe<CreditCardOffersParameters>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardOffersByKeywordArgs = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardOffersByLegacyIdsArgs = {
  ids: Array<Scalars['Int']>;
  input?: InputMaybe<CreditCardOffersParameters>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardOffersByNamedQueryArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardOffersForAccountAggregationInstitutionArgs = {
  accountAggregationInstitutionId: Scalars['ID'];
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryCreditCardPrequalOffersArgs = {
  userInput: CreditCardPrequalInput;
};

/** Empty field. Not to be used. */
export type QueryCreditCardsQuizArgs = {
  creditScore?: InputMaybe<Scalars['Int']>;
  excludedInstitutions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  inputs: QuizAnswers;
  limit?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryCreditScoreHistoryArgs = {
  input: CreditScoreHistoryInput;
};

/** Empty field. Not to be used. */
export type QueryCsirBalanceOnDateArgs = {
  date: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryDeclinePersonalLoanOffersSearchArgs = {
  params: DeclineResultsQueryInputs;
};

/** Empty field. Not to be used. */
export type QueryDrcCitySummaryArgs = {
  cityName: Scalars['String'];
  stateCode: StateCodeEnum;
};

/** Empty field. Not to be used. */
export type QueryDrcVehicleSummaryArgs = {
  make: Scalars['String'];
  model: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryDynamicPlacementArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryDynamicPlacementsArgs = {
  filter?: InputMaybe<DynamicPlacementFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryEngineeringPostArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryEngineeringPostsArgs = {
  filter?: InputMaybe<EngineeringPostFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryExperimentDecisionsArgs = {
  anonymousId?: InputMaybe<Scalars['String']>;
  testNames: Array<Scalars['String']>;
  userAttributes: Scalars['JSON'];
};

/** Empty field. Not to be used. */
export type QueryFeatureFlagArgs = {
  featureFlagName: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryFeatureFlagsArgs = {
  appName?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialAccountByIdArgs = {
  financialAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryFinancialAccountTypeSumsArgs = {
  identityId?: InputMaybe<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialAccountsArgs = {
  identityId?: InputMaybe<Scalars['ID']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialAccountsByPortalArgs = {
  financialPortalId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryFinancialAccountsIavDetailsArgs = {
  financialAccountIds: Array<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialPortalByIdArgs = {
  financialPortalId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryFinancialPortalByInstitutionIdArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryFinancialPortalsArgs = {
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionByIdArgs = {
  transactionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsArgs = {
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  sort?: InputMaybe<FinancialTransactionsSortInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsAverageSpendingByDayOfTheMonthArgs = {
  dateInTargetEndMonth: Scalars['Date'];
  dateInTargetStartMonth: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsBudgetBreakdownArgs = {
  today?: InputMaybe<Scalars['DateTime']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsBudgetBreakdownByMonthArgs = {
  numMonths?: InputMaybe<Scalars['Int']>;
  today?: InputMaybe<Scalars['DateTime']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsCashInCashOutSummaryArgs = {
  currentDate?: InputMaybe<Scalars['Date']>;
  numPreviousMonthsToInclude?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsProjectionForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningByMonthArgs = {
  dateInTargetEndMonth: Scalars['Date'];
  dateInTargetStartMonth: Scalars['Date'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningForMonthRangeArgs = {
  dateInEndMonth: Scalars['Date'];
  dateInStartMonth: Scalars['Date'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByCategoryForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByDateForMonthArgs = {
  dateInTargetMonth: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByMonthArgs = {
  dateInTargetEndMonth: Scalars['Date'];
  dateInTargetStartMonth: Scalars['Date'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingPeriodComparisonArgs = {
  datePeriod: FinancialTransactionsSpendingComparisonDatePeriodEnum;
  today?: InputMaybe<Scalars['DateTime']>;
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopCategoriesBySpendingArgs = {
  dateInTargetEndMonth: Scalars['Date'];
  dateInTargetStartMonth: Scalars['Date'];
};

/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopMerchantsBySpendingArgs = {
  dateInTargetEndMonth: Scalars['Date'];
  dateInTargetStartMonth: Scalars['Date'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryFinancialUsersForIdentityIdArgs = {
  identityId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryGetContentArgs = {
  contentSearchFilter?: InputMaybe<ContentSearchInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryGetInsuranceAirFieldArgs = {
  identifier: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryGetInsuranceAirListArgs = {
  identifier: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryGetStateFromZipCodeArgs = {
  zipCode: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryGetUserOpsCommsSubscriptionPreferencesWrapperListArgs = {
  identityId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryGetUserOpsFdpLinkingErrorEventsArgs = {
  identityId: Scalars['ID'];
  portalId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryGetUserOpsMessagingActivityEventsListArgs = {
  identityId: Scalars['ID'];
  lastDaysLimit?: InputMaybe<Scalars['Int']>;
  pagination: OffsetPaginationInput;
};

/** Empty field. Not to be used. */
export type QueryGetWeeklyInsightsCurrentStreakArgs = {
  weeklyInsightsCurrentDate?: InputMaybe<Scalars['DateTime']>;
};

/** Empty field. Not to be used. */
export type QueryGlobalNavItemArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryGlobalNavItemForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryGlobalNavItemsArgs = {
  filter?: InputMaybe<GlobalNavItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryGreenhouseDepartmentArgs = {
  kebabName?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryGreenhouseJobArgs = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryHealthabilityReportsArgs = {
  repository: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryHomeLeadMatchArgs = {
  input: HomeLeadMatchInput;
  usePep: Scalars['Boolean'];
};

/** Empty field. Not to be used. */
export type QueryHouseAdArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryHouseAdsArgs = {
  filter?: InputMaybe<HouseAdFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryHubArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryHubForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryHubsArgs = {
  filter?: InputMaybe<HubFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryInitializeLinkTokenArgs = {
  androidPackageName?: InputMaybe<Scalars['String']>;
  iavEnabled?: InputMaybe<Scalars['Boolean']>;
  redirectUri?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryInstitutionHealthDetailsByPortalIdArgs = {
  financialPortalId: Scalars['ID'];
  identityId?: InputMaybe<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type QueryInstitutionsForAccountLinkingByKeywordArgs = {
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryInsurancePageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryInsurancePageByPathArgs = {
  path: Scalars['String'];
  preview?: InputMaybe<Scalars['Boolean']>;
  wpnonce?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryInsurancePagesArgs = {
  filter?: InputMaybe<InsurancePageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersArgs = {
  driverInfo?: InputMaybe<PrequalOfferDriverInfoInput>;
  homeInfo?: InputMaybe<HomeInsurancePrequalOfferInput>;
  lifeInfo?: InputMaybe<LifeInsurancePrequalOfferInput>;
  providerIds: Array<InsuranceProviderEnum>;
  userInfo?: InputMaybe<PrequalOfferUserInfoInput>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
  vertical: InsuranceVerticalEnum;
};

/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersByJobIdArgs = {
  prequalJobs: Array<PrequalJobInput>;
};

/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<InsuranceProviderEnum>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
};

/** Empty field. Not to be used. */
export type QueryIsNerdWalletMortgageLicensedArgs = {
  address: MortgageUserAddressInput;
};

/** Empty field. Not to be used. */
export type QueryLandingPageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryLandingPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryLandingPagesArgs = {
  filter?: InputMaybe<LandingPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryLegacyLenderArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryLegacyLendersArgs = {
  filter?: InputMaybe<LegacyLenderFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryLinkedFinancialPortalsArgs = {
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryMarketplaceAutocompleteSearchArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']>;
  keyword: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  productType: Scalars['String'];
  queryFields?: InputMaybe<Array<Scalars['String']>>;
  sort?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesV2Args = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

/** Empty field. Not to be used. */
export type QueryMarketplaceEntityV2Args = {
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointsArgs = {
  filter?: InputMaybe<MarketplaceEntryPointFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryMarketplaceFieldArgs = {
  field: Scalars['String'];
  id: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryMarketplaceSearchArgs = {
  entityType?: InputMaybe<Scalars['String']>;
  namedQuery?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  parameters?: InputMaybe<Scalars['JSON']>;
  productType: Scalars['String'];
  query?: InputMaybe<Array<MarketplaceQueryInput>>;
  sort?: InputMaybe<Array<MarketplaceSortInput>>;
};

/** Empty field. Not to be used. */
export type QueryMediaItemArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryMediaItemsArgs = {
  filter?: InputMaybe<MediaItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryMediaSiteArgs = {
  input?: InputMaybe<TermItemInput>;
};

/** Empty field. Not to be used. */
export type QueryMemberHomeContentPacksArgs = {
  options?: InputMaybe<ContentPacksOptionsInput>;
};

/** Empty field. Not to be used. */
export type QueryMoneyTransferAccountEligibilityArgs = {
  financialPortalId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryMortgageLenderMatchArgs = {
  input: MortgageLenderMatchInput;
  namedQuery?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchArgs = {
  input: MortgageSavedLeadMatchInput;
};

/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchesArgs = {
  ids: Array<Scalars['ID']>;
};

/** Empty field. Not to be used. */
export type QueryMortgageSavedRecommendedLendersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};

/** Empty field. Not to be used. */
export type QueryNetWorthAccountByFinancialAccountIdArgs = {
  financialAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryNetWorthAccountByIdArgs = {
  netWorthAccountId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryNetWorthHistoryArgs = {
  effectiveDate: Scalars['DateTimeWithTimeOffset'];
  netWorthFilter: NetWorthHistoryFiltersEnum;
};

/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};

/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByPropertyIdArgs = {
  propertyId: Scalars['ID'];
  source: NetWorthHomeValueResultSourceEnum;
};

/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultWithPossibilitiesByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};

/** Empty field. Not to be used. */
export type QueryNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID'];
};

/** Empty field. Not to be used. */
export type QueryNetWorthRecommendationsArgs = {
  filter?: InputMaybe<NetWorthRecommendationsFilterInput>;
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryNonInsightFeedCardsArgs = {
  onlyTemplates: Array<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryNotificationsArgs = {
  options?: InputMaybe<NotificationsInput>;
};

/** Empty field. Not to be used. */
export type QueryPageArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryPersonalLoanOfferArgs = {
  id: Scalars['String'];
  input?: InputMaybe<PersonalLoanOffersParameters>;
  namedQuery?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryPersonalLoanOffersArgs = {
  input?: InputMaybe<PersonalLoanOffersParameters>;
  namedQuery?: InputMaybe<Scalars['String']>;
};

/** Empty field. Not to be used. */
export type QueryPostArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryPostByIdArgs = {
  id: Scalars['Int'];
};

/** Empty field. Not to be used. */
export type QueryPostsByIdArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};

/** Empty field. Not to be used. */
export type QueryPrequalJobStatusArgs = {
  prequalJobs: Array<PrequalJobInput>;
};

/** Empty field. Not to be used. */
export type QueryPressReleaseArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryPressReleasesArgs = {
  filter?: InputMaybe<PressReleaseFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryQsInsuranceOffersArgs = {
  driverInfo?: InputMaybe<OfferDriverInfoInput>;
  homeInfo?: InputMaybe<HomeInsuranceOfferInput>;
  lifeInfo?: InputMaybe<LifeInsuranceOfferInput>;
  userInfo?: InputMaybe<OfferUserInfoInput>;
  userInput?: InputMaybe<HomeInsuranceOfferInput>;
  vertical: InsuranceVerticalEnum;
};

/** Empty field. Not to be used. */
export type QueryRawIdentityProfileArgs = {
  profileType: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QueryRecentlyViewedArgs = {
  maxPagesCount?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QueryRelatedArticlesArgs = {
  input?: InputMaybe<RelatedArticlesInput>;
};

/** Empty field. Not to be used. */
export type QueryReviewArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryReviewForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryReviewsArgs = {
  filter?: InputMaybe<ReviewFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryRewardsContentArgs = {
  allowPosts?: InputMaybe<Scalars['Boolean']>;
  cardNames: Array<Scalars['String']>;
  cardPrograms: Array<Scalars['String']>;
  numResults?: InputMaybe<Scalars['Int']>;
  sortDir?: InputMaybe<ContentSortDirection>;
};

/** Empty field. Not to be used. */
export type QueryRoundupArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryRoundupForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};

/** Empty field. Not to be used. */
export type QueryRoundupsArgs = {
  filter?: InputMaybe<RoundupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QuerySavingsAccountOfferBySlugArgs = {
  slug: Scalars['String'];
};

/** Empty field. Not to be used. */
export type QuerySavingsAccountOffersByNamedQueryArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  namedQuery: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
};

/** Empty field. Not to be used. */
export type QuerySimulateCreditScoreArgs = {
  input: CreditSimulationInput;
};

/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorsArgs = {
  filter?: InputMaybe<StructuredContentCalculatorFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryStructuredContentPageArgs = {
  uri: Scalars['String'];
  urlParams?: InputMaybe<Array<UrlParamsInput>>;
};

/** Empty field. Not to be used. */
export type QuerySuggestedBillsArgs = {
  userCurrentDate?: InputMaybe<Scalars['Date']>;
};

/** Empty field. Not to be used. */
export type QueryTableArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryTablesArgs = {
  filter?: InputMaybe<TableFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryTopInstitutionsForAccountLinkingArgs = {
  productType?: InputMaybe<AccountAggregationProductType>;
  yodleeOnly?: InputMaybe<Scalars['Boolean']>;
};

/** Empty field. Not to be used. */
export type QueryTotalAmountSpentCurrentMonthArgs = {
  currentDate?: InputMaybe<Scalars['Date']>;
};

/** Empty field. Not to be used. */
export type QueryTotalAmountSpentPreviousMonthToDateArgs = {
  currentDate?: InputMaybe<Scalars['Date']>;
};

/** Empty field. Not to be used. */
export type QueryUrlRecordArgs = {
  input?: InputMaybe<PostItemInput>;
};

/** Empty field. Not to be used. */
export type QueryUrlRecordByUrlArgs = {
  url: Scalars['URL'];
};

/** Empty field. Not to be used. */
export type QueryUrlRecordsArgs = {
  filter?: InputMaybe<UrlRecordFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};

/** Empty field. Not to be used. */
export type QueryUserBestCreditCardRecommendationsArgs = {
  input?: InputMaybe<UserBestCreditCardRecommendationsInput>;
};

/** Empty field. Not to be used. */
export type QueryUserInsightsArgs = {
  effectiveDate?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<UserInsightsFilterInput>;
  rankingModelName?: InputMaybe<Scalars['String']>;
  shouldRegenerate?: InputMaybe<Scalars['Boolean']>;
};

/** Empty field. Not to be used. */
export type QueryYoutubeVideoArgs = {
  id: Scalars['ID'];
};

/** Named credit score ranges accepted for creditScoreRange in AutoInsurancePrequalOfferInput */
export const QuinStreetCreditScoreRangeEnum = {
  Excellent: 'EXCELLENT',
  Fair: 'FAIR',
  Good: 'GOOD',
  Poor: 'POOR',
} as const;

export type QuinStreetCreditScoreRangeEnum =
  (typeof QuinStreetCreditScoreRangeEnum)[keyof typeof QuinStreetCreditScoreRangeEnum];
export type QuizAnswers = {
  airlineChoice?: InputMaybe<AirlineChoice>;
  annualFees?: InputMaybe<Scalars['Boolean']>;
  annualFeesTravel?: InputMaybe<AnnualFeesTravel>;
  bonusCategories?: InputMaybe<Array<InputMaybe<BonusCategories>>>;
  bonusCategoriesStaySame?: InputMaybe<Scalars['Boolean']>;
  cardDeposit?: InputMaybe<Scalars['Boolean']>;
  cashBackMinimum?: InputMaybe<Scalars['Boolean']>;
  collegeStudent?: InputMaybe<Scalars['Boolean']>;
  creditScore?: InputMaybe<CreditScore>;
  currentBalanceCompany?: InputMaybe<CurrentBalanceCompany>;
  hotelChoice?: InputMaybe<HotelChoice>;
  howCashBack?: InputMaybe<HowCashBack>;
  howLongToPayOffDebt?: InputMaybe<HowLongToPayOffDebt>;
  howMuchTransferFee?: InputMaybe<HowMuchTransferFee>;
  howOftenTravel?: InputMaybe<HowOftenTravel>;
  internationalTravel?: InputMaybe<Scalars['Boolean']>;
  isBuildingCredit?: InputMaybe<Scalars['Boolean']>;
  isDebtCreditCard?: InputMaybe<Scalars['Boolean']>;
  primaryGoal: PrimaryGoal;
  specificAirline?: InputMaybe<Scalars['Boolean']>;
  specificHotel?: InputMaybe<Scalars['Boolean']>;
};

export type QuizOffer = {
  __typename?: 'QuizOffer';
  itemizedMethodology?: Maybe<Array<Maybe<ItemizedScore>>>;
  itemizedScore?: Maybe<Array<Maybe<ItemizedScore>>>;
  matchScore: Scalars['Float'];
  offer: CardsMarketplaceOffer;
};

export type QuizResponse = {
  __typename?: 'QuizResponse';
  offers?: Maybe<Array<Maybe<QuizOffer>>>;
};

export type RawDriver = {
  __typename?: 'RawDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']>;
  /**
   * The synthetic driver id to create a unique cache key to store this data within the Apollo cache.
   * Without this field the data in this Type will get rolled up under the parent Type,
   * and there's potential for some cache pollution since some of the field values within
   * this type are based on the minAccountBalance input.
   */
  id: Scalars['ID'];
  /** The driver label */
  label: Scalars['String'];
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']>;
  /** The value of the driver */
  value?: Maybe<Scalars['String']>;
};

/** The `RawIdentity` type represents the cookies and any payload related to the logged in identity. */
export type RawIdentity = {
  __typename?: 'RawIdentity';
  authCookies: Array<Cookie>;
  data?: Maybe<Scalars['JSON']>;
};

/** The `RawIdentityProfile` type represents the given profile */
export type RawIdentityProfile = {
  __typename?: 'RawIdentityProfile';
  data?: Maybe<Scalars['JSON']>;
  profileType: Scalars['String'];
};

/** Describes the details of the recap list section of a roundup */
export type RecapListDetails = {
  __typename?: 'RecapListDetails';
  recapItems?: Maybe<Array<RoundupSection>>;
  /** The title to use for the recap list section */
  title: Scalars['String'];
};

/** Describes the details of the recap list section of a roundup */
export type RecapListDetailsRecapItemsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Recently viewed posts by a particular user */
export type RecentlyViewed = {
  __typename?: 'RecentlyViewed';
  /** Date of last visit to the post by the user */
  dateLastVisited: Scalars['Date'];
  /** WP ID for this page */
  id?: Maybe<Scalars['Int']>;
  /** URL link of the resource */
  link?: Maybe<Scalars['URL']>;
  /** Amount of times the post has been visited by the user */
  numberOfVisits: Scalars['Int'];
  /**
   * WP post data
   * @deprecated post contains neither title nor synopsis, which are the relevant values
   */
  post?: Maybe<PostInterface>;
  /** The brief page synopsis as an HTML element */
  synopsis?: Maybe<Scalars['StructuredContentDocument']>;
  /** The one-line title of the page */
  title?: Maybe<Scalars['String']>;
  /** The WordPress post_type for the resource. */
  type?: Maybe<Scalars['String']>;
  /** Url path to the page */
  urlPath: Scalars['String'];
};

export type RecommendationGuidance = {
  __typename?: 'RecommendationGuidance';
  /**
   * Contains the information needed to display a CTA and details
   * to how to handle the action in mobile and web.
   */
  action?: Maybe<RecommendationGuidanceAction>;
  /** Suggested advice description to be shown for the particular guidance */
  advice: Scalars['String'];
  /**
   * Explanation about what we know from the user data that we believe this
   * particular guidance is surfaced to the user.
   */
  insight: Scalars['String'];
  /**
   * Source of the insight used for this recommendation, mostly used for tracking.
   * e.g. Credit Utilization, Age of Accounts.
   */
  insightSource: Scalars['String'];
  /** Cannonical name identifier for the particular guidance */
  name: Scalars['String'];
  /** Label used at the top of the guidance card. */
  tag?: Maybe<Scalars['String']>;
};

export type RecommendationGuidanceAction = {
  __typename?: 'RecommendationGuidanceAction';
  /**
   * Target used for the native app, most of the cases this will contain
   * a deep link.
   */
  mobileTarget: Scalars['String'];
  /** Cannonical name identifier for this action */
  name: Scalars['String'];
  /**
   * Target use for web, most of the cases will contain a url to open.
   * Also might be used as a fallback if the mobileTarget is not supported in the native app.
   */
  target: Scalars['String'];
  /** Enum for the target type to be used when handling the action targets. */
  targetType: RecommendationGuidanceTargetType;
  /** Friendly text displayed to the user as a CTA. */
  text: Scalars['String'];
};

export const RecommendationGuidanceTargetType = {
  WebLink: 'WEB_LINK',
} as const;

export type RecommendationGuidanceTargetType =
  (typeof RecommendationGuidanceTargetType)[keyof typeof RecommendationGuidanceTargetType];
/**
 * A user insight sourced from the recommendation-service and retrieved via Factory.
 *
 * Note that the prefix "Recommendation" indicates only the origin of this insight -- not that it is semantically more
 * worthy of "recommendation" than insights from other sources.
 */
export type RecommendationInsight = UserInsightInterface & {
  __typename?: 'RecommendationInsight';
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   * Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** Flag for whether generated user insight is stale compared to a user's new credit report pull */
  isStale?: Maybe<Scalars['Boolean']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
};

export type RefreshTokenLoginInfoInput = {
  /** The refresh token used to login */
  refreshToken: Scalars['String'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean'];
};

export type RegisterUserResponse = AuthenticationResponseInterface & {
  __typename?: 'RegisterUserResponse';
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  /** Determines whether user registration was successful */
  success: Scalars['Boolean'];
};

export type RegistrationTrackingMetadata = {
  /** The navigation source impression ID associated with the user registration event */
  navigationSourceImpressionId: Scalars['String'];
  /** The navigation source tracking code associated with the user registration event */
  navigationSourceTrackingCode?: InputMaybe<Scalars['String']>;
  /** The page impression ID associated with the user registration event */
  pageImpressionId: Scalars['String'];
  /** The tracking channel for the current user (e.g. 'mobile') */
  trackingChannel?: InputMaybe<Scalars['String']>;
  /** The tracking version for the current user */
  trackingVersion?: InputMaybe<Scalars['String']>;
  /** The tracking vertical for the current user (e.g. 'nw_native_app') */
  trackingVertical?: InputMaybe<Scalars['String']>;
};

export type ReinitializeFinancialPortalResponse = {
  __typename?: 'ReinitializeFinancialPortalResponse';
  details?: Maybe<ReinitializeFinancialPortalResponseDetails>;
  financialPortal?: Maybe<FinancialPortal>;
};

export type ReinitializeFinancialPortalResponseDetails = {
  __typename?: 'ReinitializeFinancialPortalResponseDetails';
  /**  The link token used to open the Plaid fix flow with  */
  linkToken?: Maybe<Scalars['ID']>;
  /**
   *  If there is an existing Plaid Item, use this token when opening Plaid Link to enter the fix flow
   * @deprecated For backwards compatibility, the values are the same but we should now be using the linkToken field
   */
  publicToken?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the suggested marketplace account aggregation institution id  */
  recommendedInstitutionId?: Maybe<Scalars['ID']>;
  /**  For a portal that should be migrated, the external (e.g. Plaid) id for the institution to link  */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']>;
};

/** The input for retrieving a collection of related articles. */
export type RelatedArticlesInput = {
  /** The type of article to return. */
  articleType: Scalars['String'];
  /** A WordPress ID to exclude from the query. */
  exclude: Scalars['ID'];
  /** Limit of number of results. Default: 6 */
  limit?: InputMaybe<Scalars['Int']>;
};

export type RemoveUserReportedCreditCardResult = {
  __typename?: 'RemoveUserReportedCreditCardResult';
  /** The legacy of the removed card */
  cardId: Scalars['Int'];
};

export type RemoveUserWalletCardResponse = {
  __typename?: 'RemoveUserWalletCardResponse';
  success: Scalars['Boolean'];
};

/** The enum for selecting the text formatting to return on rendered text fields. */
export const RenderedTextFormatEnum = {
  Html: 'HTML',
  PlainText: 'PLAIN_TEXT',
} as const;

export type RenderedTextFormatEnum =
  (typeof RenderedTextFormatEnum)[keyof typeof RenderedTextFormatEnum];
export type ResetPasswordInfoInput = {
  /** The challenge answer associated with the user's password reset */
  challengeAnswer: Scalars['String'];
  /** The user's existing password used to reset their password */
  password: Scalars['String'];
  /** The password reset token used to reset the user's password */
  passwordResetToken: Scalars['String'];
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type Review = ContentPageHeaderInterface &
  PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithContentInterface &
  PostWithEditorInterface &
  PostWithExcerptInterface &
  PostWithFaQsInterface &
  PostWithFeaturedImageInterface &
  PostWithInternationalVersionsInterface &
  PostWithPageTaxonomyInterface &
  PostWithReviewerInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'Review';
    /** Type of advertiser disclosure to display (default credit_cards) */
    advertiserDisclosureType: Scalars['String'];
    /** The alternate products to display. */
    alternatePicks?: Maybe<Array<ReviewAlternatePick>>;
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The Benefits and Perks content section for a Review. */
    benefitsAndPerks?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of the roundup/review. */
    bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
    /** The Breadcrumb to be displayed on a review */
    breadcrumb?: Maybe<Breadcrumb>;
    /** A list of Category objects on the Review object. */
    categories?: Maybe<Array<Category>>;
    /** Data used for rendering the comparison table */
    comparisonTable?: Maybe<ComparisonTableDetails>;
    /** The location where the Comparison Table should be rendered on a Review */
    comparisonTableLocation: ComparisonTableLocationEnum;
    /** The source of the comparison table to display. */
    comparisonTableSource?: Maybe<Scalars['String']>;
    /** The negative bullet points about the product. */
    cons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The tracking params that should be appended to this review section's marketplace entity's CTA */
    ctaTrackingParams?: Maybe<Array<TrackingParam>>;
    /** The custom last modified date for the content. */
    customLastModifiedDate?: Maybe<Scalars['DateTime']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** The format to use when displaying the date. */
    dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The Detailed Review content section for a Review. */
    detailedReview?: Maybe<Scalars['StructuredContentDocument']>;
    /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
    displayDate?: Maybe<Scalars['DateTime']>;
    /** The Drawbacks and Considerations content section for a Review. */
    drawbacksAndConsiderations?: Maybe<Scalars['StructuredContentDocument']>;
    /** The drivers associated with the entity of this review */
    drivers?: Maybe<Array<EntityPlacementDriver>>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Type of article, which will determine what (if any) additional editorial standards message to display. */
    editorialDisclaimerType?: Maybe<Scalars['String']>;
    /** The Marketplace Entity type. */
    entityType?: Maybe<MarketplaceEntityTypeEnum>;
    /** The editorial excerpt of the resource. */
    excerpt?: Maybe<Scalars['String']>;
    /** Whether or not to exclude related products. */
    excludeRelatedProducts?: Maybe<Scalars['Boolean']>;
    /** The faqs to display on this piece of content. */
    faqs?: Maybe<Array<ContentFaq>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /**
     * Get the list of review content sections filtered by the provided geolocation
     * Notes:
     *   - Filtering applies to Banking only
     *   - Does not filter CD offers
     */
    filteredReviewContentSections?: Maybe<
      Array<ReviewInstitutionBreakdownSection>
    >;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** Whether or not the review has local offers */
    hasLocalOffers?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the date for this piece of content. */
    hideDate?: Maybe<Scalars['Boolean']>;
    /** The How to Decide content section for a Review. */
    howToDecide?: Maybe<Scalars['StructuredContentDocument']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Heading text for the institution breakdown */
    institutionBreakdownHeading?: Maybe<Scalars['String']>;
    /** The content sections for an institution Review. */
    institutionBreakdownSections?: Maybe<
      Array<ReviewInstitutionBreakdownSection>
    >;
    /** The Insurance component to use on this Review. */
    insuranceComponent?: Maybe<Scalars['StructuredContentDocument']>;
    /** Information about alternate versions of the content that exist for other locales. */
    internationalVersions?: Maybe<Array<InternationalVersion>>;
    /** The heading for the review intro */
    introHeading?: Maybe<Scalars['String']>;
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /**
     * The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates)
     * @deprecated Deprecating in favor of using 'displaydate' moving forward, as it more accurately reflects the return value.
     */
    lastModifiedDate?: Maybe<Scalars['DateTime']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The Marketplace entity UUID. */
    marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
    /** The Marketplace entity UUID. */
    marketplaceEntityId?: Maybe<Scalars['String']>;
    /** The vertical-specific methodology to display for the review */
    methodology?: Maybe<Scalars['StructuredContentDocument']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Whether to override the last modified date for the content using one of the available options. */
    overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
    /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
    pageTaxonomy?: Maybe<Scalars['JSON']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary category object for the content. */
    primaryCategory?: Maybe<Category>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** The Marketplace product type. */
    productType?: Maybe<MarketplaceProductTypeEnum>;
    /** The positive bullet points about the product. */
    pros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The WP (not Marketplace) star rating for the product being reviewed. */
    rating?: Maybe<Scalars['Float']>;
    /** The disclaimer for how the rating was derived. */
    ratingDisclaimer?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** List of related links. */
    relatedLinks?: Maybe<Array<ReviewRelatedLinkSection>>;
    /** The products related to the current one to display on the page. */
    relatedProducts?: Maybe<Array<ReviewRelatedProduct>>;
    /** The reviewers that this Review has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** Boolean flag to indicate if all Marketplace Entity CTAs should be omitted on the page */
    shouldOmitCta: Scalars['Boolean'];
    /** Boolean flag to show/hide the advertiser disclosure in the page header */
    showAdvertiserDisclosure: Scalars['Boolean'];
    /** Boolean flag to show/hide the author byline in the page header */
    showAuthorByline: Scalars['Boolean'];
    /** Boolean flag to show/hide the editorial disclaimer in the page header */
    showEditorialDisclaimer: Scalars['Boolean'];
    /** Whether or not to display the FAQ's. */
    showFaqs?: Maybe<Scalars['Boolean']>;
    /** Whether or not to show the last modified date. */
    showLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Whether or not the page qualifies to show a sign up banner */
    showSignUpBanner: Scalars['Boolean'];
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The Marketplace subproduct type for the banking vertical. */
    subproductType?: Maybe<ReviewSubproductTypeEnum>;
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['StructuredContentDocument']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Whether or not to use a custom last modified date for this piece of content. */
    useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Whether the review content for the institution breakdown is nested in an accordion */
    useMobileAccordionForInstitutionBreakdown: Scalars['Boolean'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewCtaTrackingParamsArgs = {
  sourceUrl?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewFilteredReviewContentSectionsArgs = {
  userState?: InputMaybe<StateCodeEnum>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data within the alternatePicks group of fields on the Review type. */
export type ReviewAlternatePick = {
  __typename?: 'ReviewAlternatePick';
  /** The URL of the review to link to as an alternate pick. */
  ctaUrl?: Maybe<Scalars['URL']>;
  /** The description text to display for the alternate pick. */
  description?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace entity type for the alternate pick. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The label to express how the alternate product is related to the product currently being reviewed. */
  label?: Maybe<Scalars['String']>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace product type for the alternate pick. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The tagline text to display for the alternate pick. */
  tagline?: Maybe<Scalars['StructuredContentDocument']>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ReviewConnectionResponse = {
  __typename?: 'ReviewConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Review returned for the connection. */
  items?: Maybe<Array<Review>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Review objects. */
export type ReviewFilterInput = {
  /** Limit collection to Reviews published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Reviews within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Reviews with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Reviews with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSection = {
  __typename?: 'ReviewInstitutionBreakdownSection';
  /** The content to display within the section. */
  content?: Maybe<Scalars['StructuredContentDocument']>;
  /** The tracking params that should be appended to this review section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers for a given institution breakdown section */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApyId?: Maybe<Scalars['String']>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** Boolean flag to omit editorial content (e.g., pros/cons/bottom line) from the review */
  omitMarketplaceEditorialContent: Scalars['Boolean'];
  /** The section type for the current review section. */
  sectionType?: Maybe<ReviewSectionTypeEnum>;
  /** Optional title for the institution breakdown section */
  title?: Maybe<Scalars['String']>;
  /** Text size for title field */
  titleSize?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSectionCtaTrackingParamsArgs = {
  sourceUrl?: InputMaybe<Scalars['String']>;
  utmCampaign?: InputMaybe<Scalars['String']>;
};

export type ReviewRedirect = {
  __typename?: 'ReviewRedirect';
  reviewUrl: Scalars['URL'];
};

/** The RelatedLink type to encapsulate the properties within each of the related links. */
export type ReviewRelatedLinkSection = {
  __typename?: 'ReviewRelatedLinkSection';
  heading?: Maybe<Scalars['String']>;
  links?: Maybe<Array<ReviewRelatedLinks>>;
};

/** The Link type to encapsulate the properties within each of the links. */
export type ReviewRelatedLinks = {
  __typename?: 'ReviewRelatedLinks';
  text: Scalars['String'];
  url: Scalars['String'];
};

/** Type modeling the data within the relatedProducts group of fields on the Review type. */
export type ReviewRelatedProduct = {
  __typename?: 'ReviewRelatedProduct';
  /** The Marketplace entity type for the related product. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApyId?: Maybe<Scalars['String']>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApyId?: Maybe<Scalars['String']>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApyId?: Maybe<Scalars['String']>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace product type for the related product. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
};

/** Enum values for sectionType field on Review type. */
export const ReviewSectionTypeEnum = {
  BankExperience: 'BANK_EXPERIENCE',
  Default: 'DEFAULT',
  MarketplaceEntity: 'MARKETPLACE_ENTITY',
  OverdraftFee: 'OVERDRAFT_FEE',
} as const;

export type ReviewSectionTypeEnum =
  (typeof ReviewSectionTypeEnum)[keyof typeof ReviewSectionTypeEnum];
/** Enum values for subproductType field on Review type. */
export const ReviewSubproductTypeEnum = {
  Cd: 'CD',
  Checking: 'CHECKING',
  Default: 'DEFAULT',
  Savings: 'SAVINGS',
} as const;

export type ReviewSubproductTypeEnum =
  (typeof ReviewSubproductTypeEnum)[keyof typeof ReviewSubproductTypeEnum];
export type ReviewerPage = StructuredContentPageInterface & {
  __typename?: 'ReviewerPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/** The reward data connected to an account */
export type RewardAccount = {
  __typename?: 'RewardAccount';
  accountNumber?: Maybe<Scalars['String']>;
  accountStatus: RewardAccountStatus;
  createdDate?: Maybe<Scalars['DateTime']>;
  dataset?: Maybe<Array<RewardAccountDataset>>;
  id: Scalars['ID'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
  providerAccountId: Scalars['ID'];
  providerId: Scalars['ID'];
  providerName: Scalars['String'];
  rewardBalance?: Maybe<Array<RewardAccountBalance>>;
};

export type RewardAccountBalance = {
  __typename?: 'RewardAccountBalance';
  balance: Scalars['Float'];
  /** The balance required to reach a reward level. */
  balanceToLevel?: Maybe<Scalars['String']>;
  balanceToReward?: Maybe<Scalars['String']>;
  balanceType?: Maybe<RewardAccountBalanceType>;
  description?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['Date']>;
  /** Units of the account's balance */
  units?: Maybe<RewardAccountBalanceUnit>;
};

export const RewardAccountBalanceType = {
  Balance: 'BALANCE',
  BalanceToLevel: 'BALANCE_TO_LEVEL',
  BalanceToReward: 'BALANCE_TO_REWARD',
  ExpiringBalance: 'EXPIRING_BALANCE',
  TotalBalance: 'TOTAL_BALANCE',
} as const;

export type RewardAccountBalanceType =
  (typeof RewardAccountBalanceType)[keyof typeof RewardAccountBalanceType];
export const RewardAccountBalanceUnit = {
  Credits: 'CREDITS',
  Dollars: 'DOLLARS',
  Miles: 'MILES',
  Points: 'POINTS',
  Segments: 'SEGMENTS',
} as const;

export type RewardAccountBalanceUnit =
  (typeof RewardAccountBalanceUnit)[keyof typeof RewardAccountBalanceUnit];
export type RewardAccountDataset = {
  __typename?: 'RewardAccountDataset';
  lastUpdateAttempt?: Maybe<Scalars['DateTime']>;
  lastUpdated?: Maybe<Scalars['DateTime']>;
  nextUpdateScheduled?: Maybe<Scalars['DateTime']>;
};

/** The status a reward account can be in */
export const RewardAccountStatus = {
  Active: 'ACTIVE',
  Closed: 'CLOSED',
  Inactive: 'INACTIVE',
  ToBeClosed: 'TO_BE_CLOSED',
} as const;

export type RewardAccountStatus =
  (typeof RewardAccountStatus)[keyof typeof RewardAccountStatus];
export type RewardCategoryCopyOverride = {
  __typename?: 'RewardCategoryCopyOverride';
  categoryName?: Maybe<Scalars['String']>;
  disclaimer?: Maybe<Scalars['String']>;
};

/** Compliance mandated overrides for specific cards */
export type RewardCategoryCopyOverrides = {
  __typename?: 'RewardCategoryCopyOverrides';
  dining?: Maybe<RewardCategoryCopyOverride>;
  entertainment?: Maybe<RewardCategoryCopyOverride>;
  gas?: Maybe<RewardCategoryCopyOverride>;
  groceries?: Maybe<RewardCategoryCopyOverride>;
  shopping?: Maybe<RewardCategoryCopyOverride>;
  travel?: Maybe<RewardCategoryCopyOverride>;
};

/** A rewards credit card that is owned by the current user, as reported by that user. */
export type RewardsCreditCard = {
  __typename?: 'RewardsCreditCard';
  /** Override data to display instead of default values for compliance reasons */
  categoryCopyOverrides?: Maybe<RewardCategoryCopyOverrides>;
  /** The Marketplace UUID for a CreditCardOffer, lifted up */
  id: Scalars['ID'];
  /** The currently-active offer that pertains to the credit card *product* */
  offer: CreditCardOffer;
  /** The earning rates by category of this credit card */
  rewardCategoryRates?: Maybe<CreditCardOfferRewardCategoryRates>;
};

/** The various components of a credit card recommendation */
export type RewardsCreditCardRecommendationDetails = {
  __typename?: 'RewardsCreditCardRecommendationDetails';
  /** The user's 30 day average spending over the previous 90 days in this rewards category */
  categorySpendingAmount?: Maybe<Scalars['Float']>;
  /** The reward category of the recommended card */
  categoryType?: Maybe<CreditCardOfferRewardCategoryType>;
  /** The user's current card's legacy ID in this category */
  currentBestCardLegacyId: Scalars['Int'];
  /** The user's current card's best rate in this category */
  currentBestRate?: Maybe<Scalars['Float']>;
  /** The user's current card's reward type */
  currentBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's recommended card's best rate in this category */
  newBestRate?: Maybe<Scalars['Float']>;
  /** The user's recommended card's reward type in this category */
  newBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The amount of bonus points/miles/rewards a user can expect to receive if they meet signup bonus */
  qualifiedSigningBonusAmount?: Maybe<Scalars['Float']>;
  /** The currency of bonus points/miles/rewards a user can expect to receive if they meet signing bonus */
  qualifiedSigningBonusAmountType?: Maybe<CreditCardOfferRewardType>;
  /** The user's estimated +/- in rewards over two years for the recommended card */
  rewardIncrease?: Maybe<Scalars['Float']>;
};

export const RewardsCreditCardRecommendationType = {
  All: 'ALL',
  Complementary: 'COMPLEMENTARY',
  Dining: 'DINING',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  Other: 'OTHER',
  Overall: 'OVERALL',
  Travel: 'TRAVEL',
} as const;

export type RewardsCreditCardRecommendationType =
  (typeof RewardsCreditCardRecommendationType)[keyof typeof RewardsCreditCardRecommendationType];
export type RewardsMutationSuccessResponse = {
  __typename?: 'RewardsMutationSuccessResponse';
  success: Scalars['Boolean'];
};

export type RewardsOffer = {
  __typename?: 'RewardsOffer';
  /** Amount, ex: '4.00%' */
  amountText?: Maybe<Scalars['String']>;
  /** Description */
  description?: Maybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type Roundup = ContentPageHeaderInterface &
  PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithEditorInterface &
  PostWithExcerptInterface &
  PostWithFaQsInterface &
  PostWithFeaturedImageInterface &
  PostWithInternationalVersionsInterface &
  PostWithPageTaxonomyInterface &
  PostWithReviewerInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'Roundup';
    /** The custom content to display above the Roundup sections. */
    aboveSections?: Maybe<Scalars['StructuredContentDocument']>;
    /** Roundup sections to display in the Additional Recommendations section of the roundup */
    additionalRecommendations?: Maybe<Array<RoundupSection>>;
    /** Type of advertiser disclosure to display (default credit_cards) */
    advertiserDisclosureType: Scalars['String'];
    /** Marketplace Institutions to use affiliate logos from. */
    affiliateLogosInstitutions?: Maybe<Array<MarketplaceEntityInterface>>;
    /** Optional title to display above affiliate logos. */
    affiliateLogosTitle?: Maybe<Scalars['String']>;
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The content to display below the Roundup sections. */
    belowSections?: Maybe<Scalars['StructuredContentDocument']>;
    /** The Breadcrumb to display on a Roundup */
    breadcrumb?: Maybe<Breadcrumb>;
    /** A list of Category objects on the Roundup object. */
    categories?: Maybe<Array<Category>>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The cross-sell category associated with this Roundup. Relevant only for Credit Card Roundups. */
    crossSellCcCategory?: Maybe<RoundupCrossSellCcCategoryEnum>;
    /** Marketplace named query to use on the cross sell comparison table on Marketing Roundups. */
    crossSellNamedQuery?: Maybe<Scalars['String']>;
    /** Contains display information for the cross sell section of a roundup */
    crossSellSection?: Maybe<RoundupCrossSellDetails>;
    /** The source to use to populate cross sells on this Roundup. */
    crossSellSource?: Maybe<RoundupCrossSellSourceEnum>;
    /** The custom last modified date for the content. */
    customLastModifiedDate?: Maybe<Scalars['DateTime']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** The format to use when displaying the date. */
    dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /**
     * The DateTime in UTC to display for the roundup based on flags, custom dates,
     * and Marketplace entities set on the roundup
     */
    displayDate?: Maybe<Scalars['String']>;
    /** The type driver group to configure for this roundup */
    driverGroup?: Maybe<RoundupDriverGroupEnum>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** Type of article, which will determine what (if any) additional editorial standards message to display. */
    editorialDisclaimerType?: Maybe<Scalars['String']>;
    /**
     * Returns a JSON object containing entity counts keyed by location.
     * The "none" key will be used to indicate entities that are not localized.
     */
    entityCountByLocation: Scalars['JSON'];
    /** The editorial excerpt of the resource. */
    excerpt?: Maybe<Scalars['String']>;
    /** Whether or not to include the number of Marketplace entities in the title. */
    excludeEntityCountFromTitle?: Maybe<Scalars['Boolean']>;
    /** Eyebrow header text for a roundup. */
    eyebrowText?: Maybe<Scalars['String']>;
    /** The faqs to display on this piece of content. */
    faqs?: Maybe<Array<ContentFaq>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** Posts to display in the footer of this Roundup. */
    footerPosts?: Maybe<Array<RoundupFooterPostsUnion>>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** Boolean flag to indicate if the roundup has local offers to display */
    hasLocalOffers: Scalars['Boolean'];
    /** Whether or not to split the product cards by category name. */
    hideCategoriesInProductCardsSection?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the date for this piece of content. */
    hideDate?: Maybe<Scalars['Boolean']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to include the date in the SEO title. */
    includeDateInSeoTitle?: Maybe<Scalars['Boolean']>;
    /** Whether or not to include the date in the editorial title. */
    includeDateInTitle?: Maybe<Scalars['Boolean']>;
    includeExpandedProductDetails?: Maybe<Scalars['Boolean']>;
    /** The insurance component to use on the Roundup. */
    insuranceComponent?: Maybe<Scalars['StructuredContentDocument']>;
    /** Information about alternate versions of the content that exist for other locales. */
    internationalVersions?: Maybe<Array<InternationalVersion>>;
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The Marketplace product type. */
    marketplaceProductType?: Maybe<MarketplaceProductTypeEnum>;
    /** The vertical-specific methodology to display for the roundup */
    methodology?: Maybe<Scalars['StructuredContentDocument']>;
    /** The model execution ids used for ALPS ordering */
    modelExecutionIds?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Content that should appear inside a Nerdy Tip component. */
    nerdyTipContent?: Maybe<Scalars['String']>;
    numProductCardsToExpand?: Maybe<Scalars['Int']>;
    /** Whether to override the last modified date for the content using one of the available options. */
    overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
    /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
    pageTaxonomy?: Maybe<Scalars['JSON']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary category object for the content. */
    primaryCategory?: Maybe<Category>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** Contains display information for the product cards section of a roundup */
    productCardsSection: RoundupProductCardsDetails;
    /**
     * The deduped list of raw marketplace entities that are eligible to be displayed on the page.
     *   - exists
     *   - active
     *   - contains the appropriate display page
     * Includes localized entities that will need to be filtered in the client.
     * TODO: replace with GraphQL Marketplace V2 Entities
     * @deprecated Use entityCountByLocation to determine title count instead
     */
    rawMarketplaceEntitiesDisplayedOnPage?: Maybe<Array<Scalars['JSON']>>;
    /** Contains display information for the recap list section of a roundup */
    recapListSection: RecapListDetails;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** The reviewers that this Roundup has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    /** The ordered, augmented Roundup product sections to display on this Roundup. */
    roundupSections?: Maybe<Array<RoundupSection>>;
    /** The type of roundup this piece of content is. */
    roundupType?: Maybe<RoundupTypeEnum>;
    /** The title that is displayed above either the product cards or the summary table. */
    sectionTitle: Scalars['String'];
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** Boolean flag that determines if the first product card's details should be expanded on page load */
    shouldExpandFirstProductCard: Scalars['Boolean'];
    /** Boolean flag that determines if the CTA should be omitted throughout the roundup */
    shouldOmitCta: Scalars['Boolean'];
    /** Boolean flag that determines if ratings should be omitted throughout the roundup */
    shouldOmitRating: Scalars['Boolean'];
    /** Boolean flag to show/hide the advertiser disclosure in the page header */
    showAdvertiserDisclosure: Scalars['Boolean'];
    /** Boolean flag to show/hide author byline in the page header */
    showAuthorByline: Scalars['Boolean'];
    /** Boolean flag to show/hide editorial disclaimer in the page header */
    showEditorialDisclaimer: Scalars['Boolean'];
    /** Whether or not to display the FAQ's. */
    showFaqs?: Maybe<Scalars['Boolean']>;
    /** Whether or not to display the CTA at the bottom of the Roundup. */
    showFooterCta?: Maybe<Scalars['Boolean']>;
    /** Whether or not to display the CTA at the top of the Roundup. */
    showIntroCta?: Maybe<Scalars['Boolean']>;
    /** Whether or not to show the last modified date. */
    showLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Whether or not to disable the Personal Recommendation Banner in the Roundup. */
    showPersRecsBanner?: Maybe<Scalars['Boolean']>;
    /** Whether or not to show the summary table. */
    showSummaryTable?: Maybe<Scalars['Boolean']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The marketplace entity to display in the SMB aggregator partnership banner */
    smbAggregatorPartnershipEntity?: Maybe<MarketplaceEntityInterface>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The quick facts to use in the summary list for banking roundups. */
    summaryListQuickFacts?: Maybe<Array<RoundupSummaryListQuickFactsEnum>>;
    /** The custom title to display for the Summary List on this Roundup. */
    summaryListTitle?: Maybe<Scalars['String']>;
    /** The choice for the behavior of the summary table positioning. */
    summaryTablePosition?: Maybe<RoundupSummaryTablePositionEnum>;
    /** Contains display information for the summary table section of a roundup */
    summaryTableSection: RoundupSummaryTableDetails;
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['StructuredContentDocument']>;
    /** Ordered template sections for a roundup. */
    templateSections?: Maybe<Array<RoundupTemplateSectionTypeEnum>>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /**
     * The page title without the entity count. This is meant to be used for
     * pages with localized entities.
     */
    titleWithoutEntityCount: Scalars['String'];
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Whether or not to use ALPS for ordering the roundup sections. */
    useAlpOrderingForSections?: Maybe<Scalars['Boolean']>;
    /** Whether or not to use a custom last modified date for this piece of content. */
    useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupAdditionalRecommendationsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDisplayDateArgs = {
  format?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModelExecutionIdsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupRoundupSectionsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupShouldExpandFirstProductCardArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTemplateSectionsArgs = {
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Describes a category that contains a group of roundup sections to display */
export type RoundupCategorySection = {
  __typename?: 'RoundupCategorySection';
  /** The list of all product cards to display for this roundup category */
  allProductCards?: Maybe<Array<RoundupSection>>;
  /** The description of the roundup category to be displayed in the Product Cards section of a roundup */
  description?: Maybe<Scalars['String']>;
  /** The eyebrow text that prepends the category title in the Product Cards section of a roundup */
  eyebrowText?: Maybe<Scalars['String']>;
  /** The list of product cards to display for this roundup category */
  productCards?: Maybe<Array<RoundupSection>>;
  /** The name of the roundup category to be displayed in the Product Cards section of a roundup */
  title?: Maybe<Scalars['String']>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type RoundupConnectionResponse = {
  __typename?: 'RoundupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Roundup returned for the connection. */
  items?: Maybe<Array<Roundup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Enum values for crossSellCcCategory field on Roundup type. */
export const RoundupCrossSellCcCategoryEnum = {
  AirlineCreditCards: 'AIRLINE_CREDIT_CARDS',
  BadCreditCards: 'BAD_CREDIT_CARDS',
  BalanceTransferCreditCards: 'BALANCE_TRANSFER_CREDIT_CARDS',
  CashRewardsCreditCards: 'CASH_REWARDS_CREDIT_CARDS',
  HotelCreditCards: 'HOTEL_CREDIT_CARDS',
  None: 'NONE',
  StudentCreditCards: 'STUDENT_CREDIT_CARDS',
  TravelMilesCreditCards: 'TRAVEL_MILES_CREDIT_CARDS',
} as const;

export type RoundupCrossSellCcCategoryEnum =
  (typeof RoundupCrossSellCcCategoryEnum)[keyof typeof RoundupCrossSellCcCategoryEnum];
/** Describes the details of the cross sell section of a roundup */
export type RoundupCrossSellDetails = {
  __typename?: 'RoundupCrossSellDetails';
  productCards?: Maybe<Array<RoundupCrossSellSection>>;
  subtext: Scalars['String'];
};

/** Describes a card in the roundup's cross sell section */
export type RoundupCrossSellSection = {
  __typename?: 'RoundupCrossSellSection';
  /** The tracking params that should be appended to this cross sell section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /**
   * The drivers to display for this marketplaceEntity's product card when drivers
   * are defined, i.e for Credit Card Roundups
   * Returns null when there are no specific drivers defined
   */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** The marketplace entity associated with this cross sell section */
  marketplaceEntity: MarketplaceEntityInterface;
  /**
   * The raw marketplace entity for this cross sell section
   * TODO: replace with a proper marketplaceEntity schema
   */
  rawMarketplaceEntity: Scalars['JSON'];
};

/** Enum values for crossSellSource field on Roundup type. */
export const RoundupCrossSellSourceEnum = {
  CcRecs: 'CC_RECS',
  Default: 'DEFAULT',
  NamedQuery: 'NAMED_QUERY',
  SpecificEntities: 'SPECIFIC_ENTITIES',
} as const;

export type RoundupCrossSellSourceEnum =
  (typeof RoundupCrossSellSourceEnum)[keyof typeof RoundupCrossSellSourceEnum];
/** Enum values for driverGroup field on Roundup type. */
export const RoundupDriverGroupEnum = {
  BalanceTransfer: 'BALANCE_TRANSFER',
  Default: 'DEFAULT',
  Rewards: 'REWARDS',
} as const;

export type RoundupDriverGroupEnum =
  (typeof RoundupDriverGroupEnum)[keyof typeof RoundupDriverGroupEnum];
/** Query to fetch a collection of Roundup objects. */
export type RoundupFilterInput = {
  /** Limit collection to Roundups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Roundups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Roundups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to Roundups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** The union containing the Type members that can be returned by the footerPosts field on the Roundup type. */
export type RoundupFooterPostsUnion = Article | Page | Post | Roundup;

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetails = {
  __typename?: 'RoundupProductCardsDetails';
  /** The list of category sections to display in the Product Cards Section */
  categorySections?: Maybe<Array<RoundupCategorySection>>;
  /** The content tabs to display within the product cards. */
  contentTabs?: Maybe<Array<ProductCardContentTabEnum>>;
  /** The title to use for the product cards section. */
  title?: Maybe<Scalars['String']>;
};

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsCategorySectionsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsContentTabsArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSection = {
  __typename?: 'RoundupSection';
  /** The benefits of this product. */
  benefits?: Maybe<Scalars['StructuredContentDocument']>;
  /**
   * The text to show in the Why We Like It section of a product card. Overrides
   * the bottomLine provided by the Marketplace Entity.
   */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']>;
  /** The category description for the Roundup category. */
  categoryDescription?: Maybe<Scalars['String']>;
  /** The name of the Roundup category within this section. */
  categoryName?: Maybe<Scalars['String']>;
  /** The list of cons that will override this roundup section's marketplace entity's cons */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The CTA that will override this roundup section's marketplace entity's CTA */
  cta?: Maybe<EntityPlacementCta>;
  /** Where to link the CTA to. */
  ctaDestination?: Maybe<Scalars['String']>;
  /** The tracking params that should be appended to this roundup section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']>;
  /** The drawbacks of this product. */
  drawbacks?: Maybe<Scalars['StructuredContentDocument']>;
  /**
   * The driver group for a Product Card that will override this roundup section's default drivers
   * TODO: (SHOP-13277) After the Product Cards have been updated to accept drivers return override
   *   drivers directly instead of a group
   * @deprecated This field is only used while we migrate to using the drivers field.
   */
  driverGroup?: Maybe<Scalars['String']>;
  /** The driver overrides for a given roundup section. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** Boolean flag to indicate if model execution id should be excluded from impressions for this roundup section. */
  excludeModelExecutionIds: Scalars['Boolean'];
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyId?: Maybe<Scalars['String']>;
  /** The "key facts: for this roundup section. */
  keyFacts?: Maybe<Scalars['StructuredContentDocument']>;
  /** The lender associated with the roundup. */
  legacyLender?: Maybe<LegacyLender>;
  /** The Marketplace entity UUID. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyId?: Maybe<Scalars['String']>;
  /** The product card Component to use for this roundup section */
  productCardComponent: ProductCardComponentEnum;
  /** The "product details" for this roundup section. */
  productDetails?: Maybe<Scalars['StructuredContentDocument']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The list of pros that will override this roundup section's marketplace entity's pros */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /**
   * The description to show in the recap list for this roundup section - Note that this
   * field should only be used as a child of 'recapListSection.recapItems'
   */
  recapDescription?: Maybe<Scalars['String']>;
  /** Boolean flag to indicate if the "Add to Compare" button should be enabled */
  shouldEnableAddToCompare: Scalars['Boolean'];
  /** Boolean flag to indicate if the images should lazy load for this roundup section */
  shouldEnableImageLazyLoad: Scalars['Boolean'];
  /** Whether or not to display this roundup section in more options instead of a product card. */
  showInAdditionalRecommendations?: Maybe<Scalars['Boolean']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyId?: Maybe<Scalars['String']>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionDriversArgs = {
  driversVariant?: InputMaybe<DriversVariationTypeEnum>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionProductCardComponentArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Enum values for summaryListQuickFacts field on Roundup type. */
export const RoundupSummaryListQuickFactsEnum = {
  Apy: 'APY',
  Bonus: 'BONUS',
  Default: 'DEFAULT',
  MinimumBalance: 'MINIMUM_BALANCE',
  MonthlyFee: 'MONTHLY_FEE',
  OutOfNetworkAtmFee: 'OUT_OF_NETWORK_ATM_FEE',
} as const;

export type RoundupSummaryListQuickFactsEnum =
  (typeof RoundupSummaryListQuickFactsEnum)[keyof typeof RoundupSummaryListQuickFactsEnum];
/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetails = {
  __typename?: 'RoundupSummaryTableDetails';
  /** Whether to enable row truncation behavior */
  allowTruncatingRows: Scalars['Boolean'];
  /** Text to be added at the bottom of the summary table */
  disclaimerText?: Maybe<Scalars['String']>;
  /** Title that should be used as the header for each marketplace entity */
  marketplaceEntityHeader: Scalars['String'];
  /** The maximum number of rows that can be present before any truncation can be applied */
  maxRows: Scalars['Int'];
  /** The number of rows to show after applying truncation */
  numTruncatedRows: Scalars['Int'];
  /** The rows within the summary table */
  rows?: Maybe<Array<RoundupSection>>;
  /** The title to use for the Summary Table Section */
  title: Scalars['String'];
};

/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetailsRowsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']>;
};

/** Enum values for summaryTablePosition field on Roundup type. */
export const RoundupSummaryTablePositionEnum = {
  AboveProductCards: 'ABOVE_PRODUCT_CARDS',
  BelowProductCards: 'BELOW_PRODUCT_CARDS',
  Default: 'DEFAULT',
} as const;

export type RoundupSummaryTablePositionEnum =
  (typeof RoundupSummaryTablePositionEnum)[keyof typeof RoundupSummaryTablePositionEnum];
/** Types of TemplateSections for a Roundup. */
export const RoundupTemplateSectionTypeEnum = {
  AuthorBox: 'AUTHOR_BOX',
  CompareBar: 'COMPARE_BAR',
  CrossSellModule: 'CROSS_SELL_MODULE',
  Faq: 'FAQ',
  FooterPosts: 'FOOTER_POSTS',
  GeodataDropdown: 'GEODATA_DROPDOWN',
  Header: 'HEADER',
  Insurance: 'INSURANCE',
  IntroContent: 'INTRO_CONTENT',
  LearnContent: 'LEARN_CONTENT',
  Methodology: 'METHODOLOGY',
  NerdyTip: 'NERDY_TIP',
  ProductCards: 'PRODUCT_CARDS',
  Recap: 'RECAP',
  RecapWithAccordion: 'RECAP_WITH_ACCORDION',
  SideBySideCompare: 'SIDE_BY_SIDE_COMPARE',
  SmbAggregatorPartnership: 'SMB_AGGREGATOR_PARTNERSHIP',
  SummaryTablePretty: 'SUMMARY_TABLE_PRETTY',
  UpdatedDate: 'UPDATED_DATE',
} as const;

export type RoundupTemplateSectionTypeEnum =
  (typeof RoundupTemplateSectionTypeEnum)[keyof typeof RoundupTemplateSectionTypeEnum];
/** Enum values for roundupType field on Roundup type. */
export const RoundupTypeEnum = {
  MarketingRoundup: 'MARKETING_ROUNDUP',
  OrganicRoundup: 'ORGANIC_ROUNDUP',
} as const;

export type RoundupTypeEnum =
  (typeof RoundupTypeEnum)[keyof typeof RoundupTypeEnum];
export type ScCalculatorPage = StructuredContentPageInterface & {
  __typename?: 'SCCalculatorPage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/** Saved personal loans prequal offers include expanded marketplace offers, expanded marketplace static offers, and prequal offers */
export type SavedPersonalLoansPrequalOffers = {
  __typename?: 'SavedPersonalLoansPrequalOffers';
  /**
   * API offers include prequal, high interest, and conditional offers
   * @deprecated Use sortedPrequalOffers.
   */
  apiOffers: Array<PrequalPersonalLoansApiOffer>;
  /**
   * List of Best Bets offers (offers that are likely the best for the user),
   * containing the offer with the lowest APR and the offer with the lowest monthly payment.
   * @deprecated Use the bestBets field on PrequalPersonalLoansApiOffer within sortedPrequalOffers.
   */
  bestBetsOffers?: Maybe<BestBetsOffersResponse>;
  /** Expanded marketplace offers are displayed to the user if they do not prequalify for any offers; one provider may offer multiple expanded marketplace offers */
  expandedMarketplaceOffers: Array<PersonalLoansOfferV2>;
  /** Expanded marketplace static offers are displayed to the user if they do not prequalify for any offers; one provider will only offer one static offer */
  expandedMarketplaceStaticOffers: Array<ExpandedMarketplaceStaticOffer>;
  /** Set to true if there is at least one prequalified offer the user is qualified for; this is false otherwise */
  hasPrequalifiedOffers: Scalars['Boolean'];
  /** Flag indicating if the user is prequalified for personal loans offers */
  isUserPrequalified: Scalars['Boolean'];
  /** List of personal loans providers */
  providers: Array<Provider>;
  /** Personal loan amount requested by the user */
  requestedLoanAmount: Scalars['Float'];
  /**
   * PENDING RENAME: Misnomer as sorting is not done here.
   * A prequalified user's offers.
   */
  sortedPrequalOffers: Array<PrequalPersonalLoansApiOffer>;
};

export type SavedQuizAnswers = {
  __typename?: 'SavedQuizAnswers';
  airlineChoice?: Maybe<AirlineChoice>;
  annualFees?: Maybe<Scalars['Boolean']>;
  annualFeesTravel?: Maybe<AnnualFeesTravel>;
  bonusCategories?: Maybe<Array<Maybe<BonusCategories>>>;
  bonusCategoriesStaySame?: Maybe<Scalars['Boolean']>;
  cardDeposit?: Maybe<Scalars['Boolean']>;
  cashBackMinimum?: Maybe<Scalars['Boolean']>;
  collegeStudent?: Maybe<Scalars['Boolean']>;
  creditScore?: Maybe<CreditScore>;
  currentBalanceCompany?: Maybe<CurrentBalanceCompany>;
  hotelChoice?: Maybe<HotelChoice>;
  howCashBack?: Maybe<HowCashBack>;
  howLongToPayOffDebt?: Maybe<HowLongToPayOffDebt>;
  howMuchTransferFee?: Maybe<HowMuchTransferFee>;
  howOftenTravel?: Maybe<HowOftenTravel>;
  internationalTravel?: Maybe<Scalars['Boolean']>;
  isBuildingCredit?: Maybe<Scalars['Boolean']>;
  isDebtCreditCard?: Maybe<Scalars['Boolean']>;
  primaryGoal?: Maybe<PrimaryGoal>;
  specificAirline?: Maybe<Scalars['Boolean']>;
  specificHotel?: Maybe<Scalars['Boolean']>;
};

export type SavingsAccountInstitution = InstitutionInterface & {
  __typename?: 'SavingsAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dataHash?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  productType: Scalars['String'];
  status: Scalars['String'];
  tags: Array<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  versionId?: Maybe<Scalars['ID']>;
};

export type SavingsAccountOffer = AccountOfferInterface &
  OfferInterface & {
    __typename?: 'SavingsAccountOffer';
    applyLink?: Maybe<Scalars['URL']>;
    apy?: Maybe<Scalars['Float']>;
    createdAt?: Maybe<Scalars['DateTime']>;
    dataHash?: Maybe<Scalars['String']>;
    details?: Maybe<SavingsAccountOfferDetails>;
    endsAt?: Maybe<Scalars['DateTime']>;
    entityType: Scalars['String'];
    externalId?: Maybe<Scalars['String']>;
    id: Scalars['ID'];
    imageUrl?: Maybe<Scalars['String']>;
    institution?: Maybe<SavingsAccountInstitution>;
    isMonetizing?: Maybe<Scalars['Boolean']>;
    name: Scalars['String'];
    productId?: Maybe<Scalars['ID']>;
    productType: Scalars['String'];
    providerName?: Maybe<Scalars['String']>;
    rating?: Maybe<Scalars['Float']>;
    reviewUrl?: Maybe<Scalars['String']>;
    slug?: Maybe<Scalars['String']>;
    status: Scalars['String'];
    tags: Array<Scalars['String']>;
    updatedAt?: Maybe<Scalars['DateTime']>;
    versionId?: Maybe<Scalars['ID']>;
  };

export type SavingsAccountOfferDetails = {
  __typename?: 'SavingsAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']>>;
};

export type SavingsAccountOffersByNamedQueryResponse = {
  __typename?: 'SavingsAccountOffersByNamedQueryResponse';
  offers?: Maybe<Array<SavingsAccountOffer>>;
};

export type SearchServiceContentSearchResults = {
  __typename?: 'SearchServiceContentSearchResults';
  /** The facets from the search result, see 'Facets' */
  facets?: Maybe<Facets>;
  /** The current offset in results */
  offset?: Maybe<Scalars['Int']>;
  /** A list of related content given the parameters of ContentSearchInput */
  searchResults?: Maybe<Array<PostInterface>>;
  /** The total number of related content */
  total: Scalars['Int'];
};

export type SearchServiceContentSearchResultsSearchResultsArgs = {
  sortDir?: InputMaybe<ContentSortDirection>;
};

export type SecurityQuestionInfoInput = {
  /** The user's answer to their security question */
  answer: Scalars['String'];
  /** The user's security question */
  question: Scalars['String'];
};

export type SendResetPasswordEmailInfoInput = {
  /** The email used to send the password reset */
  email: Scalars['EmailAddress'];
};

export type SeoSettings = {
  __typename?: 'SeoSettings';
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'link' field on the parent Type instead. */
  canonical?: Maybe<Scalars['URL']>;
  /** The meta description for the content, used for SEO purposes. */
  description?: Maybe<Scalars['String']>;
  /** The custom JSON-LD schema to add to the existing JSON-LD generated for the content. */
  extraJsonLd?: Maybe<Scalars['JSON']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  facebook?: Maybe<SocialSeoSettings>;
  /** The focus keyword for the content, used for SEO purposes. */
  keyword?: Maybe<Scalars['String']>;
  /** Whether to instruct search engines like Google to not follow links in this content. */
  nofollow?: Maybe<Scalars['Boolean']>;
  /** Whether or not the content should be indexed in search engines like Google. */
  noindex?: Maybe<Scalars['Boolean']>;
  /** The meta title for the content, used for SEO purposes. */
  title?: Maybe<Scalars['String']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  twitter?: Maybe<SocialSeoSettings>;
};

export type SimulateCreditScoreResponse = {
  __typename?: 'SimulateCreditScoreResponse';
  /** The simulated credit score when adding child support */
  addChildSupportResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding a foreclosure */
  addForeclosureResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding a tax lien */
  addTaxLienResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when adding wage garnishment */
  addWageGarnishmentResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when all accounts are past due for a number of days */
  allAccountsPastDueNumDaysResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when applying for a number of credit cards */
  applyForNumberOfCreditCardResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when closing the oldest credit card */
  closeOldestCreditCardResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when decreasing the credit card balance amount */
  decreaseCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when increasing the credit balance amount */
  increaseCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when increasing the credit card limit */
  increaseCreditCardLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when moving one account into collection */
  moveOneAccountIntoCollectionResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining an auto loan limit */
  obtainAutoLoanLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a credit card limit */
  obtainCreditCardLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a mortgage limit */
  obtainMortgageLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when obtaining a personal loan limit */
  obtainPersonalLoanLimitResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when making on time payments for a number of months */
  onTimePaymentsNumMonthsResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when one account is past due for a number of days */
  oneAccountPastDueNumDaysResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when paying off all credit cards */
  payOffAllCreditCardsResult?: Maybe<Scalars['Int']>;
  /** The simulated credit score when transferring a credit balance amount */
  transferCreditBalanceAmountResult?: Maybe<Scalars['Int']>;
};

/** The info banner details derived from the feature flag payload, all fields required */
export type SitewideInfoBannerDetails = {
  __typename?: 'SitewideInfoBannerDetails';
  bannerName: Scalars['String'];
  btnText: Scalars['String'];
  copy: Scalars['String'];
  link: Scalars['URL'];
  title: Scalars['String'];
};

export type SitewideInfoBannerResponse = {
  __typename?: 'SitewideInfoBannerResponse';
  details?: Maybe<SitewideInfoBannerDetails>;
  isEnabled: Scalars['Boolean'];
};

/** A Small Medium Business Loans institution */
export type SmallMediumBusinessLoansInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'SmallMediumBusinessLoansInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Small Medium Business Loans offer */
export type SmallMediumBusinessLoansOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithQualificationsInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'SmallMediumBusinessLoansOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    /** Redirect link for this Offer */
    applyLink?: Maybe<Scalars['URL']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** The display name for the entity (auto-generated) */
    displayName?: Maybe<Scalars['String']>;
    /** The driver estimated apr associated with the entity */
    driverEstimatedApr?: Maybe<EntityPlacementDriver>;
    /** The driver min credit score associated with the entity */
    driverMinCreditScore?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Maximum loan amount (i.e., $5,000,000 is entered as 5000000) */
    maxLoanAmount?: Maybe<Scalars['Float']>;
    /** Maximum loan term in months (i.e., 5 years is entered as 60) */
    maxLoanTerm?: Maybe<Scalars['Int']>;
    /** Minimum loan term in months (i.e., 5 years is entered as 60) */
    minLoanTerm?: Maybe<Scalars['Int']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: SmallMediumBusinessLoansProductV2;
    /** Use this if the product has any notable features you want to highlight on the product card */
    productLabel?: Maybe<Scalars['String']>;
    /** Product type */
    productType: Scalars['String'];
    /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** List of qualifications for the offer */
    qualificationsBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** Speed to funding duration value */
    speedToFunding?: Maybe<Scalars['Int']>;
    /** Speed to funding duration type */
    speedToFundingDuration?: Maybe<Scalars['String']>;
    /** The overall editorial rating for this offer */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Small Medium Business Loans product */
export type SmallMediumBusinessLoansProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'SmallMediumBusinessLoansProductV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: SmallMediumBusinessLoansInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type SmbArticlePage = StructuredContentPageInterface & {
  __typename?: 'SmbArticlePage';
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

export type SocialSeoSettings = {
  __typename?: 'SocialSeoSettings';
  /** The description for the content as it should appear when this content is shared on Facebook. */
  description?: Maybe<Scalars['String']>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'featuredMedia' field on the parent Type instead. */
  image?: Maybe<Scalars['URL']>;
  /** The title for the content as it should appear when this content is shared on Facebook. */
  title?: Maybe<Scalars['String']>;
};

/** A Software institution */
export type SoftwareInstitutionV2 = MarketplaceEntityInterface &
  MarketplaceInstitutionInterface & {
    __typename?: 'SoftwareInstitutionV2';
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** A URL that points to the logo for the institution */
    imageSource?: Maybe<Scalars['URL']>;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Software offer */
export type SoftwareOfferV2 = MarketplaceEntityInterface &
  MarketplaceEntityWithBestOfAwardsInterface &
  MarketplaceEntityWithPlacementInterface &
  MarketplaceEntityWithReviewInterface &
  MarketplaceEntityWithStarRatingInterface &
  MarketplaceOfferInterface & {
    __typename?: 'SoftwareOfferV2';
    /** Data used for building analytics events */
    analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
    applyLink?: Maybe<Scalars['URL']>;
    /** The Best Of Awards that this offer has won */
    bestOfAwards?: Maybe<Array<BestOfAward>>;
    /** Cons for the offer. */
    consBullets?: Maybe<Array<Scalars['String']>>;
    /** The CTA for the marketplace entity */
    cta?: Maybe<EntityPlacementCta>;
    /** Text presented as part of CTA */
    ctaText?: Maybe<Scalars['String']>;
    /** The display name for the entity */
    displayName?: Maybe<Scalars['String']>;
    /** The driver bonus associated with the entity */
    driverBonus?: Maybe<EntityPlacementDriver>;
    /** The driver price associated with the entity */
    driverPrice?: Maybe<EntityPlacementDriver>;
    /** Entity type */
    entityType: Scalars['String'];
    /** The cost of any hardware the offer requires. */
    hardwareCost?: Maybe<Scalars['Float']>;
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    /** The image data associated with the entity */
    image?: Maybe<EntityPlacementImage>;
    /** URL for the logo */
    imageSource?: Maybe<Scalars['URL']>;
    /** The parent Institution of this Offer */
    institution: MarketplaceEntityInterface;
    /** Used to determine if placement is monetizing. */
    isMonetizing?: Maybe<Scalars['Boolean']>;
    /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
    monetizable: Scalars['String'];
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** The processing fees charged by the payment provider. */
    paymentsCost?: Maybe<Scalars['String']>;
    /** Additional context on the processing fees charged by the payment provider. */
    paymentsDetails?: Maybe<Scalars['String']>;
    /**
     * The drivers associated with the entity
     * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
     */
    placementDrivers: Array<EntityPlacementDriver>;
    product: SoftwareProductV2;
    /** Product type */
    productType: Scalars['String'];
    /** Pros for the offer. */
    prosBullets?: Maybe<Array<Scalars['String']>>;
    /** The URL to the NerdWallet review of this offer. */
    reviewLink?: Maybe<Scalars['URL']>;
    /** A boolean indicating if the display name should be shown in the comparison table component */
    showNameInComparisonTable: Scalars['Boolean'];
    /** The cost of any required software subscription. */
    softwareCost?: Maybe<Scalars['Float']>;
    /** The overall editorial rating for this Offer. */
    starRating?: Maybe<Scalars['Float']>;
    /** The tooltip value for NerdWallet's star rating */
    starRatingTooltip?: Maybe<Scalars['String']>;
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
    structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']>>;
    /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
    structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']>;
    /** Product description. */
    tagline?: Maybe<Scalars['String']>;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** Flag for whether to use the large product card image styles */
    useLargeImageFootprint: Scalars['Boolean'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

/** A Software product */
export type SoftwareProductV2 = MarketplaceEntityInterface &
  MarketplaceProductInterface & {
    __typename?: 'SoftwareProductV2';
    /** Essentially helps create a sub vertical. */
    category?: Maybe<Scalars['String']>;
    /** Entity type */
    entityType: Scalars['String'];
    /** UUID primary key for the Marketplace entity */
    id: Scalars['ID'];
    institution: SoftwareInstitutionV2;
    /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
    name: Scalars['String'];
    /** Product type */
    productType: Scalars['String'];
    /** Entity status */
    status: MarketplaceStatusEnum;
    /** When the entity was last updated in the DB */
    updatedAt: Scalars['DateTime'];
    /** The current version number of the entity */
    versionId: Scalars['Int'];
  };

export type SpendingByMonthsDataVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'SpendingByMonthsDataVisualization';
    /** This will always be SPENDING_BY_MONTHS */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
    /**
     * The user's total spending on each day of the current month to the current date, and each day of the _previous_
     * month (e.g. if today is 6/17, this field would include spending data for 5/1-5/30 and 6/1-6/17).
     *
     * Note that SpendingByMonthsDataVisualization utilizes the same type as the existing manifestation of this data
     * visualization in the Cash Flow product experience.
     */
    spendingByDateForTargetAndPriorMonthToDate: FinancialTransactionsSpendingByDayOfTheMonthForMonth;
  };

export type SpendingByMonthsDataVisualizationSpendingByDateForTargetAndPriorMonthToDateArgs =
  {
    effectiveDate?: InputMaybe<Scalars['String']>;
  };

export type SpendingByTopCategoriesDataVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'SpendingByTopCategoriesDataVisualization';
    /** This will always be SPENDING_BY_TOP_CATEGORIES */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
    /**
     * The user's top spending categories for the current month, to date.
     *
     * Note that SpendingByTopCategoriesDataVisualization utilizes the same type as the existing manifestation of this data
     * visualization in the Cash Flow product experience.
     */
    topCategoriesBySpending: FinancialTransactionsTopCategoriesBySpending;
  };

export type SpendingByTopCategoriesDataVisualizationTopCategoriesBySpendingArgs =
  {
    effectiveDate?: InputMaybe<Scalars['String']>;
  };

export const StateAbbreviationsEnum = {
  Ak: 'AK',
  Al: 'AL',
  Ar: 'AR',
  Az: 'AZ',
  Ca: 'CA',
  Co: 'CO',
  Ct: 'CT',
  Dc: 'DC',
  De: 'DE',
  Fl: 'FL',
  Ga: 'GA',
  Hi: 'HI',
  Ia: 'IA',
  Id: 'ID',
  Il: 'IL',
  In: 'IN',
  Ks: 'KS',
  Ky: 'KY',
  La: 'LA',
  Ma: 'MA',
  Md: 'MD',
  Me: 'ME',
  Mi: 'MI',
  Mn: 'MN',
  Mo: 'MO',
  Ms: 'MS',
  Mt: 'MT',
  Nc: 'NC',
  Nd: 'ND',
  Ne: 'NE',
  Nh: 'NH',
  Nj: 'NJ',
  Nm: 'NM',
  Nv: 'NV',
  Ny: 'NY',
  Oh: 'OH',
  Ok: 'OK',
  Or: 'OR',
  Pa: 'PA',
  Ri: 'RI',
  Sc: 'SC',
  Sd: 'SD',
  Tn: 'TN',
  Tx: 'TX',
  Ut: 'UT',
  Va: 'VA',
  Vt: 'VT',
  Wa: 'WA',
  Wi: 'WI',
  Wv: 'WV',
  Wy: 'WY',
} as const;

export type StateAbbreviationsEnum =
  (typeof StateAbbreviationsEnum)[keyof typeof StateAbbreviationsEnum];
/** A valid US State Code */
export const StateCodeEnum = {
  Ak: 'AK',
  Al: 'AL',
  Ar: 'AR',
  As: 'AS',
  Az: 'AZ',
  Ca: 'CA',
  Co: 'CO',
  Ct: 'CT',
  Dc: 'DC',
  De: 'DE',
  Fl: 'FL',
  Ga: 'GA',
  Gu: 'GU',
  Hi: 'HI',
  Ia: 'IA',
  Id: 'ID',
  Il: 'IL',
  In: 'IN',
  Ks: 'KS',
  Ky: 'KY',
  La: 'LA',
  Ma: 'MA',
  Md: 'MD',
  Me: 'ME',
  Mi: 'MI',
  Mn: 'MN',
  Mo: 'MO',
  Ms: 'MS',
  Mt: 'MT',
  Nc: 'NC',
  Nd: 'ND',
  Ne: 'NE',
  Nh: 'NH',
  Nj: 'NJ',
  Nm: 'NM',
  Nv: 'NV',
  Ny: 'NY',
  Oh: 'OH',
  Ok: 'OK',
  Or: 'OR',
  Pa: 'PA',
  Pr: 'PR',
  Ri: 'RI',
  Sc: 'SC',
  Sd: 'SD',
  Tn: 'TN',
  Tx: 'TX',
  Ut: 'UT',
  Va: 'VA',
  Vi: 'VI',
  Vt: 'VT',
  Wa: 'WA',
  Wi: 'WI',
  Wv: 'WV',
  Wy: 'WY',
} as const;

export type StateCodeEnum = (typeof StateCodeEnum)[keyof typeof StateCodeEnum];
/** The `StatementIndexedFeedItem` type represents a generically typed item in the user's feed. */
export type StatementIndexedFeedItem = {
  __typename?: 'StatementIndexedFeedItem';
  cards: Array<FeedCard>;
  statement: FeedStatement;
};

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculator = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithTitleInterface & {
    __typename?: 'StructuredContentCalculator';
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** A list of Category objects on the StructuredContentCalculator object. */
    categories?: Maybe<Array<Category>>;
    /** The config JSON for the calculator. */
    config?: Maybe<Scalars['JSON']>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type StructuredContentCalculatorConnectionResponse = {
  __typename?: 'StructuredContentCalculatorConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The StructuredContentCalculator returned for the connection. */
  items?: Maybe<Array<StructuredContentCalculator>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of StructuredContentCalculator objects. */
export type StructuredContentCalculatorFilterInput = {
  /** Limit collection to StructuredContentCalculators published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to StructuredContentCalculators within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit collection to StructuredContentCalculators with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Common interface Type for all explicit structured content page Types to implement */
export type StructuredContentPageInterface = {
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID'];
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
};

/**
 * The `SubscriptionIdentityProfile` type currently represents subscription_profile_v3 as mapped from
 * Identity. Not versioned in order to support future evolution of this type.
 */
export type SubscriptionIdentityProfile = {
  __typename?: 'SubscriptionIdentityProfile';
  /** @deprecated The Cash Back feature is deprecated */
  emailCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  emailEnabled?: Maybe<Scalars['Boolean']>;
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by emailPersonalizedContentEnabled in v3 */
  emailProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by emailTransactionalMarketingEnabled in v3 */
  emailProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Removed from v3 */
  emailProgressUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
  notificationCenterCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  notificationCenterEnabled?: Maybe<Scalars['Boolean']>;
  notificationCenterMarketingEnabled?: Maybe<Scalars['Boolean']>;
  notificationCenterPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  notificationCenterSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated The Cash Back feature is deprecated */
  pushCashBackRewardsEnabled?: Maybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  pushEnabled?: Maybe<Scalars['Boolean']>;
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by pushPersonalizedContentEnabled in v3 */
  pushProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by pushTransactionalMarketingEnabled in v3 */
  pushProfileUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
};

/** Each enum entry should be synced with each available field in SubscriptionIdentityProfile. */
export const SubscriptionTypeEnum = {
  EmailCashBackRewardsEnabled: 'EMAIL_CASH_BACK_REWARDS_ENABLED',
  EmailCreditMonitoringEnabled: 'EMAIL_CREDIT_MONITORING_ENABLED',
  EmailEnabled: 'EMAIL_ENABLED',
  EmailMarketingEnabled: 'EMAIL_MARKETING_ENABLED',
  EmailPersonalizedContentEnabled: 'EMAIL_PERSONALIZED_CONTENT_ENABLED',
  EmailProductAnnouncementsEnabled: 'EMAIL_PRODUCT_ANNOUNCEMENTS_ENABLED',
  EmailProfileUpdatesEnabled: 'EMAIL_PROFILE_UPDATES_ENABLED',
  EmailProgressUpdatesEnabled: 'EMAIL_PROGRESS_UPDATES_ENABLED',
  EmailSpendingAlertsEnabled: 'EMAIL_SPENDING_ALERTS_ENABLED',
  EmailTransactionalMarketingEnabled: 'EMAIL_TRANSACTIONAL_MARKETING_ENABLED',
  PushCashBackRewardsEnabled: 'PUSH_CASH_BACK_REWARDS_ENABLED',
  PushCreditMonitoringEnabled: 'PUSH_CREDIT_MONITORING_ENABLED',
  PushEnabled: 'PUSH_ENABLED',
  PushMarketingUpdatesEnabled: 'PUSH_MARKETING_UPDATES_ENABLED',
  PushPersonalizedContentEnabled: 'PUSH_PERSONALIZED_CONTENT_ENABLED',
  PushProductAnnouncementsEnabled: 'PUSH_PRODUCT_ANNOUNCEMENTS_ENABLED',
  PushProfileUpdatesEnabled: 'PUSH_PROFILE_UPDATES_ENABLED',
  PushSpendingAlertsEnabled: 'PUSH_SPENDING_ALERTS_ENABLED',
  PushTransactionalMarketingEnabled: 'PUSH_TRANSACTIONAL_MARKETING_ENABLED',
} as const;

export type SubscriptionTypeEnum =
  (typeof SubscriptionTypeEnum)[keyof typeof SubscriptionTypeEnum];
/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type Table = PostInterface &
  PostWithContentInterface &
  PostWithExcerptInterface &
  PostWithTitleInterface & {
    __typename?: 'Table';
    /** The column centering options selected for the table. */
    columnCentering?: Maybe<TableCenteringOptionsEnum>;
    /** The columns for the table. */
    columns?: Maybe<Array<TableColumn>>;
    /** The structured content for the resource. */
    content?: Maybe<Scalars['StructuredContentDocument']>;
    /** The data to display within the columns for the table. */
    data?: Maybe<Scalars['JSON']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The editorial excerpt of the resource. */
    excerpt?: Maybe<Scalars['String']>;
    /** Whether or not the the table has a header. */
    hasTableHeader: Scalars['Boolean'];
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not the table should be stylized with alternating stripes. */
    isStriped: Scalars['Boolean'];
    /** Whether or not the table is structured content eligible. */
    isStructuredContentEligible: Scalars['Boolean'];
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** The row centering options selected for the table. */
    rowCentering?: Maybe<TableCenteringOptionsEnum>;
    /** Whether or not the table has the rowHover feature enabled. */
    rowHover: Scalars['Boolean'];
    /** Whether or not the title of the table should be displayed. */
    showTableTitle: Scalars['Boolean'];
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The bolding style to apply to this table. */
    tableBolding?: Maybe<TableBoldingEnum>;
    /** The type of visibility for the table. */
    tableVisibility?: Maybe<TableVisibilityEnum>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
  };

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Enum values for tableBolding field on Table type. */
export const TableBoldingEnum = {
  Default: 'DEFAULT',
  FirstColumn: 'FIRST_COLUMN',
  FirstRow: 'FIRST_ROW',
  FirstRowColumn: 'FIRST_ROW_COLUMN',
  None: 'NONE',
} as const;

export type TableBoldingEnum =
  (typeof TableBoldingEnum)[keyof typeof TableBoldingEnum];
/** The available centering options for rows and columns within a table. */
export const TableCenteringOptionsEnum = {
  First: 'FIRST',
  Last: 'LAST',
} as const;

export type TableCenteringOptionsEnum =
  (typeof TableCenteringOptionsEnum)[keyof typeof TableCenteringOptionsEnum];
/** The TableColumn type to encapsulate the properties within each of the columns on a table. */
export type TableColumn = {
  __typename?: 'TableColumn';
  /** The number of columns a table cell should span. */
  colspan?: Maybe<Scalars['Int']>;
  /** The heading for the column. */
  heading?: Maybe<Array<Scalars['StructuredContentDocument']>>;
  /** The unique ID for the table to use for mapping the rows to each column, and for using as a key in React. */
  id: Scalars['ID'];
  /** Whether or not the column should be centered. */
  isCentered: Scalars['Boolean'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type TableConnectionResponse = {
  __typename?: 'TableConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The Table returned for the connection. */
  items?: Maybe<Array<Table>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of Table objects. */
export type TableFilterInput = {
  /** Limit collection to Tables with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Tables with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
};

/** Enum values for tableVisibility field on Table type. */
export const TableVisibilityEnum = {
  Private: 'PRIVATE',
  Public: 'PUBLIC',
} as const;

export type TableVisibilityEnum =
  (typeof TableVisibilityEnum)[keyof typeof TableVisibilityEnum];
/** The Term interface for modeling terms within custom taxonomies. */
export type TermInterface = {
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String'];
};

/** The input for retrieving a single resource. */
export type TermItemInput = {
  /** The slug for the term or the WordPress ID. */
  identifier: Scalars['ID'];
};

export type TermsOfServiceAcknowledgement = {
  __typename?: 'TermsOfServiceAcknowledgement';
  /** The client that is the source of the acknowledgement (MY_NERDWALLET, etc). */
  source: Scalars['String'];
  /** The type of terms of service the user is acknowledging. */
  type: Scalars['String'];
  /** The version of the terms of service being acknowledged. */
  version: Scalars['String'];
};

export type TermsOfServiceIdentityProfile = {
  __typename?: 'TermsOfServiceIdentityProfile';
  acknowledgements?: Maybe<Array<TermsOfServiceAcknowledgement>>;
};

/** A Third Party Embeds institution */
export type ThirdPartyEmbedsInstitution = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsInstitution';
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

/** A Third Party Embeds product */
export type ThirdPartyEmbedsProduct = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsProduct';
  /** Enter the HTML for this embed. This comes from the partner. */
  embedCode?: Maybe<Scalars['String']>;
  /** Entity type */
  entityType: Scalars['String'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID'];
  /** Custom height for embeds. */
  iframeHeight?: Maybe<Scalars['Float']>;
  institution: ThirdPartyEmbedsInstitution;
  isMonetizing?: Maybe<Scalars['Boolean']>;
  /** Loading text for embeds. */
  loadingCopy?: Maybe<Scalars['String']>;
  /** Marketplace product type to use in analytics events. */
  marketplaceProductType?: Maybe<Scalars['String']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String'];
  /** Product type */
  productType: Scalars['String'];
  /** Toggles ad banner for third party embeds */
  showAdBanner?: Maybe<Scalars['Boolean']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime'];
  /** The current version number of the entity */
  versionId: Scalars['Int'];
};

export const TopCategory = {
  Dining: 'DINING',
  Entertainment: 'ENTERTAINMENT',
  Gas: 'GAS',
  Groceries: 'GROCERIES',
  Shopping: 'SHOPPING',
  Travel: 'TRAVEL',
} as const;

export type TopCategory = (typeof TopCategory)[keyof typeof TopCategory];
export type TopInstitutionsForLinkingResponse = {
  __typename?: 'TopInstitutionsForLinkingResponse';
  /** The list of top institutions for the selected product type */
  institutions: Array<AccountAggregationInstitution>;
};

export type TrackEventInput = {
  anonymousId?: InputMaybe<Scalars['String']>;
  eventKey: Scalars['String'];
  userAttributes?: InputMaybe<Scalars['JSON']>;
};

export type TrackingParam = {
  __typename?: 'TrackingParam';
  key: Scalars['String'];
  value: Scalars['String'];
};

/**
 * The input supplied to the trustSessionId query.
 *
 * The blackBox string is an obfuscated device fingerprint obtained from Transunion-owned code running on the user's
 * device.
 */
export type TrustSessionIdInput = {
  blackBox: Scalars['String'];
};

/** The response from the trustSessionId query */
export type TrustSessionIdResponse = {
  __typename?: 'TrustSessionIdResponse';
  trustSessionId: Scalars['String'];
};

export const TuCreditFactorBucket = {
  Fair: 'FAIR',
  Good: 'GOOD',
  Poor: 'POOR',
} as const;

export type TuCreditFactorBucket =
  (typeof TuCreditFactorBucket)[keyof typeof TuCreditFactorBucket];
/** Represents a TransUnion credit report as it is used in the NW product experience */
export type TuCreditReport = {
  __typename?: 'TuCreditReport';
  /** The TU user's current address */
  currentAddress: IdentityAddress;
  /** The TU employers belonging to the user's credit report */
  employers?: Maybe<Array<TuEmployer>>;
  /** The TU credit inquiries belonging to the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** Indicates if the user's credit report is considered stale */
  isStale?: Maybe<Scalars['Boolean']>;
  /** The timestamp that the next credit report will be pulled at */
  nextReportPullAt?: Maybe<Scalars['DateTime']>;
  /** The percent utilization based on the user's credit limit */
  percentUtilization?: Maybe<Scalars['Float']>;
  /** The TU public records belonging to the user's credit report */
  publicRecords?: Maybe<Array<TuPublicRecord>>;
  /** The timestamp that the current credit report was pulled at */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /** The total credit balance across all accounts */
  totalCreditBalance: Scalars['Float'];
  /** The TU credit tradelines belonging to the user's credit report */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
  /** A user's numerical credit score */
  vantageScore3?: Maybe<Scalars['Int']>;
  /** A user's credit score bucket (i.e. POOR, GOOD, etc.) */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent prior score
   */
  vantageScore3Delta?: Maybe<Scalars['Int']>;
};

/**
 * The `TuCreditReportIdentityProfile` represents a TransUnion Credit Report.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type TuCreditReportIdentityProfile = {
  __typename?: 'TuCreditReportIdentityProfile';
  avgAgeOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The credit score percentile.
   * Example: `95`
   */
  creditScorePopulationRank?: Maybe<Scalars['Int']>;
  currentAddress?: Maybe<IdentityAddress>;
  employers?: Maybe<Array<Maybe<TuEmployer>>>;
  /**
   * Flag for when NW data validation calculations of summary data fields do not match TU values.
   * Example: `false`
   */
  hasReportErrors?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inquiries?: Maybe<Array<Maybe<TuInquiry>>>;
  inquiryDate?: Maybe<Scalars['Date']>;
  isStale?: Maybe<Scalars['Boolean']>;
  nextReportPullAt?: Maybe<Scalars['DateTime']>;
  numAccounts?: Maybe<Scalars['Int']>;
  numAccounts28Days?: Maybe<Scalars['Int']>;
  numAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numAutoLoanAccounts?: Maybe<Scalars['Int']>;
  numClosedAccounts?: Maybe<Scalars['Int']>;
  numClosedAccounts28Days?: Maybe<Scalars['Int']>;
  numClosedAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numCreditCardAccounts?: Maybe<Scalars['Int']>;
  numDelinquentAccounts?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts?: Maybe<Scalars['Int']>;
  numDerogatoryAccounts28Days?: Maybe<Scalars['Int']>;
  numDerogatoryAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numHelocAccounts?: Maybe<Scalars['Int']>;
  /**
   * The number of inquiries in the past 2 years.
   * Example: `6`
   */
  numInquiries?: Maybe<Scalars['Int']>;
  numInquiries28Days?: Maybe<Scalars['Int']>;
  numInquiriesDelta28Days?: Maybe<Scalars['Int']>;
  numMissedPayments?: Maybe<Scalars['Int']>;
  numMortgageAccounts?: Maybe<Scalars['Int']>;
  numOpenAccounts?: Maybe<Scalars['Int']>;
  numOpenAccounts28Days?: Maybe<Scalars['Int']>;
  /**
   * The delta between the two most recent `num_open_accounts` fields.
   * Example: `0`
   */
  numOpenAccountsDelta?: Maybe<Scalars['Int']>;
  numOpenAccountsDelta28Days?: Maybe<Scalars['Int']>;
  numOtherAccounts?: Maybe<Scalars['Int']>;
  numOtherLoanAccounts?: Maybe<Scalars['Int']>;
  numPersonalLoanAccounts?: Maybe<Scalars['Int']>;
  numPublicRecords?: Maybe<Scalars['Int']>;
  /**
   * The number of inquiries in the past 2 years.
   * Always the same as `numInquiries`
   * Example: `6`
   */
  numRecentInquiries?: Maybe<Scalars['Int']>;
  numStudentLoanAccounts?: Maybe<Scalars['Int']>;
  numUtilityAccounts?: Maybe<Scalars['Int']>;
  /**
   * A description of the average age of open credit.
   * Example: `FAIR`
   */
  nwAvgAgeOfCreditOpenBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Average age of open tradelines, in months, only for tradelines where open date can
   * be inferred (`date_opened_at_normalized`).
   * Example: `13.8`
   */
  nwAvgAgeOfCreditOpenMonths?: Maybe<Scalars['Float']>;
  nwAvgAgeOfCreditOpenMonths28Days?: Maybe<Scalars['Float']>;
  nwAvgAgeOfCreditOpenMonthsDelta28Days?: Maybe<Scalars['Float']>;
  /**
   * Count of tradelines with late pay status (1,2,3,4,5) in latest credit report,
   * for open derogatory tradelines (both open and closed).
   * Example: `4`
   */
  nwNumMissedPaymentsRecent?: Maybe<Scalars['Int']>;
  /**
   * A description of number of missed payments.
   * Example: `POOR`
   */
  nwNumMissedPaymentsRecentBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Count of tradelines with "current" or "unknown" pay status, for non-derogatory tradelines
   * (both open and closed).
   * Example: `5`
   */
  nwNumOntimeAccounts?: Maybe<Scalars['Int']>;
  nwNumOntimeAccounts28Days?: Maybe<Scalars['Int']>;
  nwNumOntimeAccountsDelta28Days?: Maybe<Scalars['Int']>;
  /**
   * Percent utilization based on open revolving tradelines and line of credit tradelines,
   * where credit limit can be inferred.
   * Example: `0.954`
   */
  nwPercentUtilization?: Maybe<Scalars['Float']>;
  nwPercentUtilization28Days?: Maybe<Scalars['Float']>;
  /**
   * A description of the percent utilization.
   * Example: `GOOD`
   */
  nwPercentUtilizationBucket?: Maybe<TuCreditFactorBucket>;
  nwPercentUtilizationDelta28Days?: Maybe<Scalars['Float']>;
  /**
   * Total balances for only open tradelines.
   * Example: `5400`
   */
  nwSumBalancesOpen?: Maybe<Scalars['Float']>;
  nwSumBalancesOpen28Days?: Maybe<Scalars['Float']>;
  nwSumBalancesOpenDelta28Days?: Maybe<Scalars['Float']>;
  /**
   * Total balances for credit utilization calculation, based on open tradelines
   * "revolving" or "line of credit" type, where normalized credit limit is available.
   * Example: `4000`
   */
  nwSumBalancesOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  /**
   * Total credit limit for credit utilization calculation, based on open tradelines
   * with "revolving" or "line of credit" type.
   * Example: `100000`
   */
  nwSumCreditLimitOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: Maybe<Scalars['Float']>;
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: Maybe<
    Scalars['Float']
  >;
  /**
   * The percentage of tradelines that have perfect payment history
   * Example: `0.8543`
   */
  percentOnTimePayments?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `percent_on_time_payments` fields.
   * Example: `0`
   */
  percentOnTimePaymentsDelta?: Maybe<Scalars['Float']>;
  percentUtilization?: Maybe<Scalars['Float']>;
  percentUtilizationDelta?: Maybe<Scalars['Float']>;
  publicRecords?: Maybe<Array<Maybe<TuPublicRecord>>>;
  /**
   * The timestamp that this credit report was pulled at.
   * Example: `2019-07-26T14:38:01.589307Z`
   */
  reportPulledAt?: Maybe<Scalars['DateTime']>;
  /**
   * The iterable timestamp the credit report was pulled at.
   * Example: `2017-01-31T09:09:21.162125Z`
   */
  reportPulledAtIterableDatetime?: Maybe<Scalars['DateTime']>;
  safetyCheckPassed?: Maybe<Scalars['Boolean']>;
  sumAgeOfCredit?: Maybe<Scalars['Float']>;
  /**
   * The delta between the two most recent `sum_age_of_credit` fields.
   * Example: `0`
   */
  sumAgeOfCreditDelta?: Maybe<Scalars['Float']>;
  sumAssetBackedDebtBalances?: Maybe<Scalars['Float']>;
  sumAutoLoanBalances?: Maybe<Scalars['Float']>;
  sumAvailableCredit?: Maybe<Scalars['Float']>;
  /**
   * Total balances for open and closed tradelines.
   * Example: `16577`
   */
  sumBalances?: Maybe<Scalars['Float']>;
  sumCreditCardBalances?: Maybe<Scalars['Float']>;
  sumCreditCardLimits?: Maybe<Scalars['Float']>;
  sumHelocBalances?: Maybe<Scalars['Float']>;
  sumMonthlyPayments?: Maybe<Scalars['Float']>;
  sumMortgageBalances?: Maybe<Scalars['Float']>;
  sumOtherBalances?: Maybe<Scalars['Float']>;
  sumOtherLoanBalances?: Maybe<Scalars['Float']>;
  sumPersonalLoanBalances?: Maybe<Scalars['Float']>;
  sumRevolvingDebtBalances?: Maybe<Scalars['Float']>;
  sumStudentLoanBalances?: Maybe<Scalars['Float']>;
  sumUtilityBalances?: Maybe<Scalars['Float']>;
  tradelines?: Maybe<Array<Maybe<TuTradeline>>>;
  /**
   * A user's numerical credit score.
   * Example value: `830`
   */
  vantageScore3?: Maybe<Scalars['Int']>;
  /**
   * The current credit score bin (a 10 point credit score range indexed
   * at the bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 7 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin7Days?: Maybe<Scalars['Int']>;
  /**
   * The credit score bin 28 days ago (a 10 point credit score range indexed at the
   * bottom of each range (e.g. 56 -> 560-569)).
   * Example: `82`
   */
  vantageScore3Bin28Days?: Maybe<Scalars['Int']>;
  /**
   * A word describing the user's credit bucket, based on their score.
   * Example value: `EXCELLENT`
   */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * A description of the directional change in the user's credit score since
   * the most recent prior credit score pull
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 7 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection7Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   * most recent prior credit score pull at least 28 days ago
   * Example value: `DECREASE`
   */
  vantageScore3ChangeDirection28Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent prior score
   * Example value: `-1`
   */
  vantageScore3Delta?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 7 days old
   * Example value: `-1`
   */
  vantageScore3Delta7Days?: Maybe<Scalars['Int']>;
  /**
   * The numerical change in a user's credit score between their current score and
   * their most recent score that is at least 28 days old
   * Example value: `-1`
   */
  vantageScore3Delta28Days?: Maybe<Scalars['Int']>;
  /**
   * The bucket in which a user's credit score delta is in
   * Example value: `NO_CHANGE`
   */
  vantageScore3DeltaBucket?: Maybe<TuVantageScore3DeltaBuckets>;
  /**
   * Credit score change since registration.
   * Example: `51`
   */
  vantageScore3DeltaSinceReg?: Maybe<Scalars['Int']>;
};

/**
 * Employer information used by TransUnion.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/employer.py
 */
export type TuEmployer = {
  __typename?: 'TuEmployer';
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateUpdatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
};

/**
 * A credit inquiry.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/inquiry.py
 */
export type TuInquiry = {
  __typename?: 'TuInquiry';
  bureau?: Maybe<Scalars['String']>;
  /**
   * The name of the Canonical Institution that corresponds to subscriberName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  inquiredAt?: Maybe<Scalars['DateTime']>;
  inquiryType?: Maybe<Scalars['String']>;
  subscriberName?: Maybe<Scalars['String']>;
};

/**
 * A public record.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/public_record.py
 */
export type TuPublicRecord = {
  __typename?: 'TuPublicRecord';
  bureau?: Maybe<Scalars['String']>;
  classification?: Maybe<Scalars['String']>;
  courtName?: Maybe<Scalars['String']>;
  filedAt?: Maybe<Scalars['DateTime']>;
  referenceNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  subscriberCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/**
 * A tradeline used by TU.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/tradeline.py
 */
export type TuTradeline = {
  __typename?: 'TuTradeline';
  accountCondition?: Maybe<Scalars['String']>;
  accountDesignator?: Maybe<Scalars['String']>;
  accountNumberHash?: Maybe<Scalars['String']>;
  accountNumberLast4?: Maybe<Scalars['String']>;
  accountSubtype?: Maybe<Scalars['String']>;
  accountSubtypeSymbol?: Maybe<Scalars['String']>;
  accountType?: Maybe<Scalars['String']>;
  accountTypeSymbol?: Maybe<Scalars['String']>;
  amountPastDue?: Maybe<Scalars['Float']>;
  bureau?: Maybe<Scalars['String']>;
  /**
   * The name of the Canonical Institution that corresponds to creditorName based on known tu_synonyms.
   * Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']>;
  collateral?: Maybe<Scalars['String']>;
  compositeKey?: Maybe<Scalars['String']>;
  creditLimit?: Maybe<Scalars['Float']>;
  creditType?: Maybe<Scalars['String']>;
  creditorName?: Maybe<Scalars['String']>;
  currentBalance?: Maybe<Scalars['Float']>;
  dateAccountStatus?: Maybe<Scalars['DateTime']>;
  dateClosedAt?: Maybe<Scalars['DateTime']>;
  dateOpenedAt?: Maybe<Scalars['DateTime']>;
  dateReportedAt?: Maybe<Scalars['DateTime']>;
  dateVerifiedAt?: Maybe<Scalars['DateTime']>;
  derogatoryTradelineReason?: Maybe<Scalars['String']>;
  disputeFlag?: Maybe<Scalars['String']>;
  highBalance?: Maybe<Scalars['Float']>;
  isIncludedInUtilization?: Maybe<Scalars['Boolean']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']>;
  late30Count?: Maybe<Scalars['Int']>;
  late60Count?: Maybe<Scalars['Int']>;
  late90Count?: Maybe<Scalars['Int']>;
  monthlyPayment?: Maybe<Scalars['Float']>;
  monthsReviewed?: Maybe<Scalars['Int']>;
  nwCreditLimitNormalized?: Maybe<Scalars['Float']>;
  nwDateOpenedAtNormalized?: Maybe<Scalars['DateTime']>;
  nwLastMissedPaymentDate?: Maybe<Scalars['DateTime']>;
  nwMonthsOpened?: Maybe<Scalars['Int']>;
  nwPayStatusBucket?: Maybe<Scalars['String']>;
  nwUtilizationPct?: Maybe<Scalars['Float']>;
  openClosed?: Maybe<TuTradelineOpenClosed>;
  openClosedSymbol?: Maybe<TuTradelineOpenClosedSymbol>;
  payHistoryBreakDown?: Maybe<Array<TuTradelinePayment>>;
  payHistoryStartDate?: Maybe<Scalars['DateTime']>;
  payHistoryStatus?: Maybe<Scalars['String']>;
  payStatus?: Maybe<Scalars['String']>;
  payStatusDescription?: Maybe<Scalars['String']>;
  payStatusSymbol?: Maybe<Scalars['String']>;
  paymentFrequency?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  subscriberCodeHash?: Maybe<Scalars['String']>;
  termMonths?: Maybe<Scalars['Int']>;
  worstPayStatus?: Maybe<Scalars['String']>;
  worstPayStatusCount?: Maybe<Scalars['Int']>;
  worstPayStatusSymbol?: Maybe<Scalars['String']>;
};

export const TuTradelineOpenClosed = {
  Closed: 'Closed',
  Open: 'Open',
} as const;

export type TuTradelineOpenClosed =
  (typeof TuTradelineOpenClosed)[keyof typeof TuTradelineOpenClosed];
export const TuTradelineOpenClosedSymbol = {
  C: 'C',
  O: 'O',
} as const;

export type TuTradelineOpenClosedSymbol =
  (typeof TuTradelineOpenClosedSymbol)[keyof typeof TuTradelineOpenClosedSymbol];
export type TuTradelinePayment = {
  __typename?: 'TuTradelinePayment';
  date: Scalars['String'];
  status: Scalars['String'];
};

export const TuVantageScore3Buckets = {
  Average: 'AVERAGE',
  Excellent: 'EXCELLENT',
  Good: 'GOOD',
  Poor: 'POOR',
} as const;

export type TuVantageScore3Buckets =
  (typeof TuVantageScore3Buckets)[keyof typeof TuVantageScore3Buckets];
export const TuVantageScore3ChangeDirections = {
  Decrease: 'DECREASE',
  Increase: 'INCREASE',
  Nochange: 'NOCHANGE',
} as const;

export type TuVantageScore3ChangeDirections =
  (typeof TuVantageScore3ChangeDirections)[keyof typeof TuVantageScore3ChangeDirections];
export const TuVantageScore3DeltaBuckets = {
  LargeDecrease: 'LARGE_DECREASE',
  LargeIncrease: 'LARGE_INCREASE',
  NoChange: 'NO_CHANGE',
  SmallDecrease: 'SMALL_DECREASE',
  SmallIncrease: 'SMALL_INCREASE',
} as const;

export type TuVantageScore3DeltaBuckets =
  (typeof TuVantageScore3DeltaBuckets)[keyof typeof TuVantageScore3DeltaBuckets];
/** Input Type for accepting URL params for a query */
export type UrlParamsInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type UndoBulkActionInput = {
  /** The operation ID of the bulk action to undo. */
  operationId: Scalars['ID'];
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']>;
};

export type UpdateFinancialAccountResponse = {
  __typename?: 'UpdateFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export type UpdateFinancialMerchantTransactionCategoryResponse = {
  __typename?: 'UpdateFinancialMerchantTransactionCategoryResponse';
  success: Scalars['Boolean'];
};

/** The expected input for the `updateIncome` mutation */
export type UpdateIncomeInput = {
  annualIncome?: InputMaybe<Scalars['Float']>;
  monthlyNetIncome?: InputMaybe<Scalars['Float']>;
};

export type UpdateIncomeResponse = {
  __typename?: 'UpdateIncomeResponse';
  annualIncome?: Maybe<Scalars['Float']>;
  monthlyNetIncome?: Maybe<Scalars['Float']>;
  success: Scalars['Boolean'];
};

/** The expected input for the `updateName` mutation */
export type UpdateNameInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type UpdateNameResponse = {
  __typename?: 'UpdateNameResponse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** The expected data shape of the updateNetWorthAccountVisibility mutation response */
export type UpdateNetWorthAccountVisibilityResponse = {
  __typename?: 'UpdateNetWorthAccountVisibilityResponse';
  account: NetWorthAccount;
};

/** Wraps the update net worth real API response, which allows for adding fields at a later date */
export type UpdateNetWorthRealAssetResponse = {
  __typename?: 'UpdateNetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

export type UpdatePasswordInfoInput = {
  /** The user's new password after the update */
  newPassword: Scalars['String'];
  /** The user's old password before the update */
  oldPassword: Scalars['String'];
};

/**
 * The expected payload for the `updateSubscriptionProfile` mutation,
 * should be synced with SubscriptionIdentityProfile.
 */
export type UpdateSubscriptionProfileInput = {
  emailCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  emailEnabled?: InputMaybe<Scalars['Boolean']>;
  emailMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
  emailPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  emailProgressUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  emailSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationCenterCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationCenterEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationCenterMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationCenterPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']>;
  notificationCenterSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']>;
  pushEnabled?: InputMaybe<Scalars['Boolean']>;
  pushMarketingUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  pushPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']>;
  pushProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']>;
  pushSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']>;
  pushTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserWalletCardInput = {
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']>;
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']>;
  /** The ID of the existing user's wallet card in the my cards service */
  userWalletCardId: Scalars['ID'];
};

export type UpdateUserWalletCardResponse = {
  __typename?: 'UpdateUserWalletCardResponse';
  card: UserWalletCard;
};

/** Response object that holds the user's updated weekly insights streak. */
export type UpdateWeeklyInsightsCurrentStreakResponse = {
  __typename?: 'UpdateWeeklyInsightsCurrentStreakResponse';
  updatedStreak: Scalars['Int'];
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecord = PostInterface &
  PostWithAuthorsInterface &
  PostWithContentClassificationInterface &
  PostWithEditorInterface &
  PostWithFaQsInterface &
  PostWithFeaturedImageInterface &
  PostWithReviewerInterface &
  PostWithSeoInterface &
  PostWithTitleInterface & {
    __typename?: 'UrlRecord';
    /** The assigning editor set on the content. */
    assigningEditor?: Maybe<Author>;
    /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
    attributionTopic?: Maybe<Scalars['String']>;
    /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
    attributionVertical?: Maybe<Scalars['String']>;
    /** The Authors for the resource. */
    authors?: Maybe<Array<Author>>;
    /** The Breadcrumb to display */
    breadcrumb?: Maybe<Breadcrumb>;
    /** A list of Category objects on the UrlRecord object. */
    categories?: Maybe<Array<Category>>;
    /** Additional content clusters for this piece of content. */
    contentClusters?: Maybe<Array<Scalars['String']>>;
    /** The custom last modified date for the content. */
    customLastModifiedDate?: Maybe<Scalars['DateTime']>;
    /** The DateTime the resource was published in UTC. */
    date?: Maybe<Scalars['String']>;
    /** The format to use when displaying the date. */
    dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
    /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
    dbId: Scalars['Int'];
    /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
    displayDate?: Maybe<Scalars['DateTime']>;
    /** The link to edit this resource in WordPress. */
    editLink?: Maybe<Scalars['URL']>;
    /** The faqs to display on this piece of content. */
    faqs?: Maybe<Array<ContentFaq>>;
    /** The featured image for the resource. */
    featuredMedia?: Maybe<MediaItem>;
    /** The funnel stage for a piece of content. */
    funnelStage?: Maybe<Scalars['String']>;
    /** Whether or not to hide the Author information from the header of this piece of content. */
    hideAuthor?: Maybe<Scalars['Boolean']>;
    /** Whether or not to hide the date for this piece of content. */
    hideDate?: Maybe<Scalars['Boolean']>;
    /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
    id: Scalars['ID'];
    /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
    isArchivesEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from being recommended to users. */
    isRecommendationEligible?: Maybe<Scalars['Boolean']>;
    /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
    isSearchEligible?: Maybe<Scalars['Boolean']>;
    /** The permalink of the resource. */
    link?: Maybe<Scalars['URL']>;
    /** The DateTime the resource was last modified in UTC. */
    modified?: Maybe<Scalars['String']>;
    /** Whether to override the last modified date for the content using one of the available options. */
    overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
    /** The page template selected for this piece of content. */
    pageTemplate?: Maybe<Scalars['String']>;
    /** The page type selected for the piece of content. */
    pageType?: Maybe<Scalars['String']>;
    /** The primary category object for the content. */
    primaryCategory?: Maybe<Category>;
    /** The primary content field for this URL record. */
    primaryContent?: Maybe<Scalars['StructuredContentDocument']>;
    /** The primary content cluster for this piece of content. */
    primaryContentCluster?: Maybe<Scalars['String']>;
    /** A date after which this content should no longer be recommended. */
    recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']>;
    /** The reviewers that this URL has been reviewed by. */
    reviewedBy?: Maybe<Array<ContentReviewer>>;
    /** Field connecting to the SeoSettings Type and all of its nested fields. */
    seo?: Maybe<SeoSettings>;
    /** Whether or not to display the FAQ's. */
    showFaqs?: Maybe<Scalars['Boolean']>;
    /** Whether or not to show the last modified date. */
    showLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** The uri slug for the resource. */
    slug?: Maybe<Scalars['String']>;
    /** The WordPress post_status for the resource. */
    status: Scalars['String'];
    /** The content to display below the title of a piece of content. */
    synopsis?: Maybe<Scalars['String']>;
    /** The editorial title of the resource. */
    title?: Maybe<Scalars['String']>;
    /** Other topics also associated with this piece of content. */
    topics?: Maybe<Array<Scalars['String']>>;
    /** The WordPress post_type for the resource. */
    type: Scalars['String'];
    /** The URL path to query for URL Records by. */
    url?: Maybe<Scalars['URL']>;
    /** Whether or not to use a custom last modified date for this piece of content. */
    useCustomLastModifiedDate?: Maybe<Scalars['Boolean']>;
    /** Other verticals also associated with this piece of content. */
    verticals?: Maybe<Array<Scalars['String']>>;
  };

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordDateArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordModifiedArgs = {
  format?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type UrlRecordConnectionResponse = {
  __typename?: 'UrlRecordConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean'];
  /** The UrlRecord returned for the connection. */
  items?: Maybe<Array<UrlRecord>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int'];
};

/** Query to fetch a collection of UrlRecord objects. */
export type UrlRecordFilterInput = {
  /** Limit collection to UrlRecords published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to UrlRecords within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']>>;
  /** Limit results to those with the specified cluster. */
  cluster?: InputMaybe<Scalars['String']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to UrlRecords with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Limit collection to UrlRecords with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']>;
};

/**
 * A UserAction is anything that the user might do in response to an insight.  At their simplest, they are just a raw
 * AppAction (e.g., a simple CTA that navigates to an L2), but can be augmented with additional context or even bespoke
 * data visualizations.
 */
export type UserAction = {
  __typename?: 'UserAction';
  /** The mechanical action to be performed in the app when the user engages with this UserAction */
  appAction: AppAction;
  /**
   * Language that describes the UserAction in detail.
   *
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  body?: Maybe<Scalars['String']>;
  /**
   * A human-readable identifier for a particular user action.  Primarily used for analytics.
   *
   * Example: credit-score-pay-off-account-early
   */
  slug?: Maybe<Scalars['String']>;
  /**
   * Language that summarizes or introduces the UserAction.
   *
   * This is *not* the CTA text -- that should be supplied in appAction.text
   */
  title?: Maybe<Scalars['String']>;
};

export type UserAddressInput = {
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  zipCode: Scalars['String'];
};

export const UserFinancialTransactionRuleType = {
  Category: 'CATEGORY',
  Hide: 'HIDE',
  Tag: 'TAG',
} as const;

export type UserFinancialTransactionRuleType =
  (typeof UserFinancialTransactionRuleType)[keyof typeof UserFinancialTransactionRuleType];
/**
 * UserInsightDataVisualizationInterface must be implemented by a concrete type that contains all the data necessary to
 * render a specific data visualization.
 */
export type UserInsightDataVisualizationInterface = {
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

/** UserInsightDataVisualizationTypeEnum represents all possible data visualizations that might appear with an insight */
export const UserInsightDataVisualizationTypeEnum = {
  /** A visualization of the user's potential score change */
  CreditBooster: 'CREDIT_BOOSTER',
  /** A visualization for credit score activation */
  CreditScoreActivation: 'CREDIT_SCORE_ACTIVATION',
  /** A visualization for financial account(s) activation */
  FinancialAccountsActivation: 'FINANCIAL_ACCOUNTS_ACTIVATION',
  /** A visualization for My Cards activation */
  MyCardsActivation: 'MY_CARDS_ACTIVATION',
  /**
   * A visualization of the user's total spending in the current month to date vs. their total spending as of the same
   * date in the previous month
   */
  SpendingByMonths: 'SPENDING_BY_MONTHS',
  /** A visualization of the user's spending in the current month, by the top categories */
  SpendingByTopCategories: 'SPENDING_BY_TOP_CATEGORIES',
  /** A visualization of the user's credit score change */
  WhyDidMyScoreChange: 'WHY_DID_MY_SCORE_CHANGE',
} as const;

export type UserInsightDataVisualizationTypeEnum =
  (typeof UserInsightDataVisualizationTypeEnum)[keyof typeof UserInsightDataVisualizationTypeEnum];
/** UserInsightEligibleModulesEnum represents all possible eligible modules */
export const UserInsightEligibleModulesEnum = {
  /** Indicates the insight is eligible for the cash flow UI&A module */
  CashFlow: 'CASH_FLOW',
  /** Indicates the insight is eligible for the credit booster module */
  CreditBooster: 'CREDIT_BOOSTER',
  /** Indicates the insight is eligible for the credit score UI&A module */
  CreditScore: 'CREDIT_SCORE',
  /** Indicates the insight is eligible for the credit score activation UI&A module */
  CreditScoreActivationHooks: 'CREDIT_SCORE_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the member home module */
  MemberHome: 'MEMBER_HOME',
  /** Indicates the insight is eligible for the member home activation UI&A module */
  MemberHomeActivationHooks: 'MEMBER_HOME_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the net worth UI&A module */
  NetWorth: 'NET_WORTH',
  /** Indicates the insight is eligible for the Moment of Delight module at the end of TU Activation */
  TuActivationComplete: 'TU_ACTIVATION_COMPLETE',
  /** Indicates the insight is eligible for the why did my score change module */
  WhyDidMyScoreChange: 'WHY_DID_MY_SCORE_CHANGE',
} as const;

export type UserInsightEligibleModulesEnum =
  (typeof UserInsightEligibleModulesEnum)[keyof typeof UserInsightEligibleModulesEnum];
/**
 * This field encapsulates the concept of an increase or gain to a user’s personal finances.
 *
 * This could range from credit score increases to an increase in savings or debt.
 */
export type UserInsightGain = {
  __typename?: 'UserInsightGain';
  /** Describes the gain impact */
  description: Scalars['String'];
  /** Represents the type of gain from this user insight */
  gainUnit: UserInsightGainUnitEnum;
  /** Represents the maximum gain from this user insight */
  maxGain: Scalars['Float'];
  /** Represents the minimum gain from this user insight */
  minGain: Scalars['Float'];
};

/**
 * "
 * UserInsightGainUnitEnum represents all possible gain units for user insights
 */
export const UserInsightGainUnitEnum = {
  /** Indicates the unit for gain is points */
  CreditScorePoints: 'CREDIT_SCORE_POINTS',
} as const;

export type UserInsightGainUnitEnum =
  (typeof UserInsightGainUnitEnum)[keyof typeof UserInsightGainUnitEnum];
/** A UserInsightImage is an image associated with a user insight. Used to add further detail or exemplify the insight itself. */
export type UserInsightImage = {
  __typename?: 'UserInsightImage';
  /** The link to the image. */
  imageUri: Scalars['String'];
  /** A descriptive title for the image. */
  label?: Maybe<Scalars['String']>;
};

export const UserInsightImageTreatmentTypeEnum = {
  Cautionary: 'CAUTIONARY',
  Congratulatory: 'CONGRATULATORY',
  Informational: 'INFORMATIONAL',
  None: 'NONE',
} as const;

export type UserInsightImageTreatmentTypeEnum =
  (typeof UserInsightImageTreatmentTypeEnum)[keyof typeof UserInsightImageTreatmentTypeEnum];
/**
 * A "user insight" is something noteworthy or interesting that NerdWallet has identified about the user.
 *
 * Examples include:
 * - Your credit score changed this week -- here's why
 * - How your cash flow compares to the same day last month
 * - Your monthly spending breakdown by category
 * - You have too much money in your checking account -- consider moving some to a high-yield savings account
 *
 * There are several insight inventory sources, each with a bespoke data model.  This interface represents the fields
 * that are common across each inventory source.
 */
export type UserInsightInterface = {
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   * This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   * Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   * be inferred by source-specific heuristics.
   *
   * Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID'];
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   * Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * impact)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   * Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   * insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   * treatment (e.g. red vs. yellow vs. blue accent color).
   *
   * Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   * the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   * Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   * Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   * urgency)
   *
   * For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   * low-urgency.
   */
  urgency?: Maybe<Scalars['Float']>;
};

/** UserInsightInventorySourceEnum represents all possible sources of truth for user insights. */
export const UserInsightInventorySourceEnum = {
  /**
   * Some insights are derived on-demand by credit-service; specifically, an activation UI&A for user's who have not
   * yet linked TU
   */
  CreditService: 'CREDIT_SERVICE',
  /**
   * Some insights are generated on-demand by financial-insights service. Note that the inventory source for such insights
   * is financial-insights service, not FDP which is where the data that determines the UI&A is derived
   */
  FinancialInsightsService: 'FINANCIAL_INSIGHTS_SERVICE',
  /** Some insights are generated on-demand by my-cards-service */
  MyCardsService: 'MY_CARDS_SERVICE',
  /**
   * Some insights are generated on-demand by recommendation-service.  Note that the inventory source for such insights
   * is recommendation-service, not the intermediary orchestration layer through which they were retrieved (e.g.
   * Factory)
   */
  RecommendationService: 'RECOMMENDATION_SERVICE',
} as const;

export type UserInsightInventorySourceEnum =
  (typeof UserInsightInventorySourceEnum)[keyof typeof UserInsightInventorySourceEnum];
/** The personalized ranking score that was used to rank this insight. */
export type UserInsightPersonalizedRankingScore = {
  __typename?: 'UserInsightPersonalizedRankingScore';
  /**
   * The model execution IDs that were involved in producing the user's personalized ranking score for this insight.
   * These should all be included in analytics events for this insight.
   *
   * Includes:
   * - A model execution ID that indicates which ML model produced this ranking score
   * - A model execution ID that indicates which _variant_ of the ML model produced this ranking score
   */
  modelExecutionIds: Array<Scalars['String']>;
  /**
   * A measure of how compelling this particular insight is to this particular user.  Used as an input into ranking
   * decisions.  Takes a value from 0 to 1.
   */
  score: Scalars['Float'];
};

/**
 * "
 * UserInsightPlatformEnum represents clients that display user insights
 */
export const UserInsightPlatformEnum = {
  Native: 'NATIVE',
  Web: 'WEB',
} as const;

export type UserInsightPlatformEnum =
  (typeof UserInsightPlatformEnum)[keyof typeof UserInsightPlatformEnum];
/** The specific insight's regeneration group */
export const UserInsightRegenerationGroupEnum = {
  /** Credit booster regeneration group (includes WDMSC) */
  CreditBooster: 'CREDIT_BOOSTER',
  /** Credit report regeneration group */
  CreditReport: 'CREDIT_REPORT',
  /** Credit score activation regeneration group */
  CreditScoreActivation: 'CREDIT_SCORE_ACTIVATION',
  /** My bills regeneration group */
  MyBills: 'MY_BILLS',
  /** My cards activation regeneration group */
  MyCardsActivation: 'MY_CARDS_ACTIVATION',
  /** Net worth activation regeneration group */
  NetWorthActivation: 'NET_WORTH_ACTIVATION',
  /** Optimize regeneration group */
  Optimize: 'OPTIMIZE',
  /** Spending regeneration group */
  Spending: 'SPENDING',
} as const;

export type UserInsightRegenerationGroupEnum =
  (typeof UserInsightRegenerationGroupEnum)[keyof typeof UserInsightRegenerationGroupEnum];
/**
 * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
 * treatment (e.g. red vs. yellow vs. blue accent color).
 */
export const UserInsightSentimentEnum = {
  /**
   * Indicates that the insight is potentially (but not necessarily) harmful for the user (e.g., a hard credit pull or
   * detection of a large transaction)
   */
  Cautionary: 'CAUTIONARY',
  /** Indicates that the insight is neither inherently beneficial nor cautionary */
  Neutral: 'NEUTRAL',
  /** Indicates that the insight is beneficial for the user (e.g., their paycheck was deposited) */
  Positive: 'POSITIVE',
} as const;

export type UserInsightSentimentEnum =
  (typeof UserInsightSentimentEnum)[keyof typeof UserInsightSentimentEnum];
/** A non-actionable suggestion related to a UserInsight */
export type UserInsightTip = {
  __typename?: 'UserInsightTip';
  /** Language that describes the tip in detail */
  description: Scalars['String'];
  /** The label under which the tip appears (e.g. "Nerdy Tip") */
  label?: Maybe<Scalars['String']>;
};

export type UserInsightsFilterInput = {
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  eligibleModules?: InputMaybe<Array<UserInsightEligibleModulesEnum>>;
  /** If specified, exclude insights with matching slugs */
  ineligibleInsightSlugs?: InputMaybe<Array<Scalars['String']>>;
  /** If specified, only include insights at or below this level of urgency.  Ranges from 0 to 1. */
  maxUrgency?: InputMaybe<Scalars['Float']>;
  /** If specified, only include insights at or above this level of urgency.  Ranges from 0 to 1. */
  minUrgency?: InputMaybe<Scalars['Float']>;
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  relatedFeatures?: InputMaybe<Array<MembershipFeatureEnum>>;
};

export type UserInsightsResponse = {
  __typename?: 'UserInsightsResponse';
  userInsights: Array<UserInsightInterface>;
};

export type UserNameInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleInitial?: InputMaybe<Scalars['String']>;
};

/** This type holds the individual subscription preference selections. */
export type UserOpsCommsSubscriptionPreferences = {
  __typename?: 'UserOpsCommsSubscriptionPreferences';
  /** Is the emailCreditMonitoringEnabled message type enabled */
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the email channel enabled */
  emailEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailMarketingEnabled message type enabled */
  emailMarketingEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailPersonalizedContentEnabled message type enabled */
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailSpendingAlertsEnabled message type enabled */
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the emailTransactionalMarketingEnabled message type enabled */
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the notificationCenterCreditMonitoringEnabled message type enabled */
  notificationCenterCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the Notification Center channel enabled */
  notificationCenterEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the notificationCenterMarketingEnabled message type enabled */
  notificationCenterMarketingEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the notificationCenterPersonalizedContentEnabled message type enabled */
  notificationCenterPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the notificationCenterSpendingAlertsEnabled message type enabled */
  notificationCenterSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushCreditMonitoringEnabled message type enabled */
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the push channel enabled */
  pushEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushMarketingUpdatesEnabled message type enabled */
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushPersonalizedContentEnabled message type enabled */
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushSpendingAlertsEnabled message type enabled */
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']>;
  /** Is the pushTransactionalMarketingEnabled message type enabled */
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']>;
};

/** This type wraps the users subscription preferences and also includes metadata about the preferences. */
export type UserOpsCommsSubscriptionPreferencesWrapper = {
  __typename?: 'UserOpsCommsSubscriptionPreferencesWrapper';
  /** Event ID associated with this snapshot of subscription preferences. Useful for looking up in Snowflake. */
  eventId: Scalars['ID'];
  /** List of subscription preferences sorted in descending order. */
  subscriptionPreferences: UserOpsCommsSubscriptionPreferences;
  /** Timestamp associated with this snapshot of subscription preferences. */
  timestamp: Scalars['DateTime'];
};

/** The shape of each messaging activity event */
export type UserOpsMessagingActivityEvent = {
  __typename?: 'UserOpsMessagingActivityEvent';
  /** Action that the user took on this message, could be opened, delivered, bounced, or spam report */
  action: Scalars['String'];
  /** Blueshift campaign uuid associated with this message */
  campaignUuid: Scalars['ID'];
  /** Either push-message or email, cannot use enum because of hyphen */
  channel: Scalars['String'];
  /** Event ID associated with this messaging event, useful for Snowflake lookup */
  eventId: Scalars['ID'];
  /** Subject line of the message if applicable */
  subjectLine?: Maybe<Scalars['String']>;
  /** Timestamp associated with this messaging event. */
  timestamp: Scalars['DateTime'];
};

/** This type holds a subset of fields from the portal_activity_occurred event that is relevant for User Ops. */
export type UserOpsPaoEventDetails = {
  __typename?: 'UserOpsPAOEventDetails';
  /** The activity type that happened (such as linking_process_error). */
  activityType?: Maybe<Scalars['String']>;
  /** Authentication state of the portal. */
  authState?: Maybe<FinancialPortalAuthState>;
  /** When this event occurred */
  eventOccurredAt: Scalars['DateTime'];
  /** app-schemata definition: The raw error payload from FDP Proxy. */
  fdpPrimaryErrorBlob?: Maybe<UserOpsPaoEventDetailsError>;
  /** app-schemata definition: The associated Plaid event_name. */
  plaidEventName?: Maybe<Scalars['String']>;
  /** app-schemata definition: Plaid's link_session_idZ. */
  plaidLinkSessionId?: Maybe<Scalars['ID']>;
  /** app-schemata definition: Plaid's request_id. */
  plaidRequestId?: Maybe<Scalars['String']>;
  /** ID of the portal for which this event was fired */
  portalId?: Maybe<Scalars['ID']>;
  /**
   * app-schemata definition: The identifier of the institution as defined in the underlying source,
   * i.e. plaid_id or yodlee_id.
   */
  sourceInstitutionId?: Maybe<Scalars['String']>;
};

/** This type represents the error blob inside the portal_activity_occurred event. */
export type UserOpsPaoEventDetailsError = {
  __typename?: 'UserOpsPAOEventDetailsError';
  /** The error code from Plaid. */
  errorCode?: Maybe<Scalars['String']>;
  /** The error message from Plaid. */
  errorMessage?: Maybe<Scalars['String']>;
  /** The error type from Plaid. */
  errorType?: Maybe<Scalars['String']>;
};

export type UserPageVideo = {
  __typename?: 'UserPageVideo';
  /** Featured video length for this User Page. */
  length?: Maybe<Scalars['String']>;
  /** Featured video synopsis for this User Page. */
  synopsis?: Maybe<Scalars['String']>;
  /** Featured video title for this User Page. */
  title?: Maybe<Scalars['String']>;
  /** Featured video Youtube URL for this User Page. */
  url?: Maybe<Scalars['URL']>;
};

export type UserReportedCreditCardInput = {
  cardId: Scalars['Int'];
  cardName: Scalars['String'];
};

export type UserReportedCreditCardsResult = {
  __typename?: 'UserReportedCreditCardsResult';
  /** User self-reported list of credit cards */
  cards?: Maybe<Array<RewardsCreditCard>>;
};

/**
 * The `UserReportedFinancialAccount` type represents a financial
 * account queried as part of the Financial Identity Profile
 */
export type UserReportedFinancialAccount = {
  __typename?: 'UserReportedFinancialAccount';
  ccExtraData?: Maybe<Scalars['JSON']>;
  createdBy?: Maybe<Scalars['String']>;
  currentValue?: Maybe<Scalars['Float']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  institutionFk?: Maybe<Scalars['String']>;
  marketplaceFk?: Maybe<Scalars['String']>;
  transunionFk?: Maybe<Scalars['String']>;
  tuTradelineCompositeKey?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  yodleeFk?: Maybe<Scalars['String']>;
};

export type UserWalletCard = {
  __typename?: 'UserWalletCard';
  /** The FDP financial account associated with the user's wallet card */
  financialAccount?: Maybe<FinancialAccount>;
  /** The ID of the user's wallet card in the my cards service */
  id: Scalars['ID'];
  /** The credit card offer associated with the user's wallet card */
  offer?: Maybe<CreditCardsOfferV2>;
};

export type UserWalletCardsResponse = {
  __typename?: 'UserWalletCardsResponse';
  cards: Array<Maybe<UserWalletCard>>;
};

export type Variant = {
  __typename?: 'Variant';
  customData?: Maybe<Scalars['JSON']>;
  variantId: Scalars['String'];
  variantName: Scalars['String'];
};

export type VehiclePremiumByYear = {
  __typename?: 'VehiclePremiumByYear';
  /** The average annual premium */
  averagePremium: Scalars['Float'];
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']>;
};

export type VehicleYearCheapestPremiums = {
  __typename?: 'VehicleYearCheapestPremiums';
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']>;
  /** Array of cheapest companies and annual premiums for this model year */
  offers?: Maybe<Array<AutoInsuranceCarrier>>;
};

export type VideoThumbnail = {
  __typename?: 'VideoThumbnail';
  /** The image's height. */
  height: Scalars['Int'];
  /** The image's URL. */
  url: Scalars['String'];
  /** The image's width. */
  width: Scalars['Int'];
};

export type WealthRecommenderUser = {
  __typename?: 'WealthRecommenderUser';
  /** User-defined amount for how much to keep in their checking account */
  checkingTargetBalance?: Maybe<Scalars['Float']>;
  /** ID for wealth-recommender user */
  id: Scalars['ID'];
  /**
   * Whether the user has dismissed notification about saving too much money
   * before paying off debt
   */
  isDebtWarningDismissed: Scalars['Boolean'];
  /**
   * NW-defined amount that the user should maintain in their checking account
   * (1.5x average monthly spend)
   */
  recommendedChecking?: Maybe<Scalars['Float']>;
  /**
   * NW-defined amount that the user should maintain in their savings account.
   * (3x average monthly spend)
   */
  recommendedSavings?: Maybe<Scalars['Float']>;
  /** User-defined amount for how much to keep in their savings account */
  savingsTargetBalance?: Maybe<Scalars['Float']>;
};

export type WebFeatureDiscoveryDetails = {
  __typename?: 'WebFeatureDiscoveryDetails';
  copy: Scalars['String'];
  destinationUrl: Scalars['String'];
  featureName: Scalars['String'];
  featuredImageUrl: Scalars['URL'];
  title?: Maybe<Scalars['String']>;
};

/**
 * Response object that holds the user's current weekly insights streak and a boolean value that determines whether
 * the user has already completed the current week's weekly insights.
 */
export type WeeklyInsightsCurrentStreakResponse = {
  __typename?: 'WeeklyInsightsCurrentStreakResponse';
  currentBadgeUrl: Scalars['URL'];
  currentStreak: Scalars['Int'];
  endCurrentWeek: Scalars['DateTime'];
  hasCompletedCurrentWeek: Scalars['Boolean'];
  nextBadgeUrl: Scalars['URL'];
  startCurrentWeek: Scalars['DateTime'];
};

export type WhyDidMyScoreChangeDataVisualization =
  UserInsightDataVisualizationInterface & {
    __typename?: 'WhyDidMyScoreChangeDataVisualization';
    /** User's current credit score info */
    creditScoreChangeInfo: CreditScoreChangeInfo;
    /** This will always be WHY_DID_MY_SCORE_CHANGE */
    dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  };

/** The input type representing the Yak message to be published */
export type YakMessageInput = {
  /**
   * The Yak exchange to which the message should be delivered. Supplied on the message envelope.
   *
   * Example: `ANALYTIC_PIPELINE_MOUTH`
   */
  exchangeId: Scalars['String'];
  /** A GUID (UUID) for this specific message. Supplied on the message envelope. */
  id?: InputMaybe<Scalars['String']>;
  /** The Yak message payload. */
  payload?: InputMaybe<Scalars['JSON']>;
  /** The Yak message subtype. Supplied on the message envelope. */
  subType?: InputMaybe<Scalars['String']>;
  /**
   * The Yak message type. Supplied on the message envelope.
   *
   * Example: `navigate` (for a navigation analytics event)
   */
  type?: InputMaybe<Scalars['String']>;
};

export type YoutubePlayerDetails = {
  __typename?: 'YoutubePlayerDetails';
  /** The height of the embedded player returned in the player.embedHtml property. This property is only returned if the request specified a value for the maxHeight and/or maxWidth parameters and the video's aspect ratio is known. */
  embedHeight?: Maybe<Scalars['BigInt']>;
  /** An <iframe> tag that embeds a player that plays the video. */
  embedHtml: Scalars['String'];
  /** The width of the embedded player returned in the player.embedHtml property. This property is only returned if the request specified a value for the maxHeight and/or maxWidth parameters and the video's aspect ratio is known. */
  embedWidth?: Maybe<Scalars['BigInt']>;
};

export type YoutubeSnippetObject = {
  __typename?: 'YoutubeSnippetObject';
  /** The ID that YouTube uses to uniquely identify the channel that the video was uploaded to. */
  channelId: Scalars['String'];
  /** Channel title for the channel that the video belongs to. */
  channelTitle: Scalars['String'];
  /** The video's description. The property value has a maximum length of 5000 bytes and may contain all valid UTF-8 characters except < and >. */
  description: Scalars['String'];
  /** The date and time that the video was published. Note that this time might be different than the time that the video was uploaded. */
  publishedAt: Scalars['String'];
  /** A map of thumbnail images associated with the video. */
  thumbnails?: Maybe<YoutubeThumbnail>;
  /** The video's title. The property value has a maximum length of 100 characters and may contain all valid UTF-8 characters except < and > */
  title: Scalars['String'];
};

export type YoutubeThumbnail = {
  __typename?: 'YoutubeThumbnail';
  /** The default thumbnail image. */
  default?: Maybe<VideoThumbnail>;
  /** A high resolution version of the thumbnail image. For a video (or a resource that refers to a video), this image is 480px wide and 360px tall. */
  high?: Maybe<VideoThumbnail>;
  /** The highest resolution version of the thumbnail image. This image size is available for some videos and other resources that refer to videos, like playlist items or search results. */
  maxres?: Maybe<VideoThumbnail>;
  /** A higher resolution version of the thumbnail image. For a video (or a resource that refers to a video), this image is 320px wide and 180px tall. */
  medium?: Maybe<VideoThumbnail>;
  /** An even higher resolution version of the thumbnail image than the high resolution image. This image is available for some videos and other resources that refer to videos, like playlist items or search results */
  standard?: Maybe<VideoThumbnail>;
};

export type YoutubeVideo = {
  __typename?: 'YoutubeVideo';
  /** The contentDetails object contains information about the video content, including the length of the video and an indication of whether captions are available for the video */
  contentDetails?: Maybe<YoutubeVideoContentDetails>;
  /** Unique ID of a Youtube Video */
  id: Scalars['ID'];
  /** API resource's type */
  kind: Scalars['String'];
  /** The player object contains information that you would use to play the video in an embedded player. */
  player?: Maybe<YoutubePlayerDetails>;
  /** The snippet object contains basic details about the video, such as its title, description, and category */
  snippet?: Maybe<YoutubeSnippetObject>;
};

export type YoutubeVideoContentDetails = {
  __typename?: 'YoutubeVideoContentDetails';
  /** The length of the video. The property value is an ISO 8601 duration. */
  duration: Scalars['String'];
};

/** Format of response to autoInsurancePrequalOffers query */
export type AutoInsurancePrequalOffersResponse = {
  __typename?: 'autoInsurancePrequalOffersResponse';
  offers?: Maybe<Array<Maybe<AutoInsurancePrequalOffer>>>;
  status?: Maybe<PrequalOfferStatus>;
};

export type UserBestCreditCardRecommendations = {
  __typename?: 'userBestCreditCardRecommendations';
  recommendations: Array<BccPageCard>;
};

export type UserBestCreditCardRecommendationsInput = {
  limit?: InputMaybe<Scalars['Int']>;
  pageId?: InputMaybe<Scalars['String']>;
};

export type GreenhouseDepartmentsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GreenhouseDepartmentsQuery = {
  __typename?: 'Query';
  greenhouseDepartments?: Array<{
    __typename?: 'GreenhouseDepartment';
    id: string;
    name: string;
    jobs?: Array<{ __typename?: 'GreenhouseJob'; id: string }> | null;
  }> | null;
};

export type EngBlogPostsQueryVariables = Exact<{ [key: string]: never }>;

export type EngBlogPostsQuery = {
  __typename?: 'Query';
  engineeringPosts?: {
    __typename?: 'EngineeringPostConnectionResponse';
    items?: Array<{
      __typename?: 'EngineeringPost';
      id: string;
      link?: any | null;
      title?: string | null;
      featuredMedia?: {
        __typename?: 'MediaItem';
        sourceUrl?: any | null;
      } | null;
    }> | null;
  } | null;
};

export type PressReleasesQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
}>;

export type PressReleasesQuery = {
  __typename?: 'Query';
  pressReleases?: {
    __typename?: 'PressReleaseConnectionResponse';
    hasNextPage: boolean;
    total: number;
    currentOffset: number;
    items?: Array<{
      __typename?: 'PressRelease';
      url?: any | null;
      title?: string | null;
      date?: string | null;
      mediaSites?: Array<{
        __typename?: 'MediaSite';
        name?: string | null;
      }> | null;
    }> | null;
  } | null;
};

export type FilteredPressReleasesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FilteredPressReleasesQuery = {
  __typename?: 'Query';
  pressReleases?: {
    __typename?: 'PressReleaseConnectionResponse';
    items?: Array<{
      __typename?: 'PressRelease';
      url?: any | null;
      title?: string | null;
      content?: any | null;
      featuredMedia?: {
        __typename?: 'MediaItem';
        sourceUrl?: any | null;
      } | null;
      mediaSites?: Array<{
        __typename?: 'MediaSite';
        logo?: {
          __typename?: 'MediaItem';
          croppedImages?: Array<{
            __typename?: 'CroppedImageSize';
            sourceUrl?: any | null;
          }> | null;
        } | null;
      }> | null;
    }> | null;
  } | null;
};

export type NewsArticlesQueryVariables = Exact<{
  identifier: Scalars['ID'];
  exclude?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;

export type NewsArticlesQuery = {
  __typename?: 'Query';
  article?: {
    __typename?: 'Article';
    id: string;
    link?: any | null;
    title?: string | null;
    timeToRead?: {
      minutes?: number | null;
      seconds?: number | null;
    } | null;
    date?: string | null;
    modified?: string | null;
    featuredMedia?: {
      __typename?: 'MediaItem';
      sourceUrl?: any | null;
      mediaDetails?: {
        __typename?: 'MediaDetails';
        height?: number | null;
        width?: number | null;
        srcSet?: string | null;
      } | null;
    } | null;
    authors?: Array<{
      __typename?: 'Author';
      name?: string | null;
      link?: any | null;
      avatarUrls?: Array<{
        __typename?: 'AuthorAvatarUrl';
        url?: any | null;
      }> | null;
    }> | null;
  } | null;
  articles?: {
    __typename?: 'ArticleConnectionResponse';
    items?: Array<{
      __typename?: 'Article';
      id: string;
      link?: any | null;
      title?: string | null;
      timeToRead?: {
        minutes?: number | null;
        seconds?: number | null;
      } | null;
      date?: string | null;
      authors?: Array<{
        __typename?: 'Author';
        name?: string | null;
        link?: any | null;
        avatarUrls?: Array<{
          __typename?: 'AuthorAvatarUrl';
          url?: any | null;
        }> | null;
      }> | null;
    }> | null;
  } | null;
};

export type ArticleDetailsFragment = {
  __typename?: 'Article';
  id: string;
  link?: any | null;
  title?: string | null;
  authors?: Array<{
    __typename?: 'Author';
    name?: string | null;
    link?: any | null;
    avatarUrls?: Array<{
      __typename?: 'AuthorAvatarUrl';
      url?: any | null;
    }> | null;
  }> | null;
};

export type GreehhouseDepartmentQueryVariables = Exact<{
  kebabName: Scalars['String'];
}>;

export type GreehhouseDepartmentQuery = {
  __typename?: 'Query';
  greenhouseDepartment?: {
    __typename?: 'GreenhouseDepartment';
    name: string;
    id: string;
    jobs?: Array<{
      __typename?: 'GreenhouseJob';
      id: string;
      title: string;
      location?: string | null;
    }> | null;
  } | null;
};

export type GreehhouseJobQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type GreehhouseJobQuery = {
  __typename?: 'Query';
  greenhouseJob?: {
    __typename?: 'GreenhouseJob';
    id: string;
    title: string;
    location?: string | null;
    content?: string | null;
    department?: {
      __typename?: 'GreenhouseDepartment';
      id: string;
      name: string;
    } | null;
  } | null;
};

export const ArticleDetailsFragmentDoc = gql`
  fragment ArticleDetails on Article {
    id
    link
    title
    timeToRead {
      minutes
      seconds
    }
    date
    modified
    authors {
      name
      link
      avatarUrls(sizes: [SIZE_48]) {
        url
      }
    }
  }
`;
export const GreenhouseDepartmentsDocument = gql`
  query GreenhouseDepartments {
    greenhouseDepartments {
      id
      name
      jobs {
        id
      }
    }
  }
`;

/**
 * __useGreenhouseDepartmentsQuery__
 *
 * To run a query within a React component, call `useGreenhouseDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreenhouseDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreenhouseDepartmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGreenhouseDepartmentsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GreenhouseDepartmentsQuery,
    GreenhouseDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GreenhouseDepartmentsQuery,
    GreenhouseDepartmentsQueryVariables
  >(GreenhouseDepartmentsDocument, options);
}
export function useGreenhouseDepartmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GreenhouseDepartmentsQuery,
    GreenhouseDepartmentsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GreenhouseDepartmentsQuery,
    GreenhouseDepartmentsQueryVariables
  >(GreenhouseDepartmentsDocument, options);
}
export type GreenhouseDepartmentsQueryHookResult = ReturnType<
  typeof useGreenhouseDepartmentsQuery
>;
export type GreenhouseDepartmentsLazyQueryHookResult = ReturnType<
  typeof useGreenhouseDepartmentsLazyQuery
>;
export type GreenhouseDepartmentsQueryResult = Apollo.QueryResult<
  GreenhouseDepartmentsQuery,
  GreenhouseDepartmentsQueryVariables
>;
export const EngBlogPostsDocument = gql`
  query engBlogPosts {
    engineeringPosts(
      order: { field: DATE, sortDirection: DESC }
      pagination: { limit: 6 }
    ) {
      items {
        id
        link
        title
        featuredMedia {
          sourceUrl
        }
      }
    }
  }
`;

/**
 * __useEngBlogPostsQuery__
 *
 * To run a query within a React component, call `useEngBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEngBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEngBlogPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useEngBlogPostsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    EngBlogPostsQuery,
    EngBlogPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<EngBlogPostsQuery, EngBlogPostsQueryVariables>(
    EngBlogPostsDocument,
    options,
  );
}
export function useEngBlogPostsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    EngBlogPostsQuery,
    EngBlogPostsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<EngBlogPostsQuery, EngBlogPostsQueryVariables>(
    EngBlogPostsDocument,
    options,
  );
}
export type EngBlogPostsQueryHookResult = ReturnType<
  typeof useEngBlogPostsQuery
>;
export type EngBlogPostsLazyQueryHookResult = ReturnType<
  typeof useEngBlogPostsLazyQuery
>;
export type EngBlogPostsQueryResult = Apollo.QueryResult<
  EngBlogPostsQuery,
  EngBlogPostsQueryVariables
>;
export const PressReleasesDocument = gql`
  query pressReleases($offset: Int, $limit: Int) {
    pressReleases(
      pagination: { limit: $limit, offset: $offset }
      order: { field: DATE, sortDirection: DESC }
    ) {
      hasNextPage
      total
      currentOffset
      items {
        url
        title
        date
        mediaSites {
          name
        }
      }
    }
  }
`;

/**
 * __usePressReleasesQuery__
 *
 * To run a query within a React component, call `usePressReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePressReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePressReleasesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePressReleasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    PressReleasesQuery,
    PressReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PressReleasesQuery, PressReleasesQueryVariables>(
    PressReleasesDocument,
    options,
  );
}
export function usePressReleasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PressReleasesQuery,
    PressReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PressReleasesQuery, PressReleasesQueryVariables>(
    PressReleasesDocument,
    options,
  );
}
export type PressReleasesQueryHookResult = ReturnType<
  typeof usePressReleasesQuery
>;
export type PressReleasesLazyQueryHookResult = ReturnType<
  typeof usePressReleasesLazyQuery
>;
export type PressReleasesQueryResult = Apollo.QueryResult<
  PressReleasesQuery,
  PressReleasesQueryVariables
>;
export const FilteredPressReleasesDocument = gql`
  query filteredPressReleases {
    pressReleases(
      filter: { featured: true }
      pagination: { limit: 4 }
      order: { field: DATE, sortDirection: DESC }
    ) {
      items {
        featuredMedia {
          sourceUrl
        }
        url
        title
        content
        mediaSites {
          logo {
            croppedImages(sizes: [FULL]) {
              sourceUrl
            }
          }
        }
      }
    }
  }
`;

/**
 * __useFilteredPressReleasesQuery__
 *
 * To run a query within a React component, call `useFilteredPressReleasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFilteredPressReleasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFilteredPressReleasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFilteredPressReleasesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    FilteredPressReleasesQuery,
    FilteredPressReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    FilteredPressReleasesQuery,
    FilteredPressReleasesQueryVariables
  >(FilteredPressReleasesDocument, options);
}
export function useFilteredPressReleasesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    FilteredPressReleasesQuery,
    FilteredPressReleasesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    FilteredPressReleasesQuery,
    FilteredPressReleasesQueryVariables
  >(FilteredPressReleasesDocument, options);
}
export type FilteredPressReleasesQueryHookResult = ReturnType<
  typeof useFilteredPressReleasesQuery
>;
export type FilteredPressReleasesLazyQueryHookResult = ReturnType<
  typeof useFilteredPressReleasesLazyQuery
>;
export type FilteredPressReleasesQueryResult = Apollo.QueryResult<
  FilteredPressReleasesQuery,
  FilteredPressReleasesQueryVariables
>;
export const NewsArticlesDocument = gql`
  query newsArticles($identifier: ID!, $exclude: [Int!]) {
    article(input: { identifier: $identifier }) {
      ...ArticleDetails
      featuredMedia {
        sourceUrl
        mediaDetails {
          height
          width
          srcSet
        }
      }
    }
    articles(
      order: { field: DATE, sortDirection: DESC }
      pagination: { limit: 4 }
      filter: { contentTags: "news", ids: { exclude: $exclude } }
    ) {
      items {
        ...ArticleDetails
      }
    }
  }
  ${ArticleDetailsFragmentDoc}
`;

/**
 * __useNewsArticlesQuery__
 *
 * To run a query within a React component, call `useNewsArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsArticlesQuery({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      exclude: // value for 'exclude'
 *   },
 * });
 */
export function useNewsArticlesQuery(
  baseOptions: Apollo.QueryHookOptions<
    NewsArticlesQuery,
    NewsArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<NewsArticlesQuery, NewsArticlesQueryVariables>(
    NewsArticlesDocument,
    options,
  );
}
export function useNewsArticlesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NewsArticlesQuery,
    NewsArticlesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<NewsArticlesQuery, NewsArticlesQueryVariables>(
    NewsArticlesDocument,
    options,
  );
}
export type NewsArticlesQueryHookResult = ReturnType<
  typeof useNewsArticlesQuery
>;
export type NewsArticlesLazyQueryHookResult = ReturnType<
  typeof useNewsArticlesLazyQuery
>;
export type NewsArticlesQueryResult = Apollo.QueryResult<
  NewsArticlesQuery,
  NewsArticlesQueryVariables
>;
export const GreehhouseDepartmentDocument = gql`
  query GreehhouseDepartment($kebabName: String!) {
    greenhouseDepartment(kebabName: $kebabName) {
      name
      id
      jobs {
        id
        title
        location
      }
    }
  }
`;

/**
 * __useGreehhouseDepartmentQuery__
 *
 * To run a query within a React component, call `useGreehhouseDepartmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreehhouseDepartmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreehhouseDepartmentQuery({
 *   variables: {
 *      kebabName: // value for 'kebabName'
 *   },
 * });
 */
export function useGreehhouseDepartmentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GreehhouseDepartmentQuery,
    GreehhouseDepartmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GreehhouseDepartmentQuery,
    GreehhouseDepartmentQueryVariables
  >(GreehhouseDepartmentDocument, options);
}
export function useGreehhouseDepartmentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GreehhouseDepartmentQuery,
    GreehhouseDepartmentQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GreehhouseDepartmentQuery,
    GreehhouseDepartmentQueryVariables
  >(GreehhouseDepartmentDocument, options);
}
export type GreehhouseDepartmentQueryHookResult = ReturnType<
  typeof useGreehhouseDepartmentQuery
>;
export type GreehhouseDepartmentLazyQueryHookResult = ReturnType<
  typeof useGreehhouseDepartmentLazyQuery
>;
export type GreehhouseDepartmentQueryResult = Apollo.QueryResult<
  GreehhouseDepartmentQuery,
  GreehhouseDepartmentQueryVariables
>;
export const GreehhouseJobDocument = gql`
  query GreehhouseJob($id: ID!) {
    greenhouseJob(id: $id) {
      id
      title
      location
      content
      department {
        id
        name
      }
    }
  }
`;

/**
 * __useGreehhouseJobQuery__
 *
 * To run a query within a React component, call `useGreehhouseJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGreehhouseJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGreehhouseJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGreehhouseJobQuery(
  baseOptions: Apollo.QueryHookOptions<
    GreehhouseJobQuery,
    GreehhouseJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GreehhouseJobQuery, GreehhouseJobQueryVariables>(
    GreehhouseJobDocument,
    options,
  );
}
export function useGreehhouseJobLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GreehhouseJobQuery,
    GreehhouseJobQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GreehhouseJobQuery, GreehhouseJobQueryVariables>(
    GreehhouseJobDocument,
    options,
  );
}
export type GreehhouseJobQueryHookResult = ReturnType<
  typeof useGreehhouseJobQuery
>;
export type GreehhouseJobLazyQueryHookResult = ReturnType<
  typeof useGreehhouseJobLazyQuery
>;
export type GreehhouseJobQueryResult = Apollo.QueryResult<
  GreehhouseJobQuery,
  GreehhouseJobQueryVariables
>;
